import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: number; output: number };
  /** Cursor for paging through collections */
  ConnectionCursor: { input: any; output: any };
  /** Date custom scalar type */
  Date: { input: string; output: string };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
};

export type AcceptInvitationInput = {
  token: Scalars['String']['input'];
};

export enum AccountingAcquisitionMethod {
  File = 'FILE',
  Intuit = 'INTUIT',
  Manual = 'MANUAL',
  MergeDev = 'MERGE_DEV',
}

export type AccountingExpense = {
  __typename?: 'AccountingExpense';
  account?: Maybe<Scalars['String']['output']>;
  accountingQre: AccountingQre;
  amountCents: Scalars['BigInt']['output'];
  costCenter?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  department?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  entity?: Maybe<Scalars['String']['output']>;
  fiscalYearId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  projectPerAccountingExpense: Array<ProjectPerAccountingExpense>;
};

export enum AccountingProvider {
  Netsuite = 'NETSUITE',
  Quickbooks = 'QUICKBOOKS',
  SelfReported = 'SELF_REPORTED',
}

export type AccountingProviderFilterComparison = {
  eq?: InputMaybe<AccountingProvider>;
  gt?: InputMaybe<AccountingProvider>;
  gte?: InputMaybe<AccountingProvider>;
  iLike?: InputMaybe<AccountingProvider>;
  in?: InputMaybe<Array<AccountingProvider>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<AccountingProvider>;
  lt?: InputMaybe<AccountingProvider>;
  lte?: InputMaybe<AccountingProvider>;
  neq?: InputMaybe<AccountingProvider>;
  notILike?: InputMaybe<AccountingProvider>;
  notIn?: InputMaybe<Array<AccountingProvider>>;
  notLike?: InputMaybe<AccountingProvider>;
};

export type AccountingQre = {
  __typename?: 'AccountingQre';
  account?: Maybe<Scalars['String']['output']>;
  accountingExpenseId: Scalars['String']['output'];
  accountingProvider?: Maybe<AccountingProvider>;
  /** null for any user without financial permissions */
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  fiscalYearId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  qreRdPercentage: Scalars['Int']['output'];
  /** null for any user without financial permissions */
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  rdCategory: RdCategory;
  state?: Maybe<Scalars['String']['output']>;
};

export type AccountingQreAggregateFilter = {
  account?: InputMaybe<StringFieldComparison>;
  accountingProvider?: InputMaybe<AccountingProviderFilterComparison>;
  amountCents?: InputMaybe<BigIntFilterComparison>;
  and?: InputMaybe<Array<AccountingQreAggregateFilter>>;
  costCenter?: InputMaybe<StringFieldComparison>;
  country?: InputMaybe<StringFieldComparison>;
  department?: InputMaybe<StringFieldComparison>;
  entity?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AccountingQreAggregateFilter>>;
  qreRdPercentage?: InputMaybe<FloatFieldComparison>;
  qualifiedAmountCents?: InputMaybe<BigIntFilterComparison>;
  rdCategory?: InputMaybe<RdCategoryFilterComparison>;
  state?: InputMaybe<StringFieldComparison>;
};

export type AccountingQreAggregateGroupBy = {
  __typename?: 'AccountingQreAggregateGroupBy';
  account?: Maybe<Scalars['String']['output']>;
  accountingProvider?: Maybe<AccountingProvider>;
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qreRdPercentage?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  rdCategory?: Maybe<RdCategory>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AccountingQreAvgAggregate = {
  __typename?: 'AccountingQreAvgAggregate';
  amountCents?: Maybe<Scalars['Float']['output']>;
  qreRdPercentage?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['Float']['output']>;
};

export type AccountingQreConnection = {
  __typename?: 'AccountingQreConnection';
  /** Array of edges. */
  edges: Array<AccountingQreEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AccountingQreCountAggregate = {
  __typename?: 'AccountingQreCountAggregate';
  account?: Maybe<Scalars['Int']['output']>;
  accountingProvider?: Maybe<Scalars['Int']['output']>;
  amountCents?: Maybe<Scalars['Int']['output']>;
  costCenter?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Scalars['Int']['output']>;
  entity?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  qreRdPercentage?: Maybe<Scalars['Int']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['Int']['output']>;
  rdCategory?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
};

export type AccountingQreEdge = {
  __typename?: 'AccountingQreEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AccountingQre */
  node: AccountingQre;
};

export type AccountingQreFilter = {
  account?: InputMaybe<StringFieldComparison>;
  accountingProvider?: InputMaybe<AccountingProviderFilterComparison>;
  amountCents?: InputMaybe<BigIntFilterComparison>;
  and?: InputMaybe<Array<AccountingQreFilter>>;
  costCenter?: InputMaybe<StringFieldComparison>;
  country?: InputMaybe<StringFieldComparison>;
  department?: InputMaybe<StringFieldComparison>;
  entity?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AccountingQreFilter>>;
  qreRdPercentage?: InputMaybe<FloatFieldComparison>;
  qualifiedAmountCents?: InputMaybe<BigIntFilterComparison>;
  rdCategory?: InputMaybe<RdCategoryFilterComparison>;
  state?: InputMaybe<StringFieldComparison>;
};

export type AccountingQreMaxAggregate = {
  __typename?: 'AccountingQreMaxAggregate';
  account?: Maybe<Scalars['String']['output']>;
  accountingProvider?: Maybe<AccountingProvider>;
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qreRdPercentage?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  rdCategory?: Maybe<RdCategory>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AccountingQreMinAggregate = {
  __typename?: 'AccountingQreMinAggregate';
  account?: Maybe<Scalars['String']['output']>;
  accountingProvider?: Maybe<AccountingProvider>;
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qreRdPercentage?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  rdCategory?: Maybe<RdCategory>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AccountingQreSort = {
  direction: SortDirection;
  field: AccountingQreSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AccountingQreSortFields {
  Account = 'account',
  AccountingProvider = 'accountingProvider',
  AmountCents = 'amountCents',
  CostCenter = 'costCenter',
  Country = 'country',
  Department = 'department',
  Entity = 'entity',
  Id = 'id',
  Name = 'name',
  QreRdPercentage = 'qreRdPercentage',
  QualifiedAmountCents = 'qualifiedAmountCents',
  RdCategory = 'rdCategory',
  State = 'state',
}

export type AccountingQreSumAggregate = {
  __typename?: 'AccountingQreSumAggregate';
  amountCents?: Maybe<Scalars['Float']['output']>;
  qreRdPercentage?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['Float']['output']>;
};

export type AccountingQreSummary = {
  __typename?: 'AccountingQreSummary';
  avg?: Maybe<AccountingQreAvgAggregate>;
  count?: Maybe<AccountingQreCountAggregate>;
  groupBy?: Maybe<AccountingQreAggregateGroupBy>;
  max?: Maybe<AccountingQreMaxAggregate>;
  min?: Maybe<AccountingQreMinAggregate>;
  sum?: Maybe<AccountingQreSumAggregate>;
  uniqueCount?: Maybe<AccountingQreUniqueCountAggregate>;
};

export type AccountingQreSummaryFilter = {
  account?: InputMaybe<StringFieldComparison>;
  accountingProvider?: InputMaybe<AccountingProviderFilterComparison>;
  amountCents?: InputMaybe<BigIntFilterComparison>;
  and?: InputMaybe<Array<AccountingQreAggregateFilter>>;
  costCenter?: InputMaybe<StringFieldComparison>;
  country?: InputMaybe<StringFieldComparison>;
  department?: InputMaybe<StringFieldComparison>;
  entity?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AccountingQreAggregateFilter>>;
  qreRdPercentage?: InputMaybe<FloatFieldComparison>;
  qualifiedAmountCents?: InputMaybe<BigIntFilterComparison>;
  rdCategory?: InputMaybe<RdCategoryFilterComparison>;
  state?: InputMaybe<StringFieldComparison>;
};

export type AccountingQreUniqueCountAggregate = {
  __typename?: 'AccountingQreUniqueCountAggregate';
  account: Scalars['Int']['output'];
  costCenter: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  department: Scalars['Int']['output'];
  entity: Scalars['Int']['output'];
  rdCategory: Scalars['Int']['output'];
  state: Scalars['Int']['output'];
};

export type AccountingToken = {
  __typename?: 'AccountingToken';
  accountingProvider: AccountingProvider;
  acquisitionMethod: AccountingAcquisitionMethod;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

export type AddAscCostFileInput = {
  /** The file's cloud storage permanent URL */
  permanentUrl: Scalars['String']['input'];
};

export type AddAscProjectsFileInput = {
  /** The CSV file's cloud storage permanent URL */
  permanentUrl: Scalars['String']['input'];
};

export type AddCompanyBulkTicketingDataInput = {
  /** The file's cloud storage permanent URL */
  permanentUrl: Scalars['String']['input'];
  /** Type of entities in the ticketing file */
  ticketingEntityType: TicketingEntityType;
  /** The ticketing provider of the file */
  ticketingProvider: FileUploadTicketingProvider;
};

export type AddGithubEmailMappingFileInput = {
  /** The CSV file's cloud storage permanent URL */
  permanentUrl: Scalars['String']['input'];
};

export type AddOrganizationInvitationInput = {
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  companyScope?: InputMaybe<CompanyScope>;
  email: Scalars['String']['input'];
  expirationDays: Scalars['Int']['input'];
  organizationScope: OrganizationScope;
};

export type AddPriorYearTaxDocumentInput = {
  /** The file's cloud storage permanent URL */
  permanentUrl: Scalars['String']['input'];
};

export type AddRdBusinessComponentsFileInput = {
  /** The CSV file's cloud storage permanent URL */
  permanentUrl: Scalars['String']['input'];
  /** Whether this upload may supersede the fiscal year's existing business components */
  replaceExisting: Scalars['Boolean']['input'];
};

export type AddRdPayrollCostFileInput = {
  /** The payroll provider for this file */
  payrollProvider: PayrollProvider;
  /** The file's cloud storage permanent URL */
  permanentUrl: Scalars['String']['input'];
};

export type AddRdProjectSupportingDocumentInput = {
  /** The file's cloud storage permanent URL */
  permanentUrl: Scalars['String']['input'];
};

export type AddRdProjectsFileInput = {
  /** The CSV file's cloud storage permanent URL */
  permanentUrl: Scalars['String']['input'];
};

export type AddSentinelEmailInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
};

export type AddTimesheetFileInput = {
  /** The effort unit for every row in this import */
  effortUnit: TimesheetEffortUnit;
  /** User-specified name identifying this import batch */
  name: Scalars['String']['input'];
  /** The file's cloud storage permanent URL */
  permanentUrl: Scalars['String']['input'];
};

export type AllocationProjectDetails = {
  __typename?: 'AllocationProjectDetails';
  consideredForRd: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isSection174Eligible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum AnalysisType {
  Asc = 'ASC',
  CaSred = 'CA_SRED',
  Rd = 'RD',
}

export enum AnswerType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Ein = 'EIN',
  Number = 'NUMBER',
  PostalCode = 'POSTAL_CODE',
  State = 'STATE',
  String = 'STRING',
  Year = 'YEAR',
}

export type ApplyWeightedCapitalizedPercentageToContributorInput = {
  contributorIds: Array<Scalars['ID']['input']>;
  desiredCapitalizedPercentage: Scalars['Int']['input'];
};

export type ApplyWeightedCapitalizedPercentageToContributorsResult = {
  __typename?: 'ApplyWeightedCapitalizedPercentageToContributorsResult';
  success: Scalars['Boolean']['output'];
  summary: ApplyWeightedCapitalizedPercentageToContributorsSummary;
};

export type ApplyWeightedCapitalizedPercentageToContributorsSummary = {
  __typename?: 'ApplyWeightedCapitalizedPercentageToContributorsSummary';
  contributorsProcessed: Scalars['Int']['output'];
  totalRecordsAffected: Scalars['Int']['output'];
  totalRecordsCreated: Scalars['Int']['output'];
  totalRecordsUpdated: Scalars['Int']['output'];
};

export type ApplyWeightedRdPercentageToExpensesInput = {
  /** When true, applies to all payroll QREs in the fiscal year */
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  desiredRdPercentage: Scalars['Float']['input'];
  fiscalYearId: Scalars['ID']['input'];
  rdExpenseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ApplyWeightedRdPercentageToExpensesResult = {
  __typename?: 'ApplyWeightedRdPercentageToExpensesResult';
  success: Scalars['Boolean']['output'];
};

export type ApproveRdProjectInput = {
  approvalComment?: InputMaybe<Scalars['String']['input']>;
};

export enum AscClusterType {
  CapitalizableProjectMain = 'CAPITALIZABLE_PROJECT_MAIN',
  CapitalizableProjectNoise = 'CAPITALIZABLE_PROJECT_NOISE',
  DeterministicHasRoot = 'DETERMINISTIC_HAS_ROOT',
  DeterministicNoRoot = 'DETERMINISTIC_NO_ROOT',
  ManuallyCreated = 'MANUALLY_CREATED',
  Merged = 'MERGED',
  SmartMain = 'SMART_MAIN',
  SmartNoise = 'SMART_NOISE',
}

export type AscClusterTypeFilterComparison = {
  eq?: InputMaybe<AscClusterType>;
  gt?: InputMaybe<AscClusterType>;
  gte?: InputMaybe<AscClusterType>;
  iLike?: InputMaybe<AscClusterType>;
  in?: InputMaybe<Array<AscClusterType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<AscClusterType>;
  lt?: InputMaybe<AscClusterType>;
  lte?: InputMaybe<AscClusterType>;
  neq?: InputMaybe<AscClusterType>;
  notILike?: InputMaybe<AscClusterType>;
  notIn?: InputMaybe<Array<AscClusterType>>;
  notLike?: InputMaybe<AscClusterType>;
};

export type AscContributorProjectAllocation = {
  __typename?: 'AscContributorProjectAllocation';
  /** The average percentage allocation across all months in the period */
  allocationPercentAvg: Scalars['Float']['output'];
  ascProjectId: Scalars['ID']['output'];
  ascProjectName: Scalars['String']['output'];
  capitalizationEndDate?: Maybe<Scalars['Date']['output']>;
  capitalizationStartDate?: Maybe<Scalars['Date']['output']>;
  capitalizationStatus: CapitalizationStatus;
  clusterType: AscClusterType;
  companyId: Scalars['ID']['output'];
  contributorId: Scalars['ID']['output'];
  fiscalYearId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  periodName: Scalars['String']['output'];
};

export type AscContributorProjectAllocationAggregateGroupBy = {
  __typename?: 'AscContributorProjectAllocationAggregateGroupBy';
  ascProjectName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AscContributorProjectAllocationConnection = {
  __typename?: 'AscContributorProjectAllocationConnection';
  /** Array of edges. */
  edges: Array<AscContributorProjectAllocationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AscContributorProjectAllocationCountAggregate = {
  __typename?: 'AscContributorProjectAllocationCountAggregate';
  ascProjectName?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type AscContributorProjectAllocationEdge = {
  __typename?: 'AscContributorProjectAllocationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AscContributorProjectAllocation */
  node: AscContributorProjectAllocation;
};

export type AscContributorProjectAllocationFilter = {
  and?: InputMaybe<Array<AscContributorProjectAllocationFilter>>;
  ascProjectName?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AscContributorProjectAllocationFilter>>;
};

export type AscContributorProjectAllocationMaxAggregate = {
  __typename?: 'AscContributorProjectAllocationMaxAggregate';
  ascProjectName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AscContributorProjectAllocationMinAggregate = {
  __typename?: 'AscContributorProjectAllocationMinAggregate';
  ascProjectName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AscContributorProjectAllocationSort = {
  direction: SortDirection;
  field: AscContributorProjectAllocationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AscContributorProjectAllocationSortFields {
  AscProjectName = 'ascProjectName',
  Id = 'id',
}

export type AscCostCsvResultRo = {
  __typename?: 'AscCostCsvResultRo';
  /** Permanent URL to the CSV file in cloud storage */
  permanentUrl: Scalars['String']['output'];
  /** Signed URL for downloading the CSV (expires in 7 days) */
  signedUrl: Scalars['String']['output'];
};

export type AscGroupingTicketOrCollection = {
  __typename?: 'AscGroupingTicketOrCollection';
  ascProjectId: Scalars['ID']['output'];
  count: Scalars['Int']['output'];
  fiscalYearId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  isMatchedInLatestSync: Scalars['Boolean']['output'];
  kind: TicketGroupingKind;
  matchingConfidence?: Maybe<AscMatchingConfidence>;
  matchingReasoning?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  periodName: PeriodName;
  ticketType?: Maybe<Scalars['String']['output']>;
};

export enum AscMatchMethod {
  MaintenanceTicket = 'MAINTENANCE_TICKET',
  NoMatchedProjectsInWorkstream = 'NO_MATCHED_PROJECTS_IN_WORKSTREAM',
  NoMatchingProjects = 'NO_MATCHING_PROJECTS',
  RestrictedMatching = 'RESTRICTED_MATCHING',
  WorkstreamConsensus = 'WORKSTREAM_CONSENSUS',
  WorkstreamMatching = 'WORKSTREAM_MATCHING',
}

export enum AscMatchingConfidence {
  High = 'HIGH',
  Low = 'LOW',
}

export type AscMonthLockState = {
  __typename?: 'AscMonthLockState';
  /** Whether this individual month is locked */
  isLocked: Scalars['Boolean']['output'];
  /** The month this state refers to, in "YYYY-MM" format */
  monthYear: Scalars['String']['output'];
};

export type AscPeriodLockStatus = {
  __typename?: 'AscPeriodLockStatus';
  /** The ID of the fiscal year */
  fiscalYearId: Scalars['ID']['output'];
  /** Whether any month this period covers is locked. A write aimed at the period would touch every month it spans, so one closed month closes the period. */
  isLocked: Scalars['Boolean']['output'];
  /** Lock state of each month the period spans, ordered chronologically. Empty when the period is itself a month. A locked period may still hold open months — releasing one out of a locked quarter leaves the quarter locked. */
  monthLockStates: Array<AscMonthLockState>;
  /** The period this status refers to */
  periodName: PeriodName;
};

export type AscProject = {
  __typename?: 'AscProject';
  /** Get the approval status for an ASC project based on the fiscal period */
  approvalStatus?: Maybe<AscProjectApprovalStatusResult>;
  capitalizableProjectClusteringOverride?: Maybe<CapitalizableProjectClusteringOverride>;
  capitalizationEndDate?: Maybe<Scalars['Date']['output']>;
  capitalizationEndDateExtendedFrom?: Maybe<Scalars['Date']['output']>;
  capitalizationStartDate?: Maybe<Scalars['Date']['output']>;
  capitalizationStatus: CapitalizationStatus;
  clusterType: AscClusterType;
  companyId: Scalars['ID']['output'];
  customFieldLaunchDate?: Maybe<Scalars['Date']['output']>;
  customFieldTeams?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endMonthYear?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeterministic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  predictedCapitalizationEndDate?: Maybe<Scalars['Date']['output']>;
  predictedCapitalizationEndDateReason?: Maybe<Scalars['String']['output']>;
  predictedCapitalizationStartDate?: Maybe<Scalars['Date']['output']>;
  predictedCapitalizationStatus?: Maybe<PredictedCapitalizationStatus>;
  predictedCapitalizationStatusReason?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwner?: Maybe<AscProjectOwner>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  startMonthYear?: Maybe<Scalars['String']['output']>;
  ticketCount: Scalars['Int']['output'];
  workstreamNames: Array<Scalars['String']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type AscProjectApprovalStatusArgs = {
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type AscProjectTicketCountArgs = {
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type AscProjectAggregateFilter = {
  and?: InputMaybe<Array<AscProjectAggregateFilter>>;
  capitalizableProjectClusteringOverride?: InputMaybe<CapitalizableProjectClusteringOverrideFilterComparison>;
  capitalizationEndDate?: InputMaybe<DateFieldComparison>;
  capitalizationEndDateExtendedFrom?: InputMaybe<DateFieldComparison>;
  capitalizationStartDate?: InputMaybe<DateFieldComparison>;
  capitalizationStatus?: InputMaybe<CapitalizationStatusFilterComparison>;
  clusterType?: InputMaybe<AscClusterTypeFilterComparison>;
  companyId?: InputMaybe<IdFilterComparison>;
  customFieldLaunchDate?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  endMonthYear?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isDeterministic?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AscProjectAggregateFilter>>;
  predictedCapitalizationEndDate?: InputMaybe<DateFieldComparison>;
  predictedCapitalizationStartDate?: InputMaybe<DateFieldComparison>;
  predictedCapitalizationStatus?: InputMaybe<PredictedCapitalizationStatusFilterComparison>;
  productName?: InputMaybe<StringFieldComparison>;
  projectOwnerId?: InputMaybe<IdFilterComparison>;
  projectOwnerName?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  startMonthYear?: InputMaybe<StringFieldComparison>;
  ticketCount?: InputMaybe<IntFieldComparison>;
  workstreamNamesSearch?: InputMaybe<StringFieldComparison>;
};

export type AscProjectAggregateGroupBy = {
  __typename?: 'AscProjectAggregateGroupBy';
  capitalizableProjectClusteringOverride?: Maybe<CapitalizableProjectClusteringOverride>;
  capitalizationEndDate?: Maybe<Scalars['Date']['output']>;
  capitalizationEndDateExtendedFrom?: Maybe<Scalars['Date']['output']>;
  capitalizationStartDate?: Maybe<Scalars['Date']['output']>;
  capitalizationStatus?: Maybe<CapitalizationStatus>;
  clusterType?: Maybe<AscClusterType>;
  companyId?: Maybe<Scalars['ID']['output']>;
  customFieldLaunchDate?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endMonthYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isDeterministic?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  predictedCapitalizationEndDate?: Maybe<Scalars['Date']['output']>;
  predictedCapitalizationStartDate?: Maybe<Scalars['Date']['output']>;
  predictedCapitalizationStatus?: Maybe<PredictedCapitalizationStatus>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  startMonthYear?: Maybe<Scalars['String']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type AscProjectAllocationPercentInput = {
  allocationPercent: Scalars['Float']['input'];
  ascProjectId: Scalars['ID']['input'];
};

/** The approval status of an ASC project within a specific period */
export enum AscProjectApprovalStatus {
  Approved = 'APPROVED',
  NotApproved = 'NOT_APPROVED',
  PartiallyApproved = 'PARTIALLY_APPROVED',
}

export type AscProjectApprovalStatusResult = {
  __typename?: 'AscProjectApprovalStatusResult';
  /** The overall latest month-year through which the project is approved (regardless of period), in "YYYY-MM" format */
  approvedThroughMonthYear?: Maybe<Scalars['String']['output']>;
  /** The ID of the ASC project */
  ascProjectId: Scalars['ID']['output'];
  /** The ID of the fiscal year */
  fiscalYearId: Scalars['ID']['output'];
  /** The full name of the user who approved the end month of the requested period */
  periodApprovalByUserFullName?: Maybe<Scalars['String']['output']>;
  /** The user ID who approved the end month of the requested period */
  periodApprovalByUserId?: Maybe<Scalars['ID']['output']>;
  /** The approval comment for the end month of the requested period, if approved */
  periodApprovalComment?: Maybe<Scalars['String']['output']>;
  /** When the end month of the requested period was approved */
  periodApprovalDatetime?: Maybe<Scalars['Date']['output']>;
  /** The name of the period */
  periodName: PeriodName;
  /** The approval status for the requested period */
  status: AscProjectApprovalStatus;
};

export type AscProjectAvgAggregate = {
  __typename?: 'AscProjectAvgAggregate';
  ticketCount?: Maybe<Scalars['Float']['output']>;
};

export type AscProjectConnection = {
  __typename?: 'AscProjectConnection';
  /** Array of edges. */
  edges: Array<AscProjectEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AscProjectCountAggregate = {
  __typename?: 'AscProjectCountAggregate';
  capitalizableProjectClusteringOverride?: Maybe<Scalars['Int']['output']>;
  capitalizationEndDate?: Maybe<Scalars['Int']['output']>;
  capitalizationEndDateExtendedFrom?: Maybe<Scalars['Int']['output']>;
  capitalizationStartDate?: Maybe<Scalars['Int']['output']>;
  capitalizationStatus?: Maybe<Scalars['Int']['output']>;
  clusterType?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  customFieldLaunchDate?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Int']['output']>;
  endMonthYear?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDeterministic?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  predictedCapitalizationEndDate?: Maybe<Scalars['Int']['output']>;
  predictedCapitalizationStartDate?: Maybe<Scalars['Int']['output']>;
  predictedCapitalizationStatus?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['Int']['output']>;
  projectOwnerId?: Maybe<Scalars['Int']['output']>;
  projectOwnerName?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Int']['output']>;
  startMonthYear?: Maybe<Scalars['Int']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['Int']['output']>;
};

export type AscProjectDeletionResult = {
  __typename?: 'AscProjectDeletionResult';
  success: Scalars['Boolean']['output'];
};

export type AscProjectEdge = {
  __typename?: 'AscProjectEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AscProject */
  node: AscProject;
};

export type AscProjectFilter = {
  and?: InputMaybe<Array<AscProjectFilter>>;
  capitalizableProjectClusteringOverride?: InputMaybe<CapitalizableProjectClusteringOverrideFilterComparison>;
  capitalizationEndDate?: InputMaybe<DateFieldComparison>;
  capitalizationEndDateExtendedFrom?: InputMaybe<DateFieldComparison>;
  capitalizationStartDate?: InputMaybe<DateFieldComparison>;
  capitalizationStatus?: InputMaybe<CapitalizationStatusFilterComparison>;
  clusterType?: InputMaybe<AscClusterTypeFilterComparison>;
  companyId?: InputMaybe<IdFilterComparison>;
  customFieldLaunchDate?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  endMonthYear?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isDeterministic?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AscProjectFilter>>;
  predictedCapitalizationEndDate?: InputMaybe<DateFieldComparison>;
  predictedCapitalizationStartDate?: InputMaybe<DateFieldComparison>;
  predictedCapitalizationStatus?: InputMaybe<PredictedCapitalizationStatusFilterComparison>;
  productName?: InputMaybe<StringFieldComparison>;
  projectOwnerId?: InputMaybe<IdFilterComparison>;
  projectOwnerName?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  startMonthYear?: InputMaybe<StringFieldComparison>;
  ticketCount?: InputMaybe<IntFieldComparison>;
  workstreamNamesSearch?: InputMaybe<StringFieldComparison>;
};

export type AscProjectMaxAggregate = {
  __typename?: 'AscProjectMaxAggregate';
  capitalizableProjectClusteringOverride?: Maybe<CapitalizableProjectClusteringOverride>;
  capitalizationEndDate?: Maybe<Scalars['Date']['output']>;
  capitalizationEndDateExtendedFrom?: Maybe<Scalars['Date']['output']>;
  capitalizationStartDate?: Maybe<Scalars['Date']['output']>;
  capitalizationStatus?: Maybe<CapitalizationStatus>;
  clusterType?: Maybe<AscClusterType>;
  companyId?: Maybe<Scalars['ID']['output']>;
  customFieldLaunchDate?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endMonthYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  predictedCapitalizationEndDate?: Maybe<Scalars['Date']['output']>;
  predictedCapitalizationStartDate?: Maybe<Scalars['Date']['output']>;
  predictedCapitalizationStatus?: Maybe<PredictedCapitalizationStatus>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  startMonthYear?: Maybe<Scalars['String']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type AscProjectMinAggregate = {
  __typename?: 'AscProjectMinAggregate';
  capitalizableProjectClusteringOverride?: Maybe<CapitalizableProjectClusteringOverride>;
  capitalizationEndDate?: Maybe<Scalars['Date']['output']>;
  capitalizationEndDateExtendedFrom?: Maybe<Scalars['Date']['output']>;
  capitalizationStartDate?: Maybe<Scalars['Date']['output']>;
  capitalizationStatus?: Maybe<CapitalizationStatus>;
  clusterType?: Maybe<AscClusterType>;
  companyId?: Maybe<Scalars['ID']['output']>;
  customFieldLaunchDate?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endMonthYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  predictedCapitalizationEndDate?: Maybe<Scalars['Date']['output']>;
  predictedCapitalizationStartDate?: Maybe<Scalars['Date']['output']>;
  predictedCapitalizationStatus?: Maybe<PredictedCapitalizationStatus>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  startMonthYear?: Maybe<Scalars['String']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type AscProjectMonthPerContributor = {
  __typename?: 'AscProjectMonthPerContributor';
  allocationPercent: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  month: Scalars['Int']['output'];
  useAllocationPercent?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
};

export type AscProjectOwner = {
  __typename?: 'AscProjectOwner';
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AscProjectPerContributor = {
  __typename?: 'AscProjectPerContributor';
  ascProject: AscProject;
  ascProjectMonthsPerContributor: Array<AscProjectMonthPerContributor>;
  id: Scalars['ID']['output'];
};

export type AscProjectReport = {
  __typename?: 'AscProjectReport';
  columnNames: Array<Scalars['String']['output']>;
  excelData: Scalars['String']['output'];
};

export type AscProjectSort = {
  direction: SortDirection;
  field: AscProjectSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AscProjectSortFields {
  CapitalizableProjectClusteringOverride = 'capitalizableProjectClusteringOverride',
  CapitalizationEndDate = 'capitalizationEndDate',
  CapitalizationEndDateExtendedFrom = 'capitalizationEndDateExtendedFrom',
  CapitalizationStartDate = 'capitalizationStartDate',
  CapitalizationStatus = 'capitalizationStatus',
  ClusterType = 'clusterType',
  CompanyId = 'companyId',
  CustomFieldLaunchDate = 'customFieldLaunchDate',
  Description = 'description',
  EndDate = 'endDate',
  EndMonthYear = 'endMonthYear',
  Id = 'id',
  IsDeterministic = 'isDeterministic',
  Name = 'name',
  PredictedCapitalizationEndDate = 'predictedCapitalizationEndDate',
  PredictedCapitalizationStartDate = 'predictedCapitalizationStartDate',
  PredictedCapitalizationStatus = 'predictedCapitalizationStatus',
  ProductName = 'productName',
  ProjectOwnerId = 'projectOwnerId',
  ProjectOwnerName = 'projectOwnerName',
  StartDate = 'startDate',
  StartMonthYear = 'startMonthYear',
  TicketCount = 'ticketCount',
  WorkstreamNamesSearch = 'workstreamNamesSearch',
}

export type AscProjectSumAggregate = {
  __typename?: 'AscProjectSumAggregate';
  ticketCount?: Maybe<Scalars['Float']['output']>;
};

export type AscProjectTeamMember = {
  __typename?: 'AscProjectTeamMember';
  allocationPercent: Scalars['Int']['output'];
  ascProjectId?: Maybe<Scalars['String']['output']>;
  contributorEmail?: Maybe<Scalars['String']['output']>;
  contributorId: Scalars['String']['output'];
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId: Scalars['String']['output'];
  periodName: PeriodName;
};

export type AscProjectTeamMemberAggregateGroupBy = {
  __typename?: 'AscProjectTeamMemberAggregateGroupBy';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
  ascProjectId?: Maybe<Scalars['String']['output']>;
  contributorId?: Maybe<Scalars['String']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  periodName?: Maybe<PeriodName>;
};

export type AscProjectTeamMemberAvgAggregate = {
  __typename?: 'AscProjectTeamMemberAvgAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
};

export type AscProjectTeamMemberConnection = {
  __typename?: 'AscProjectTeamMemberConnection';
  /** Array of edges. */
  edges: Array<AscProjectTeamMemberEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AscProjectTeamMemberCountAggregate = {
  __typename?: 'AscProjectTeamMemberCountAggregate';
  allocationPercent?: Maybe<Scalars['Int']['output']>;
  ascProjectId?: Maybe<Scalars['Int']['output']>;
  contributorId?: Maybe<Scalars['Int']['output']>;
  contributorName?: Maybe<Scalars['Int']['output']>;
  fiscalYearId?: Maybe<Scalars['Int']['output']>;
  periodName?: Maybe<Scalars['Int']['output']>;
};

export type AscProjectTeamMemberEdge = {
  __typename?: 'AscProjectTeamMemberEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AscProjectTeamMember */
  node: AscProjectTeamMember;
};

export type AscProjectTeamMemberFilter = {
  allocationPercent?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<AscProjectTeamMemberFilter>>;
  ascProjectId?: InputMaybe<StringFieldComparison>;
  contributorId?: InputMaybe<StringFieldComparison>;
  contributorName?: InputMaybe<StringFieldComparison>;
  fiscalYearId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AscProjectTeamMemberFilter>>;
  periodName?: InputMaybe<PeriodNameFilterComparison>;
};

export type AscProjectTeamMemberMaxAggregate = {
  __typename?: 'AscProjectTeamMemberMaxAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
  ascProjectId?: Maybe<Scalars['String']['output']>;
  contributorId?: Maybe<Scalars['String']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  periodName?: Maybe<PeriodName>;
};

export type AscProjectTeamMemberMinAggregate = {
  __typename?: 'AscProjectTeamMemberMinAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
  ascProjectId?: Maybe<Scalars['String']['output']>;
  contributorId?: Maybe<Scalars['String']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  periodName?: Maybe<PeriodName>;
};

export type AscProjectTeamMemberSort = {
  direction: SortDirection;
  field: AscProjectTeamMemberSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AscProjectTeamMemberSortFields {
  AllocationPercent = 'allocationPercent',
  AscProjectId = 'ascProjectId',
  ContributorId = 'contributorId',
  ContributorName = 'contributorName',
  FiscalYearId = 'fiscalYearId',
  PeriodName = 'periodName',
}

export type AscProjectTeamMemberSumAggregate = {
  __typename?: 'AscProjectTeamMemberSumAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
};

export type AscProjectTpTicketsView = {
  __typename?: 'AscProjectTpTicketsView';
  ascProjectId: Scalars['String']['output'];
  completedDatetime?: Maybe<Scalars['Date']['output']>;
  contributorId: Scalars['String']['output'];
  contributorName: Scalars['String']['output'];
  fiscalYearId: Scalars['String']['output'];
  groupingTicketingProviderCollectionId?: Maybe<Scalars['String']['output']>;
  groupingTicketingProviderTicketId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  matchingConfidence?: Maybe<AscMatchingConfidence>;
  matchingMethod?: Maybe<AscMatchMethod>;
  matchingReasoning?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  periodName: PeriodName;
  predictedEffortDays: Scalars['Float']['output'];
  ticketUrl?: Maybe<Scalars['String']['output']>;
  workstreamId?: Maybe<Scalars['String']['output']>;
  workstreamName?: Maybe<Scalars['String']['output']>;
};

export type AscProjectTpTicketsViewAggregateGroupBy = {
  __typename?: 'AscProjectTpTicketsViewAggregateGroupBy';
  ascProjectId?: Maybe<Scalars['String']['output']>;
  completedDatetime?: Maybe<Scalars['Date']['output']>;
  contributorId?: Maybe<Scalars['String']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  groupingTicketingProviderCollectionId?: Maybe<Scalars['String']['output']>;
  groupingTicketingProviderTicketId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  periodName?: Maybe<PeriodName>;
  predictedEffortDays?: Maybe<Scalars['Float']['output']>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
  workstreamId?: Maybe<Scalars['String']['output']>;
  workstreamName?: Maybe<Scalars['String']['output']>;
};

export type AscProjectTpTicketsViewAvgAggregate = {
  __typename?: 'AscProjectTpTicketsViewAvgAggregate';
  predictedEffortDays?: Maybe<Scalars['Float']['output']>;
};

export type AscProjectTpTicketsViewConnection = {
  __typename?: 'AscProjectTpTicketsViewConnection';
  /** Array of edges. */
  edges: Array<AscProjectTpTicketsViewEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AscProjectTpTicketsViewCountAggregate = {
  __typename?: 'AscProjectTpTicketsViewCountAggregate';
  ascProjectId?: Maybe<Scalars['Int']['output']>;
  completedDatetime?: Maybe<Scalars['Int']['output']>;
  contributorId?: Maybe<Scalars['Int']['output']>;
  contributorName?: Maybe<Scalars['Int']['output']>;
  fiscalYearId?: Maybe<Scalars['Int']['output']>;
  groupingTicketingProviderCollectionId?: Maybe<Scalars['Int']['output']>;
  groupingTicketingProviderTicketId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identifier?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  periodName?: Maybe<Scalars['Int']['output']>;
  predictedEffortDays?: Maybe<Scalars['Int']['output']>;
  ticketUrl?: Maybe<Scalars['Int']['output']>;
  workstreamId?: Maybe<Scalars['Int']['output']>;
  workstreamName?: Maybe<Scalars['Int']['output']>;
};

export type AscProjectTpTicketsViewEdge = {
  __typename?: 'AscProjectTpTicketsViewEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AscProjectTpTicketsView */
  node: AscProjectTpTicketsView;
};

export type AscProjectTpTicketsViewFilter = {
  and?: InputMaybe<Array<AscProjectTpTicketsViewFilter>>;
  ascProjectId?: InputMaybe<StringFieldComparison>;
  completedDatetime?: InputMaybe<DateFieldComparison>;
  contributorId?: InputMaybe<StringFieldComparison>;
  contributorName?: InputMaybe<StringFieldComparison>;
  fiscalYearId?: InputMaybe<StringFieldComparison>;
  groupingTicketingProviderCollectionId?: InputMaybe<StringFieldComparison>;
  groupingTicketingProviderTicketId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  identifier?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AscProjectTpTicketsViewFilter>>;
  parentId?: InputMaybe<StringFieldComparison>;
  periodName?: InputMaybe<PeriodNameFilterComparison>;
  predictedEffortDays?: InputMaybe<FloatFieldComparison>;
  ticketUrl?: InputMaybe<StringFieldComparison>;
  workstreamId?: InputMaybe<StringFieldComparison>;
  workstreamName?: InputMaybe<StringFieldComparison>;
};

export type AscProjectTpTicketsViewMaxAggregate = {
  __typename?: 'AscProjectTpTicketsViewMaxAggregate';
  ascProjectId?: Maybe<Scalars['String']['output']>;
  completedDatetime?: Maybe<Scalars['Date']['output']>;
  contributorId?: Maybe<Scalars['String']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  groupingTicketingProviderCollectionId?: Maybe<Scalars['String']['output']>;
  groupingTicketingProviderTicketId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  periodName?: Maybe<PeriodName>;
  predictedEffortDays?: Maybe<Scalars['Float']['output']>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
  workstreamId?: Maybe<Scalars['String']['output']>;
  workstreamName?: Maybe<Scalars['String']['output']>;
};

export type AscProjectTpTicketsViewMinAggregate = {
  __typename?: 'AscProjectTpTicketsViewMinAggregate';
  ascProjectId?: Maybe<Scalars['String']['output']>;
  completedDatetime?: Maybe<Scalars['Date']['output']>;
  contributorId?: Maybe<Scalars['String']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  groupingTicketingProviderCollectionId?: Maybe<Scalars['String']['output']>;
  groupingTicketingProviderTicketId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  periodName?: Maybe<PeriodName>;
  predictedEffortDays?: Maybe<Scalars['Float']['output']>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
  workstreamId?: Maybe<Scalars['String']['output']>;
  workstreamName?: Maybe<Scalars['String']['output']>;
};

export type AscProjectTpTicketsViewSort = {
  direction: SortDirection;
  field: AscProjectTpTicketsViewSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AscProjectTpTicketsViewSortFields {
  AscProjectId = 'ascProjectId',
  CompletedDatetime = 'completedDatetime',
  ContributorId = 'contributorId',
  ContributorName = 'contributorName',
  FiscalYearId = 'fiscalYearId',
  GroupingTicketingProviderCollectionId = 'groupingTicketingProviderCollectionId',
  GroupingTicketingProviderTicketId = 'groupingTicketingProviderTicketId',
  Id = 'id',
  Identifier = 'identifier',
  Name = 'name',
  ParentId = 'parentId',
  PeriodName = 'periodName',
  PredictedEffortDays = 'predictedEffortDays',
  TicketUrl = 'ticketUrl',
  WorkstreamId = 'workstreamId',
  WorkstreamName = 'workstreamName',
}

export type AscProjectTpTicketsViewSumAggregate = {
  __typename?: 'AscProjectTpTicketsViewSumAggregate';
  predictedEffortDays?: Maybe<Scalars['Float']['output']>;
};

export type AscProjectUniqueCountAggregate = {
  __typename?: 'AscProjectUniqueCountAggregate';
  capitalizableProjectClusteringOverride: Scalars['Int']['output'];
  capitalizationEndDate: Scalars['Int']['output'];
  capitalizationEndDateExtendedFrom: Scalars['Int']['output'];
  capitalizationStartDate: Scalars['Int']['output'];
  capitalizationStatus: Scalars['Int']['output'];
  clusterType: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  customFieldLaunchDate: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  endMonthYear: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDeterministic: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  predictedCapitalizationEndDate: Scalars['Int']['output'];
  predictedCapitalizationStartDate: Scalars['Int']['output'];
  predictedCapitalizationStatus: Scalars['Int']['output'];
  productName: Scalars['Int']['output'];
  projectOwnerId: Scalars['Int']['output'];
  projectOwnerName: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  startMonthYear: Scalars['Int']['output'];
  ticketCount: Scalars['Int']['output'];
  workstreamNamesSearch: Scalars['Int']['output'];
};

export type AscProjectsSummary = {
  __typename?: 'AscProjectsSummary';
  avg?: Maybe<AscProjectAvgAggregate>;
  count?: Maybe<AscProjectCountAggregate>;
  groupBy?: Maybe<AscProjectAggregateGroupBy>;
  max?: Maybe<AscProjectMaxAggregate>;
  min?: Maybe<AscProjectMinAggregate>;
  sum?: Maybe<AscProjectSumAggregate>;
  uniqueCount?: Maybe<AscProjectUniqueCountAggregate>;
};

export type AscProjectsSummaryFilter = {
  and?: InputMaybe<Array<AscProjectAggregateFilter>>;
  capitalizableProjectClusteringOverride?: InputMaybe<CapitalizableProjectClusteringOverrideFilterComparison>;
  capitalizationEndDate?: InputMaybe<DateFieldComparison>;
  capitalizationEndDateExtendedFrom?: InputMaybe<DateFieldComparison>;
  capitalizationStartDate?: InputMaybe<DateFieldComparison>;
  capitalizationStatus?: InputMaybe<CapitalizationStatusFilterComparison>;
  clusterType?: InputMaybe<AscClusterTypeFilterComparison>;
  companyId?: InputMaybe<IdFilterComparison>;
  customFieldLaunchDate?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  endDate?: InputMaybe<DateFieldComparison>;
  endMonthYear?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isDeterministic?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AscProjectAggregateFilter>>;
  predictedCapitalizationEndDate?: InputMaybe<DateFieldComparison>;
  predictedCapitalizationStartDate?: InputMaybe<DateFieldComparison>;
  predictedCapitalizationStatus?: InputMaybe<PredictedCapitalizationStatusFilterComparison>;
  productName?: InputMaybe<StringFieldComparison>;
  projectOwnerId?: InputMaybe<IdFilterComparison>;
  projectOwnerName?: InputMaybe<StringFieldComparison>;
  startDate?: InputMaybe<DateFieldComparison>;
  startMonthYear?: InputMaybe<StringFieldComparison>;
  ticketCount?: InputMaybe<IntFieldComparison>;
  workstreamNamesSearch?: InputMaybe<StringFieldComparison>;
};

export type AscReportRo = {
  __typename?: 'AscReportRo';
  signedUrl: Scalars['String']['output'];
};

export type AscSyncConfiguration = {
  __typename?: 'AscSyncConfiguration';
  ascTicketGroupLevel?: Maybe<AscTicketGroupLevel>;
  booleanTruthyStatus?: Maybe<CapitalizationStatus>;
  clusterDurationObjectiveFnWeight?: Maybe<Scalars['Float']['output']>;
  clusteringMethod: ClusteringMethod;
  customFieldCapitalizationMappings?: Maybe<Array<CustomFieldCapitalizationMapping>>;
  id: Scalars['ID']['output'];
  jiraCapitalizationCustomFieldId?: Maybe<Scalars['String']['output']>;
  matchingAggressiveness: MatchingAggressiveness;
  maxNumberOfClusters?: Maybe<Scalars['Int']['output']>;
  maxTargetClusterDuration?: Maybe<Scalars['Int']['output']>;
  minNumberOfClusters?: Maybe<Scalars['Int']['output']>;
  minNumberOfTicketsPerCluster?: Maybe<Scalars['Int']['output']>;
  minTargetClusterDuration?: Maybe<Scalars['Int']['output']>;
  parentlessTicketMatching: ParentlessTicketMatching;
  useDeterministic: Scalars['Boolean']['output'];
  usePartitionByWorkstream: Scalars['Boolean']['output'];
};

export type AscSyncConfigurationInput = {
  ascTicketGroupLevel?: InputMaybe<AscTicketGroupLevel>;
  booleanTruthyStatus?: InputMaybe<CapitalizationStatus>;
  clusterDurationObjectiveFnWeight?: InputMaybe<Scalars['Float']['input']>;
  clusteringMethod: ClusteringMethod;
  customFieldCapitalizationMappings?: InputMaybe<Array<CustomFieldCapitalizationMappingInput>>;
  jiraCapitalizationCustomFieldId?: InputMaybe<Scalars['String']['input']>;
  matchingAggressiveness: MatchingAggressiveness;
  maxNumberOfClusters?: InputMaybe<Scalars['Int']['input']>;
  maxTargetClusterDuration?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfClusters?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfTicketsPerCluster?: InputMaybe<Scalars['Int']['input']>;
  minTargetClusterDuration?: InputMaybe<Scalars['Int']['input']>;
  parentlessTicketMatching: ParentlessTicketMatching;
  usePartitionByWorkstream: Scalars['Boolean']['input'];
};

export enum AscTicketGroupLevel {
  Collection = 'COLLECTION',
  Epic = 'EPIC',
  Feature = 'FEATURE',
  Initiative = 'INITIATIVE',
  None = 'NONE',
}

export type AscTicketGroupingInput = {
  id: Scalars['ID']['input'];
  kind: TicketGroupingKind;
};

export type AscWage = {
  __typename?: 'AscWage';
  allocationPercent: Scalars['Int']['output'];
  /** null for any user without financial permissions */
  capitalizedSalaryCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  /** null for any user without financial permissions */
  capitalizedStockCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  /** null for any user without financial permissions */
  capitalizedTotalCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  contributorId: Scalars['String']['output'];
  costCenters?: Maybe<Scalars['String']['output']>;
  countries?: Maybe<Scalars['String']['output']>;
  departments?: Maybe<Scalars['String']['output']>;
  employeeIds?: Maybe<Scalars['String']['output']>;
  entities?: Maybe<Scalars['String']['output']>;
  fiscalYearId: Scalars['String']['output'];
  /** Whether the contributor has data for all months in the period */
  hasCompleteDataInPeriod: Scalars['Boolean']['output'];
  hireDates?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  managerIds?: Maybe<Scalars['String']['output']>;
  managerNames?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  periodName: PeriodName;
  /** null for any user without financial permissions */
  salaryCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  /** null for any user without financial permissions */
  stockCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  terminationDates?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<Scalars['String']['output']>;
  /** null for any user without financial permissions */
  totalCompensationCents?: Maybe<Scalars['BigInt']['output']>;
};

export type AscWageAggregateFilter = {
  allocationPercent?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<AscWageAggregateFilter>>;
  capitalizedSalaryCompensationCents?: InputMaybe<BigIntFilterComparison>;
  capitalizedStockCompensationCents?: InputMaybe<BigIntFilterComparison>;
  capitalizedTotalCompensationCents?: InputMaybe<BigIntFilterComparison>;
  contributorId?: InputMaybe<StringFieldComparison>;
  costCenters?: InputMaybe<StringFieldComparison>;
  countries?: InputMaybe<StringFieldComparison>;
  departments?: InputMaybe<StringFieldComparison>;
  employeeIds?: InputMaybe<StringFieldComparison>;
  entities?: InputMaybe<StringFieldComparison>;
  fiscalYearId?: InputMaybe<StringFieldComparison>;
  hasCompleteDataInPeriod?: InputMaybe<BooleanFieldComparison>;
  hireDates?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  managerIds?: InputMaybe<StringFieldComparison>;
  managerNames?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AscWageAggregateFilter>>;
  periodName?: InputMaybe<PeriodNameFilterComparison>;
  salaryCompensationCents?: InputMaybe<BigIntFilterComparison>;
  stockCompensationCents?: InputMaybe<BigIntFilterComparison>;
  terminationDates?: InputMaybe<StringFieldComparison>;
  titles?: InputMaybe<StringFieldComparison>;
  totalCompensationCents?: InputMaybe<BigIntFilterComparison>;
};

export type AscWageAggregateGroupBy = {
  __typename?: 'AscWageAggregateGroupBy';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
  capitalizedSalaryCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  capitalizedStockCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  capitalizedTotalCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  contributorId?: Maybe<Scalars['String']['output']>;
  costCenters?: Maybe<Scalars['String']['output']>;
  countries?: Maybe<Scalars['String']['output']>;
  departments?: Maybe<Scalars['String']['output']>;
  employeeIds?: Maybe<Scalars['String']['output']>;
  entities?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  hasCompleteDataInPeriod?: Maybe<Scalars['Boolean']['output']>;
  hireDates?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  managerIds?: Maybe<Scalars['String']['output']>;
  managerNames?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  periodName?: Maybe<PeriodName>;
  salaryCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  stockCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  terminationDates?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<Scalars['String']['output']>;
  totalCompensationCents?: Maybe<Scalars['BigInt']['output']>;
};

export type AscWageAvgAggregate = {
  __typename?: 'AscWageAvgAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
  capitalizedSalaryCompensationCents?: Maybe<Scalars['Float']['output']>;
  capitalizedStockCompensationCents?: Maybe<Scalars['Float']['output']>;
  capitalizedTotalCompensationCents?: Maybe<Scalars['Float']['output']>;
  salaryCompensationCents?: Maybe<Scalars['Float']['output']>;
  stockCompensationCents?: Maybe<Scalars['Float']['output']>;
  totalCompensationCents?: Maybe<Scalars['Float']['output']>;
};

export type AscWageConnection = {
  __typename?: 'AscWageConnection';
  /** Array of edges. */
  edges: Array<AscWageEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AscWageCountAggregate = {
  __typename?: 'AscWageCountAggregate';
  allocationPercent?: Maybe<Scalars['Int']['output']>;
  capitalizedSalaryCompensationCents?: Maybe<Scalars['Int']['output']>;
  capitalizedStockCompensationCents?: Maybe<Scalars['Int']['output']>;
  capitalizedTotalCompensationCents?: Maybe<Scalars['Int']['output']>;
  contributorId?: Maybe<Scalars['Int']['output']>;
  costCenters?: Maybe<Scalars['Int']['output']>;
  countries?: Maybe<Scalars['Int']['output']>;
  departments?: Maybe<Scalars['Int']['output']>;
  employeeIds?: Maybe<Scalars['Int']['output']>;
  entities?: Maybe<Scalars['Int']['output']>;
  fiscalYearId?: Maybe<Scalars['Int']['output']>;
  hasCompleteDataInPeriod?: Maybe<Scalars['Int']['output']>;
  hireDates?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  managerIds?: Maybe<Scalars['Int']['output']>;
  managerNames?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  periodName?: Maybe<Scalars['Int']['output']>;
  salaryCompensationCents?: Maybe<Scalars['Int']['output']>;
  stockCompensationCents?: Maybe<Scalars['Int']['output']>;
  terminationDates?: Maybe<Scalars['Int']['output']>;
  titles?: Maybe<Scalars['Int']['output']>;
  totalCompensationCents?: Maybe<Scalars['Int']['output']>;
};

export type AscWageEdge = {
  __typename?: 'AscWageEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AscWage */
  node: AscWage;
};

export type AscWageFilter = {
  allocationPercent?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<AscWageFilter>>;
  capitalizedSalaryCompensationCents?: InputMaybe<BigIntFilterComparison>;
  capitalizedStockCompensationCents?: InputMaybe<BigIntFilterComparison>;
  capitalizedTotalCompensationCents?: InputMaybe<BigIntFilterComparison>;
  contributorId?: InputMaybe<StringFieldComparison>;
  costCenters?: InputMaybe<StringFieldComparison>;
  countries?: InputMaybe<StringFieldComparison>;
  departments?: InputMaybe<StringFieldComparison>;
  employeeIds?: InputMaybe<StringFieldComparison>;
  entities?: InputMaybe<StringFieldComparison>;
  fiscalYearId?: InputMaybe<StringFieldComparison>;
  hasCompleteDataInPeriod?: InputMaybe<BooleanFieldComparison>;
  hireDates?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  managerIds?: InputMaybe<StringFieldComparison>;
  managerNames?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AscWageFilter>>;
  periodName?: InputMaybe<PeriodNameFilterComparison>;
  salaryCompensationCents?: InputMaybe<BigIntFilterComparison>;
  stockCompensationCents?: InputMaybe<BigIntFilterComparison>;
  terminationDates?: InputMaybe<StringFieldComparison>;
  titles?: InputMaybe<StringFieldComparison>;
  totalCompensationCents?: InputMaybe<BigIntFilterComparison>;
};

export type AscWageMaxAggregate = {
  __typename?: 'AscWageMaxAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
  capitalizedSalaryCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  capitalizedStockCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  capitalizedTotalCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  contributorId?: Maybe<Scalars['String']['output']>;
  costCenters?: Maybe<Scalars['String']['output']>;
  countries?: Maybe<Scalars['String']['output']>;
  departments?: Maybe<Scalars['String']['output']>;
  employeeIds?: Maybe<Scalars['String']['output']>;
  entities?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  hireDates?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  managerIds?: Maybe<Scalars['String']['output']>;
  managerNames?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  periodName?: Maybe<PeriodName>;
  salaryCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  stockCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  terminationDates?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<Scalars['String']['output']>;
  totalCompensationCents?: Maybe<Scalars['BigInt']['output']>;
};

export type AscWageMinAggregate = {
  __typename?: 'AscWageMinAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
  capitalizedSalaryCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  capitalizedStockCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  capitalizedTotalCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  contributorId?: Maybe<Scalars['String']['output']>;
  costCenters?: Maybe<Scalars['String']['output']>;
  countries?: Maybe<Scalars['String']['output']>;
  departments?: Maybe<Scalars['String']['output']>;
  employeeIds?: Maybe<Scalars['String']['output']>;
  entities?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  hireDates?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  managerIds?: Maybe<Scalars['String']['output']>;
  managerNames?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  periodName?: Maybe<PeriodName>;
  salaryCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  stockCompensationCents?: Maybe<Scalars['BigInt']['output']>;
  terminationDates?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<Scalars['String']['output']>;
  totalCompensationCents?: Maybe<Scalars['BigInt']['output']>;
};

export type AscWageReportResult = {
  __typename?: 'AscWageReportResult';
  signedUrl: Scalars['String']['output'];
};

export type AscWageSort = {
  direction: SortDirection;
  field: AscWageSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AscWageSortFields {
  AllocationPercent = 'allocationPercent',
  CapitalizedSalaryCompensationCents = 'capitalizedSalaryCompensationCents',
  CapitalizedStockCompensationCents = 'capitalizedStockCompensationCents',
  CapitalizedTotalCompensationCents = 'capitalizedTotalCompensationCents',
  ContributorId = 'contributorId',
  CostCenters = 'costCenters',
  Countries = 'countries',
  Departments = 'departments',
  EmployeeIds = 'employeeIds',
  Entities = 'entities',
  FiscalYearId = 'fiscalYearId',
  HasCompleteDataInPeriod = 'hasCompleteDataInPeriod',
  HireDates = 'hireDates',
  Id = 'id',
  ManagerIds = 'managerIds',
  ManagerNames = 'managerNames',
  Name = 'name',
  PeriodName = 'periodName',
  SalaryCompensationCents = 'salaryCompensationCents',
  StockCompensationCents = 'stockCompensationCents',
  TerminationDates = 'terminationDates',
  Titles = 'titles',
  TotalCompensationCents = 'totalCompensationCents',
}

export type AscWageSumAggregate = {
  __typename?: 'AscWageSumAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
  capitalizedSalaryCompensationCents?: Maybe<Scalars['Float']['output']>;
  capitalizedStockCompensationCents?: Maybe<Scalars['Float']['output']>;
  capitalizedTotalCompensationCents?: Maybe<Scalars['Float']['output']>;
  salaryCompensationCents?: Maybe<Scalars['Float']['output']>;
  stockCompensationCents?: Maybe<Scalars['Float']['output']>;
  totalCompensationCents?: Maybe<Scalars['Float']['output']>;
};

export type AscWageSummary = {
  __typename?: 'AscWageSummary';
  avg?: Maybe<AscWageAvgAggregate>;
  count?: Maybe<AscWageCountAggregate>;
  groupBy?: Maybe<AscWageAggregateGroupBy>;
  max?: Maybe<AscWageMaxAggregate>;
  min?: Maybe<AscWageMinAggregate>;
  sum?: Maybe<AscWageSumAggregate>;
  uniqueCount?: Maybe<AscWageUniqueCountAggregate>;
};

export type AscWageSummaryFilter = {
  allocationPercent?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<AscWageAggregateFilter>>;
  capitalizedSalaryCompensationCents?: InputMaybe<BigIntFilterComparison>;
  capitalizedStockCompensationCents?: InputMaybe<BigIntFilterComparison>;
  capitalizedTotalCompensationCents?: InputMaybe<BigIntFilterComparison>;
  contributorId?: InputMaybe<StringFieldComparison>;
  costCenters?: InputMaybe<StringFieldComparison>;
  countries?: InputMaybe<StringFieldComparison>;
  departments?: InputMaybe<StringFieldComparison>;
  employeeIds?: InputMaybe<StringFieldComparison>;
  entities?: InputMaybe<StringFieldComparison>;
  fiscalYearId?: InputMaybe<StringFieldComparison>;
  hasCompleteDataInPeriod?: InputMaybe<BooleanFieldComparison>;
  hireDates?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  managerIds?: InputMaybe<StringFieldComparison>;
  managerNames?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AscWageAggregateFilter>>;
  periodName?: InputMaybe<PeriodNameFilterComparison>;
  salaryCompensationCents?: InputMaybe<BigIntFilterComparison>;
  stockCompensationCents?: InputMaybe<BigIntFilterComparison>;
  terminationDates?: InputMaybe<StringFieldComparison>;
  titles?: InputMaybe<StringFieldComparison>;
  totalCompensationCents?: InputMaybe<BigIntFilterComparison>;
};

export type AscWageUniqueCountAggregate = {
  __typename?: 'AscWageUniqueCountAggregate';
  countries: Scalars['Int']['output'];
  departments: Scalars['Int']['output'];
  titles: Scalars['Int']['output'];
};

export type BackgroundOperation = {
  __typename?: 'BackgroundOperation';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: BackgroundOperationName;
  progressPercent: Scalars['Int']['output'];
};

export enum BackgroundOperationName {
  ApplyGithubEmailMappingOperation = 'APPLY_GITHUB_EMAIL_MAPPING_OPERATION',
  ApplyRdSupervisorAllocationOperation = 'APPLY_RD_SUPERVISOR_ALLOCATION_OPERATION',
  BulkRecalculateAscAllocationsOperation = 'BULK_RECALCULATE_ASC_ALLOCATIONS_OPERATION',
  BulkRecalculateRdAllocationsOperation = 'BULK_RECALCULATE_RD_ALLOCATIONS_OPERATION',
  GenerateAscReportOperation = 'GENERATE_ASC_REPORT_OPERATION',
  GenerateFederalRdWriteupOperation = 'GENERATE_FEDERAL_RD_WRITEUP_OPERATION',
  GenerateRdFromTimesheetsOperation = 'GENERATE_RD_FROM_TIMESHEETS_OPERATION',
  GenerateRdProjectsReportOperation = 'GENERATE_RD_PROJECTS_REPORT_OPERATION',
  ImportAscCostFileOperation = 'IMPORT_ASC_COST_FILE_OPERATION',
  ImportAscProjectsFileOperation = 'IMPORT_ASC_PROJECTS_FILE_OPERATION',
  ImportRdBusinessComponentsFileOperation = 'IMPORT_RD_BUSINESS_COMPONENTS_FILE_OPERATION',
  ImportRdCostFileOperation = 'IMPORT_RD_COST_FILE_OPERATION',
  ImportRdProjectsFileOperation = 'IMPORT_RD_PROJECTS_FILE_OPERATION',
  ImportTimesheetFileOperation = 'IMPORT_TIMESHEET_FILE_OPERATION',
  MergeRdProjectsOperation = 'MERGE_RD_PROJECTS_OPERATION',
  RegenerateRdProjectDetailsOperation = 'REGENERATE_RD_PROJECT_DETAILS_OPERATION',
  ResyncTicketingDataOperation = 'RESYNC_TICKETING_DATA_OPERATION',
  SyncTicketingDataOperation = 'SYNC_TICKETING_DATA_OPERATION',
  ValidateTicketingFileOperation = 'VALIDATE_TICKETING_FILE_OPERATION',
}

export type BatchUpdateAscProjectCapitalizableProjectClusteringOverrideInput = {
  updates: Array<CapitalizableProjectClusteringOverrideEntry>;
};

export type BigIntFilterComparison = {
  eq?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  iLike?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['BigInt']['input']>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  neq?: InputMaybe<Scalars['BigInt']['input']>;
  notILike?: InputMaybe<Scalars['BigInt']['input']>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  notLike?: InputMaybe<Scalars['BigInt']['input']>;
};

export type BooleanFieldComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkDeleteAscProjectsResult = {
  __typename?: 'BulkDeleteAscProjectsResult';
  pmasDeleted: Scalars['Int']['output'];
  projectsDeleted: Scalars['Int']['output'];
  ticketsUnassigned: Scalars['Int']['output'];
};

export type BulkDeleteEmptyRdProjectsResult = {
  __typename?: 'BulkDeleteEmptyRdProjectsResult';
  deletedProjectIds: Array<Scalars['ID']['output']>;
  excludedEmptyProjectIds: Array<Scalars['ID']['output']>;
  totalExcludedEmptyProjects: Scalars['Int']['output'];
  totalProjectsDeleted: Scalars['Int']['output'];
};

export type BulkTicketingDataFileUpload = {
  __typename?: 'BulkTicketingDataFileUpload';
  createdAt: Scalars['Date']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isValid?: Maybe<Scalars['Boolean']['output']>;
  payrollMonthExpenseSyncEventId?: Maybe<Scalars['ID']['output']>;
  payrollProviderSyncEventId?: Maybe<Scalars['ID']['output']>;
  period?: Maybe<MonthYearPeriod>;
  signedUrl: Scalars['String']['output'];
  ticketingEntityType: TicketingEntityType;
  ticketingProvider: FileUploadTicketingProvider;
};

export type BulkUpdateRdProjectsProductByCsvResult = {
  __typename?: 'BulkUpdateRdProjectsProductByCsvResult';
  productsCreated: Scalars['Int']['output'];
  rdProjectsUpdated: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type BusinessComponentParams = {
  __typename?: 'BusinessComponentParams';
  maxExpectedProjectsOverride: Scalars['Int']['output'];
  maxTicketShareOverride: Scalars['Float']['output'];
  minExpectedProjectsOverride: Scalars['Int']['output'];
};

export type BusinessComponentParamsInput = {
  maxExpectedProjectsOverride: Scalars['Int']['input'];
  maxTicketShareOverride: Scalars['Float']['input'];
  minExpectedProjectsOverride: Scalars['Int']['input'];
};

export type BusinessQuestions = {
  __typename?: 'BusinessQuestions';
  /** @deprecated This field is deprecated, we use sync period when triggering the sync flows instead */
  firstDayOfTicketingSyncPeriod?: Maybe<Scalars['String']['output']>;
  fiscalYearEndMonth?: Maybe<Scalars['Int']['output']>;
  gustoCompanyId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is deprecated, we use sync period when triggering the sync flows instead */
  lastDayOfTicketingSyncPeriod?: Maybe<Scalars['String']['output']>;
};

export enum CaSredDataCleaningStrategy {
  Full = 'FULL',
  Incremental = 'INCREMENTAL',
}

export type CaSredSyncConfigurationInput = {
  dataCleaningStrategy: CaSredDataCleaningStrategy;
  maxNumberOfClusters: Scalars['Int']['input'];
  minNumberOfClusters: Scalars['Int']['input'];
  minNumberOfTicketsPerCluster: Scalars['Int']['input'];
  usePartitionByWorkstream: Scalars['Boolean']['input'];
};

export type CaSredSyncConfigurationRo = {
  __typename?: 'CaSredSyncConfigurationRo';
  companyId: Scalars['ID']['output'];
  dataCleaningStrategy: CaSredDataCleaningStrategy;
  id: Scalars['ID']['output'];
  maxNumberOfClusters: Scalars['Int']['output'];
  minNumberOfClusters: Scalars['Int']['output'];
  minNumberOfTicketsPerCluster: Scalars['Int']['output'];
  usePartitionByWorkstream: Scalars['Boolean']['output'];
};

export enum CaWageType {
  T4 = 'T4',
  T4A = 'T4A',
}

export type CaWageTypeFilterComparison = {
  eq?: InputMaybe<CaWageType>;
  gt?: InputMaybe<CaWageType>;
  gte?: InputMaybe<CaWageType>;
  iLike?: InputMaybe<CaWageType>;
  in?: InputMaybe<Array<CaWageType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<CaWageType>;
  lt?: InputMaybe<CaWageType>;
  lte?: InputMaybe<CaWageType>;
  neq?: InputMaybe<CaWageType>;
  notILike?: InputMaybe<CaWageType>;
  notIn?: InputMaybe<Array<CaWageType>>;
  notLike?: InputMaybe<CaWageType>;
};

export type CalculateAllocationsRdResult = {
  __typename?: 'CalculateAllocationsRdResult';
  rdExpenseProjectsDeleted: Scalars['Int']['output'];
  rdExpenseProjectsInserted: Scalars['Int']['output'];
  rdExpenseProjectsUpdated: Scalars['Int']['output'];
};

export enum CapitalizableProjectClusteringOverride {
  Excluded = 'EXCLUDED',
  Included = 'INCLUDED',
}

export type CapitalizableProjectClusteringOverrideEntry = {
  /** INCLUDED, EXCLUDED, or null to reset to default capitalization rule */
  override?: InputMaybe<CapitalizableProjectClusteringOverride>;
  projectId: Scalars['ID']['input'];
};

export type CapitalizableProjectClusteringOverrideFilterComparison = {
  eq?: InputMaybe<CapitalizableProjectClusteringOverride>;
  gt?: InputMaybe<CapitalizableProjectClusteringOverride>;
  gte?: InputMaybe<CapitalizableProjectClusteringOverride>;
  iLike?: InputMaybe<CapitalizableProjectClusteringOverride>;
  in?: InputMaybe<Array<CapitalizableProjectClusteringOverride>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<CapitalizableProjectClusteringOverride>;
  lt?: InputMaybe<CapitalizableProjectClusteringOverride>;
  lte?: InputMaybe<CapitalizableProjectClusteringOverride>;
  neq?: InputMaybe<CapitalizableProjectClusteringOverride>;
  notILike?: InputMaybe<CapitalizableProjectClusteringOverride>;
  notIn?: InputMaybe<Array<CapitalizableProjectClusteringOverride>>;
  notLike?: InputMaybe<CapitalizableProjectClusteringOverride>;
};

export enum CapitalizationStatus {
  Capitalized = 'CAPITALIZED',
  Expensed = 'EXPENSED',
  NotCapitalized = 'NOT_CAPITALIZED',
}

export type CapitalizationStatusFilterComparison = {
  eq?: InputMaybe<CapitalizationStatus>;
  gt?: InputMaybe<CapitalizationStatus>;
  gte?: InputMaybe<CapitalizationStatus>;
  iLike?: InputMaybe<CapitalizationStatus>;
  in?: InputMaybe<Array<CapitalizationStatus>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<CapitalizationStatus>;
  lt?: InputMaybe<CapitalizationStatus>;
  lte?: InputMaybe<CapitalizationStatus>;
  neq?: InputMaybe<CapitalizationStatus>;
  notILike?: InputMaybe<CapitalizationStatus>;
  notIn?: InputMaybe<Array<CapitalizationStatus>>;
  notLike?: InputMaybe<CapitalizationStatus>;
};

export type ChangeSentinelEmailScopeInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  scope: SentinelEmailScope;
};

export enum ChoiceCode {
  ApiDocumentation = 'API_DOCUMENTATION',
  ApiLogs = 'API_LOGS',
  ArchitectureDiagrams = 'ARCHITECTURE_DIAGRAMS',
  Biology = 'BIOLOGY',
  BCorporation = 'B_CORPORATION',
  Chemistry = 'CHEMISTRY',
  CloudComputingLogs = 'CLOUD_COMPUTING_LOGS',
  CommitLogs = 'COMMIT_LOGS',
  ComputationalDocumentation = 'COMPUTATIONAL_DOCUMENTATION',
  ComputerScience = 'COMPUTER_SCIENCE',
  ConceptDrawings = 'CONCEPT_DRAWINGS',
  Consolidated = 'CONSOLIDATED',
  Contract = 'CONTRACT',
  CCorporation = 'C_CORPORATION',
  DesignPrototypes = 'DESIGN_PROTOTYPES',
  Emails = 'EMAILS',
  EmployeeCalendars = 'EMPLOYEE_CALENDARS',
  Engineering = 'ENGINEERING',
  FreeForm = 'FREE_FORM',
  GanttCharts = 'GANTT_CHARTS',
  Grant = 'GRANT',
  LabTestResults = 'LAB_TEST_RESULTS',
  LlcAsCCorporation = 'LLC_AS_C_CORPORATION',
  LlcAsPartnership = 'LLC_AS_PARTNERSHIP',
  LlcAsSoleProprietorship = 'LLC_AS_SOLE_PROPRIETORSHIP',
  LlcAsSCorporation = 'LLC_AS_S_CORPORATION',
  MeetingAgenda = 'MEETING_AGENDA',
  MeetingMinutes = 'MEETING_MINUTES',
  Mockups = 'MOCKUPS',
  No = 'NO',
  Other = 'OTHER',
  Partnership = 'PARTNERSHIP',
  Patents = 'PATENTS',
  Physics = 'PHYSICS',
  ProcessCharts = 'PROCESS_CHARTS',
  ProjectManagementSoftware = 'PROJECT_MANAGEMENT_SOFTWARE',
  PrototypeBuildSheets = 'PROTOTYPE_BUILD_SHEETS',
  PullRequests = 'PULL_REQUESTS',
  ReleaseNotes = 'RELEASE_NOTES',
  ResearchPapers = 'RESEARCH_PAPERS',
  Sbir = 'SBIR',
  Separate = 'SEPARATE',
  SoftwareSourceCode = 'SOFTWARE_SOURCE_CODE',
  SCorporation = 'S_CORPORATION',
  WhitePapers = 'WHITE_PAPERS',
  Yes = 'YES',
}

export enum ClientReportableLoginMethod {
  EmailPassword = 'EMAIL_PASSWORD',
  GoogleSso = 'GOOGLE_SSO',
  IntuitSso = 'INTUIT_SSO',
  MagicLink = 'MAGIC_LINK',
  MicrosoftSso = 'MICROSOFT_SSO',
  Oidc = 'OIDC',
  Other = 'OTHER',
  Saml = 'SAML',
}

export enum ClusteringMethod {
  CapitalizableProject = 'CAPITALIZABLE_PROJECT',
  Deterministic = 'DETERMINISTIC',
  Smart = 'SMART',
}

export enum ClusteringMode {
  BusinessComponent = 'BUSINESS_COMPONENT',
  Smart = 'SMART',
}

export type CombineContributorInput = {
  sourceContributorId: Scalars['ID']['input'];
  /** This is the target contributor, that will maintain all properties and be given the relations of the reference contributor defined in the input object. */
  targetContributorId: Scalars['ID']['input'];
};

export type Company = {
  __typename?: 'Company';
  accountingTokens: Array<AccountingToken>;
  approvedForLlmTraining: Scalars['Boolean']['output'];
  approvedForOtherAiTraining: Scalars['Boolean']['output'];
  ascLockedUntilMonthYear?: Maybe<Scalars['String']['output']>;
  bulkPriorYearTaxDocumentUploads: Array<FileUpload>;
  bulkTicketingDataUploads: Array<BulkTicketingDataFileUpload>;
  businessQuestions: BusinessQuestions;
  companyCreationType: CompanyCreationType;
  fiscalYears: Array<FiscalYear>;
  fuzzyMatchThreshold: Scalars['Float']['output'];
  gitHubAppAvailable: Scalars['Boolean']['output'];
  githubEmailMappingUploads: Array<FileUpload>;
  id: Scalars['ID']['output'];
  invitedMembers: Array<CompanyInvitation>;
  isPiiRedacted: Scalars['Boolean']['output'];
  /** ISO date (YYYY-MM-DD) of the last completed ASC sync period end. Cap-end dates in/after this month are auto-set artifacts of that sync that may still extend — the capitalizable project clustering matching-target rule treats such projects as active. */
  lastCompletedAscSyncPeriodEnd?: Maybe<Scalars['String']['output']>;
  legalName: Scalars['String']['output'];
  llmProvider: LlmProvider;
  members: Array<User>;
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  payrollTokens: Array<PayrollToken>;
  /** null for any user without financial permissions */
  priorYearQREs?: Maybe<Array<PriorYearQre>>;
  priorYearRevenues: Array<PriorYearRevenue>;
  questionSections: Array<QuestionSection>;
  questions: Array<Question>;
  rdContributorCombineLimit: Scalars['Int']['output'];
  shortName: Scalars['String']['output'];
  syncConfigurationAsc?: Maybe<AscSyncConfiguration>;
  syncConfigurationRd?: Maybe<SyncConfigurationRd>;
  syncedPayrollMonthExpense: Array<SyncedPayrollMonthExpense>;
  syncedTicketingProviders: Array<TicketingProvider>;
  ticketingTokens: Array<TicketingToken>;
  timesheetUploads: Array<FileUpload>;
};

export enum CompanyCreationType {
  Demo = 'DEMO',
  Real = 'REAL',
  Test = 'TEST',
}

export type CompanyInvitation = {
  __typename?: 'CompanyInvitation';
  acceptedAt?: Maybe<Scalars['Date']['output']>;
  company: Company;
  companyId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  scope: CompanyScope;
};

export type CompanyQuestionInput = {
  /** The values to set for this `Question` for this `Company`. The exact semantics depend on the `Question`. For a `Question` which has `questionChoices`, the `answerValues` should be the `ChoiceCode`s of any selected choices; for any other `Question`, the `answerValues` should be the text typed or picked by the user. Also, some question types support more than one `answerValues`, while other `Question`s must provide at most one. */
  answerValues: Array<Scalars['String']['input']>;
  answeredUtcDatetime: Scalars['String']['input'];
  questionId: Scalars['ID']['input'];
};

export type CompanyQuestionsInput = {
  fiscalYearEndMonth?: InputMaybe<Scalars['Int']['input']>;
  priorYearQREs?: InputMaybe<Array<PriorYearQreInput>>;
  priorYearRevenues?: InputMaybe<Array<PriorYearRevenueInput>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum CompanyScope {
  CompanyMember = 'COMPANY_MEMBER',
  NonFinancial = 'NON_FINANCIAL',
}

export type CompanyScopes = {
  __typename?: 'CompanyScopes';
  companyId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  scope: CompanyScope;
};

export type CompanySearchInput = {
  companyCreationTypes?: InputMaybe<Array<CompanyCreationType>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  organizationNamePrefix?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type Contributor = {
  __typename?: 'Contributor';
  ascProjectsPerContributor: Array<AscProjectPerContributor>;
  emails: Array<Scalars['String']['output']>;
  /** @deprecated Replace with a resolved field that returns an array of linked accounts */
  hasLinkedTpUsers: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ticketingProviderUsers: Array<TicketingProviderUser>;
};

export type ContributorAscProjectsPerContributorArgs = {
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type CreateAscProjectInput = {
  customFieldLaunchDate?: InputMaybe<Scalars['Date']['input']>;
  customFieldTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateCompanyForOrganizationInput = {
  companyName: Scalars['String']['input'];
  fiscalYearEndMonth: Scalars['Int']['input'];
};

export type CreateContributorInput = {
  name: Scalars['String']['input'];
};

export type CreateFiscalYearInput = {
  fiscalYearPeriod: MonthYearPeriodInput;
  /** Whether the fiscal year is enabled. If true, enabledDatetime will be set to the current time. */
  isEnabled: Scalars['Boolean']['input'];
  productType: ProductType;
};

export type CreateGitHubAppAuthorizationUrlInput = {
  companyId: Scalars['String']['input'];
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGitHubAppInstallUrlInput = {
  companyId: Scalars['String']['input'];
  organizationSlug: Scalars['String']['input'];
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMergeDevAccessTokenForAccountingInput = {
  accountingProvider: MergeDevAccountingProvider;
  companyId: Scalars['String']['input'];
  mergeDevPublicToken: Scalars['String']['input'];
};

export type CreateMergeDevAccessTokenForTicketingInput = {
  companyId: Scalars['String']['input'];
  mergeDevPublicToken: Scalars['String']['input'];
  ticketingProvider: TicketingProvider;
};

export type CreateProductInput = {
  ascProjectId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  rdProjectId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateRdProjectInput = {
  aiGuidance?: InputMaybe<Scalars['String']['input']>;
  approvalComment?: InputMaybe<Scalars['String']['input']>;
  approvalTime?: InputMaybe<Scalars['String']['input']>;
  businessComponent?: InputMaybe<ProjectBusinessComponent>;
  businessPurpose?: InputMaybe<ProjectBusinessPurpose>;
  clusterType?: InputMaybe<RdClusterType>;
  consideredForRd?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  disallowances?: InputMaybe<Array<ProjectDisallowance>>;
  fiscalYearId?: InputMaybe<Scalars['String']['input']>;
  improvedAspects?: InputMaybe<Array<ProjectPurposeImprovedAspect>>;
  isCustomerFacingDevelopment?: InputMaybe<Scalars['Boolean']['input']>;
  isInnovativeAndRisky?: InputMaybe<Scalars['Boolean']['input']>;
  isSection174Eligible?: InputMaybe<Scalars['Boolean']['input']>;
  isTechnicallyUncertain?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  processOfExperimentation?: InputMaybe<Scalars['String']['input']>;
  processingState?: InputMaybe<ProcessingProjectState>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  projectOwnerId?: InputMaybe<Scalars['ID']['input']>;
  projectOwnerName?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<ProjectPurpose>;
  rdDocumentationStatus?: InputMaybe<RdDocumentationStatus>;
  selectedCategory?: InputMaybe<SelectedRdProjectCategory>;
  technicalChallenges?: InputMaybe<Scalars['String']['input']>;
  ticketCount?: InputMaybe<Scalars['Int']['input']>;
  workstreamNames?: InputMaybe<Array<Scalars['String']['input']>>;
  workstreamNamesSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CreateScheduledBackgroundOperationInput = {
  notifySlack?: Scalars['Boolean']['input'];
  operationType: ScheduledBackgroundOperationType;
  runAt: Scalars['String']['input'];
  syncTicketingData?: InputMaybe<ScheduleSyncTicketingDataInput>;
};

export type CreateSingleTenantDomainRedirectInput = {
  emailDomain: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type CreatorRdWageAllocationResult = {
  __typename?: 'CreatorRdWageAllocationResult';
  cappedEmployeeNames: Array<Scalars['String']['output']>;
  changelogCsvData: Scalars['String']['output'];
  duplicateCreatorRdRowNames: Array<Scalars['String']['output']>;
  skippedAmountEmployeeNames: Array<Scalars['String']['output']>;
  unallocatedEmployeeNames: Array<Scalars['String']['output']>;
  unchangedEmployeeNames: Array<Scalars['String']['output']>;
  unmatchedEmployeeNames: Array<Scalars['String']['output']>;
  updatedEmployeeNames: Array<Scalars['String']['output']>;
  wageExcelData: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type CreditEstimate = Form6765Values | MissingValue;

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomFieldCapitalizationMapping = {
  __typename?: 'CustomFieldCapitalizationMapping';
  capitalizationStatus: CapitalizationStatus;
  id: Scalars['ID']['output'];
  matcher: Scalars['String']['output'];
};

export type CustomFieldCapitalizationMappingInput = {
  capitalizationStatus: CapitalizationStatus;
  matcher: Scalars['String']['input'];
};

export enum DataCleaningStrategy {
  Full = 'FULL',
  Incremental = 'INCREMENTAL',
}

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type DeleteAccountingSyncEventForFiscalYearResult = {
  __typename?: 'DeleteAccountingSyncEventForFiscalYearResult';
  deletedAccountingProviderSyncEventId: Scalars['String']['output'];
};

export type DeleteAccountingTokensResult = {
  __typename?: 'DeleteAccountingTokensResult';
  ids: Array<Scalars['String']['output']>;
};

export type DeleteFirebaseIdentityInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};

export type DeletePayrollMonthExpenseSyncEventResult = {
  __typename?: 'DeletePayrollMonthExpenseSyncEventResult';
  deletedPayrollMonthExpenseSyncEventId: Scalars['String']['output'];
};

export type DeletePayrollSyncEventForFiscalYearResult = {
  __typename?: 'DeletePayrollSyncEventForFiscalYearResult';
  deletedPayrollProviderSyncEventId: Scalars['String']['output'];
};

export type DeletePayrollTokensResult = {
  __typename?: 'DeletePayrollTokensResult';
  ids: Array<Scalars['String']['output']>;
};

export type DemoAccountInitialization = {
  __typename?: 'DemoAccountInitialization';
  companyId: Scalars['ID']['output'];
  /** The created company name, including the " - DEMO" suffix. */
  companyName: Scalars['String']['output'];
  counts: DemoBundleCounts;
};

export type DemoAccountReadiness = {
  __typename?: 'DemoAccountReadiness';
  /** How many of those projects have a completed §41 evaluation. */
  projectsEvaluated: Scalars['Int']['output'];
  /** Total imported projects in the demo account. */
  projectsTotal: Scalars['Int']['output'];
  /** True once all projects are evaluated — the demo is presentable. */
  ready: Scalars['Boolean']['output'];
};

export type DemoBundleConflict = {
  __typename?: 'DemoBundleConflict';
  existingCompanyId: Scalars['ID']['output'];
  existingCompanyName: Scalars['String']['output'];
};

export type DemoBundleCounts = {
  __typename?: 'DemoBundleCounts';
  allocations: Scalars['Int']['output'];
  employees: Scalars['Int']['output'];
  patents: Scalars['Int']['output'];
  projects: Scalars['Int']['output'];
};

export type DemoBundleIdentity = {
  __typename?: 'DemoBundleIdentity';
  companyName: Scalars['String']['output'];
  taxYear: Scalars['Int']['output'];
  website: Scalars['String']['output'];
};

export type DemoBundlePreflightReport = {
  __typename?: 'DemoBundlePreflightReport';
  /** Set when a demo for this company already exists in the org; requires a replace/keep-both choice. */
  conflict?: Maybe<DemoBundleConflict>;
  counts: DemoBundleCounts;
  /** Complete list of validation errors; empty when valid. */
  errors: Array<Scalars['String']['output']>;
  identity?: Maybe<DemoBundleIdentity>;
  valid: Scalars['Boolean']['output'];
};

export enum DemoConflictResolution {
  KeepBoth = 'KEEP_BOTH',
  Replace = 'REPLACE',
}

export enum DeterminationSource {
  AiGenerated = 'AI_GENERATED',
  UserOverridden = 'USER_OVERRIDDEN',
}

export enum DeterministicClusteringObjectLevel {
  Epic = 'Epic',
  Initiative = 'Initiative',
  InitiativeAndEpic = 'InitiativeAndEpic',
}

export type DisconnectTicketingTokenOutput = {
  __typename?: 'DisconnectTicketingTokenOutput';
  scheduledSyncsCancelled: Scalars['Int']['output'];
  ticketingTokenId: Scalars['ID']['output'];
};

export enum DistributedFlowDag {
  ApplyGithubEmailMapping = 'APPLY_GITHUB_EMAIL_MAPPING',
  ApplyRdSupervisorAllocation = 'APPLY_RD_SUPERVISOR_ALLOCATION',
  BulkRecalculateAscAllocations = 'BULK_RECALCULATE_ASC_ALLOCATIONS',
  BulkRecalculateRdAllocations = 'BULK_RECALCULATE_RD_ALLOCATIONS',
  CalculateAllocations = 'CALCULATE_ALLOCATIONS',
  CalculateAllocationsAsc = 'CALCULATE_ALLOCATIONS_ASC',
  CalculateAllocationsRd = 'CALCULATE_ALLOCATIONS_RD',
  CarryForwardAscHr = 'CARRY_FORWARD_ASC_HR',
  CreateGaapTickets = 'CREATE_GAAP_TICKETS',
  DetermineAscCapitalization = 'DETERMINE_ASC_CAPITALIZATION',
  DetermineRdEligibility = 'DETERMINE_RD_ELIGIBILITY',
  FeaturizeTicketsRd = 'FEATURIZE_TICKETS_RD',
  GenerateAscReport = 'GENERATE_ASC_REPORT',
  GenerateAscSnapshot = 'GENERATE_ASC_SNAPSHOT',
  GenerateBusinessComponentsRd = 'GENERATE_BUSINESS_COMPONENTS_RD',
  GenerateClusterPartitions = 'GENERATE_CLUSTER_PARTITIONS',
  GenerateFederalRdWriteup = 'GENERATE_FEDERAL_RD_WRITEUP',
  GenerateProjectsAsc = 'GENERATE_PROJECTS_ASC',
  GenerateProjectsForClusters = 'GENERATE_PROJECTS_FOR_CLUSTERS',
  GenerateProjectsFromBusinessComponentsRd = 'GENERATE_PROJECTS_FROM_BUSINESS_COMPONENTS_RD',
  GenerateProjectsRd = 'GENERATE_PROJECTS_RD',
  GenerateRdFromTimesheets = 'GENERATE_RD_FROM_TIMESHEETS',
  GenerateRdProjectsReport = 'GENERATE_RD_PROJECTS_REPORT',
  GenerateTicketClusters = 'GENERATE_TICKET_CLUSTERS',
  GenerateTicketClustersAsc = 'GENERATE_TICKET_CLUSTERS_ASC',
  GenerateTicketClustersRd = 'GENERATE_TICKET_CLUSTERS_RD',
  GenerateTicketPartitionsAsc = 'GENERATE_TICKET_PARTITIONS_ASC',
  GenerateTicketPartitionsRd = 'GENERATE_TICKET_PARTITIONS_RD',
  ImportAscCostFile = 'IMPORT_ASC_COST_FILE',
  ImportAscProjectsFile = 'IMPORT_ASC_PROJECTS_FILE',
  ImportRdBusinessComponentsFile = 'IMPORT_RD_BUSINESS_COMPONENTS_FILE',
  ImportRdCostFile = 'IMPORT_RD_COST_FILE',
  ImportRdProjectsFile = 'IMPORT_RD_PROJECTS_FILE',
  ImportTimesheetFile = 'IMPORT_TIMESHEET_FILE',
  MergeRdProjects = 'MERGE_RD_PROJECTS',
  ReconcileTicketingProviderUsersForAsc = 'RECONCILE_TICKETING_PROVIDER_USERS_FOR_ASC',
  ReconcileTicketingProviderUsersForRd = 'RECONCILE_TICKETING_PROVIDER_USERS_FOR_RD',
  RegenerateRdProjectDetails = 'REGENERATE_RD_PROJECT_DETAILS',
  SetupBusinessComponentsRd = 'SETUP_BUSINESS_COMPONENTS_RD',
  SetupTicketingDataAsc = 'SETUP_TICKETING_DATA_ASC',
  SyncTicketingData = 'SYNC_TICKETING_DATA',
  TicketEffortEstimationAsc = 'TICKET_EFFORT_ESTIMATION_ASC',
  TicketEffortEstimationRd = 'TICKET_EFFORT_ESTIMATION_RD',
  TicketEffortEstimationV3 = 'TICKET_EFFORT_ESTIMATION_V3',
  ValidateTicketingFile = 'VALIDATE_TICKETING_FILE',
}

export type DistributedFlowState = {
  __typename?: 'DistributedFlowState';
  backgroundOperation: BackgroundOperation;
  backgroundOperationId: Scalars['ID']['output'];
  company: Company;
  createdAt: Scalars['String']['output'];
  distributedFlowDag: DistributedFlowDag;
  id: Scalars['ID']['output'];
  isPausedDatetime?: Maybe<Scalars['Date']['output']>;
  jobExecutionStateCounts: JobExecutionStateCounts;
  jobExecutions: Array<JobExecution>;
  status: Scalars['String']['output'];
};

export type DistributedFlowStateJobExecutionsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

export type DocumentEvent = {
  __typename?: 'DocumentEvent';
  createdAt: Scalars['Date']['output'];
  documentType: DocumentType;
  eventType: DocumentEventType;
  fiscalYearId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  period: MonthYearPeriod;
  periodName: PeriodName;
  taxAuthority: TaxAuthority;
};

export enum DocumentEventType {
  ApprovedForDownload = 'APPROVED_FOR_DOWNLOAD',
  DownloadedByUser = 'DOWNLOADED_BY_USER',
  GeneratedDocument = 'GENERATED_DOCUMENT',
  GeneratedForSnapshot = 'GENERATED_FOR_SNAPSHOT',
  RevokedAccess = 'REVOKED_ACCESS',
  SentDownloadEmail = 'SENT_DOWNLOAD_EMAIL',
  SubmittedForReview = 'SUBMITTED_FOR_REVIEW',
  UploadedDocument = 'UPLOADED_DOCUMENT',
}

export type DocumentInput = {
  documentType: DocumentType;
  taxAuthority: TaxAuthority;
};

export enum DocumentStatus {
  HumanReview = 'HUMAN_REVIEW',
  MissingInformation = 'MISSING_INFORMATION',
  ReadyForDownload = 'READY_FOR_DOWNLOAD',
  ReadyToSubmit = 'READY_TO_SUBMIT',
}

export enum DocumentType {
  AscCostCsv = 'ASC_COST_CSV',
  AscProjectsReport = 'ASC_PROJECTS_REPORT',
  AscWageReport = 'ASC_WAGE_REPORT',
  GaapCapExcelReport = 'GAAP_CAP_EXCEL_REPORT',
  RdCredit = 'RD_CREDIT',
  RdCreditsReport = 'RD_CREDITS_REPORT',
  RdCreditAndCapitalizationWithInstructions = 'RD_CREDIT_AND_CAPITALIZATION_WITH_INSTRUCTIONS',
  RdCreditWithInstructions = 'RD_CREDIT_WITH_INSTRUCTIONS',
  RdExpenseProjectAllocationReport = 'RD_EXPENSE_PROJECT_ALLOCATION_REPORT',
  WriteUp = 'WRITE_UP',
}

export type Documents = {
  __typename?: 'Documents';
  federalRdTaxCreditDocuments?: Maybe<FederalRdTaxCreditDocuments>;
  form6765Values?: Maybe<Form6765Values>;
  id: Scalars['ID']['output'];
  stateRdTaxCreditDocuments: Array<StateRdTaxCreditDocument>;
  year: Scalars['Int']['output'];
};

export type ExcelParseError = {
  __typename?: 'ExcelParseError';
  column?: Maybe<Scalars['String']['output']>;
  row?: Maybe<Scalars['Int']['output']>;
  type: ExcelParseErrorType;
  value?: Maybe<Scalars['String']['output']>;
};

export enum ExcelParseErrorType {
  DisallowedValue = 'DISALLOWED_VALUE',
  DuplicatedValue = 'DUPLICATED_VALUE',
  InvalidDate = 'INVALID_DATE',
  InvalidPercentage = 'INVALID_PERCENTAGE',
  InvalidSheetCount = 'INVALID_SHEET_COUNT',
  InvalidTotalPercentage = 'INVALID_TOTAL_PERCENTAGE',
  InvalidValue = 'INVALID_VALUE',
  MissingAtLeastOneColumnHeader = 'MISSING_AT_LEAST_ONE_COLUMN_HEADER',
  MissingColumn = 'MISSING_COLUMN',
  MissingValue = 'MISSING_VALUE',
  NonNumericValue = 'NON_NUMERIC_VALUE',
  WrongTemplate = 'WRONG_TEMPLATE',
}

export enum ExpenseCategory {
  Cloud = 'CLOUD',
  Contractors = 'CONTRACTORS',
  Employee = 'EMPLOYEE',
  Legal = 'LEGAL',
  Supplies = 'SUPPLIES',
}

export type FederalDocumentStatuses = {
  __typename?: 'FederalDocumentStatuses';
  taxCreditFormStatus: DocumentStatus;
  taxWriteUpStatus: DocumentStatus;
};

export type FederalRdTaxCreditDocuments = {
  __typename?: 'FederalRdTaxCreditDocuments';
  allowAccessForm6765Datetime?: Maybe<Scalars['Date']['output']>;
  allowAccessRdWriteupDatetime?: Maybe<Scalars['Date']['output']>;
  filingMethod: FilingMethod;
  id: Scalars['ID']['output'];
  isIncomeCredit: Scalars['Boolean']['output'];
  isReducedCredit: Scalars['Boolean']['output'];
  payrollCreditFormFileName?: Maybe<Scalars['String']['output']>;
  /** null for any user without financial permissions */
  payrollCreditFormUrl?: Maybe<Scalars['String']['output']>;
  taxCreditFormFileName?: Maybe<Scalars['String']['output']>;
  taxCreditFormGeneratedDate?: Maybe<Scalars['Date']['output']>;
  taxCreditFormMissingInformation?: Maybe<Array<Scalars['String']['output']>>;
  taxCreditFormStatus: DocumentStatus;
  /** null for any user without financial permissions */
  taxCreditFormUrl?: Maybe<Scalars['String']['output']>;
  taxWriteUpGeneratedDate?: Maybe<Scalars['Date']['output']>;
  taxWriteUpMissingInformation?: Maybe<Array<Scalars['String']['output']>>;
  taxWriteUpPdfFileName?: Maybe<Scalars['String']['output']>;
  /** null for any user without financial permissions */
  taxWriteUpPdfUrl?: Maybe<Scalars['String']['output']>;
  taxWriteUpStatus: DocumentStatus;
};

export type FileUpload = {
  __typename?: 'FileUpload';
  createdAt: Scalars['Date']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isValid?: Maybe<Scalars['Boolean']['output']>;
  payrollMonthExpenseSyncEventId?: Maybe<Scalars['ID']['output']>;
  payrollProviderSyncEventId?: Maybe<Scalars['ID']['output']>;
  period?: Maybe<MonthYearPeriod>;
  signedUrl: Scalars['String']['output'];
};

export type FileUploadInput = {
  id: Scalars['ID']['input'];
};

export enum FileUploadTicketingProvider {
  Asana = 'ASANA',
  AzureDevops = 'AZURE_DEVOPS',
  GithubIssues = 'GITHUB_ISSUES',
  JiraCloud = 'JIRA_CLOUD',
  JiraDataCenter = 'JIRA_DATA_CENTER',
  Linear = 'LINEAR',
  Other = 'OTHER',
  Shortcut = 'SHORTCUT',
  Trello = 'TRELLO',
}

export enum FilingMethod {
  Asc = 'ASC',
  Regular = 'REGULAR',
}

export enum FinchScopeType {
  FullPayroll = 'FULL_PAYROLL',
  HrOnly = 'HR_ONLY',
}

export type FinchSession = {
  __typename?: 'FinchSession';
  sessionId: Scalars['String']['output'];
};

export type FirebaseIdentityAccountModel = {
  __typename?: 'FirebaseIdentityAccountModel';
  createdAt: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  lastSignInAt?: Maybe<Scalars['String']['output']>;
  providers: Array<FirebaseIdentityProviderModel>;
  uid: Scalars['String']['output'];
};

export type FirebaseIdentityModel = {
  __typename?: 'FirebaseIdentityModel';
  account?: Maybe<FirebaseIdentityAccountModel>;
  email: Scalars['String']['output'];
  enterpriseSsoExempt: Scalars['Boolean']['output'];
  firebaseUserId?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  nameMatchScore?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type FirebaseIdentityProviderModel = {
  __typename?: 'FirebaseIdentityProviderModel';
  email?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
};

export type FiscalYear = {
  __typename?: 'FiscalYear';
  companyId: Scalars['ID']['output'];
  /** Date the fiscal year was enabled, null if not enabled */
  enabledDatetime?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lockedForCustomers: Scalars['Boolean']['output'];
  /** Whether ticketing data for this fiscal year has been processed or skipped */
  processingTicketingDataState: ProcessingTicketingDataState;
  /** The product type of the fiscal year */
  productType: ProductType;
  rdTaxCredit?: Maybe<RdTaxCredit>;
  rdTaxCreditId?: Maybe<Scalars['ID']['output']>;
  sredTaxCredit?: Maybe<SredTaxCredit>;
  syncedProviders: SyncedProviders;
  syncedRdPayrollCost: Array<SyncedRdPayrollCost>;
  /** The end date of the tax year in the format YYYY-MM-DD */
  taxYearEndDate: Scalars['String']['output'];
  /** The start date of the tax year in the format YYYY-MM-DD */
  taxYearStartDate: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type FloatFieldComparison = {
  between?: InputMaybe<FloatFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notBetween?: InputMaybe<FloatFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatFieldComparisonBetween = {
  lower: Scalars['Float']['input'];
  upper: Scalars['Float']['input'];
};

export type Form6765Values = {
  __typename?: 'Form6765Values';
  ascMethodCreditCents: Scalars['BigInt']['output'];
  cloudQreCents: Scalars['BigInt']['output'];
  contractorQreCents: Scalars['BigInt']['output'];
  formLines: Array<FormLineItem>;
  id: Scalars['ID']['output'];
  isEstimateCalculation: Scalars['Boolean']['output'];
  isPayrollCreditEligible: Scalars['Boolean']['output'];
  regularMethodCreditCents: Scalars['BigInt']['output'];
  suppliesQreCents: Scalars['BigInt']['output'];
  totalQreCents: Scalars['BigInt']['output'];
  wagesQreCents: Scalars['BigInt']['output'];
  year: Scalars['Float']['output'];
};

export type FormLineItem = {
  __typename?: 'FormLineItem';
  line: Scalars['String']['output'];
  metadata?: Maybe<FormLineItemMetadata>;
  type: ValueType;
  /** this will be null for any user without financial permissions */
  value?: Maybe<Scalars['String']['output']>;
};

export type FormLineItemMetadata = {
  __typename?: 'FormLineItemMetadata';
  label?: Maybe<Scalars['String']['output']>;
  /** this will be null for any user without financial permissions */
  steps?: Maybe<Array<Scalars['String']['output']>>;
  /** this will be null for any user without financial permissions */
  valueCents?: Maybe<Scalars['Int']['output']>;
};

export type FourPartTest = {
  __typename?: 'FourPartTest';
  id: Scalars['ID']['output'];
  industries: Array<Scalars['String']['output']>;
  rdTaxCreditId: Scalars['String']['output'];
  researchActivities?: Maybe<Array<Scalars['String']['output']>>;
  tools?: Maybe<Array<Scalars['String']['output']>>;
};

export type GaapOnboardingFlowStatus = {
  __typename?: 'GaapOnboardingFlowStatus';
  percentCompleted: Scalars['Int']['output'];
};

export type GenerateAscCostCsvInput = {
  firstDayOfPeriod: Scalars['String']['input'];
  lastDayOfPeriod: Scalars['String']['input'];
};

export type GenerateRdDetailsInput = {
  overrideProjectDescription: Scalars['Boolean']['input'];
  overrideQualifiedPurposeDetermination: Scalars['Boolean']['input'];
  overrideTechnicalInNatureDetermination: Scalars['Boolean']['input'];
};

export type GetDemoBundlePreflightReportInput = {
  /** Permanent URL of the uploaded Demo Bundle zip. */
  bundlePermanentUrl: Scalars['String']['input'];
  /** Organization the demo account would be created inside. */
  organizationId: Scalars['ID']['input'];
};

export type GetMergeDevLinkTokenInput = {
  companyId: Scalars['String']['input'];
  provider: MergeDevProvider;
};

export enum GitHubInstallationStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED',
}

export type GithubTokenDetails = {
  __typename?: 'GithubTokenDetails';
  /** Organizations the token can currently see */
  observedOrganizations: Array<Scalars['String']['output']>;
  /** Organization stored on the token, if one has been written */
  storedOrganization?: Maybe<Scalars['String']['output']>;
};

export type IdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  iLike?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notILike?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notLike?: InputMaybe<Scalars['ID']['input']>;
};

export type InitializeDemoAccountInput = {
  /** Permanent URL of the uploaded Demo Bundle zip (already pre-flight validated). */
  bundlePermanentUrl: Scalars['String']['input'];
  /** Required only when a demo for this company already exists in the org: REPLACE or KEEP_BOTH. */
  conflictResolution?: InputMaybe<DemoConflictResolution>;
  /** Organization the demo account is created inside. */
  organizationId: Scalars['ID']['input'];
};

export enum InputType {
  Button = 'BUTTON',
  Checkbox = 'CHECKBOX',
  DatePicker = 'DATE_PICKER',
  Dropdown = 'DROPDOWN',
  Input = 'INPUT',
  MonthYear = 'MONTH_YEAR',
  Textarea = 'TEXTAREA',
  Upload = 'UPLOAD',
}

export type IntFieldComparison = {
  between?: InputMaybe<IntFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notBetween?: InputMaybe<IntFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntFieldComparisonBetween = {
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

/** Category of Jira custom field for capitalization configuration */
export enum JiraCustomFieldCategory {
  /** Boolean field - auto-maps true/false to CAPITALIZED/EXPENSED */
  Boolean = 'BOOLEAN',
  /** Multi-select field - configure matchers for values */
  MultiSelect = 'MULTI_SELECT',
  /** Failed to parse field schema - data issue requires investigation */
  ParseError = 'PARSE_ERROR',
  /** Single-select field - configure matchers for values */
  SingleSelect = 'SINGLE_SELECT',
  /** Text field - configure matchers for substring matching */
  String = 'STRING',
  /** Field type not supported for capitalization matching */
  Unsupported = 'UNSUPPORTED',
}

export type JiraFieldMetadata = {
  __typename?: 'JiraFieldMetadata';
  /** Category determining how this field can be used for capitalization matching */
  category: JiraCustomFieldCategory;
  /** Error message if category is PARSE_ERROR or UNSUPPORTED */
  categoryErrorMessage?: Maybe<Scalars['String']['output']>;
  /** Jira field ID (e.g., "customfield_10001") */
  fieldId: Scalars['String']['output'];
  /** Unique identifier for this field metadata record */
  id: Scalars['ID']['output'];
  /** Human-readable field name */
  name: Scalars['String']['output'];
  /** Raw field type from Jira schema (for debugging) */
  rawFieldType?: Maybe<Scalars['String']['output']>;
};

export type JobExecution = {
  __typename?: 'JobExecution';
  attemptCount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  enqueuingJobExecutionId?: Maybe<Scalars['ID']['output']>;
  fileId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  jobState: JobState;
  paginationId?: Maybe<Scalars['ID']['output']>;
  queueName: Scalars['String']['output'];
  requeueDatetime?: Maybe<Scalars['Date']['output']>;
  statusId?: Maybe<Scalars['ID']['output']>;
  taskDetails?: Maybe<TaskDetails>;
};

export type JobExecutionStateCounts = {
  __typename?: 'JobExecutionStateCounts';
  blockedCount: Scalars['Int']['output'];
  completedCount: Scalars['Int']['output'];
  failedAndDequeuedCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  queuedCount: Scalars['Int']['output'];
  runningCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum JobState {
  Blocked = 'BLOCKED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FailedAndDequeued = 'FAILED_AND_DEQUEUED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
}

export type KeyValuePairInput = {
  reportKey: ReportKey;
  value: Scalars['String']['input'];
};

export type LegacyDocuments = {
  __typename?: 'LegacyDocuments';
  federalRdTaxForm?: Maybe<LegacyFederalRdTaxCreditDocumentsRo>;
  federalRdTaxWriteUp?: Maybe<LegacyFederalRdTaxWriteUpDocumentsRo>;
  id: Scalars['ID']['output'];
  stateRdTaxCreditDocuments: Array<LegacyStateRdTaxCreditDocumentsRo>;
  year: Scalars['Int']['output'];
};

export type LegacyFederalRdTaxCreditDocumentsRo = {
  __typename?: 'LegacyFederalRdTaxCreditDocumentsRo';
  filingMethod: FilingMethod;
  isIncomeCredit: Scalars['Boolean']['output'];
  isReducedCredit?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  taxFilingId: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type LegacyFederalRdTaxWriteUpDocumentsRo = {
  __typename?: 'LegacyFederalRdTaxWriteUpDocumentsRo';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LegacyStateRdTaxCreditDocumentsRo = {
  __typename?: 'LegacyStateRdTaxCreditDocumentsRo';
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum LlmProvider {
  Modal = 'MODAL',
  Openai = 'OPENAI',
}

export type LoginAuditLog = {
  __typename?: 'LoginAuditLog';
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  isSuccessful: Scalars['Boolean']['output'];
  method: LoginAuditMethod;
  note?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  reportedByClient: Scalars['Boolean']['output'];
};

export enum LoginAuditMethod {
  AdminIdentityDeletion = 'ADMIN_IDENTITY_DELETION',
  EmailPassword = 'EMAIL_PASSWORD',
  GoogleSso = 'GOOGLE_SSO',
  IntuitSso = 'INTUIT_SSO',
  MagicLink = 'MAGIC_LINK',
  MagicLinkRequest = 'MAGIC_LINK_REQUEST',
  MicrosoftSso = 'MICROSOFT_SSO',
  Oidc = 'OIDC',
  Other = 'OTHER',
  PasswordResetRequest = 'PASSWORD_RESET_REQUEST',
  Saml = 'SAML',
}

export enum MatchingAggressiveness {
  Aggressive = 'AGGRESSIVE',
  Normal = 'NORMAL',
}

export type MergeAscProjectsInput = {
  ascProjectIds: Array<Scalars['String']['input']>;
};

export enum MergeDevAccountingProvider {
  Netsuite = 'NETSUITE',
}

export enum MergeDevProvider {
  Asana = 'ASANA',
  AzureDevops = 'AZURE_DEVOPS',
  GithubIssues = 'GITHUB_ISSUES',
  JiraCloud = 'JIRA_CLOUD',
  JiraDataCenter = 'JIRA_DATA_CENTER',
  Linear = 'LINEAR',
  Netsuite = 'NETSUITE',
  Shortcut = 'SHORTCUT',
  Trello = 'TRELLO',
}

export type MergeRdProjectsInput = {
  rdProjectIds: Array<Scalars['String']['input']>;
};

export type MergeRdProjectsResult = BackgroundOperation;

export type MissingValue = {
  __typename?: 'MissingValue';
  reason: Scalars['String']['output'];
};

export type MonthYear = {
  __typename?: 'MonthYear';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type MonthYearInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type MonthYearPeriod = {
  __typename?: 'MonthYearPeriod';
  endMonthYear: MonthYear;
  startMonthYear: MonthYear;
};

export type MonthYearPeriodInput = {
  endMonthYear: MonthYearInput;
  startMonthYear: MonthYearInput;
};

export type MoveTicketsToAscProjectInput = {
  fiscalYearId: Scalars['ID']['input'];
  /** Grouping buckets (epics / collections / no-parent) to expand into tickets for bulk move. Resolved via asc_ticket_groups scoped to sourceAscProjectId. */
  groupings: Array<AscTicketGroupingInput>;
  periodName: PeriodName;
  sourceAscProjectId: Scalars['ID']['input'];
  /** The IDs of the TicketingProviderTicket to move */
  ticketingProviderTicketIds: Array<Scalars['ID']['input']>;
};

export type MoveTicketsToAscProjectOutput = {
  __typename?: 'MoveTicketsToAscProjectOutput';
  ascProjects: Array<AscProject>;
  contributors: Array<Contributor>;
};

export type MoveTicketsToRdProjectInput = {
  groupingTicketingProviderCollectionIds: Array<Scalars['ID']['input']>;
  groupingTicketingProviderTicketIds: Array<Scalars['ID']['input']>;
  includeNoParentTickets: Scalars['Boolean']['input'];
  sourceRdProjectId: Scalars['ID']['input'];
  /** The IDs of the TicketingProviderTicket to move */
  ticketingProviderTicketIds: Array<Scalars['ID']['input']>;
};

export type MoveTicketsToRdProjectOutput = {
  __typename?: 'MoveTicketsToRdProjectOutput';
  rdProjects: Array<RdProject>;
  rdTaxCreditContributors: Array<RdTaxCreditContributor>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: OrganizationInvitation;
  addAscCostFile: Company;
  addAscProjectsFile: Company;
  addCompanyBulkTicketingDataFile: Company;
  addGithubEmailMappingFile: Company;
  addOrganizationInvitation: OrganizationInvitation;
  addPriorYearTaxDocument: Company;
  addRdBusinessComponentsFile: Company;
  addRdPayrollCostFile: Company;
  addRdProjectSupportingDocument: RdProject;
  addRdProjectsFile: Company;
  addSentinelEmail: SentinelEmail;
  addTimesheetFile: Company;
  allocateCreatorRdWagePercentages: CreatorRdWageAllocationResult;
  allowRealCompany: User;
  applySupervisorRdPercentage: BackgroundOperation;
  applyWeightedCapitalizedPercentageToContributors: ApplyWeightedCapitalizedPercentageToContributorsResult;
  applyWeightedRdPercentageToExpenses: ApplyWeightedRdPercentageToExpensesResult;
  approveRdBusinessComponentSyncEvent: Scalars['ID']['output'];
  /** Approve an R&D project by setting approval time and comment */
  approveRdProject: RdProject;
  /** Batch override matching target status for multiple ASC projects */
  batchUpdateAscProjectCapitalizableProjectClusteringOverride: Array<AscProject>;
  bulkDeleteAscProjectsInPeriod: BulkDeleteAscProjectsResult;
  /** Delete empty R&D projects for a fiscal year */
  bulkDeleteEmptyRdProjectsForFiscalYear: BulkDeleteEmptyRdProjectsResult;
  bulkRecalculateAscAllocations: DistributedFlowState;
  bulkRecalculateRdAllocations: DistributedFlowState;
  bulkUpdateRdProjectsProductByCsv: BulkUpdateRdProjectsProductByCsvResult;
  calculateAllocationsRd: CalculateAllocationsRdResult;
  cancelScheduledBackgroundOperation: ScheduledBackgroundOperationModel;
  changeSentinelEmailScope: SentinelEmail;
  /** Clear approval for an ASC project from a fiscal period onward */
  clearAscProjectApproval: AscProject;
  clearBackgroundOperation: Array<DistributedFlowState>;
  clearReportOrImportOperations: Array<DistributedFlowState>;
  clearSyncTicketingData: Array<DistributedFlowState>;
  /** This will combine the source contributor into the target contributor, and delete the source contributor. Use this to re-assign provider relations. */
  combineContributor: Contributor;
  copyCompany: Scalars['ID']['output'];
  createAscProject: AscProject;
  createCompanyForOrganization: Company;
  createContributor: Contributor;
  createFinchAccessToken: Company;
  createFiscalYear: FiscalYear;
  createGitHubAppAuthorizationUrl: Scalars['String']['output'];
  createGitHubAppInstallUrl: Scalars['String']['output'];
  createMergeDevAccessTokenForAccounting: Company;
  createMergeDevAccessTokenForTicketing: Company;
  /** Create a product */
  createProduct: Product;
  createRdBusinessComponent: Scalars['ID']['output'];
  createRdProject: RdProject;
  createScheduledBackgroundOperation: ScheduledBackgroundOperationModel;
  createSingleTenantDomainRedirect: SingleTenantDomainRedirect;
  deleteAccountingSyncEventForFiscalYear: DeleteAccountingSyncEventForFiscalYearResult;
  deleteAccountingTokensByCompanyAndProvider: DeleteAccountingTokensResult;
  deleteAscProject: AscProjectDeletionResult;
  deleteCompany: Scalars['ID']['output'];
  deleteFirebaseIdentity: Scalars['Boolean']['output'];
  deleteOrganizationInvitation: OrganizationInvitation;
  deletePayrollMonthExpenseSyncEvent: DeletePayrollMonthExpenseSyncEventResult;
  deletePayrollSyncEventForFiscalYear: DeletePayrollSyncEventForFiscalYearResult;
  deletePayrollTokensByCompanyAndProvider: DeletePayrollTokensResult;
  /** Delete a product */
  deleteProduct: Product;
  deleteRdBusinessComponent: Scalars['ID']['output'];
  deleteRdProject: RdProjectDeletionResult;
  deleteSingleTenantDomainRedirect: Scalars['ID']['output'];
  disconnectTicketingToken: DisconnectTicketingTokenOutput;
  generateAscCostCsv: AscCostCsvResultRo;
  generateAscReport: DistributedFlowState;
  generateDocument: Documents;
  generateElevatorPitch: Question;
  generateFederalRdWriteup: DistributedFlowState;
  /** Re-generate and overwrite project description and/or R&D determination */
  generateRdDetails: RdProject;
  generateRdFromTimesheets: DistributedFlowState;
  generateRdProjectsReport: DistributedFlowState;
  getAndSaveAscReportSignedUrl: AscReportRo;
  getAndSaveRdProjectsReportSignedUrl: RdCreditsReportRo;
  getAscCostSignedUploadUrl: UploadUrl;
  getAscProjectsFileSignedUploadUrl: UploadUrl;
  getDemoAccountBundleSignedUploadUrl: UploadUrl;
  getGithubEmailMappingSignedUploadUrl: UploadUrl;
  getOneSchemaJwt: Scalars['String']['output'];
  getPriorYearTaxDocumentSignedUploadUrl: UploadUrl;
  getRdBusinessComponentsFileSignedUploadUrl: UploadUrl;
  getRdPayrollCostSignedUploadUrl: UploadUrl;
  getRdProjectSupportingDocumentSignedUploadUrl: UploadUrl;
  getRdProjectsFileSignedUploadUrl: UploadUrl;
  getTicketingDataSignedUploadUrl: UploadUrl;
  getTimesheetFileSignedUploadUrl: UploadUrl;
  initializeDemoAccount: DemoAccountInitialization;
  linkTicketingProviderUserToPayrollExpense: RdTaxCreditContributor;
  markJobAsFailed: JobExecution;
  mergeAscProjects: AscProject;
  /** Merge multiple R&D projects into one. Always runs as a background operation and returns a BackgroundOperation to track progress. */
  mergeRdProjects: MergeRdProjectsResult;
  /** Move tickets from one ASC project to another */
  moveTicketsToAscProject: MoveTicketsToAscProjectOutput;
  /** Move tickets from one R&D project to another */
  moveTicketsToRdProject: MoveTicketsToRdProjectOutput;
  onboardUser: User;
  /** Override the qualified purpose and reasoning for an R&D project */
  overrideQualifiedPurpose: RdProject;
  provisionCurrentUser: Scalars['Boolean']['output'];
  provisionEmailPasswordUser: Scalars['Boolean']['output'];
  queueIsolatedCoordinator: Array<DistributedFlowState>;
  reconcileUserState: User;
  recordDownloadDocument: DocumentEvent;
  recordSubmitDocuments: Array<DocumentEvent>;
  refreshGithubOrganization: ValidateTicketingTokenOutput;
  /** Re-run capitalization predictions for a single ASC project */
  regenerateAscCapitalizationDetermination: AscProject;
  /** Regenerate the name, description and/or eligibility of a fiscal year's R&D projects */
  regenerateRdProjectDetails: DistributedFlowState;
  rematchRdBusinessComponentSyncEvent: Scalars['ID']['output'];
  removeCompanyBulkTicketingDataFile: Company;
  removePriorYearTaxDocument: Company;
  removeRdProjectSupportingDocument: RdProject;
  removeSentinelEmail: Scalars['ID']['output'];
  removeUserAccessFromOrganization: Scalars['Float']['output'];
  replaceUserAccessInOrganization: Scalars['String']['output'];
  reportLoginFailure: Scalars['Boolean']['output'];
  requeueJob: JobExecution;
  resendMyOrganizationInvitation: OrganizationInvitation;
  resendOrganizationInvitation: OrganizationInvitation;
  restartOnboardingFlow: Array<DistributedFlowState>;
  resyncTicketingDataInPeriod: DistributedFlowState;
  sendEmailVerification: Scalars['ID']['output'];
  sendMagicLinkEmail: Scalars['Boolean']['output'];
  sendOnboardingFlowCompleteEmail: Scalars['String']['output'];
  sendResetPasswordEmail: Scalars['Boolean']['output'];
  /** Lock or unlock a single ASC period */
  setAscPeriodLock: AscPeriodLockStatus;
  /** Approve an ASC project for a fiscal period */
  setAscProjectApproval: AscProject;
  setDistributedFlowStateIsPaused: DistributedFlowState;
  setUserEnterpriseSsoExemption: User;
  settleSentinelEmail: SentinelEmail;
  startProcessingTicketingData: Company;
  syncAccountingProvider: SyncAccountingProviderResult;
  syncPayrollProvider: SyncPayrollProviderResult;
  syncTicketingFiles: DistributedFlowState;
  unlinkTicketingProviderUserFromRdTaxCreditContributor: RdTaxCreditContributor;
  updateAccountingExpense: AccountingExpense;
  updateAllowAccessToDocument: Documents;
  updateAscProject: AscProject;
  /** Override whether an ASC project is a CPC matching target */
  updateAscProjectCapitalizableProjectClusteringOverride: AscProject;
  updateAscProjectCapitalization: AscProject;
  updateAscProjectCapitalizationSuperUser: AscProject;
  /** Update the fiscal year end month for a company. Recalculates all fiscal year and prior year revenue/QRE dates. Blocked if fiscal years have data. */
  updateCompanyFiscalYearEnd: Company;
  updateCompanyOfficer: PayrollQre;
  updateCompanyQuestion: Question;
  updateCompanyQuestions: Company;
  updateCompanySettings: Company;
  updateContributor: Contributor;
  updateContributorAllocationsForAsc: Scalars['Int']['output'];
  updateFiscalYear: FiscalYear;
  updateFiscalYearProcessingTicketingDataState: FiscalYear;
  updateIpWhitelist: Organization;
  /** Set the locked for customers datetime */
  updateLockedForCustomers: FiscalYear;
  updatePayrollExpense: PayrollQre;
  updatePriorYearQre: Company;
  updatePriorYearRevenue: PriorYearRevenue;
  /** Update a product */
  updateProduct: Product;
  updateRdBusinessComponent: Scalars['ID']['output'];
  updateRdBusinessComponentMatchThreshold: Scalars['Float']['output'];
  updateRdExpenseProjectAllocations: RdExpense;
  updateRdProject: RdProject;
  updateRdProjectEligibility: RdProject;
  updateRdTaxCreditOverrides: FederalRdTaxCreditDocuments;
  updateRequiredEnterpriseSsoProviderId: Organization;
  /** Set the sent 6765 datetime and lock the fiscal year for customer */
  updateSent6765: FiscalYear;
  updateShortYearPeriod: Company;
  updateSingleTenantDomainRedirect: SingleTenantDomainRedirect;
  updateUser: User;
  uploadAccountingExpenseCsv: UploadAccountingExpenseCsvResult;
  uploadAscWageReport: UploadAscWageReportResult;
  uploadCsvToMoveTicketsToAscProjects: UploadCsvToMoveTicketsToAscProjects;
  uploadCsvToMoveTicketsToRdProjects: UploadCsvToMoveTicketsToRdProjects;
  uploadDocument: Documents;
  uploadOrganizationPhoto: Organization;
  uploadPayrollExpenseCsv: UploadPayrollExpenseCsvResult;
  /** Upload a CSV file containing product names and create products from it */
  uploadProductListCsv: Array<Product>;
  uploadRdExpenseProjectAllocationReport: UploadRdExpenseProjectAllocationReportResult;
  upsertCaSredSyncConfiguration: CaSredSyncConfigurationRo;
  upsertSnowflakeConfiguration: SnowflakeTicketingToken;
  upsertSyncConfigurationAsc: Company;
  upsertSyncConfigurationRd: Company;
  validateTicketingToken: ValidateTicketingTokenOutput;
};

export type MutationAcceptInvitationArgs = {
  acceptInvitationInput: AcceptInvitationInput;
};

export type MutationAddAscCostFileArgs = {
  addAscCostFileInput: AddAscCostFileInput;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type MutationAddAscProjectsFileArgs = {
  companyId: Scalars['ID']['input'];
  input: AddAscProjectsFileInput;
};

export type MutationAddCompanyBulkTicketingDataFileArgs = {
  addCompanyBulkTicketingDataInput: AddCompanyBulkTicketingDataInput;
  companyId: Scalars['ID']['input'];
};

export type MutationAddGithubEmailMappingFileArgs = {
  companyId: Scalars['ID']['input'];
  input: AddGithubEmailMappingFileInput;
};

export type MutationAddOrganizationInvitationArgs = {
  addOrganizationInvitationInput: AddOrganizationInvitationInput;
  organizationId: Scalars['ID']['input'];
};

export type MutationAddPriorYearTaxDocumentArgs = {
  addPriorYearTaxDocumentInput: AddPriorYearTaxDocumentInput;
  companyId: Scalars['ID']['input'];
};

export type MutationAddRdBusinessComponentsFileArgs = {
  fiscalYearId: Scalars['ID']['input'];
  input: AddRdBusinessComponentsFileInput;
};

export type MutationAddRdPayrollCostFileArgs = {
  addRdPayrollCostFileInput: AddRdPayrollCostFileInput;
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationAddRdProjectSupportingDocumentArgs = {
  addRdProjectSupportingDocumentInput: AddRdProjectSupportingDocumentInput;
  rdProjectId: Scalars['ID']['input'];
};

export type MutationAddRdProjectsFileArgs = {
  fiscalYearId: Scalars['ID']['input'];
  input: AddRdProjectsFileInput;
};

export type MutationAddSentinelEmailArgs = {
  input: AddSentinelEmailInput;
};

export type MutationAddTimesheetFileArgs = {
  addTimesheetFileInput: AddTimesheetFileInput;
  companyId: Scalars['ID']['input'];
};

export type MutationAllocateCreatorRdWagePercentagesArgs = {
  creatorRdCsvFile: Scalars['Upload']['input'];
  wageFile: Scalars['Upload']['input'];
};

export type MutationAllowRealCompanyArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationApplySupervisorRdPercentageArgs = {
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  expenseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<PayrollQreFilter>;
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationApplyWeightedCapitalizedPercentageToContributorsArgs = {
  fiscalYearId: Scalars['ID']['input'];
  input: ApplyWeightedCapitalizedPercentageToContributorInput;
  periodName: PeriodName;
};

export type MutationApplyWeightedRdPercentageToExpensesArgs = {
  applyWeightedRdPercentageToExpensesInput: ApplyWeightedRdPercentageToExpensesInput;
  filter?: InputMaybe<PayrollQreFilter>;
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationApproveRdBusinessComponentSyncEventArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationApproveRdProjectArgs = {
  approveRdProjectInput: ApproveRdProjectInput;
  rdProjectId: Scalars['ID']['input'];
};

export type MutationBatchUpdateAscProjectCapitalizableProjectClusteringOverrideArgs = {
  batchUpdateAscProjectCapitalizableProjectClusteringOverrideInput: BatchUpdateAscProjectCapitalizableProjectClusteringOverrideInput;
  companyId: Scalars['ID']['input'];
};

export type MutationBulkDeleteAscProjectsInPeriodArgs = {
  companyId: Scalars['ID']['input'];
  period: MonthYearPeriodInput;
};

export type MutationBulkDeleteEmptyRdProjectsForFiscalYearArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationBulkRecalculateAscAllocationsArgs = {
  companyId: Scalars['ID']['input'];
  period: MonthYearPeriodInput;
};

export type MutationBulkRecalculateRdAllocationsArgs = {
  fiscalYearId: Scalars['ID']['input'];
  rdTaxCreditContributorIds: Array<Scalars['ID']['input']>;
};

export type MutationBulkUpdateRdProjectsProductByCsvArgs = {
  csvFile: Scalars['Upload']['input'];
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationCalculateAllocationsRdArgs = {
  fiscalYearId: Scalars['ID']['input'];
  rdAllocationMethod: RdAllocationMethod;
  rdTaxCreditContributorId: Scalars['ID']['input'];
};

export type MutationCancelScheduledBackgroundOperationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationChangeSentinelEmailScopeArgs = {
  id: Scalars['ID']['input'];
  input: ChangeSentinelEmailScopeInput;
};

export type MutationClearAscProjectApprovalArgs = {
  ascProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type MutationClearBackgroundOperationArgs = {
  backgroundOperationId: Scalars['ID']['input'];
};

export type MutationClearReportOrImportOperationsArgs = {
  backgroundOperationId: Scalars['ID']['input'];
};

export type MutationClearSyncTicketingDataArgs = {
  backgroundOperationId: Scalars['ID']['input'];
};

export type MutationCombineContributorArgs = {
  companyId: Scalars['ID']['input'];
  input: CombineContributorInput;
};

export type MutationCopyCompanyArgs = {
  companyId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationCreateAscProjectArgs = {
  companyId: Scalars['ID']['input'];
  createAscProjectInput: CreateAscProjectInput;
};

export type MutationCreateCompanyForOrganizationArgs = {
  createCompanyForOrganizationInput: CreateCompanyForOrganizationInput;
  organizationId: Scalars['ID']['input'];
};

export type MutationCreateContributorArgs = {
  companyId: Scalars['ID']['input'];
  input: CreateContributorInput;
};

export type MutationCreateFinchAccessTokenArgs = {
  companyId: Scalars['ID']['input'];
  finchAuthCode: Scalars['String']['input'];
  provider: PayrollProvider;
  userId: Scalars['ID']['input'];
};

export type MutationCreateFiscalYearArgs = {
  companyId: Scalars['ID']['input'];
  createFiscalYearInput: CreateFiscalYearInput;
};

export type MutationCreateGitHubAppAuthorizationUrlArgs = {
  input: CreateGitHubAppAuthorizationUrlInput;
  userId: Scalars['ID']['input'];
};

export type MutationCreateGitHubAppInstallUrlArgs = {
  input: CreateGitHubAppInstallUrlInput;
  userId: Scalars['ID']['input'];
};

export type MutationCreateMergeDevAccessTokenForAccountingArgs = {
  input: CreateMergeDevAccessTokenForAccountingInput;
  userId: Scalars['ID']['input'];
};

export type MutationCreateMergeDevAccessTokenForTicketingArgs = {
  input: CreateMergeDevAccessTokenForTicketingInput;
  userId: Scalars['ID']['input'];
};

export type MutationCreateProductArgs = {
  companyId: Scalars['ID']['input'];
  createProductInput: CreateProductInput;
};

export type MutationCreateRdBusinessComponentArgs = {
  fiscalYearId: Scalars['ID']['input'];
  input: RdBusinessComponentInput;
};

export type MutationCreateRdProjectArgs = {
  createRdProjectInput: CreateRdProjectInput;
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationCreateScheduledBackgroundOperationArgs = {
  input: CreateScheduledBackgroundOperationInput;
};

export type MutationCreateSingleTenantDomainRedirectArgs = {
  createSingleTenantDomainRedirectInput: CreateSingleTenantDomainRedirectInput;
};

export type MutationDeleteAccountingSyncEventForFiscalYearArgs = {
  accountingProviderSyncEventId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationDeleteAccountingTokensByCompanyAndProviderArgs = {
  accountingProvider: AccountingProvider;
  companyId: Scalars['ID']['input'];
  revokeAtVendor?: Scalars['Boolean']['input'];
};

export type MutationDeleteAscProjectArgs = {
  ascProjectId: Scalars['ID']['input'];
};

export type MutationDeleteCompanyArgs = {
  companyId: Scalars['ID']['input'];
};

export type MutationDeleteFirebaseIdentityArgs = {
  input: DeleteFirebaseIdentityInput;
};

export type MutationDeleteOrganizationInvitationArgs = {
  organizationInvitationId: Scalars['ID']['input'];
};

export type MutationDeletePayrollMonthExpenseSyncEventArgs = {
  companyId: Scalars['ID']['input'];
  payrollMonthExpenseSyncEventId: Scalars['ID']['input'];
};

export type MutationDeletePayrollSyncEventForFiscalYearArgs = {
  fiscalYearId: Scalars['ID']['input'];
  payrollProviderSyncEventId: Scalars['ID']['input'];
};

export type MutationDeletePayrollTokensByCompanyAndProviderArgs = {
  companyId: Scalars['ID']['input'];
  payrollProvider: PayrollProvider;
};

export type MutationDeleteProductArgs = {
  productId: Scalars['ID']['input'];
};

export type MutationDeleteRdBusinessComponentArgs = {
  businessComponentId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationDeleteRdProjectArgs = {
  rdProjectId: Scalars['ID']['input'];
};

export type MutationDeleteSingleTenantDomainRedirectArgs = {
  singleTenantDomainRedirectId: Scalars['ID']['input'];
};

export type MutationDisconnectTicketingTokenArgs = {
  ticketingTokenId: Scalars['ID']['input'];
};

export type MutationGenerateAscCostCsvArgs = {
  input: GenerateAscCostCsvInput;
  payrollTokenId: Scalars['ID']['input'];
};

export type MutationGenerateAscReportArgs = {
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type MutationGenerateDocumentArgs = {
  documentInput: DocumentInput;
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationGenerateElevatorPitchArgs = {
  companyId: Scalars['ID']['input'];
};

export type MutationGenerateFederalRdWriteupArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationGenerateRdDetailsArgs = {
  fiscalYearId: Scalars['ID']['input'];
  generateRdDetailsInput: GenerateRdDetailsInput;
  rdProjectId: Scalars['ID']['input'];
};

export type MutationGenerateRdFromTimesheetsArgs = {
  fiscalYearId: Scalars['ID']['input'];
  fuzzyThreshold?: InputMaybe<Scalars['Float']['input']>;
  timesheetSyncEventIds: Array<Scalars['ID']['input']>;
};

export type MutationGenerateRdProjectsReportArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationGetAndSaveAscReportSignedUrlArgs = {
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type MutationGetAndSaveRdProjectsReportSignedUrlArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationGetAscCostSignedUploadUrlArgs = {
  companyId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type MutationGetAscProjectsFileSignedUploadUrlArgs = {
  companyId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type MutationGetDemoAccountBundleSignedUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationGetGithubEmailMappingSignedUploadUrlArgs = {
  companyId: Scalars['ID']['input'];
};

export type MutationGetOneSchemaJwtArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationGetPriorYearTaxDocumentSignedUploadUrlArgs = {
  companyId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type MutationGetRdBusinessComponentsFileSignedUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationGetRdPayrollCostSignedUploadUrlArgs = {
  companyId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type MutationGetRdProjectSupportingDocumentSignedUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  rdProjectId: Scalars['ID']['input'];
};

export type MutationGetRdProjectsFileSignedUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationGetTicketingDataSignedUploadUrlArgs = {
  action: UploadAction;
  companyId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type MutationGetTimesheetFileSignedUploadUrlArgs = {
  companyId: Scalars['ID']['input'];
  effortUnit: TimesheetEffortUnit;
  name: Scalars['String']['input'];
};

export type MutationInitializeDemoAccountArgs = {
  input: InitializeDemoAccountInput;
};

export type MutationLinkTicketingProviderUserToPayrollExpenseArgs = {
  rdTaxCreditContributorId: Scalars['ID']['input'];
  ticketingProviderUserId: Scalars['ID']['input'];
};

export type MutationMarkJobAsFailedArgs = {
  jobExecutionId: Scalars['ID']['input'];
};

export type MutationMergeAscProjectsArgs = {
  companyId: Scalars['ID']['input'];
  mergeAscProjectsInput: MergeAscProjectsInput;
};

export type MutationMergeRdProjectsArgs = {
  fiscalYearId: Scalars['ID']['input'];
  mergeRdProjectsInput: MergeRdProjectsInput;
};

export type MutationMoveTicketsToAscProjectArgs = {
  ascProjectId: Scalars['ID']['input'];
  moveTicketsToAscProjectInput: MoveTicketsToAscProjectInput;
};

export type MutationMoveTicketsToRdProjectArgs = {
  moveTicketsToRdProjectInput: MoveTicketsToRdProjectInput;
  rdProjectId: Scalars['ID']['input'];
};

export type MutationOnboardUserArgs = {
  onboardUserInput: OnboardUserInput;
  userId: Scalars['ID']['input'];
};

export type MutationOverrideQualifiedPurposeArgs = {
  hasQualifiedPurpose: QualifiedPurposeDetermination;
  qualifiedPurposeReasoning: Scalars['String']['input'];
  rdProjectId: Scalars['ID']['input'];
};

export type MutationProvisionEmailPasswordUserArgs = {
  input: ProvisionEmailPasswordUserInput;
};

export type MutationQueueIsolatedCoordinatorArgs = {
  companyId: Scalars['ID']['input'];
  queueIdentifier: QueueIdentifier;
};

export type MutationReconcileUserStateArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationRecordDownloadDocumentArgs = {
  documentInput: DocumentInput;
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationRecordSubmitDocumentsArgs = {
  documentInputs: Array<DocumentInput>;
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationRefreshGithubOrganizationArgs = {
  organization: Scalars['String']['input'];
  ticketingTokenId: Scalars['ID']['input'];
};

export type MutationRegenerateAscCapitalizationDeterminationArgs = {
  ascProjectId: Scalars['ID']['input'];
};

export type MutationRegenerateRdProjectDetailsArgs = {
  fiscalYearId: Scalars['ID']['input'];
  regenerateRdProjectDetailsInput: RegenerateRdProjectDetailsInput;
};

export type MutationRematchRdBusinessComponentSyncEventArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationRemoveCompanyBulkTicketingDataFileArgs = {
  fileUploadId: Scalars['ID']['input'];
};

export type MutationRemovePriorYearTaxDocumentArgs = {
  fileUploadId: Scalars['ID']['input'];
};

export type MutationRemoveRdProjectSupportingDocumentArgs = {
  fileUploadId: Scalars['ID']['input'];
};

export type MutationRemoveSentinelEmailArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveUserAccessFromOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationReplaceUserAccessInOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  replaceUserAccessInOrganizationInput: ReplaceUserAccessInOrganizationInput;
  userId: Scalars['ID']['input'];
};

export type MutationReportLoginFailureArgs = {
  input: ReportLoginFailureInput;
};

export type MutationRequeueJobArgs = {
  jobExecutionId: Scalars['ID']['input'];
};

export type MutationResendMyOrganizationInvitationArgs = {
  organizationInvitationId: Scalars['ID']['input'];
};

export type MutationResendOrganizationInvitationArgs = {
  organizationInvitationId: Scalars['ID']['input'];
};

export type MutationRestartOnboardingFlowArgs = {
  companyId: Scalars['ID']['input'];
  queueIdentifier: QueueIdentifier;
};

export type MutationResyncTicketingDataInPeriodArgs = {
  analysisTypes: Array<AnalysisType>;
  period: PeriodDatesInput;
  ticketingTokenId: Scalars['ID']['input'];
};

export type MutationSendEmailVerificationArgs = {
  continueUrl?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type MutationSendMagicLinkEmailArgs = {
  sendMagicLinkEmailInput: SendMagicLinkEmailInput;
};

export type MutationSendOnboardingFlowCompleteEmailArgs = {
  companyId: Scalars['ID']['input'];
};

export type MutationSendResetPasswordEmailArgs = {
  sendResetPasswordEmailInput: SendResetPasswordEmailInput;
};

export type MutationSetAscPeriodLockArgs = {
  fiscalYearId: Scalars['ID']['input'];
  isLocked: Scalars['Boolean']['input'];
  periodName: PeriodName;
};

export type MutationSetAscProjectApprovalArgs = {
  ascProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  setAscProjectApprovalInput: SetAscProjectApprovalInput;
};

export type MutationSetDistributedFlowStateIsPausedArgs = {
  distributedFlowId: Scalars['ID']['input'];
  isPaused: Scalars['Boolean']['input'];
};

export type MutationSetUserEnterpriseSsoExemptionArgs = {
  exempt: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationSettleSentinelEmailArgs = {
  id: Scalars['ID']['input'];
  input: SettleSentinelEmailInput;
};

export type MutationStartProcessingTicketingDataArgs = {
  companyId: Scalars['ID']['input'];
  input: StartProcessingTicketingDataInput;
  ticketingTokenId: Scalars['ID']['input'];
};

export type MutationSyncAccountingProviderArgs = {
  fiscalYearId: Scalars['ID']['input'];
  provider: Scalars['String']['input'];
};

export type MutationSyncPayrollProviderArgs = {
  fiscalYearId: Scalars['ID']['input'];
  payrollProvider: PayrollProvider;
};

export type MutationSyncTicketingFilesArgs = {
  analysisTypes: Array<AnalysisType>;
  collectionFileUploads: Array<FileUploadInput>;
  companyId: Scalars['ID']['input'];
  period: PeriodDatesInput;
  provider: TicketingProvider;
  teamFileUploads: Array<FileUploadInput>;
  ticketFileUploads: Array<FileUploadInput>;
  userFileUploads: Array<FileUploadInput>;
};

export type MutationUnlinkTicketingProviderUserFromRdTaxCreditContributorArgs = {
  rdTaxCreditContributorId: Scalars['ID']['input'];
  ticketingProviderUserId: Scalars['ID']['input'];
};

export type MutationUpdateAccountingExpenseArgs = {
  accountingExpenseId: Scalars['ID']['input'];
  updateAccountingExpenseInput: UpdateAccountingExpenseInput;
};

export type MutationUpdateAllowAccessToDocumentArgs = {
  fiscalYearId: Scalars['ID']['input'];
  updateAllowAccessToDocumentInput: UpdateAllowAccessToDocumentInput;
};

export type MutationUpdateAscProjectArgs = {
  ascProjectId: Scalars['ID']['input'];
  updateAscProjectInput: UpdateAscProjectInput;
};

export type MutationUpdateAscProjectCapitalizableProjectClusteringOverrideArgs = {
  ascProjectId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  updateAscProjectCapitalizableProjectClusteringOverrideInput: UpdateAscProjectCapitalizableProjectClusteringOverrideInput;
};

export type MutationUpdateAscProjectCapitalizationArgs = {
  ascProjectId: Scalars['ID']['input'];
  updateAscProjectCapitalizationInput: UpdateAscProjectCapitalizationInput;
};

export type MutationUpdateAscProjectCapitalizationSuperUserArgs = {
  ascProjectId: Scalars['ID']['input'];
  updateAscProjectCapitalizationInput: UpdateAscProjectCapitalizationInput;
};

export type MutationUpdateCompanyFiscalYearEndArgs = {
  companyId: Scalars['ID']['input'];
  input: UpdateCompanyFiscalYearEndInput;
};

export type MutationUpdateCompanyOfficerArgs = {
  input: UpdateCompanyOfficerInput;
  payrollExpenseId: Scalars['ID']['input'];
};

export type MutationUpdateCompanyQuestionArgs = {
  companyId: Scalars['ID']['input'];
  companyQuestionInput: CompanyQuestionInput;
};

export type MutationUpdateCompanyQuestionsArgs = {
  companyId: Scalars['ID']['input'];
  questions: CompanyQuestionsInput;
};

export type MutationUpdateCompanySettingsArgs = {
  companyId: Scalars['ID']['input'];
  input: UpdateCompanySettingsInput;
};

export type MutationUpdateContributorArgs = {
  contributorId: Scalars['ID']['input'];
  input: UpdateContributorInput;
};

export type MutationUpdateContributorAllocationsForAscArgs = {
  fiscalYearId: Scalars['ID']['input'];
  input: UpdateContributorAllocationForAscInput;
  periodName: PeriodName;
};

export type MutationUpdateFiscalYearArgs = {
  fiscalYearId: Scalars['ID']['input'];
  updateFiscalYearInput: UpdateFiscalYearInput;
};

export type MutationUpdateFiscalYearProcessingTicketingDataStateArgs = {
  fiscalYearId: Scalars['ID']['input'];
  processingTicketingDataState: ProcessingTicketingDataState;
};

export type MutationUpdateIpWhitelistArgs = {
  ipWhitelist: Array<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MutationUpdateLockedForCustomersArgs = {
  fiscalYearId: Scalars['ID']['input'];
  isLocked: Scalars['Boolean']['input'];
};

export type MutationUpdatePayrollExpenseArgs = {
  input: UpdatePayrollExpenseInput;
  payrollExpenseId: Scalars['ID']['input'];
};

export type MutationUpdatePriorYearQreArgs = {
  amountCents: Scalars['BigInt']['input'];
  companyId: Scalars['ID']['input'];
  taxYearStartDate: Scalars['String']['input'];
};

export type MutationUpdatePriorYearRevenueArgs = {
  priorYearRevenueId: Scalars['ID']['input'];
  revenueCents: Scalars['BigInt']['input'];
};

export type MutationUpdateProductArgs = {
  productId: Scalars['ID']['input'];
  updateProductInput: UpdateProductInput;
};

export type MutationUpdateRdBusinessComponentArgs = {
  businessComponentId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  input: RdBusinessComponentInput;
};

export type MutationUpdateRdBusinessComponentMatchThresholdArgs = {
  fiscalYearId: Scalars['ID']['input'];
  threshold: Scalars['Float']['input'];
};

export type MutationUpdateRdExpenseProjectAllocationsArgs = {
  rdExpenseId: Scalars['ID']['input'];
  updateRdExpenseProjectAllocationsInput: UpdateRdExpenseProjectAllocationsInput;
};

export type MutationUpdateRdProjectArgs = {
  rdProjectId: Scalars['ID']['input'];
  updateRdProjectInput: UpdateRdProjectInput;
};

export type MutationUpdateRdProjectEligibilityArgs = {
  rdProjectEligibilityAnswersInput: RdProjectEligibilityAnswersInput;
  rdProjectId: Scalars['ID']['input'];
};

export type MutationUpdateRdTaxCreditOverridesArgs = {
  fiscalYearId: Scalars['ID']['input'];
  rdTaxCreditOverrides: RdTaxCreditOverridesInput;
};

export type MutationUpdateRequiredEnterpriseSsoProviderIdArgs = {
  organizationId: Scalars['ID']['input'];
  requiredEnterpriseSsoProviderId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateSent6765Args = {
  fiscalYearId: Scalars['ID']['input'];
  isLocked: Scalars['Boolean']['input'];
};

export type MutationUpdateShortYearPeriodArgs = {
  companyId: Scalars['ID']['input'];
  shortYearPeriod: MonthYearPeriodInput;
};

export type MutationUpdateSingleTenantDomainRedirectArgs = {
  updateSingleTenantDomainRedirectInput: UpdateSingleTenantDomainRedirectInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
  userId: Scalars['ID']['input'];
};

export type MutationUploadAccountingExpenseCsvArgs = {
  accountingProvider: AccountingProvider;
  file: Scalars['Upload']['input'];
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationUploadAscWageReportArgs = {
  file: Scalars['Upload']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type MutationUploadCsvToMoveTicketsToAscProjectsArgs = {
  companyId: Scalars['ID']['input'];
  csvFile: Scalars['Upload']['input'];
};

export type MutationUploadCsvToMoveTicketsToRdProjectsArgs = {
  csvFile: Scalars['Upload']['input'];
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationUploadDocumentArgs = {
  documentInput: DocumentInput;
  fileUpload: Scalars['Upload']['input'];
  fiscalYearId: Scalars['ID']['input'];
};

export type MutationUploadOrganizationPhotoArgs = {
  fileUpload: Scalars['Upload']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationUploadPayrollExpenseCsvArgs = {
  file: Scalars['Upload']['input'];
  fiscalYearId: Scalars['ID']['input'];
  payrollProvider: PayrollProvider;
};

export type MutationUploadProductListCsvArgs = {
  companyId: Scalars['ID']['input'];
  csvFile: Scalars['Upload']['input'];
};

export type MutationUploadRdExpenseProjectAllocationReportArgs = {
  file: Scalars['Upload']['input'];
  fiscalYearId: Scalars['ID']['input'];
  uploadRdExpenseProjectAllocationReportInput: UploadRdExpenseProjectAllocationReportInput;
};

export type MutationUpsertCaSredSyncConfigurationArgs = {
  companyId: Scalars['ID']['input'];
  input: CaSredSyncConfigurationInput;
};

export type MutationUpsertSnowflakeConfigurationArgs = {
  companyId: Scalars['ID']['input'];
  input: SnowflakeConfigurationInput;
  userId: Scalars['ID']['input'];
};

export type MutationUpsertSyncConfigurationAscArgs = {
  clusterHierarchyTypes?: InputMaybe<DeterministicClusteringObjectLevel>;
  companyId: Scalars['ID']['input'];
  excludedWorkstreamIds: Array<Scalars['ID']['input']>;
  input: AscSyncConfigurationInput;
};

export type MutationUpsertSyncConfigurationRdArgs = {
  companyId: Scalars['ID']['input'];
  input: SyncConfigurationRdInput;
};

export type MutationValidateTicketingTokenArgs = {
  ticketingTokenId: Scalars['ID']['input'];
};

export type OnCallShift = {
  __typename?: 'OnCallShift';
  endDate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  team: OnCallTeam;
};

export enum OnCallTeam {
  Asc = 'ASC',
  Platform = 'PLATFORM',
  Rd = 'RD',
}

export type OnboardUserInput = {
  companyName: Scalars['String']['input'];
  fiscalYearEndMonth?: InputMaybe<Scalars['Int']['input']>;
  fullName: Scalars['String']['input'];
  isAccountingFirm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Organization = {
  __typename?: 'Organization';
  companies: Array<Company>;
  id: Scalars['ID']['output'];
  invitedMembers: Array<OrganizationInvitation>;
  ipWhitelist: Array<Scalars['String']['output']>;
  isAccountingFirm: Scalars['Boolean']['output'];
  members: Array<User>;
  name: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  requiredEnterpriseSsoProviderId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationInvitation = {
  __typename?: 'OrganizationInvitation';
  acceptedAt?: Maybe<Scalars['Date']['output']>;
  derivedState: Scalars['String']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  revokedAt?: Maybe<Scalars['Date']['output']>;
  scope: OrganizationScope;
};

export enum OrganizationScope {
  OrganizationAdmin = 'ORGANIZATION_ADMIN',
  OrganizationMember = 'ORGANIZATION_MEMBER',
}

export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
};

export type ParentQuestionChoice = {
  __typename?: 'ParentQuestionChoice';
  id: Scalars['ID']['output'];
  parentQuestionId: Scalars['ID']['output'];
};

export enum ParentlessTicketMatching {
  DoNotMatch = 'DO_NOT_MATCH',
  Match = 'MATCH',
}

export type PayrollExpense = {
  __typename?: 'PayrollExpense';
  /** null for any user without financial permissions */
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  fiscalYearId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  payrollProvider: PayrollProvider;
  payrollQre: PayrollQre;
  /** this will be null for any user without financial permissions */
  wageType?: Maybe<WageType>;
};

export enum PayrollProvider {
  AdpRun = 'ADP_RUN',
  AdpWorkforceNow = 'ADP_WORKFORCE_NOW',
  CeridianDayforce = 'CERIDIAN_DAYFORCE',
  Gusto = 'GUSTO',
  Justworks = 'JUSTWORKS',
  PaychexFlex = 'PAYCHEX_FLEX',
  Paylocity = 'PAYLOCITY',
  Quickbooks = 'QUICKBOOKS',
  Rippling = 'RIPPLING',
  SelfReported = 'SELF_REPORTED',
  Trinet = 'TRINET',
  Workday = 'WORKDAY',
  Zenefits = 'ZENEFITS',
}

export type PayrollProviderFilterComparison = {
  eq?: InputMaybe<PayrollProvider>;
  gt?: InputMaybe<PayrollProvider>;
  gte?: InputMaybe<PayrollProvider>;
  iLike?: InputMaybe<PayrollProvider>;
  in?: InputMaybe<Array<PayrollProvider>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<PayrollProvider>;
  lt?: InputMaybe<PayrollProvider>;
  lte?: InputMaybe<PayrollProvider>;
  neq?: InputMaybe<PayrollProvider>;
  notILike?: InputMaybe<PayrollProvider>;
  notIn?: InputMaybe<Array<PayrollProvider>>;
  notLike?: InputMaybe<PayrollProvider>;
};

export type PayrollQre = {
  __typename?: 'PayrollQre';
  /** null for any user without financial permissions */
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  fiscalYearId: Scalars['String']['output'];
  hireDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMatched: Scalars['Boolean']['output'];
  isOfficer: Scalars['Boolean']['output'];
  managerName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  payrollExpenseId?: Maybe<Scalars['String']['output']>;
  payrollProvider?: Maybe<PayrollProvider>;
  qreRdPercentage: Scalars['Int']['output'];
  /** null for any user without financial permissions */
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  rdCategory: RdCategory;
  rdTaxCreditContributorId: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  ticketingProviders: Array<TicketingProvider>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PayrollQreAggregateFilter = {
  amountCents?: InputMaybe<BigIntFilterComparison>;
  and?: InputMaybe<Array<PayrollQreAggregateFilter>>;
  costCenter?: InputMaybe<StringFieldComparison>;
  country?: InputMaybe<StringFieldComparison>;
  department?: InputMaybe<StringFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  entity?: InputMaybe<StringFieldComparison>;
  hireDate?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isMatched?: InputMaybe<BooleanFieldComparison>;
  isOfficer?: InputMaybe<BooleanFieldComparison>;
  managerName?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<PayrollQreAggregateFilter>>;
  payrollProvider?: InputMaybe<PayrollProviderFilterComparison>;
  qreRdPercentage?: InputMaybe<FloatFieldComparison>;
  qualifiedAmountCents?: InputMaybe<BigIntFilterComparison>;
  rdCategory?: InputMaybe<RdCategoryFilterComparison>;
  state?: InputMaybe<StringFieldComparison>;
  terminationDate?: InputMaybe<StringFieldComparison>;
  title?: InputMaybe<StringFieldComparison>;
};

export type PayrollQreAggregateGroupBy = {
  __typename?: 'PayrollQreAggregateGroupBy';
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isMatched?: Maybe<Scalars['Boolean']['output']>;
  isOfficer?: Maybe<Scalars['Boolean']['output']>;
  managerName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payrollProvider?: Maybe<PayrollProvider>;
  qreRdPercentage?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  rdCategory?: Maybe<RdCategory>;
  state?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PayrollQreAvgAggregate = {
  __typename?: 'PayrollQreAvgAggregate';
  amountCents?: Maybe<Scalars['Float']['output']>;
  qreRdPercentage?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['Float']['output']>;
};

export type PayrollQreConnection = {
  __typename?: 'PayrollQreConnection';
  /** Array of edges. */
  edges: Array<PayrollQreEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type PayrollQreCountAggregate = {
  __typename?: 'PayrollQreCountAggregate';
  amountCents?: Maybe<Scalars['Int']['output']>;
  costCenter?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['Int']['output']>;
  entity?: Maybe<Scalars['Int']['output']>;
  hireDate?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isMatched?: Maybe<Scalars['Int']['output']>;
  isOfficer?: Maybe<Scalars['Int']['output']>;
  managerName?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  payrollProvider?: Maybe<Scalars['Int']['output']>;
  qreRdPercentage?: Maybe<Scalars['Int']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['Int']['output']>;
  rdCategory?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  terminationDate?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['Int']['output']>;
};

export type PayrollQreEdge = {
  __typename?: 'PayrollQreEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the PayrollQre */
  node: PayrollQre;
};

export type PayrollQreFilter = {
  amountCents?: InputMaybe<BigIntFilterComparison>;
  and?: InputMaybe<Array<PayrollQreFilter>>;
  costCenter?: InputMaybe<StringFieldComparison>;
  country?: InputMaybe<StringFieldComparison>;
  department?: InputMaybe<StringFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  entity?: InputMaybe<StringFieldComparison>;
  hireDate?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isMatched?: InputMaybe<BooleanFieldComparison>;
  isOfficer?: InputMaybe<BooleanFieldComparison>;
  managerName?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<PayrollQreFilter>>;
  payrollProvider?: InputMaybe<PayrollProviderFilterComparison>;
  qreRdPercentage?: InputMaybe<FloatFieldComparison>;
  qualifiedAmountCents?: InputMaybe<BigIntFilterComparison>;
  rdCategory?: InputMaybe<RdCategoryFilterComparison>;
  state?: InputMaybe<StringFieldComparison>;
  terminationDate?: InputMaybe<StringFieldComparison>;
  title?: InputMaybe<StringFieldComparison>;
};

export type PayrollQreMaxAggregate = {
  __typename?: 'PayrollQreMaxAggregate';
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  managerName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payrollProvider?: Maybe<PayrollProvider>;
  qreRdPercentage?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  rdCategory?: Maybe<RdCategory>;
  state?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PayrollQreMinAggregate = {
  __typename?: 'PayrollQreMinAggregate';
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  managerName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payrollProvider?: Maybe<PayrollProvider>;
  qreRdPercentage?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  rdCategory?: Maybe<RdCategory>;
  state?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PayrollQreSort = {
  direction: SortDirection;
  field: PayrollQreSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PayrollQreSortFields {
  AmountCents = 'amountCents',
  CostCenter = 'costCenter',
  Country = 'country',
  Department = 'department',
  Email = 'email',
  Entity = 'entity',
  HireDate = 'hireDate',
  Id = 'id',
  IsMatched = 'isMatched',
  IsOfficer = 'isOfficer',
  ManagerName = 'managerName',
  Name = 'name',
  PayrollProvider = 'payrollProvider',
  QreRdPercentage = 'qreRdPercentage',
  QualifiedAmountCents = 'qualifiedAmountCents',
  RdCategory = 'rdCategory',
  State = 'state',
  TerminationDate = 'terminationDate',
  Title = 'title',
}

export type PayrollQreSumAggregate = {
  __typename?: 'PayrollQreSumAggregate';
  amountCents?: Maybe<Scalars['Float']['output']>;
  qreRdPercentage?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['Float']['output']>;
};

export type PayrollQreSummary = {
  __typename?: 'PayrollQreSummary';
  avg?: Maybe<PayrollQreAvgAggregate>;
  count?: Maybe<PayrollQreCountAggregate>;
  groupBy?: Maybe<PayrollQreAggregateGroupBy>;
  max?: Maybe<PayrollQreMaxAggregate>;
  min?: Maybe<PayrollQreMinAggregate>;
  sum?: Maybe<PayrollQreSumAggregate>;
  uniqueCount?: Maybe<PayrollQreUniqueCountAggregate>;
};

export type PayrollQreSummaryFilter = {
  amountCents?: InputMaybe<BigIntFilterComparison>;
  and?: InputMaybe<Array<PayrollQreAggregateFilter>>;
  costCenter?: InputMaybe<StringFieldComparison>;
  country?: InputMaybe<StringFieldComparison>;
  department?: InputMaybe<StringFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  entity?: InputMaybe<StringFieldComparison>;
  hireDate?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isMatched?: InputMaybe<BooleanFieldComparison>;
  isOfficer?: InputMaybe<BooleanFieldComparison>;
  managerName?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<PayrollQreAggregateFilter>>;
  payrollProvider?: InputMaybe<PayrollProviderFilterComparison>;
  qreRdPercentage?: InputMaybe<FloatFieldComparison>;
  qualifiedAmountCents?: InputMaybe<BigIntFilterComparison>;
  rdCategory?: InputMaybe<RdCategoryFilterComparison>;
  state?: InputMaybe<StringFieldComparison>;
  terminationDate?: InputMaybe<StringFieldComparison>;
  title?: InputMaybe<StringFieldComparison>;
};

export type PayrollQreUniqueCountAggregate = {
  __typename?: 'PayrollQreUniqueCountAggregate';
  costCenter: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  department: Scalars['Int']['output'];
  entity: Scalars['Int']['output'];
  managerName: Scalars['Int']['output'];
  rdCategory: Scalars['Int']['output'];
  state: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
};

export type PayrollToken = {
  __typename?: 'PayrollToken';
  createdAt: Scalars['Date']['output'];
  /** Scope type used for Finch tokens, null for non-Finch tokens */
  finchScopeType?: Maybe<FinchScopeType>;
  id: Scalars['ID']['output'];
  payrollProvider: PayrollProvider;
};

export type PeriodDatesInput = {
  firstDayOfPeriod: Scalars['String']['input'];
  lastDayOfPeriod: Scalars['String']['input'];
};

export enum PeriodName {
  A = 'A',
  H1 = 'H1',
  H2 = 'H2',
  M1 = 'M1',
  M2 = 'M2',
  M3 = 'M3',
  M4 = 'M4',
  M5 = 'M5',
  M6 = 'M6',
  M7 = 'M7',
  M8 = 'M8',
  M9 = 'M9',
  M10 = 'M10',
  M11 = 'M11',
  M12 = 'M12',
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4',
  Ytd1 = 'YTD1',
  Ytd2 = 'YTD2',
  Ytd3 = 'YTD3',
  Ytd4 = 'YTD4',
  Ytd5 = 'YTD5',
  Ytd6 = 'YTD6',
  Ytd7 = 'YTD7',
  Ytd8 = 'YTD8',
  Ytd9 = 'YTD9',
  Ytd10 = 'YTD10',
  Ytd11 = 'YTD11',
  Ytd12 = 'YTD12',
}

export type PeriodNameFilterComparison = {
  eq?: InputMaybe<PeriodName>;
  gt?: InputMaybe<PeriodName>;
  gte?: InputMaybe<PeriodName>;
  iLike?: InputMaybe<PeriodName>;
  in?: InputMaybe<Array<PeriodName>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<PeriodName>;
  lt?: InputMaybe<PeriodName>;
  lte?: InputMaybe<PeriodName>;
  neq?: InputMaybe<PeriodName>;
  notILike?: InputMaybe<PeriodName>;
  notIn?: InputMaybe<Array<PeriodName>>;
  notLike?: InputMaybe<PeriodName>;
};

export enum PredictedCapitalizationStatus {
  Capitalizable = 'CAPITALIZABLE',
  NotCapitalizable = 'NOT_CAPITALIZABLE',
  Uncertain = 'UNCERTAIN',
}

export type PredictedCapitalizationStatusFilterComparison = {
  eq?: InputMaybe<PredictedCapitalizationStatus>;
  gt?: InputMaybe<PredictedCapitalizationStatus>;
  gte?: InputMaybe<PredictedCapitalizationStatus>;
  iLike?: InputMaybe<PredictedCapitalizationStatus>;
  in?: InputMaybe<Array<PredictedCapitalizationStatus>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<PredictedCapitalizationStatus>;
  lt?: InputMaybe<PredictedCapitalizationStatus>;
  lte?: InputMaybe<PredictedCapitalizationStatus>;
  neq?: InputMaybe<PredictedCapitalizationStatus>;
  notILike?: InputMaybe<PredictedCapitalizationStatus>;
  notIn?: InputMaybe<Array<PredictedCapitalizationStatus>>;
  notLike?: InputMaybe<PredictedCapitalizationStatus>;
};

export type PreviewAllocationChangeResult = {
  __typename?: 'PreviewAllocationChangeResult';
  contributorName: Scalars['String']['output'];
  currentMethod: RdAllocationMethod;
  currentNonProjectTimePercentage: Scalars['Float']['output'];
  currentTotalRdPercentage: Scalars['Float']['output'];
  newNonProjectTimePercentage: Scalars['Float']['output'];
  newTotalRdPercentage: Scalars['Float']['output'];
  projectAllocations: Array<PreviewAllocationProject>;
  rdTaxCreditContributorId: Scalars['ID']['output'];
  targetMethod: RdAllocationMethod;
  totalEffortDaysForEligibleProjects: Scalars['Float']['output'];
  totalTicketCount: Scalars['Int']['output'];
};

export type PreviewAllocationProject = {
  __typename?: 'PreviewAllocationProject';
  currentPercentage: Scalars['Float']['output'];
  isEligibleForRd: Scalars['Boolean']['output'];
  newPercentage: Scalars['Float']['output'];
  projectName: Scalars['String']['output'];
  rdProjectId: Scalars['ID']['output'];
};

export type PriorYearQre = {
  __typename?: 'PriorYearQRE';
  /** null for any user without financial permissions */
  amount?: Maybe<Scalars['BigInt']['output']>;
  taxYearEndDate: Scalars['String']['output'];
  taxYearStartDate: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export type PriorYearQreInput = {
  /** null for any user without financial permissions */
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  taxYearEndDate: Scalars['String']['input'];
  taxYearStartDate: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type PriorYearRevenue = {
  __typename?: 'PriorYearRevenue';
  id: Scalars['ID']['output'];
  /** null for any user without financial permissions */
  revenueCents?: Maybe<Scalars['BigInt']['output']>;
  revenueSource: RevenueSource;
  taxYearEndDate: Scalars['String']['output'];
  taxYearStartDate: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type PriorYearRevenueInput = {
  /** null for any user without financial permissions */
  revenueCents?: InputMaybe<Scalars['BigInt']['input']>;
  revenueSource: RevenueSource;
  taxYearEndDate: Scalars['String']['input'];
  taxYearStartDate: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export enum ProcessingProjectState {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  NeverProcessed = 'NEVER_PROCESSED',
}

export enum ProcessingTicketingDataState {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Skipped = 'SKIPPED',
}

export type Product = {
  __typename?: 'Product';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum ProductType {
  CaSred = 'CA_SRED',
  UsAsc = 'US_ASC',
  UsRd = 'US_RD',
}

export enum ProjectBusinessComponent {
  ComputerSoftware = 'COMPUTER_SOFTWARE',
  Process = 'PROCESS',
  Product = 'PRODUCT',
}

export type ProjectBusinessComponentFilterComparison = {
  eq?: InputMaybe<ProjectBusinessComponent>;
  gt?: InputMaybe<ProjectBusinessComponent>;
  gte?: InputMaybe<ProjectBusinessComponent>;
  iLike?: InputMaybe<ProjectBusinessComponent>;
  in?: InputMaybe<Array<ProjectBusinessComponent>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ProjectBusinessComponent>;
  lt?: InputMaybe<ProjectBusinessComponent>;
  lte?: InputMaybe<ProjectBusinessComponent>;
  neq?: InputMaybe<ProjectBusinessComponent>;
  notILike?: InputMaybe<ProjectBusinessComponent>;
  notIn?: InputMaybe<Array<ProjectBusinessComponent>>;
  notLike?: InputMaybe<ProjectBusinessComponent>;
};

export enum ProjectBusinessPurpose {
  InternalUse = 'INTERNAL_USE',
  SaleOrLease = 'SALE_OR_LEASE',
}

export type ProjectBusinessPurposeFilterComparison = {
  eq?: InputMaybe<ProjectBusinessPurpose>;
  gt?: InputMaybe<ProjectBusinessPurpose>;
  gte?: InputMaybe<ProjectBusinessPurpose>;
  iLike?: InputMaybe<ProjectBusinessPurpose>;
  in?: InputMaybe<Array<ProjectBusinessPurpose>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ProjectBusinessPurpose>;
  lt?: InputMaybe<ProjectBusinessPurpose>;
  lte?: InputMaybe<ProjectBusinessPurpose>;
  neq?: InputMaybe<ProjectBusinessPurpose>;
  notILike?: InputMaybe<ProjectBusinessPurpose>;
  notIn?: InputMaybe<Array<ProjectBusinessPurpose>>;
  notLike?: InputMaybe<ProjectBusinessPurpose>;
};

export enum ProjectDisallowance {
  AdaptationForCustomer = 'ADAPTATION_FOR_CUSTOMER',
  InternalUseSoftware = 'INTERNAL_USE_SOFTWARE',
  ResearchFundedByGrantContractEtc = 'RESEARCH_FUNDED_BY_GRANT_CONTRACT_ETC',
  ResearchIntoSocialSciences = 'RESEARCH_INTO_SOCIAL_SCIENCES',
  ResearchOutsideUs = 'RESEARCH_OUTSIDE_US',
  ReverseEngineering = 'REVERSE_ENGINEERING',
  SurveyOrMarketResearch = 'SURVEY_OR_MARKET_RESEARCH',
  TestingOrQaInProduction = 'TESTING_OR_QA_IN_PRODUCTION',
}

export type ProjectPerAccountingExpense = {
  __typename?: 'ProjectPerAccountingExpense';
  /** The percentage of the accounting expense that is allocated to this project as an unrounded number */
  allocationPercentNotRounded: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  rdProjectId: Scalars['ID']['output'];
};

export type ProjectPerRdExpense = {
  __typename?: 'ProjectPerRdExpense';
  /** The percentage of the payroll expense that is allocated to this project as an unrounded number */
  allocationPercentNotRounded: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  rdProjectId: Scalars['ID']['output'];
};

export enum ProjectPurpose {
  CreateNewProduct = 'CREATE_NEW_PRODUCT',
  ImproveExistingProduct = 'IMPROVE_EXISTING_PRODUCT',
}

export type ProjectPurposeFilterComparison = {
  eq?: InputMaybe<ProjectPurpose>;
  gt?: InputMaybe<ProjectPurpose>;
  gte?: InputMaybe<ProjectPurpose>;
  iLike?: InputMaybe<ProjectPurpose>;
  in?: InputMaybe<Array<ProjectPurpose>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ProjectPurpose>;
  lt?: InputMaybe<ProjectPurpose>;
  lte?: InputMaybe<ProjectPurpose>;
  neq?: InputMaybe<ProjectPurpose>;
  notILike?: InputMaybe<ProjectPurpose>;
  notIn?: InputMaybe<Array<ProjectPurpose>>;
  notLike?: InputMaybe<ProjectPurpose>;
};

export enum ProjectPurposeImprovedAspect {
  Function = 'FUNCTION',
  Performance = 'PERFORMANCE',
  Quality = 'QUALITY',
  Reliability = 'RELIABILITY',
}

export type ProjectRdDetermination = {
  __typename?: 'ProjectRdDetermination';
  createsNewProductOrProcess?: Maybe<Scalars['Boolean']['output']>;
  hasQualifiedPurpose: QualifiedPurposeDetermination;
  hasQualifiedPurposeSource?: Maybe<DeterminationSource>;
  hasTechnicalUncertainties: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  improvedAspects?: Maybe<Array<ProjectPurposeImprovedAspect>>;
  isTechnicalInNature: Scalars['Boolean']['output'];
  isTechnicalInNatureSource?: Maybe<DeterminationSource>;
  processOfExperimentationNarrative: Scalars['String']['output'];
  projectRdDeterminationUncertainties: Array<ProjectRdDeterminationUncertainty>;
  qualifiedPurposeReasoning: Scalars['String']['output'];
  qualifiedPurposeReasoningSource?: Maybe<DeterminationSource>;
  technicalInNatureShare: Scalars['Float']['output'];
  technicalUncertaintiesNarrative: Scalars['String']['output'];
  technicalUncertaintiesReasoning: Scalars['String']['output'];
};

export type ProjectRdDeterminationUncertainty = {
  __typename?: 'ProjectRdDeterminationUncertainty';
  id: Scalars['ID']['output'];
  matchedTicketCount: Scalars['Int']['output'];
  uncertainty: Scalars['String']['output'];
};

export enum ProviderType {
  Accounting = 'ACCOUNTING',
  Payroll = 'PAYROLL',
  PayrollMonthExpenses = 'PAYROLL_MONTH_EXPENSES',
  Ticketing = 'TICKETING',
}

export enum Province {
  Ab = 'AB',
  Bc = 'BC',
  Mb = 'MB',
  Nb = 'NB',
  Nl = 'NL',
  Ns = 'NS',
  Nt = 'NT',
  Nu = 'NU',
  On = 'ON',
  Pe = 'PE',
  Qc = 'QC',
  Sk = 'SK',
  Yt = 'YT',
}

export type ProvisionEmailPasswordUserInput = {
  continueUrl?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum QualifiedPurposeDetermination {
  False = 'FALSE',
  Maybe = 'MAYBE',
  True = 'TRUE',
}

export type Query = {
  __typename?: 'Query';
  /** Re-generate R&D project name and description using tickets (without saving) */
  generateRdProjectNameAndDescription: RdProjectNameAndDescription;
  getAccountingExpense: AccountingExpense;
  getAccountingQreSummary: AccountingQreSummary;
  getAccountingQres: AccountingQreConnection;
  getAllDocuments: Array<Documents>;
  getAllLegacyDocuments: Array<LegacyDocuments>;
  getAllocationChangePreview: PreviewAllocationChangeResult;
  getAscContributorProjectAllocations: AscContributorProjectAllocationConnection;
  /** Lock state of an ASC period and of the months it spans */
  getAscPeriodLockStatus: AscPeriodLockStatus;
  getAscProject: AscProject;
  getAscProjectCountInDateRange: BulkDeleteAscProjectsResult;
  getAscProjectGroupingTicketsOrCollections: Array<AscGroupingTicketOrCollection>;
  getAscProjectReport: AscProjectReport;
  getAscProjectTeamMembers: AscProjectTeamMemberConnection;
  getAscProjectTpTickets: AscProjectTpTicketsViewConnection;
  getAscProjects: AscProjectConnection;
  getAscProjectsSummary: AscProjectsSummary;
  getAscSnapshotDocumentEvents: Array<DocumentEvent>;
  getAscWage: AscWage;
  getAscWageReport: AscWageReportResult;
  getAscWageSummary: AscWageSummary;
  getAscWages: AscWageConnection;
  getBackgroundOperations: Array<BackgroundOperation>;
  getBulkTicketingDataFileUploads: Array<BulkTicketingDataFileUpload>;
  getCaSredSyncConfiguration?: Maybe<CaSredSyncConfigurationRo>;
  getCompaniesForUser?: Maybe<Array<Company>>;
  getCompany: Company;
  getCompanyOfficerPayrollQres: Array<PayrollQre>;
  getContributor: Contributor;
  getCreditEstimate: CreditEstimate;
  /** Whether the demo account is presentable — i.e. all its projects have been §41-evaluated. */
  getDemoAccountReadiness: DemoAccountReadiness;
  getDemoBundlePreflightReport: DemoBundlePreflightReport;
  getDistributedFlow: DistributedFlowState;
  getDistributedFlowsForCompany: Array<DistributedFlowState>;
  getDocumentEventSignedUrl: Scalars['String']['output'];
  getDocuments: Documents;
  /** Preview how many empty R&D projects would be deleted for a fiscal year */
  getEmptyRdProjectsDeletionPreview: BulkDeleteEmptyRdProjectsResult;
  getExcludedWorkstreamsForSyncConfigAscId: Array<SyncConfigurationsAscExcludedWorkstreamRo>;
  getFederalDocumentStatuses: FederalDocumentStatuses;
  getFinchSession: FinchSession;
  getFiscalYear: FiscalYear;
  getGaapOnboardingFlowStatus: GaapOnboardingFlowStatus;
  getInProgressDistributedFlows: Array<DistributedFlowState>;
  /** Get all Jira custom field metadata for a company with categories */
  getJiraFieldMetadataForCompany: Array<JiraFieldMetadata>;
  getLatestAscReportDocumentEvent?: Maybe<DocumentEvent>;
  getLatestFederalDocumentStatusesForCompany?: Maybe<FederalDocumentStatuses>;
  getMergeDevLinkToken?: Maybe<Scalars['String']['output']>;
  /** Get the merged R&D project ID after a merge operation completes */
  getMergedRdProjectId?: Maybe<Scalars['ID']['output']>;
  getOnCallRotation: Array<OnCallShift>;
  getOrganization: Organization;
  getOrganizationMembersCsv: Report;
  getPayrollExpense: PayrollExpense;
  getPayrollQreSummary: PayrollQreSummary;
  getPayrollQres: PayrollQreConnection;
  getPendingSentinelEmails: Array<SentinelEmail>;
  getProducts: Array<Product>;
  getRdBusinessComponentTicketMatches: RdBusinessComponentTicketMatches;
  getRdExpense: RdExpense;
  getRdExpenseProjectAllocationReport: RdExpenseProjectAllocationReportRo;
  getRdExpenseProjectAllocations: RdExpenseProjectAllocationConnection;
  getRdProject: RdProject;
  /** Number of R&D projects an "Update Project Details" run would cover */
  getRdProjectCountForDetailsUpdate: Scalars['Int']['output'];
  getRdProjectCountInPeriod: Scalars['Int']['output'];
  getRdProjectGroupingTicketsOrCollections: Array<RdGroupingTicketOrCollection>;
  getRdProjectReport: RdProjectReport;
  getRdProjectTeamMembers: RdProjectTeamMemberConnection;
  getRdProjectTpTickets: RdProjectTpTicketsViewConnection;
  getRdProjects: RdProjectConnection;
  getRdProjectsSummary: RdProjectsSummary;
  getRdTaxCreditContributor: RdTaxCreditContributor;
  /** Get paginated R&D tax credit contributors with their allocation method for a fiscal year */
  getRdTaxCreditContributorsWithAllocation: RdTaxCreditContributorsWithAllocationPaginated;
  getRdTicketMatchExport: RdTicketMatchExport;
  getReport: Report;
  getScheduledBackgroundOperationForToken?: Maybe<ScheduledBackgroundOperationModel>;
  getScheduledBackgroundOperations: Array<ScheduledBackgroundOperationModel>;
  getSentinelEmails: Array<SentinelEmail>;
  getServerInfo: ServerInfo;
  getSingleTenantDomainRedirects: Array<SingleTenantDomainRedirect>;
  getSingleTenantRedirectUrl?: Maybe<Scalars['String']['output']>;
  getSnowflakeConfiguration?: Maybe<SnowflakeTicketingToken>;
  getSredPayrollExpenses: SredPayrollExpenseConnection;
  getSredPayrollExpensesSummary: SredPayrollExpensesSummary;
  getSredProject: SredProject;
  getSredProjects: SredProjectConnection;
  getStateDocumentStatus: Scalars['Boolean']['output'];
  getSupervisorRdAnalysisPreview: Report;
  getSupervisorsInExpenses: SupervisorIdentificationResult;
  getTicketingProviderSyncEvents: Array<TicketingProviderSyncEvent>;
  getTicketingProviderWorkstreamsForCompany: Array<TicketingProviderWorkstream>;
  getTicketingUsers: TicketingUserConnection;
  getTimesheetRdReport: TimesheetRdReport;
  getTimesheetRdReportCsv: Report;
  getTimesheetSyncEvents: Array<TimesheetSyncEvent>;
  getUnfinishedSyncEventsInPeriodByAnalysisType?: Maybe<MonthYearPeriod>;
  getUser: User;
  getUserFromAuth?: Maybe<UserIdWithRole>;
  isVersionOutdated: Scalars['Boolean']['output'];
  rdExpenseProjects: RdExpenseProjectConnection;
  searchFirebaseIdentities: Array<FirebaseIdentityModel>;
  searchFirebaseIdentitiesByName: Array<FirebaseIdentityModel>;
  searchForCompanies: Array<Company>;
  searchForOrganization: Array<Organization>;
  searchForPotentialCompanyOfficers: Array<PayrollQre>;
  searchForUsers: Array<User>;
  searchLoginAuditLogs: Array<LoginAuditLog>;
};

export type QueryGenerateRdProjectNameAndDescriptionArgs = {
  rdProjectId: Scalars['ID']['input'];
};

export type QueryGetAccountingExpenseArgs = {
  accountingExpenseId: Scalars['ID']['input'];
};

export type QueryGetAccountingQreSummaryArgs = {
  filter?: AccountingQreSummaryFilter;
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetAccountingQresArgs = {
  filter?: AccountingQreFilter;
  fiscalYearId: Scalars['ID']['input'];
  paging?: CursorPaging;
  sorting?: Array<AccountingQreSort>;
};

export type QueryGetAllDocumentsArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetAllLegacyDocumentsArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetAllocationChangePreviewArgs = {
  fiscalYearId: Scalars['ID']['input'];
  rdTaxCreditContributorId: Scalars['ID']['input'];
  targetMethod: RdAllocationMethod;
};

export type QueryGetAscContributorProjectAllocationsArgs = {
  contributorId: Scalars['ID']['input'];
  filter?: AscContributorProjectAllocationFilter;
  fiscalYearId: Scalars['ID']['input'];
  paging?: CursorPaging;
  periodName: PeriodName;
  sorting?: Array<AscContributorProjectAllocationSort>;
};

export type QueryGetAscPeriodLockStatusArgs = {
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type QueryGetAscProjectArgs = {
  ascProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type QueryGetAscProjectCountInDateRangeArgs = {
  companyId: Scalars['ID']['input'];
  period: MonthYearPeriodInput;
};

export type QueryGetAscProjectGroupingTicketsOrCollectionsArgs = {
  ascProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAscProjectReportArgs = {
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type QueryGetAscProjectTeamMembersArgs = {
  ascProjectId: Scalars['ID']['input'];
  filter?: AscProjectTeamMemberFilter;
  fiscalYearId: Scalars['ID']['input'];
  paging?: CursorPaging;
  periodName: PeriodName;
  sorting?: Array<AscProjectTeamMemberSort>;
};

export type QueryGetAscProjectTpTicketsArgs = {
  ascProjectId: Scalars['ID']['input'];
  filter?: AscProjectTpTicketsViewFilter;
  fiscalYearId: Scalars['ID']['input'];
  paging?: CursorPaging;
  periodName: PeriodName;
  sorting?: Array<AscProjectTpTicketsViewSort>;
};

export type QueryGetAscProjectsArgs = {
  companyId: Scalars['ID']['input'];
  filter?: AscProjectFilter;
  fiscalYearId: Scalars['ID']['input'];
  paging?: CursorPaging;
  periodName: PeriodName;
  sorting?: Array<AscProjectSort>;
};

export type QueryGetAscProjectsSummaryArgs = {
  companyId: Scalars['ID']['input'];
  filter?: AscProjectsSummaryFilter;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type QueryGetAscSnapshotDocumentEventsArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetAscWageArgs = {
  ascWageId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type QueryGetAscWageReportArgs = {
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type QueryGetAscWageSummaryArgs = {
  filter?: AscWageSummaryFilter;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type QueryGetAscWagesArgs = {
  filter?: AscWageFilter;
  fiscalYearId: Scalars['ID']['input'];
  paging?: CursorPaging;
  periodName: PeriodName;
  sorting?: Array<AscWageSort>;
};

export type QueryGetBackgroundOperationsArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetBulkTicketingDataFileUploadsArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetCaSredSyncConfigurationArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetCompaniesForUserArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryGetCompanyArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetCompanyOfficerPayrollQresArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetContributorArgs = {
  contributorId: Scalars['ID']['input'];
};

export type QueryGetCreditEstimateArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetDemoAccountReadinessArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetDemoBundlePreflightReportArgs = {
  input: GetDemoBundlePreflightReportInput;
};

export type QueryGetDistributedFlowArgs = {
  distributedFlowId: Scalars['ID']['input'];
};

export type QueryGetDistributedFlowsForCompanyArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetDocumentEventSignedUrlArgs = {
  documentEventId: Scalars['ID']['input'];
};

export type QueryGetDocumentsArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetEmptyRdProjectsDeletionPreviewArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetExcludedWorkstreamsForSyncConfigAscIdArgs = {
  syncConfigurationAscId: Scalars['ID']['input'];
};

export type QueryGetFederalDocumentStatusesArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetFinchSessionArgs = {
  companyId: Scalars['ID']['input'];
  provider: Scalars['String']['input'];
};

export type QueryGetFiscalYearArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetGaapOnboardingFlowStatusArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetJiraFieldMetadataForCompanyArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetLatestAscReportDocumentEventArgs = {
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type QueryGetLatestFederalDocumentStatusesForCompanyArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetMergeDevLinkTokenArgs = {
  input: GetMergeDevLinkTokenInput;
  userId: Scalars['ID']['input'];
};

export type QueryGetMergedRdProjectIdArgs = {
  backgroundOperationId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationMembersCsvArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetPayrollExpenseArgs = {
  payrollExpenseId: Scalars['ID']['input'];
};

export type QueryGetPayrollQreSummaryArgs = {
  filter?: PayrollQreSummaryFilter;
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetPayrollQresArgs = {
  filter?: PayrollQreFilter;
  fiscalYearId: Scalars['ID']['input'];
  paging?: CursorPaging;
  sorting?: Array<PayrollQreSort>;
};

export type QueryGetPendingSentinelEmailsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetProductsArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetRdBusinessComponentTicketMatchesArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetRdExpenseArgs = {
  rdExpenseId: Scalars['ID']['input'];
};

export type QueryGetRdExpenseProjectAllocationReportArgs = {
  fiscalYearId: Scalars['ID']['input'];
  providerType: ProviderType;
};

export type QueryGetRdExpenseProjectAllocationsArgs = {
  filter?: RdExpenseProjectAllocationFilter;
  fiscalYearId: Scalars['ID']['input'];
  paging?: CursorPaging;
  rdExpenseId: Scalars['ID']['input'];
  sorting?: Array<RdExpenseProjectAllocationSort>;
};

export type QueryGetRdProjectArgs = {
  rdProjectId: Scalars['ID']['input'];
};

export type QueryGetRdProjectCountForDetailsUpdateArgs = {
  fiscalYearId: Scalars['ID']['input'];
  scope: RdProjectDetailsUpdateScope;
};

export type QueryGetRdProjectCountInPeriodArgs = {
  companyId: Scalars['ID']['input'];
  period: MonthYearPeriodInput;
};

export type QueryGetRdProjectGroupingTicketsOrCollectionsArgs = {
  fiscalYearId: Scalars['ID']['input'];
  rdProjectId: Scalars['ID']['input'];
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetRdProjectReportArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetRdProjectTeamMembersArgs = {
  filter?: RdProjectTeamMemberFilter;
  fiscalYearId: Scalars['ID']['input'];
  paging?: CursorPaging;
  rdProjectId: Scalars['ID']['input'];
  sorting?: Array<RdProjectTeamMemberSort>;
};

export type QueryGetRdProjectTpTicketsArgs = {
  filter?: RdProjectTpTicketsViewFilter;
  paging?: CursorPaging;
  rdProjectId: Scalars['ID']['input'];
  sorting?: Array<RdProjectTpTicketsViewSort>;
};

export type QueryGetRdProjectsArgs = {
  filter?: RdProjectFilter;
  fiscalYearId: Scalars['ID']['input'];
  paging?: CursorPaging;
  sorting?: Array<RdProjectSort>;
};

export type QueryGetRdProjectsSummaryArgs = {
  filter?: RdProjectsSummaryFilter;
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetRdTaxCreditContributorArgs = {
  rdTaxCreditContributorId: Scalars['ID']['input'];
};

export type QueryGetRdTaxCreditContributorsWithAllocationArgs = {
  fiscalYearId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<RdTaxCreditContributorSortInput>;
};

export type QueryGetRdTicketMatchExportArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetReportArgs = {
  keyValuePairs: Array<KeyValuePairInput>;
  reportName: ReportName;
};

export type QueryGetScheduledBackgroundOperationForTokenArgs = {
  ticketingTokenId: Scalars['ID']['input'];
};

export type QueryGetScheduledBackgroundOperationsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetSentinelEmailsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetSingleTenantRedirectUrlArgs = {
  email: Scalars['String']['input'];
};

export type QueryGetSnowflakeConfigurationArgs = {
  companyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type QueryGetSredPayrollExpensesArgs = {
  filter?: SredPayrollExpenseFilter;
  paging?: CursorPaging;
  sorting?: Array<SredPayrollExpenseSort>;
  sredTaxCreditId: Scalars['ID']['input'];
};

export type QueryGetSredPayrollExpensesSummaryArgs = {
  filter?: SredPayrollExpensesSummaryFilter;
  sredTaxCreditId: Scalars['ID']['input'];
};

export type QueryGetSredProjectArgs = {
  sredProjectId: Scalars['ID']['input'];
};

export type QueryGetSredProjectsArgs = {
  filter?: SredProjectFilter;
  paging?: CursorPaging;
  sorting?: Array<SredProjectSort>;
  sredTaxCreditId: Scalars['ID']['input'];
};

export type QueryGetStateDocumentStatusArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetSupervisorRdAnalysisPreviewArgs = {
  expenseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<PayrollQreFilter>;
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetSupervisorsInExpensesArgs = {
  expenseIds: Array<Scalars['ID']['input']>;
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetTicketingProviderSyncEventsArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetTicketingProviderWorkstreamsForCompanyArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetTicketingUsersArgs = {
  companyId: Scalars['ID']['input'];
  filter?: TicketingUserFilter;
  paging?: CursorPaging;
  rdTaxCreditId: Scalars['ID']['input'];
  sorting?: Array<TicketingUserSort>;
};

export type QueryGetTimesheetRdReportArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetTimesheetRdReportCsvArgs = {
  fiscalYearId: Scalars['ID']['input'];
};

export type QueryGetTimesheetSyncEventsArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetUnfinishedSyncEventsInPeriodByAnalysisTypeArgs = {
  analysisType: AnalysisType;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
};

export type QueryGetUserArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryGetUserFromAuthArgs = {
  firebaseUserId: Scalars['String']['input'];
};

export type QueryRdExpenseProjectsArgs = {
  filter?: RdExpenseProjectFilter;
  paging?: CursorPaging;
  sorting?: Array<RdExpenseProjectSort>;
};

export type QuerySearchFirebaseIdentitiesArgs = {
  input: SearchFirebaseIdentitiesInput;
};

export type QuerySearchFirebaseIdentitiesByNameArgs = {
  input: SearchFirebaseIdentitiesByNameInput;
};

export type QuerySearchForCompaniesArgs = {
  companySearchInput: CompanySearchInput;
};

export type QuerySearchForOrganizationArgs = {
  searchForOrganizationInput: SearchForOrganizationInput;
};

export type QuerySearchForPotentialCompanyOfficersArgs = {
  fiscalYearId: Scalars['ID']['input'];
  searchTerm: Scalars['String']['input'];
};

export type QuerySearchForUsersArgs = {
  searchString: Scalars['String']['input'];
};

export type QuerySearchLoginAuditLogsArgs = {
  input: SearchLoginAuditLogsInput;
};

export type Question = {
  __typename?: 'Question';
  answerType: AnswerType;
  /** For a `Question` which has no `questionChoices`, the single value (if any) currently set for this `Question` for the `Company`. For a `Question` with `questionChoices`, instead see each `QuestionChoice`'s `selected` field. */
  answerValue?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  displaySubtext?: Maybe<Scalars['String']['output']>;
  displayText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputType: InputType;
  parentQuestionChoice?: Maybe<ParentQuestionChoice>;
  placeholder?: Maybe<Scalars['String']['output']>;
  questionChoices?: Maybe<Array<QuestionChoice>>;
  questionCode: QuestionCode;
  questionId: Scalars['ID']['output'];
};

export type QuestionChoice = {
  __typename?: 'QuestionChoice';
  choiceCode: ChoiceCode;
  displayOrder: Scalars['Int']['output'];
  displaySubtext?: Maybe<Scalars['String']['output']>;
  displayText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether this `QuestionChoice` is currently selected by the `Company`. */
  selected: Scalars['Boolean']['output'];
};

export enum QuestionCode {
  CompanyAddressCity = 'COMPANY_ADDRESS_CITY',
  CompanyAddressLine1 = 'COMPANY_ADDRESS_LINE1',
  CompanyAddressLine2 = 'COMPANY_ADDRESS_LINE2',
  CompanyAddressPostalCode = 'COMPANY_ADDRESS_POSTAL_CODE',
  CompanyAddressState = 'COMPANY_ADDRESS_STATE',
  CompanyElevatorPitch = 'COMPANY_ELEVATOR_PITCH',
  CompanyUrl = 'COMPANY_URL',
  ControlledGroupFilingType = 'CONTROLLED_GROUP_FILING_TYPE',
  ControlledGroupMembersCount = 'CONTROLLED_GROUP_MEMBERS_COUNT',
  ControlledGroupMembersCountPrev = 'CONTROLLED_GROUP_MEMBERS_COUNT_PREV',
  CurrentIncorporationDate = 'CURRENT_INCORPORATION_DATE',
  DesignDocumentation = 'DESIGN_DOCUMENTATION',
  DifferentPayrollEin = 'DIFFERENT_PAYROLL_EIN',
  DoingBusinessAs = 'DOING_BUSINESS_AS',
  EntityType = 'ENTITY_TYPE',
  FirstYearClaimedRdCredit = 'FIRST_YEAR_CLAIMED_RD_CREDIT',
  FirstYearQreAndPyr = 'FIRST_YEAR_QRE_AND_PYR',
  FundedResearchTypes = 'FUNDED_RESEARCH_TYPES',
  HadAquiredABusiness = 'HAD_AQUIRED_A_BUSINESS',
  HadDisposedABusiness = 'HAD_DISPOSED_A_BUSINESS',
  HadFundedResearch = 'HAD_FUNDED_RESEARCH',
  HadNewQreCategories = 'HAD_NEW_QRE_CATEGORIES',
  HadPayrollSwitch = 'HAD_PAYROLL_SWITCH',
  HadPreviouslyClaimedRdCredit = 'HAD_PREVIOUSLY_CLAIMED_RD_CREDIT',
  HadPreviousEntity = 'HAD_PREVIOUS_ENTITY',
  HadPurchaseOrSaleControlledGroup = 'HAD_PURCHASE_OR_SALE_CONTROLLED_GROUP',
  HadQualifiedPayments = 'HAD_QUALIFIED_PAYMENTS',
  HadQualifiedResearchByControlledGroup = 'HAD_QUALIFIED_RESEARCH_BY_CONTROLLED_GROUP',
  HadShortYear = 'HAD_SHORT_YEAR',
  HardSciences = 'HARD_SCIENCES',
  ImplementationDocumentation = 'IMPLEMENTATION_DOCUMENTATION',
  IsControlledGroup = 'IS_CONTROLLED_GROUP',
  LegalName = 'LEGAL_NAME',
  OriginalIncorporationDate = 'ORIGINAL_INCORPORATION_DATE',
  OtherDocumentation = 'OTHER_DOCUMENTATION',
  OtherFundedResearch = 'OTHER_FUNDED_RESEARCH',
  Patents = 'PATENTS',
  PlanningDocumentation = 'PLANNING_DOCUMENTATION',
  PrimaryEin = 'PRIMARY_EIN',
  ProjectPlanningMethodology = 'PROJECT_PLANNING_METHODOLOGY',
  ResearchActivities = 'RESEARCH_ACTIVITIES',
  ResponsibleForRdCredit = 'RESPONSIBLE_FOR_RD_CREDIT',
  ShortYearEndMonthYear = 'SHORT_YEAR_END_MONTH_YEAR',
  ShortYearStartMonthYear = 'SHORT_YEAR_START_MONTH_YEAR',
  UploadStorageUrlEntityStructure = 'UPLOAD_STORAGE_URL_ENTITY_STRUCTURE',
  UploadStorageUrlTaxReturnYearMinus_1 = 'UPLOAD_STORAGE_URL_TAX_RETURN_YEAR_MINUS_1',
  UploadStorageUrlTaxReturnYearMinus_2 = 'UPLOAD_STORAGE_URL_TAX_RETURN_YEAR_MINUS_2',
  UploadStorageUrlTaxReturnYearMinus_3 = 'UPLOAD_STORAGE_URL_TAX_RETURN_YEAR_MINUS_3',
}

export type QuestionSection = {
  __typename?: 'QuestionSection';
  displayOrder: Scalars['Int']['output'];
  displaySubtext?: Maybe<Scalars['String']['output']>;
  displayText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  questions: Array<Question>;
  sectionCode: QuestionSectionCode;
};

export enum QuestionSectionCode {
  CompanyActivity = 'COMPANY_ACTIVITY',
  CompanyAddress = 'COMPANY_ADDRESS',
  CompanyDetails = 'COMPANY_DETAILS',
  CompanyFinances = 'COMPANY_FINANCES',
  CompanyHistory = 'COMPANY_HISTORY',
  CompanyRdDocumentation = 'COMPANY_RD_DOCUMENTATION',
  CompanyToolsDocumentation = 'COMPANY_TOOLS_DOCUMENTATION',
  CreditCalculation = 'CREDIT_CALCULATION',
  ShortYearDetails = 'SHORT_YEAR_DETAILS',
}

export enum QueueIdentifier {
  QueueChildrenAssignTicketingUsersToTeams = 'QUEUE_CHILDREN_ASSIGN_TICKETING_USERS_TO_TEAMS',
  QueueChildrenCalculateAscAllocations = 'QUEUE_CHILDREN_CALCULATE_ASC_ALLOCATIONS',
  QueueChildrenCalculateRdAllocations = 'QUEUE_CHILDREN_CALCULATE_RD_ALLOCATIONS',
  QueueChildrenCarryForwardAscHr = 'QUEUE_CHILDREN_CARRY_FORWARD_ASC_HR',
  QueueChildrenClassifyTicketsV3 = 'QUEUE_CHILDREN_CLASSIFY_TICKETS_V3',
  QueueChildrenCleanExistingAscData = 'QUEUE_CHILDREN_CLEAN_EXISTING_ASC_DATA',
  QueueChildrenCleanExistingRdData = 'QUEUE_CHILDREN_CLEAN_EXISTING_RD_DATA',
  QueueChildrenClusterRdProjects = 'QUEUE_CHILDREN_CLUSTER_RD_PROJECTS',
  QueueChildrenCreateGaapTickets = 'QUEUE_CHILDREN_CREATE_GAAP_TICKETS',
  QueueChildrenCreateTicketingUsersFromTickets = 'QUEUE_CHILDREN_CREATE_TICKETING_USERS_FROM_TICKETS',
  QueueChildrenCreateWorkstreams = 'QUEUE_CHILDREN_CREATE_WORKSTREAMS',
  QueueChildrenDetermineAscCapitalization = 'QUEUE_CHILDREN_DETERMINE_ASC_CAPITALIZATION',
  QueueChildrenDetermineRdEligibilityV3 = 'QUEUE_CHILDREN_DETERMINE_RD_ELIGIBILITY_V3',
  QueueChildrenEnrichCustomFieldsFromCollectionIssueTypeScope = 'QUEUE_CHILDREN_ENRICH_CUSTOM_FIELDS_FROM_COLLECTION_ISSUE_TYPE_SCOPE',
  QueueChildrenEnrichCustomFieldsFromGlobalScope = 'QUEUE_CHILDREN_ENRICH_CUSTOM_FIELDS_FROM_GLOBAL_SCOPE',
  QueueChildrenEnrichTicketingDataV3 = 'QUEUE_CHILDREN_ENRICH_TICKETING_DATA_V3',
  QueueChildrenEstimateTicketEffortAsc = 'QUEUE_CHILDREN_ESTIMATE_TICKET_EFFORT_ASC',
  QueueChildrenEstimateTicketEffortRd = 'QUEUE_CHILDREN_ESTIMATE_TICKET_EFFORT_RD',
  QueueChildrenExtractJiraCustomFields = 'QUEUE_CHILDREN_EXTRACT_JIRA_CUSTOM_FIELDS',
  QueueChildrenGenerateAscClusterPartitions = 'QUEUE_CHILDREN_GENERATE_ASC_CLUSTER_PARTITIONS',
  QueueChildrenGenerateAscProjects = 'QUEUE_CHILDREN_GENERATE_ASC_PROJECTS',
  QueueChildrenGenerateAscProjectMatchKeywords = 'QUEUE_CHILDREN_GENERATE_ASC_PROJECT_MATCH_KEYWORDS',
  QueueChildrenGenerateAscReportAndSendEmail = 'QUEUE_CHILDREN_GENERATE_ASC_REPORT_AND_SEND_EMAIL',
  QueueChildrenGenerateAscReportForSnapshot = 'QUEUE_CHILDREN_GENERATE_ASC_REPORT_FOR_SNAPSHOT',
  QueueChildrenGenerateHierarchyClusters = 'QUEUE_CHILDREN_GENERATE_HIERARCHY_CLUSTERS',
  QueueChildrenGeneratePredictedClusters = 'QUEUE_CHILDREN_GENERATE_PREDICTED_CLUSTERS',
  QueueChildrenGenerateRdClusterPartitions = 'QUEUE_CHILDREN_GENERATE_RD_CLUSTER_PARTITIONS',
  QueueChildrenGenerateRdFromTimesheetsAllocate = 'QUEUE_CHILDREN_GENERATE_RD_FROM_TIMESHEETS_ALLOCATE',
  QueueChildrenGenerateRdFromTimesheetsCleanupProjects = 'QUEUE_CHILDREN_GENERATE_RD_FROM_TIMESHEETS_CLEANUP_PROJECTS',
  QueueChildrenGenerateRdFromTimesheetsCleanupUsers = 'QUEUE_CHILDREN_GENERATE_RD_FROM_TIMESHEETS_CLEANUP_USERS',
  QueueChildrenGenerateRdFromTimesheetsCopy = 'QUEUE_CHILDREN_GENERATE_RD_FROM_TIMESHEETS_COPY',
  QueueChildrenGenerateRdFromTimesheetsMatch = 'QUEUE_CHILDREN_GENERATE_RD_FROM_TIMESHEETS_MATCH',
  QueueChildrenGenerateRdFromTimesheetsProjects = 'QUEUE_CHILDREN_GENERATE_RD_FROM_TIMESHEETS_PROJECTS',
  QueueChildrenGenerateRdProjects = 'QUEUE_CHILDREN_GENERATE_RD_PROJECTS',
  QueueChildrenGroupTickets = 'QUEUE_CHILDREN_GROUP_TICKETS',
  QueueChildrenPopulateAscTicketGroups = 'QUEUE_CHILDREN_POPULATE_ASC_TICKET_GROUPS',
  QueueChildrenPredictAscCapitalizationMilestones = 'QUEUE_CHILDREN_PREDICT_ASC_CAPITALIZATION_MILESTONES',
  QueueChildrenPredictAscCapitalizationStatus = 'QUEUE_CHILDREN_PREDICT_ASC_CAPITALIZATION_STATUS',
  QueueChildrenPredictParentlessTicketMatchAsc = 'QUEUE_CHILDREN_PREDICT_PARENTLESS_TICKET_MATCH_ASC',
  QueueChildrenPredictTicketDurationAsc = 'QUEUE_CHILDREN_PREDICT_TICKET_DURATION_ASC',
  QueueChildrenPredictTicketDurationRd = 'QUEUE_CHILDREN_PREDICT_TICKET_DURATION_RD',
  QueueChildrenPredictTicketGroupMatchAsc = 'QUEUE_CHILDREN_PREDICT_TICKET_GROUP_MATCH_ASC',
  QueueChildrenPredictWorkstreamMatchAsc = 'QUEUE_CHILDREN_PREDICT_WORKSTREAM_MATCH_ASC',
  QueueChildrenRdBcFlowCleanExistingRdProjects = 'QUEUE_CHILDREN_RD_BC_FLOW_CLEAN_EXISTING_RD_PROJECTS',
  QueueChildrenRdBcFlowFeaturizeTickets = 'QUEUE_CHILDREN_RD_BC_FLOW_FEATURIZE_TICKETS',
  QueueChildrenRdBcFlowGenerateBusinessComponents = 'QUEUE_CHILDREN_RD_BC_FLOW_GENERATE_BUSINESS_COMPONENTS',
  QueueChildrenRdBcFlowGenerateRdProjects = 'QUEUE_CHILDREN_RD_BC_FLOW_GENERATE_RD_PROJECTS',
  QueueChildrenRdBcFlowSelectSyncEvent = 'QUEUE_CHILDREN_RD_BC_FLOW_SELECT_SYNC_EVENT',
  QueueChildrenRdBcFlowStageTickets = 'QUEUE_CHILDREN_RD_BC_FLOW_STAGE_TICKETS',
  QueueChildrenRecalculateSingleAscContributor = 'QUEUE_CHILDREN_RECALCULATE_SINGLE_ASC_CONTRIBUTOR',
  QueueChildrenRecalculateSingleContributor = 'QUEUE_CHILDREN_RECALCULATE_SINGLE_CONTRIBUTOR',
  QueueChildrenReclassifyTickets = 'QUEUE_CHILDREN_RECLASSIFY_TICKETS',
  QueueChildrenReconcileTicketingProviderUsersAsc = 'QUEUE_CHILDREN_RECONCILE_TICKETING_PROVIDER_USERS_ASC',
  QueueChildrenReconcileTicketingProviderUsersRd = 'QUEUE_CHILDREN_RECONCILE_TICKETING_PROVIDER_USERS_RD',
  QueueChildrenRegenerateSingleRdProjectDetails = 'QUEUE_CHILDREN_REGENERATE_SINGLE_RD_PROJECT_DETAILS',
  QueueChildrenResolveCollectionParent = 'QUEUE_CHILDREN_RESOLVE_COLLECTION_PARENT',
  QueueChildrenResolveCustomFields = 'QUEUE_CHILDREN_RESOLVE_CUSTOM_FIELDS',
  QueueChildrenResolveTicketParent = 'QUEUE_CHILDREN_RESOLVE_TICKET_PARENT',
  QueueChildrenResolveTicketRelations = 'QUEUE_CHILDREN_RESOLVE_TICKET_RELATIONS',
  QueueChildrenResolveTicketStatus = 'QUEUE_CHILDREN_RESOLVE_TICKET_STATUS',
  QueueChildrenSetupCustomFields = 'QUEUE_CHILDREN_SETUP_CUSTOM_FIELDS',
  QueueChildrenSetupCustomFieldsCollections = 'QUEUE_CHILDREN_SETUP_CUSTOM_FIELDS_COLLECTIONS',
  QueueChildrenSetupCustomFieldsCollectionIssueTypes = 'QUEUE_CHILDREN_SETUP_CUSTOM_FIELDS_COLLECTION_ISSUE_TYPES',
  QueueChildrenSetupStatusCategoryMappings = 'QUEUE_CHILDREN_SETUP_STATUS_CATEGORY_MAPPINGS',
  QueueChildrenSetupTicketingTokenConfiguration = 'QUEUE_CHILDREN_SETUP_TICKETING_TOKEN_CONFIGURATION',
  QueueChildrenSyncCollectionsV3 = 'QUEUE_CHILDREN_SYNC_COLLECTIONS_V3',
  QueueChildrenSyncTeamsV3 = 'QUEUE_CHILDREN_SYNC_TEAMS_V3',
  QueueChildrenSyncTicketsV3 = 'QUEUE_CHILDREN_SYNC_TICKETS_V3',
  QueueChildrenSyncUsersV3 = 'QUEUE_CHILDREN_SYNC_USERS_V3',
  QueueChildrenUpdateAscProjects = 'QUEUE_CHILDREN_UPDATE_ASC_PROJECTS',
  QueueChildrenValidateEpicPresence = 'QUEUE_CHILDREN_VALIDATE_EPIC_PRESENCE',
  QueueChildrenValidateParentChildRelationships = 'QUEUE_CHILDREN_VALIDATE_PARENT_CHILD_RELATIONSHIPS',
  QueueChildrenValidateUserTicketAssigneeMatch = 'QUEUE_CHILDREN_VALIDATE_USER_TICKET_ASSIGNEE_MATCH',
  QueueChildrenValidateWorkstreamKeyUniqueness = 'QUEUE_CHILDREN_VALIDATE_WORKSTREAM_KEY_UNIQUENESS',
  QueueChildrenValidateWorkstreamTicketDistribution = 'QUEUE_CHILDREN_VALIDATE_WORKSTREAM_TICKET_DISTRIBUTION',
  QueueCoordinatorApplyGithubEmailMapping = 'QUEUE_COORDINATOR_APPLY_GITHUB_EMAIL_MAPPING',
  QueueCoordinatorApplyRdSupervisorAllocation = 'QUEUE_COORDINATOR_APPLY_RD_SUPERVISOR_ALLOCATION',
  QueueCoordinatorAssignTicketingUsersToTeams = 'QUEUE_COORDINATOR_ASSIGN_TICKETING_USERS_TO_TEAMS',
  QueueCoordinatorCalculateAllocationsAsc = 'QUEUE_COORDINATOR_CALCULATE_ALLOCATIONS_ASC',
  QueueCoordinatorCalculateAllocationsRd = 'QUEUE_COORDINATOR_CALCULATE_ALLOCATIONS_RD',
  QueueCoordinatorCarryForwardAscHr = 'QUEUE_COORDINATOR_CARRY_FORWARD_ASC_HR',
  QueueCoordinatorClassifyTicketsV3 = 'QUEUE_COORDINATOR_CLASSIFY_TICKETS_V3',
  QueueCoordinatorCleanExistingDataAsc = 'QUEUE_COORDINATOR_CLEAN_EXISTING_DATA_ASC',
  QueueCoordinatorCleanExistingDataRd = 'QUEUE_COORDINATOR_CLEAN_EXISTING_DATA_RD',
  QueueCoordinatorCompleteBulkRecalculateAscAllocations = 'QUEUE_COORDINATOR_COMPLETE_BULK_RECALCULATE_ASC_ALLOCATIONS',
  QueueCoordinatorCompleteBulkRecalculateRdAllocations = 'QUEUE_COORDINATOR_COMPLETE_BULK_RECALCULATE_RD_ALLOCATIONS',
  QueueCoordinatorCompleteFlowCalculateAllocationsAsc = 'QUEUE_COORDINATOR_COMPLETE_FLOW_CALCULATE_ALLOCATIONS_ASC',
  QueueCoordinatorCompleteFlowCalculateAllocationsRd = 'QUEUE_COORDINATOR_COMPLETE_FLOW_CALCULATE_ALLOCATIONS_RD',
  QueueCoordinatorCompleteFlowCarryForwardAscHr = 'QUEUE_COORDINATOR_COMPLETE_FLOW_CARRY_FORWARD_ASC_HR',
  QueueCoordinatorCompleteFlowCreateGaapTickets = 'QUEUE_COORDINATOR_COMPLETE_FLOW_CREATE_GAAP_TICKETS',
  QueueCoordinatorCompleteFlowDetermineAscCapitalization = 'QUEUE_COORDINATOR_COMPLETE_FLOW_DETERMINE_ASC_CAPITALIZATION',
  QueueCoordinatorCompleteFlowDetermineRdEligibilityV3 = 'QUEUE_COORDINATOR_COMPLETE_FLOW_DETERMINE_RD_ELIGIBILITY_V3',
  QueueCoordinatorCompleteFlowGenerateAscReportAndSendEmail = 'QUEUE_COORDINATOR_COMPLETE_FLOW_GENERATE_ASC_REPORT_AND_SEND_EMAIL',
  QueueCoordinatorCompleteFlowGenerateAscReportForSnapshot = 'QUEUE_COORDINATOR_COMPLETE_FLOW_GENERATE_ASC_REPORT_FOR_SNAPSHOT',
  QueueCoordinatorCompleteFlowGenerateClustersAsc = 'QUEUE_COORDINATOR_COMPLETE_FLOW_GENERATE_CLUSTERS_ASC',
  QueueCoordinatorCompleteFlowGenerateClustersRd = 'QUEUE_COORDINATOR_COMPLETE_FLOW_GENERATE_CLUSTERS_RD',
  QueueCoordinatorCompleteFlowGenerateProjectsAsc = 'QUEUE_COORDINATOR_COMPLETE_FLOW_GENERATE_PROJECTS_ASC',
  QueueCoordinatorCompleteFlowGenerateProjectsRd = 'QUEUE_COORDINATOR_COMPLETE_FLOW_GENERATE_PROJECTS_RD',
  QueueCoordinatorCompleteFlowGenerateTicketPartitionsAsc = 'QUEUE_COORDINATOR_COMPLETE_FLOW_GENERATE_TICKET_PARTITIONS_ASC',
  QueueCoordinatorCompleteFlowGenerateTicketPartitionsRd = 'QUEUE_COORDINATOR_COMPLETE_FLOW_GENERATE_TICKET_PARTITIONS_RD',
  QueueCoordinatorCompleteFlowReconcileTicketingProviderUsersAsc = 'QUEUE_COORDINATOR_COMPLETE_FLOW_RECONCILE_TICKETING_PROVIDER_USERS_ASC',
  QueueCoordinatorCompleteFlowReconcileTicketingProviderUsersRd = 'QUEUE_COORDINATOR_COMPLETE_FLOW_RECONCILE_TICKETING_PROVIDER_USERS_RD',
  QueueCoordinatorCompleteFlowSetupTicketingDataAsc = 'QUEUE_COORDINATOR_COMPLETE_FLOW_SETUP_TICKETING_DATA_ASC',
  QueueCoordinatorCompleteFlowSyncTicketingDataV3 = 'QUEUE_COORDINATOR_COMPLETE_FLOW_SYNC_TICKETING_DATA_V3',
  QueueCoordinatorCompleteFlowTicketEffortEstimationAsc = 'QUEUE_COORDINATOR_COMPLETE_FLOW_TICKET_EFFORT_ESTIMATION_ASC',
  QueueCoordinatorCompleteFlowTicketEffortEstimationRd = 'QUEUE_COORDINATOR_COMPLETE_FLOW_TICKET_EFFORT_ESTIMATION_RD',
  QueueCoordinatorCompleteFlowValidateTicketingFiles = 'QUEUE_COORDINATOR_COMPLETE_FLOW_VALIDATE_TICKETING_FILES',
  QueueCoordinatorCompleteRegenerateRdProjectDetails = 'QUEUE_COORDINATOR_COMPLETE_REGENERATE_RD_PROJECT_DETAILS',
  QueueCoordinatorCreateGaapTickets = 'QUEUE_COORDINATOR_CREATE_GAAP_TICKETS',
  QueueCoordinatorCreateTicketingUsersFromTickets = 'QUEUE_COORDINATOR_CREATE_TICKETING_USERS_FROM_TICKETS',
  QueueCoordinatorCreateWorkstreams = 'QUEUE_COORDINATOR_CREATE_WORKSTREAMS',
  QueueCoordinatorDataIsAvailableV3 = 'QUEUE_COORDINATOR_DATA_IS_AVAILABLE_V3',
  QueueCoordinatorDetermineAscCapitalization = 'QUEUE_COORDINATOR_DETERMINE_ASC_CAPITALIZATION',
  QueueCoordinatorDetermineRdEligibilityV3 = 'QUEUE_COORDINATOR_DETERMINE_RD_ELIGIBILITY_V3',
  QueueCoordinatorEnrichCustomFieldsFromCollectionIssueTypeScope = 'QUEUE_COORDINATOR_ENRICH_CUSTOM_FIELDS_FROM_COLLECTION_ISSUE_TYPE_SCOPE',
  QueueCoordinatorEnrichCustomFieldsFromGlobalScope = 'QUEUE_COORDINATOR_ENRICH_CUSTOM_FIELDS_FROM_GLOBAL_SCOPE',
  QueueCoordinatorEnrichTicketingDataV3 = 'QUEUE_COORDINATOR_ENRICH_TICKETING_DATA_V3',
  QueueCoordinatorEstimateTicketEffortAsc = 'QUEUE_COORDINATOR_ESTIMATE_TICKET_EFFORT_ASC',
  QueueCoordinatorEstimateTicketEffortRd = 'QUEUE_COORDINATOR_ESTIMATE_TICKET_EFFORT_RD',
  QueueCoordinatorExtractJiraCustomFields = 'QUEUE_COORDINATOR_EXTRACT_JIRA_CUSTOM_FIELDS',
  QueueCoordinatorFanoutBulkRecalculateAscAllocations = 'QUEUE_COORDINATOR_FANOUT_BULK_RECALCULATE_ASC_ALLOCATIONS',
  QueueCoordinatorGenerateAscProjectMatchKeywords = 'QUEUE_COORDINATOR_GENERATE_ASC_PROJECT_MATCH_KEYWORDS',
  QueueCoordinatorGenerateAscReportAndSendEmail = 'QUEUE_COORDINATOR_GENERATE_ASC_REPORT_AND_SEND_EMAIL',
  QueueCoordinatorGenerateAscReportForSnapshot = 'QUEUE_COORDINATOR_GENERATE_ASC_REPORT_FOR_SNAPSHOT',
  QueueCoordinatorGenerateClustersAsc = 'QUEUE_COORDINATOR_GENERATE_CLUSTERS_ASC',
  QueueCoordinatorGenerateClustersRd = 'QUEUE_COORDINATOR_GENERATE_CLUSTERS_RD',
  QueueCoordinatorGenerateFederalRdWriteup = 'QUEUE_COORDINATOR_GENERATE_FEDERAL_RD_WRITEUP',
  QueueCoordinatorGenerateProjectsAsc = 'QUEUE_COORDINATOR_GENERATE_PROJECTS_ASC',
  QueueCoordinatorGenerateProjectsRd = 'QUEUE_COORDINATOR_GENERATE_PROJECTS_RD',
  QueueCoordinatorGenerateRdFromTimesheetsAllocate = 'QUEUE_COORDINATOR_GENERATE_RD_FROM_TIMESHEETS_ALLOCATE',
  QueueCoordinatorGenerateRdFromTimesheetsCleanupProjects = 'QUEUE_COORDINATOR_GENERATE_RD_FROM_TIMESHEETS_CLEANUP_PROJECTS',
  QueueCoordinatorGenerateRdFromTimesheetsCleanupUsers = 'QUEUE_COORDINATOR_GENERATE_RD_FROM_TIMESHEETS_CLEANUP_USERS',
  QueueCoordinatorGenerateRdFromTimesheetsComplete = 'QUEUE_COORDINATOR_GENERATE_RD_FROM_TIMESHEETS_COMPLETE',
  QueueCoordinatorGenerateRdFromTimesheetsCopy = 'QUEUE_COORDINATOR_GENERATE_RD_FROM_TIMESHEETS_COPY',
  QueueCoordinatorGenerateRdFromTimesheetsMatch = 'QUEUE_COORDINATOR_GENERATE_RD_FROM_TIMESHEETS_MATCH',
  QueueCoordinatorGenerateRdFromTimesheetsProjects = 'QUEUE_COORDINATOR_GENERATE_RD_FROM_TIMESHEETS_PROJECTS',
  QueueCoordinatorGenerateRdProjectsReport = 'QUEUE_COORDINATOR_GENERATE_RD_PROJECTS_REPORT',
  QueueCoordinatorGenerateTicketPartitionsAsc = 'QUEUE_COORDINATOR_GENERATE_TICKET_PARTITIONS_ASC',
  QueueCoordinatorGenerateTicketPartitionsRd = 'QUEUE_COORDINATOR_GENERATE_TICKET_PARTITIONS_RD',
  QueueCoordinatorGroupTickets = 'QUEUE_COORDINATOR_GROUP_TICKETS',
  QueueCoordinatorImportAscCostFile = 'QUEUE_COORDINATOR_IMPORT_ASC_COST_FILE',
  QueueCoordinatorImportAscProjectsFile = 'QUEUE_COORDINATOR_IMPORT_ASC_PROJECTS_FILE',
  QueueCoordinatorImportRdCostFile = 'QUEUE_COORDINATOR_IMPORT_RD_COST_FILE',
  QueueCoordinatorImportRdProjectsFile = 'QUEUE_COORDINATOR_IMPORT_RD_PROJECTS_FILE',
  QueueCoordinatorImportTimesheetFile = 'QUEUE_COORDINATOR_IMPORT_TIMESHEET_FILE',
  QueueCoordinatorMergeRdProjects = 'QUEUE_COORDINATOR_MERGE_RD_PROJECTS',
  QueueCoordinatorPopulateAscTicketGroups = 'QUEUE_COORDINATOR_POPULATE_ASC_TICKET_GROUPS',
  QueueCoordinatorPredictAscCapitalization = 'QUEUE_COORDINATOR_PREDICT_ASC_CAPITALIZATION',
  QueueCoordinatorPredictParentlessTicketMatchAsc = 'QUEUE_COORDINATOR_PREDICT_PARENTLESS_TICKET_MATCH_ASC',
  QueueCoordinatorPredictTicketDurationAsc = 'QUEUE_COORDINATOR_PREDICT_TICKET_DURATION_ASC',
  QueueCoordinatorPredictTicketDurationRd = 'QUEUE_COORDINATOR_PREDICT_TICKET_DURATION_RD',
  QueueCoordinatorPredictTicketGroupMatchAsc = 'QUEUE_COORDINATOR_PREDICT_TICKET_GROUP_MATCH_ASC',
  QueueCoordinatorPredictWorkstreamMatchAsc = 'QUEUE_COORDINATOR_PREDICT_WORKSTREAM_MATCH_ASC',
  QueueCoordinatorRdBcFlowCleanExistingRdProjects = 'QUEUE_COORDINATOR_RD_BC_FLOW_CLEAN_EXISTING_RD_PROJECTS',
  QueueCoordinatorRdBcFlowFeaturizeTickets = 'QUEUE_COORDINATOR_RD_BC_FLOW_FEATURIZE_TICKETS',
  QueueCoordinatorRdBcFlowFeaturizeTicketsComplete = 'QUEUE_COORDINATOR_RD_BC_FLOW_FEATURIZE_TICKETS_COMPLETE',
  QueueCoordinatorRdBcFlowGenerateBusinessComponents = 'QUEUE_COORDINATOR_RD_BC_FLOW_GENERATE_BUSINESS_COMPONENTS',
  QueueCoordinatorRdBcFlowGenerateBusinessComponentsComplete = 'QUEUE_COORDINATOR_RD_BC_FLOW_GENERATE_BUSINESS_COMPONENTS_COMPLETE',
  QueueCoordinatorRdBcFlowGenerateProjectsFromBcComplete = 'QUEUE_COORDINATOR_RD_BC_FLOW_GENERATE_PROJECTS_FROM_BC_COMPLETE',
  QueueCoordinatorRdBcFlowGenerateRdProjects = 'QUEUE_COORDINATOR_RD_BC_FLOW_GENERATE_RD_PROJECTS',
  QueueCoordinatorRdBcFlowSelectSyncEvent = 'QUEUE_COORDINATOR_RD_BC_FLOW_SELECT_SYNC_EVENT',
  QueueCoordinatorRdBcFlowSetupBusinessComponentsComplete = 'QUEUE_COORDINATOR_RD_BC_FLOW_SETUP_BUSINESS_COMPONENTS_COMPLETE',
  QueueCoordinatorRdBcFlowStageTickets = 'QUEUE_COORDINATOR_RD_BC_FLOW_STAGE_TICKETS',
  QueueCoordinatorRdImportBusinessComponentsFile = 'QUEUE_COORDINATOR_RD_IMPORT_BUSINESS_COMPONENTS_FILE',
  QueueCoordinatorReclassifyTickets = 'QUEUE_COORDINATOR_RECLASSIFY_TICKETS',
  QueueCoordinatorReconcileTicketingProviderUsersAsc = 'QUEUE_COORDINATOR_RECONCILE_TICKETING_PROVIDER_USERS_ASC',
  QueueCoordinatorReconcileTicketingProviderUsersRd = 'QUEUE_COORDINATOR_RECONCILE_TICKETING_PROVIDER_USERS_RD',
  QueueCoordinatorResolveCollectionParent = 'QUEUE_COORDINATOR_RESOLVE_COLLECTION_PARENT',
  QueueCoordinatorResolveCustomFields = 'QUEUE_COORDINATOR_RESOLVE_CUSTOM_FIELDS',
  QueueCoordinatorResolveTicketParent = 'QUEUE_COORDINATOR_RESOLVE_TICKET_PARENT',
  QueueCoordinatorResolveTicketRelations = 'QUEUE_COORDINATOR_RESOLVE_TICKET_RELATIONS',
  QueueCoordinatorResolveTicketStatus = 'QUEUE_COORDINATOR_RESOLVE_TICKET_STATUS',
  QueueCoordinatorSetupCustomFields = 'QUEUE_COORDINATOR_SETUP_CUSTOM_FIELDS',
  QueueCoordinatorSetupCustomFieldsCollections = 'QUEUE_COORDINATOR_SETUP_CUSTOM_FIELDS_COLLECTIONS',
  QueueCoordinatorSetupCustomFieldsCollectionIssueTypes = 'QUEUE_COORDINATOR_SETUP_CUSTOM_FIELDS_COLLECTION_ISSUE_TYPES',
  QueueCoordinatorSetupStatusCategoryMappings = 'QUEUE_COORDINATOR_SETUP_STATUS_CATEGORY_MAPPINGS',
  QueueCoordinatorSetupTicketingTokenConfiguration = 'QUEUE_COORDINATOR_SETUP_TICKETING_TOKEN_CONFIGURATION',
  QueueCoordinatorStartBulkRecalculateAscAllocations = 'QUEUE_COORDINATOR_START_BULK_RECALCULATE_ASC_ALLOCATIONS',
  QueueCoordinatorStartBulkRecalculateRdAllocations = 'QUEUE_COORDINATOR_START_BULK_RECALCULATE_RD_ALLOCATIONS',
  QueueCoordinatorStartRegenerateRdProjectDetails = 'QUEUE_COORDINATOR_START_REGENERATE_RD_PROJECT_DETAILS',
  QueueCoordinatorSyncTicketingProviderV3 = 'QUEUE_COORDINATOR_SYNC_TICKETING_PROVIDER_V3',
  QueueCoordinatorUpdateAscProjects = 'QUEUE_COORDINATOR_UPDATE_ASC_PROJECTS',
  QueueCoordinatorValidateTicketingFile = 'QUEUE_COORDINATOR_VALIDATE_TICKETING_FILE',
  QueueCoordinatorValidateTicketingFiles = 'QUEUE_COORDINATOR_VALIDATE_TICKETING_FILES',
  QueueCoordinatorWarmUpDataFetching = 'QUEUE_COORDINATOR_WARM_UP_DATA_FETCHING',
}

export type RdTaxCredit = {
  __typename?: 'RDTaxCredit';
  acceptedTermsOfServiceDate?: Maybe<Scalars['Date']['output']>;
  fiscalYear: FiscalYear;
  /** @deprecated This is no longer used to determine eligibility */
  fourPartTest?: Maybe<FourPartTest>;
  id: Scalars['ID']['output'];
  lastUpdatedAt?: Maybe<Scalars['Date']['output']>;
  rdTaxCreditQuestions: RdTaxQuestions;
  sent6765: Scalars['Boolean']['output'];
  useIncomeCredit?: Maybe<Scalars['Boolean']['output']>;
  useReducedCredit?: Maybe<Scalars['Boolean']['output']>;
};

export type RdTaxQuestions = {
  __typename?: 'RDTaxQuestions';
  fiscalYearEndsInDec?: Maybe<Scalars['Boolean']['output']>;
  furthestVisitedExpense?: Maybe<ExpenseCategory>;
  hasAnAccountant?: Maybe<Scalars['Boolean']['output']>;
  hasCalendarYearBasis?: Maybe<Scalars['Boolean']['output']>;
  hasClaimedErc?: Maybe<Scalars['Boolean']['output']>;
  hasFiledExtension?: Maybe<Scalars['Boolean']['output']>;
  hasFiledTaxReturn?: Maybe<Scalars['Boolean']['output']>;
  hasFundedResearch?: Maybe<Scalars['Boolean']['output']>;
  hasMadeFiveMillion?: Maybe<Scalars['Boolean']['output']>;
  hasPayrollEin?: Maybe<Scalars['Boolean']['output']>;
  hasTaxableIncome?: Maybe<Scalars['Boolean']['output']>;
  hasTaxableIncomeAfterDeduction?: Maybe<Scalars['Boolean']['output']>;
  hasW2Employees?: Maybe<Scalars['Boolean']['output']>;
  haveBooksFinalized?: Maybe<Scalars['Boolean']['output']>;
  howIsYourBusinessEntityTaxed?: Maybe<Scalars['String']['output']>;
  isProfitable?: Maybe<Scalars['Boolean']['output']>;
  monthAndDayOfTaxYearEnd?: Maybe<Scalars['String']['output']>;
  payrollEin?: Maybe<Scalars['String']['output']>;
  payrollProviders?: Maybe<Array<Scalars['String']['output']>>;
  receivedFundingTypes?: Maybe<Array<Scalars['String']['output']>>;
};

export enum RdAllocationMethod {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE',
}

export type RdBusinessComponent = {
  __typename?: 'RdBusinessComponent';
  businessComponentId: Scalars['ID']['output'];
  canonicalName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
  minimumExpectedShare?: Maybe<Scalars['Float']['output']>;
  source: RdBusinessComponentSource;
  variants: Array<Scalars['String']['output']>;
};

export type RdBusinessComponentInput = {
  canonicalName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  keywords: Scalars['String']['input'];
};

export enum RdBusinessComponentReviewStatus {
  Approved = 'APPROVED',
  Generating = 'GENERATING',
  InReview = 'IN_REVIEW',
}

export enum RdBusinessComponentSource {
  Predicted = 'PREDICTED',
  Uploaded = 'UPLOADED',
}

export type RdBusinessComponentSync = {
  __typename?: 'RdBusinessComponentSync';
  businessComponentSyncId: Scalars['ID']['output'];
  reviewStatus?: Maybe<RdBusinessComponentReviewStatus>;
  source: RdBusinessComponentSource;
};

export type RdBusinessComponentTicketMatch = {
  __typename?: 'RdBusinessComponentTicketMatch';
  businessComponent?: Maybe<RdBusinessComponent>;
  ticketCount: Scalars['Int']['output'];
  workstreamNames: Array<Scalars['String']['output']>;
};

export type RdBusinessComponentTicketMatches = {
  __typename?: 'RdBusinessComponentTicketMatches';
  currentBusinessComponentSync?: Maybe<RdBusinessComponentSync>;
  hasSyncConfiguration: Scalars['Boolean']['output'];
  isRunAwaitingReview: Scalars['Boolean']['output'];
  matchThreshold: Scalars['Float']['output'];
  matches: Array<RdBusinessComponentTicketMatch>;
};

export enum RdCategory {
  AccountingPayroll = 'ACCOUNTING_PAYROLL',
  Cloud = 'CLOUD',
  Contractor = 'CONTRACTOR',
  Employee = 'EMPLOYEE',
  Legal = 'LEGAL',
  NonRd = 'NON_RD',
  Overhead = 'OVERHEAD',
  Supply = 'SUPPLY',
  Unknown = 'UNKNOWN',
}

export type RdCategoryFilterComparison = {
  eq?: InputMaybe<RdCategory>;
  gt?: InputMaybe<RdCategory>;
  gte?: InputMaybe<RdCategory>;
  iLike?: InputMaybe<RdCategory>;
  in?: InputMaybe<Array<RdCategory>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<RdCategory>;
  lt?: InputMaybe<RdCategory>;
  lte?: InputMaybe<RdCategory>;
  neq?: InputMaybe<RdCategory>;
  notILike?: InputMaybe<RdCategory>;
  notIn?: InputMaybe<Array<RdCategory>>;
  notLike?: InputMaybe<RdCategory>;
};

export enum RdClusterType {
  BusinessComponent = 'BUSINESS_COMPONENT',
  BusinessComponentNoise = 'BUSINESS_COMPONENT_NOISE',
  ManuallyCreated = 'MANUALLY_CREATED',
  Merged = 'MERGED',
  SmartMain = 'SMART_MAIN',
  SmartNoise = 'SMART_NOISE',
  Timesheet = 'TIMESHEET',
}

export type RdCreditsReportRo = {
  __typename?: 'RdCreditsReportRo';
  signedUrl: Scalars['String']['output'];
};

export enum RdDocumentationStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  NotApplicable = 'NOT_APPLICABLE',
}

export type RdDocumentationStatusFilterComparison = {
  eq?: InputMaybe<RdDocumentationStatus>;
  gt?: InputMaybe<RdDocumentationStatus>;
  gte?: InputMaybe<RdDocumentationStatus>;
  iLike?: InputMaybe<RdDocumentationStatus>;
  in?: InputMaybe<Array<RdDocumentationStatus>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<RdDocumentationStatus>;
  lt?: InputMaybe<RdDocumentationStatus>;
  lte?: InputMaybe<RdDocumentationStatus>;
  neq?: InputMaybe<RdDocumentationStatus>;
  notILike?: InputMaybe<RdDocumentationStatus>;
  notIn?: InputMaybe<Array<RdDocumentationStatus>>;
  notLike?: InputMaybe<RdDocumentationStatus>;
};

export type RdExpense = {
  __typename?: 'RdExpense';
  accountingQre?: Maybe<AccountingQre>;
  id: Scalars['ID']['output'];
  payrollQre?: Maybe<PayrollQre>;
  projectPerRdExpense: Array<ProjectPerRdExpense>;
  rdCategory: RdCategory;
  rdCategoryConfidence: Scalars['Int']['output'];
};

export type RdExpenseProject = {
  __typename?: 'RdExpenseProject';
  id: Scalars['ID']['output'];
  qreRdPercentage: Scalars['Int']['output'];
  rdProject: RdProject;
};

export type RdExpenseProjectAggregateGroupBy = {
  __typename?: 'RdExpenseProjectAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
};

export type RdExpenseProjectAllocation = {
  __typename?: 'RdExpenseProjectAllocation';
  /** The percentage of the RD expense that is allocated to this project as an unrounded number */
  allocationPercentNotRounded: Scalars['Float']['output'];
  fiscalYearId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  project: AllocationProjectDetails;
  projectName: Scalars['String']['output'];
  rdExpenseId: Scalars['ID']['output'];
  rdProjectId: Scalars['ID']['output'];
};

export type RdExpenseProjectAllocationAggregateGroupBy = {
  __typename?: 'RdExpenseProjectAllocationAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
};

export type RdExpenseProjectAllocationConnection = {
  __typename?: 'RdExpenseProjectAllocationConnection';
  /** Array of edges. */
  edges: Array<RdExpenseProjectAllocationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type RdExpenseProjectAllocationCountAggregate = {
  __typename?: 'RdExpenseProjectAllocationCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  projectName?: Maybe<Scalars['Int']['output']>;
};

export type RdExpenseProjectAllocationEdge = {
  __typename?: 'RdExpenseProjectAllocationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RdExpenseProjectAllocation */
  node: RdExpenseProjectAllocation;
};

export type RdExpenseProjectAllocationFilter = {
  and?: InputMaybe<Array<RdExpenseProjectAllocationFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RdExpenseProjectAllocationFilter>>;
  projectName?: InputMaybe<StringFieldComparison>;
};

export type RdExpenseProjectAllocationMaxAggregate = {
  __typename?: 'RdExpenseProjectAllocationMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
};

export type RdExpenseProjectAllocationMinAggregate = {
  __typename?: 'RdExpenseProjectAllocationMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
};

export type RdExpenseProjectAllocationReportRo = {
  __typename?: 'RdExpenseProjectAllocationReportRo';
  signedUrl: Scalars['String']['output'];
};

export type RdExpenseProjectAllocationSort = {
  direction: SortDirection;
  field: RdExpenseProjectAllocationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RdExpenseProjectAllocationSortFields {
  Id = 'id',
  ProjectName = 'projectName',
}

export type RdExpenseProjectConnection = {
  __typename?: 'RdExpenseProjectConnection';
  /** Array of edges. */
  edges: Array<RdExpenseProjectEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type RdExpenseProjectCountAggregate = {
  __typename?: 'RdExpenseProjectCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type RdExpenseProjectEdge = {
  __typename?: 'RdExpenseProjectEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RdExpenseProject */
  node: RdExpenseProject;
};

export type RdExpenseProjectFilter = {
  and?: InputMaybe<Array<RdExpenseProjectFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RdExpenseProjectFilter>>;
};

export type RdExpenseProjectMaxAggregate = {
  __typename?: 'RdExpenseProjectMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type RdExpenseProjectMinAggregate = {
  __typename?: 'RdExpenseProjectMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type RdExpenseProjectSort = {
  direction: SortDirection;
  field: RdExpenseProjectSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RdExpenseProjectSortFields {
  Id = 'id',
}

export type RdGroupingTicketOrCollection = {
  __typename?: 'RdGroupingTicketOrCollection';
  count: Scalars['Int']['output'];
  fiscalYearId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  kind: TicketGroupingKind;
  name: Scalars['String']['output'];
  rdProjectId: Scalars['ID']['output'];
  ticketType?: Maybe<Scalars['String']['output']>;
};

export type RdGroupingTicketOrCollectionInput = {
  count: Scalars['Int']['input'];
  fiscalYearId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
  kind: TicketGroupingKind;
  name: Scalars['String']['input'];
  rdProjectId: Scalars['ID']['input'];
  ticketType?: InputMaybe<Scalars['String']['input']>;
};

export type RdProject = {
  __typename?: 'RdProject';
  aiGuidance?: Maybe<Scalars['String']['output']>;
  approvalComment?: Maybe<Scalars['String']['output']>;
  approvalTime?: Maybe<Scalars['String']['output']>;
  businessComponent?: Maybe<ProjectBusinessComponent>;
  businessPurpose?: Maybe<ProjectBusinessPurpose>;
  clusterType: RdClusterType;
  consideredForRd: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disallowances?: Maybe<Array<ProjectDisallowance>>;
  fiscalYearId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  improvedAspects?: Maybe<Array<ProjectPurposeImprovedAspect>>;
  isCustomerFacingDevelopment?: Maybe<Scalars['Boolean']['output']>;
  isInnovativeAndRisky?: Maybe<Scalars['Boolean']['output']>;
  isSection174Eligible: Scalars['Boolean']['output'];
  isTechnicallyUncertain?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  processOfExperimentation?: Maybe<Scalars['String']['output']>;
  processingState: ProcessingProjectState;
  product?: Maybe<Product>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwner?: Maybe<RdProjectOwner>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<ProjectPurpose>;
  rdDetermination?: Maybe<ProjectRdDetermination>;
  rdDocumentationStatus: RdDocumentationStatus;
  selectedCategory: SelectedRdProjectCategory;
  supportingDocuments: Array<FileUpload>;
  technicalChallenges?: Maybe<Scalars['String']['output']>;
  ticketCount: Scalars['Int']['output'];
  workstreamNames: Array<Scalars['String']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type RdProjectAggregateFilter = {
  aiGuidance?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<RdProjectAggregateFilter>>;
  businessComponent?: InputMaybe<ProjectBusinessComponentFilterComparison>;
  businessPurpose?: InputMaybe<ProjectBusinessPurposeFilterComparison>;
  consideredForRd?: InputMaybe<BooleanFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isSection174Eligible?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RdProjectAggregateFilter>>;
  processOfExperimentation?: InputMaybe<StringFieldComparison>;
  productName?: InputMaybe<StringFieldComparison>;
  projectOwnerId?: InputMaybe<IdFilterComparison>;
  projectOwnerName?: InputMaybe<StringFieldComparison>;
  purpose?: InputMaybe<ProjectPurposeFilterComparison>;
  rdDocumentationStatus?: InputMaybe<RdDocumentationStatusFilterComparison>;
  selectedCategory?: InputMaybe<SelectedRdProjectCategoryFilterComparison>;
  technicalChallenges?: InputMaybe<StringFieldComparison>;
  ticketCount?: InputMaybe<IntFieldComparison>;
  workstreamNamesSearch?: InputMaybe<StringFieldComparison>;
};

export type RdProjectAggregateGroupBy = {
  __typename?: 'RdProjectAggregateGroupBy';
  aiGuidance?: Maybe<Scalars['String']['output']>;
  businessComponent?: Maybe<ProjectBusinessComponent>;
  businessPurpose?: Maybe<ProjectBusinessPurpose>;
  consideredForRd?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isSection174Eligible?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processOfExperimentation?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<ProjectPurpose>;
  rdDocumentationStatus?: Maybe<RdDocumentationStatus>;
  selectedCategory?: Maybe<SelectedRdProjectCategory>;
  technicalChallenges?: Maybe<Scalars['String']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type RdProjectAllocationPercentInput = {
  allocationPercent: Scalars['Float']['input'];
  rdProjectId: Scalars['ID']['input'];
};

export type RdProjectAvgAggregate = {
  __typename?: 'RdProjectAvgAggregate';
  ticketCount?: Maybe<Scalars['Float']['output']>;
};

export type RdProjectConnection = {
  __typename?: 'RdProjectConnection';
  /** Array of edges. */
  edges: Array<RdProjectEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type RdProjectCountAggregate = {
  __typename?: 'RdProjectCountAggregate';
  aiGuidance?: Maybe<Scalars['Int']['output']>;
  businessComponent?: Maybe<Scalars['Int']['output']>;
  businessPurpose?: Maybe<Scalars['Int']['output']>;
  consideredForRd?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isSection174Eligible?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  processOfExperimentation?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['Int']['output']>;
  projectOwnerId?: Maybe<Scalars['Int']['output']>;
  projectOwnerName?: Maybe<Scalars['Int']['output']>;
  purpose?: Maybe<Scalars['Int']['output']>;
  rdDocumentationStatus?: Maybe<Scalars['Int']['output']>;
  selectedCategory?: Maybe<Scalars['Int']['output']>;
  technicalChallenges?: Maybe<Scalars['Int']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['Int']['output']>;
};

export type RdProjectDeletionResult = {
  __typename?: 'RdProjectDeletionResult';
  success: Scalars['Boolean']['output'];
};

export enum RdProjectDetailsUpdateScope {
  All = 'ALL',
  MissingDescription = 'MISSING_DESCRIPTION',
  MissingEligibility = 'MISSING_ELIGIBILITY',
}

export type RdProjectEdge = {
  __typename?: 'RdProjectEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RdProject */
  node: RdProject;
};

export type RdProjectEligibilityAnswersInput = {
  isCustomerFacingDevelopment?: InputMaybe<Scalars['Boolean']['input']>;
  isInnovativeAndRisky?: InputMaybe<Scalars['Boolean']['input']>;
  isTechnicallyUncertain?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RdProjectFilter = {
  aiGuidance?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<RdProjectFilter>>;
  businessComponent?: InputMaybe<ProjectBusinessComponentFilterComparison>;
  businessPurpose?: InputMaybe<ProjectBusinessPurposeFilterComparison>;
  consideredForRd?: InputMaybe<BooleanFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isSection174Eligible?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RdProjectFilter>>;
  processOfExperimentation?: InputMaybe<StringFieldComparison>;
  productName?: InputMaybe<StringFieldComparison>;
  projectOwnerId?: InputMaybe<IdFilterComparison>;
  projectOwnerName?: InputMaybe<StringFieldComparison>;
  purpose?: InputMaybe<ProjectPurposeFilterComparison>;
  rdDocumentationStatus?: InputMaybe<RdDocumentationStatusFilterComparison>;
  selectedCategory?: InputMaybe<SelectedRdProjectCategoryFilterComparison>;
  technicalChallenges?: InputMaybe<StringFieldComparison>;
  ticketCount?: InputMaybe<IntFieldComparison>;
  workstreamNamesSearch?: InputMaybe<StringFieldComparison>;
};

export type RdProjectMaxAggregate = {
  __typename?: 'RdProjectMaxAggregate';
  aiGuidance?: Maybe<Scalars['String']['output']>;
  businessComponent?: Maybe<ProjectBusinessComponent>;
  businessPurpose?: Maybe<ProjectBusinessPurpose>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processOfExperimentation?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<ProjectPurpose>;
  rdDocumentationStatus?: Maybe<RdDocumentationStatus>;
  selectedCategory?: Maybe<SelectedRdProjectCategory>;
  technicalChallenges?: Maybe<Scalars['String']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type RdProjectMinAggregate = {
  __typename?: 'RdProjectMinAggregate';
  aiGuidance?: Maybe<Scalars['String']['output']>;
  businessComponent?: Maybe<ProjectBusinessComponent>;
  businessPurpose?: Maybe<ProjectBusinessPurpose>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processOfExperimentation?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<ProjectPurpose>;
  rdDocumentationStatus?: Maybe<RdDocumentationStatus>;
  selectedCategory?: Maybe<SelectedRdProjectCategory>;
  technicalChallenges?: Maybe<Scalars['String']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type RdProjectNameAndDescription = {
  __typename?: 'RdProjectNameAndDescription';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RdProjectOwner = {
  __typename?: 'RdProjectOwner';
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type RdProjectReport = {
  __typename?: 'RdProjectReport';
  columnNames: Array<Scalars['String']['output']>;
  excelData: Scalars['String']['output'];
};

export type RdProjectSort = {
  direction: SortDirection;
  field: RdProjectSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RdProjectSortFields {
  AiGuidance = 'aiGuidance',
  BusinessComponent = 'businessComponent',
  BusinessPurpose = 'businessPurpose',
  ConsideredForRd = 'consideredForRd',
  Description = 'description',
  Id = 'id',
  IsSection174Eligible = 'isSection174Eligible',
  Name = 'name',
  ProcessOfExperimentation = 'processOfExperimentation',
  ProductName = 'productName',
  ProjectOwnerId = 'projectOwnerId',
  ProjectOwnerName = 'projectOwnerName',
  Purpose = 'purpose',
  RdDocumentationStatus = 'rdDocumentationStatus',
  SelectedCategory = 'selectedCategory',
  TechnicalChallenges = 'technicalChallenges',
  TicketCount = 'ticketCount',
  WorkstreamNamesSearch = 'workstreamNamesSearch',
}

export type RdProjectSumAggregate = {
  __typename?: 'RdProjectSumAggregate';
  ticketCount?: Maybe<Scalars['Float']['output']>;
};

export type RdProjectTeamMember = {
  __typename?: 'RdProjectTeamMember';
  allocationPercent: Scalars['Int']['output'];
  contributorEmail?: Maybe<Scalars['String']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId: Scalars['String']['output'];
  rdExpenseId: Scalars['String']['output'];
  rdProjectId: Scalars['String']['output'];
  rdTaxCreditContributorId: Scalars['String']['output'];
};

export type RdProjectTeamMemberAggregateGroupBy = {
  __typename?: 'RdProjectTeamMemberAggregateGroupBy';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  rdExpenseId?: Maybe<Scalars['String']['output']>;
  rdProjectId?: Maybe<Scalars['String']['output']>;
  rdTaxCreditContributorId?: Maybe<Scalars['String']['output']>;
};

export type RdProjectTeamMemberAvgAggregate = {
  __typename?: 'RdProjectTeamMemberAvgAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
};

export type RdProjectTeamMemberConnection = {
  __typename?: 'RdProjectTeamMemberConnection';
  /** Array of edges. */
  edges: Array<RdProjectTeamMemberEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type RdProjectTeamMemberCountAggregate = {
  __typename?: 'RdProjectTeamMemberCountAggregate';
  allocationPercent?: Maybe<Scalars['Int']['output']>;
  contributorName?: Maybe<Scalars['Int']['output']>;
  fiscalYearId?: Maybe<Scalars['Int']['output']>;
  rdExpenseId?: Maybe<Scalars['Int']['output']>;
  rdProjectId?: Maybe<Scalars['Int']['output']>;
  rdTaxCreditContributorId?: Maybe<Scalars['Int']['output']>;
};

export type RdProjectTeamMemberEdge = {
  __typename?: 'RdProjectTeamMemberEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RdProjectTeamMember */
  node: RdProjectTeamMember;
};

export type RdProjectTeamMemberFilter = {
  allocationPercent?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<RdProjectTeamMemberFilter>>;
  contributorName?: InputMaybe<StringFieldComparison>;
  fiscalYearId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RdProjectTeamMemberFilter>>;
  rdExpenseId?: InputMaybe<StringFieldComparison>;
  rdProjectId?: InputMaybe<StringFieldComparison>;
  rdTaxCreditContributorId?: InputMaybe<StringFieldComparison>;
};

export type RdProjectTeamMemberMaxAggregate = {
  __typename?: 'RdProjectTeamMemberMaxAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  rdExpenseId?: Maybe<Scalars['String']['output']>;
  rdProjectId?: Maybe<Scalars['String']['output']>;
  rdTaxCreditContributorId?: Maybe<Scalars['String']['output']>;
};

export type RdProjectTeamMemberMinAggregate = {
  __typename?: 'RdProjectTeamMemberMinAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  rdExpenseId?: Maybe<Scalars['String']['output']>;
  rdProjectId?: Maybe<Scalars['String']['output']>;
  rdTaxCreditContributorId?: Maybe<Scalars['String']['output']>;
};

export type RdProjectTeamMemberSort = {
  direction: SortDirection;
  field: RdProjectTeamMemberSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RdProjectTeamMemberSortFields {
  AllocationPercent = 'allocationPercent',
  ContributorName = 'contributorName',
  FiscalYearId = 'fiscalYearId',
  RdExpenseId = 'rdExpenseId',
  RdProjectId = 'rdProjectId',
  RdTaxCreditContributorId = 'rdTaxCreditContributorId',
}

export type RdProjectTeamMemberSumAggregate = {
  __typename?: 'RdProjectTeamMemberSumAggregate';
  allocationPercent?: Maybe<Scalars['Float']['output']>;
};

export type RdProjectTpTicketsView = {
  __typename?: 'RdProjectTpTicketsView';
  collectionName?: Maybe<Scalars['String']['output']>;
  completedDatetime?: Maybe<Scalars['Date']['output']>;
  contributorName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fiscalYearId: Scalars['String']['output'];
  groupingTicketingProviderCollectionId?: Maybe<Scalars['ID']['output']>;
  groupingTicketingProviderTicketId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  predictedEffortDays: Scalars['Float']['output'];
  rdProjectId: Scalars['String']['output'];
  rdTaxCreditContributorId: Scalars['String']['output'];
  ticketUrl?: Maybe<Scalars['String']['output']>;
};

export type RdProjectTpTicketsViewAggregateGroupBy = {
  __typename?: 'RdProjectTpTicketsViewAggregateGroupBy';
  collectionName?: Maybe<Scalars['String']['output']>;
  completedDatetime?: Maybe<Scalars['Date']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  groupingTicketingProviderCollectionId?: Maybe<Scalars['ID']['output']>;
  groupingTicketingProviderTicketId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  predictedEffortDays?: Maybe<Scalars['Float']['output']>;
  rdProjectId?: Maybe<Scalars['String']['output']>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
};

export type RdProjectTpTicketsViewAvgAggregate = {
  __typename?: 'RdProjectTpTicketsViewAvgAggregate';
  predictedEffortDays?: Maybe<Scalars['Float']['output']>;
};

export type RdProjectTpTicketsViewConnection = {
  __typename?: 'RdProjectTpTicketsViewConnection';
  /** Array of edges. */
  edges: Array<RdProjectTpTicketsViewEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type RdProjectTpTicketsViewCountAggregate = {
  __typename?: 'RdProjectTpTicketsViewCountAggregate';
  collectionName?: Maybe<Scalars['Int']['output']>;
  completedDatetime?: Maybe<Scalars['Int']['output']>;
  contributorName?: Maybe<Scalars['Int']['output']>;
  fiscalYearId?: Maybe<Scalars['Int']['output']>;
  groupingTicketingProviderCollectionId?: Maybe<Scalars['Int']['output']>;
  groupingTicketingProviderTicketId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identifier?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  predictedEffortDays?: Maybe<Scalars['Int']['output']>;
  rdProjectId?: Maybe<Scalars['Int']['output']>;
  ticketUrl?: Maybe<Scalars['Int']['output']>;
};

export type RdProjectTpTicketsViewEdge = {
  __typename?: 'RdProjectTpTicketsViewEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RdProjectTpTicketsView */
  node: RdProjectTpTicketsView;
};

export type RdProjectTpTicketsViewFilter = {
  and?: InputMaybe<Array<RdProjectTpTicketsViewFilter>>;
  collectionName?: InputMaybe<StringFieldComparison>;
  completedDatetime?: InputMaybe<DateFieldComparison>;
  contributorName?: InputMaybe<StringFieldComparison>;
  fiscalYearId?: InputMaybe<StringFieldComparison>;
  groupingTicketingProviderCollectionId?: InputMaybe<IdFilterComparison>;
  groupingTicketingProviderTicketId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  identifier?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RdProjectTpTicketsViewFilter>>;
  predictedEffortDays?: InputMaybe<FloatFieldComparison>;
  rdProjectId?: InputMaybe<StringFieldComparison>;
  ticketUrl?: InputMaybe<StringFieldComparison>;
};

export type RdProjectTpTicketsViewMaxAggregate = {
  __typename?: 'RdProjectTpTicketsViewMaxAggregate';
  collectionName?: Maybe<Scalars['String']['output']>;
  completedDatetime?: Maybe<Scalars['Date']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  groupingTicketingProviderCollectionId?: Maybe<Scalars['ID']['output']>;
  groupingTicketingProviderTicketId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  predictedEffortDays?: Maybe<Scalars['Float']['output']>;
  rdProjectId?: Maybe<Scalars['String']['output']>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
};

export type RdProjectTpTicketsViewMinAggregate = {
  __typename?: 'RdProjectTpTicketsViewMinAggregate';
  collectionName?: Maybe<Scalars['String']['output']>;
  completedDatetime?: Maybe<Scalars['Date']['output']>;
  contributorName?: Maybe<Scalars['String']['output']>;
  fiscalYearId?: Maybe<Scalars['String']['output']>;
  groupingTicketingProviderCollectionId?: Maybe<Scalars['ID']['output']>;
  groupingTicketingProviderTicketId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  predictedEffortDays?: Maybe<Scalars['Float']['output']>;
  rdProjectId?: Maybe<Scalars['String']['output']>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
};

export type RdProjectTpTicketsViewSort = {
  direction: SortDirection;
  field: RdProjectTpTicketsViewSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RdProjectTpTicketsViewSortFields {
  CollectionName = 'collectionName',
  CompletedDatetime = 'completedDatetime',
  ContributorName = 'contributorName',
  FiscalYearId = 'fiscalYearId',
  GroupingTicketingProviderCollectionId = 'groupingTicketingProviderCollectionId',
  GroupingTicketingProviderTicketId = 'groupingTicketingProviderTicketId',
  Id = 'id',
  Identifier = 'identifier',
  Name = 'name',
  PredictedEffortDays = 'predictedEffortDays',
  RdProjectId = 'rdProjectId',
  TicketUrl = 'ticketUrl',
}

export type RdProjectTpTicketsViewSumAggregate = {
  __typename?: 'RdProjectTpTicketsViewSumAggregate';
  predictedEffortDays?: Maybe<Scalars['Float']['output']>;
};

export type RdProjectUniqueCountAggregate = {
  __typename?: 'RdProjectUniqueCountAggregate';
  aiGuidance: Scalars['Int']['output'];
  businessComponent: Scalars['Int']['output'];
  businessPurpose: Scalars['Int']['output'];
  consideredForRd: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isSection174Eligible: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  processOfExperimentation: Scalars['Int']['output'];
  productName: Scalars['Int']['output'];
  projectOwnerId: Scalars['Int']['output'];
  projectOwnerName: Scalars['Int']['output'];
  purpose: Scalars['Int']['output'];
  rdDocumentationStatus: Scalars['Int']['output'];
  selectedCategory: Scalars['Int']['output'];
  technicalChallenges: Scalars['Int']['output'];
  ticketCount: Scalars['Int']['output'];
  workstreamNamesSearch: Scalars['Int']['output'];
};

export type RdProjectsSummary = {
  __typename?: 'RdProjectsSummary';
  avg?: Maybe<RdProjectAvgAggregate>;
  count?: Maybe<RdProjectCountAggregate>;
  groupBy?: Maybe<RdProjectAggregateGroupBy>;
  max?: Maybe<RdProjectMaxAggregate>;
  min?: Maybe<RdProjectMinAggregate>;
  sum?: Maybe<RdProjectSumAggregate>;
  uniqueCount?: Maybe<RdProjectUniqueCountAggregate>;
};

export type RdProjectsSummaryFilter = {
  aiGuidance?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<RdProjectAggregateFilter>>;
  businessComponent?: InputMaybe<ProjectBusinessComponentFilterComparison>;
  businessPurpose?: InputMaybe<ProjectBusinessPurposeFilterComparison>;
  consideredForRd?: InputMaybe<BooleanFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isSection174Eligible?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RdProjectAggregateFilter>>;
  processOfExperimentation?: InputMaybe<StringFieldComparison>;
  productName?: InputMaybe<StringFieldComparison>;
  projectOwnerId?: InputMaybe<IdFilterComparison>;
  projectOwnerName?: InputMaybe<StringFieldComparison>;
  purpose?: InputMaybe<ProjectPurposeFilterComparison>;
  rdDocumentationStatus?: InputMaybe<RdDocumentationStatusFilterComparison>;
  selectedCategory?: InputMaybe<SelectedRdProjectCategoryFilterComparison>;
  technicalChallenges?: InputMaybe<StringFieldComparison>;
  ticketCount?: InputMaybe<IntFieldComparison>;
  workstreamNamesSearch?: InputMaybe<StringFieldComparison>;
};

export type RdTaxCreditContributor = {
  __typename?: 'RdTaxCreditContributor';
  canonicalEmail?: Maybe<Scalars['String']['output']>;
  canonicalName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rdTaxCreditId: Scalars['String']['output'];
  ticketingProviderUsers: Array<TicketingProviderUser>;
};

/** Fields available for sorting R&D tax credit contributors */
export enum RdTaxCreditContributorSortField {
  CanonicalEmail = 'CANONICAL_EMAIL',
  CanonicalName = 'CANONICAL_NAME',
  NonProjectTimePercentage = 'NON_PROJECT_TIME_PERCENTAGE',
  Title = 'TITLE',
  TotalRdPercentage = 'TOTAL_RD_PERCENTAGE',
}

export type RdTaxCreditContributorSortInput = {
  direction: SortDirection;
  field: RdTaxCreditContributorSortField;
};

export type RdTaxCreditContributorWithAllocation = {
  __typename?: 'RdTaxCreditContributorWithAllocation';
  allocationMethod: RdAllocationMethod;
  canonicalEmail?: Maybe<Scalars['String']['output']>;
  canonicalName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nonProjectTimePercentage: Scalars['Float']['output'];
  title?: Maybe<Scalars['String']['output']>;
  totalRdPercentage: Scalars['Float']['output'];
};

export type RdTaxCreditContributorsWithAllocationPaginated = {
  __typename?: 'RdTaxCreditContributorsWithAllocationPaginated';
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<RdTaxCreditContributorWithAllocation>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type RdTaxCreditOverridesInput = {
  useFilingMethod?: InputMaybe<FilingMethod>;
  useIncomeCredit?: InputMaybe<Scalars['Boolean']['input']>;
  useReducedCredit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RdTicketMatchExport = {
  __typename?: 'RdTicketMatchExport';
  fileName: Scalars['String']['output'];
  report: Report;
};

export type RegenerateRdProjectDetailsInput = {
  includeDescription: Scalars['Boolean']['input'];
  includeEligibilityDetermination: Scalars['Boolean']['input'];
  includeName: Scalars['Boolean']['input'];
  scope: RdProjectDetailsUpdateScope;
};

export type ReplaceUserAccessInOrganizationInput = {
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  companyScope?: InputMaybe<CompanyScope>;
  organizationScope: OrganizationScope;
};

export type Report = {
  __typename?: 'Report';
  columnNames: Array<Scalars['String']['output']>;
  resultCsv: Scalars['String']['output'];
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export enum ReportKey {
  FiscalYearId = 'FISCAL_YEAR_ID',
  PeriodName = 'PERIOD_NAME',
}

export type ReportLoginFailureInput = {
  email: Scalars['String']['input'];
  method: ClientReportableLoginMethod;
  rejectionReason: Scalars['String']['input'];
};

export enum ReportName {
  AscProjectReport = 'ASC_PROJECT_REPORT',
  ContributorsWithoutPayrollExpenses = 'CONTRIBUTORS_WITHOUT_PAYROLL_EXPENSES',
  ExpenseReport = 'EXPENSE_REPORT',
  ExpenseReportByState = 'EXPENSE_REPORT_BY_STATE',
  PayrollExpensesWithoutContributors = 'PAYROLL_EXPENSES_WITHOUT_CONTRIBUTORS',
  RdProjectReport = 'RD_PROJECT_REPORT',
  TicketsByAscProject = 'TICKETS_BY_ASC_PROJECT',
  TicketsByRdProject = 'TICKETS_BY_RD_PROJECT',
}

export enum RevenueSource {
  QuickbooksOrXero = 'QUICKBOOKS_OR_XERO',
  Retool = 'RETOOL',
  SelfReported = 'SELF_REPORTED',
}

export type ScheduleSyncTicketingDataInput = {
  analysisTypes: Array<AnalysisType>;
  ascConfigPreConfirmed?: Scalars['Boolean']['input'];
  syncPeriod: PeriodDatesInput;
  ticketingTokenId: Scalars['ID']['input'];
};

export type ScheduledBackgroundOperationModel = {
  __typename?: 'ScheduledBackgroundOperationModel';
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notifySlack: Scalars['Boolean']['output'];
  operationType: ScheduledBackgroundOperationType;
  runAt: Scalars['Date']['output'];
  status: ScheduledBackgroundOperationStatus;
  syncTicketingData?: Maybe<SyncTicketingDataScheduleModel>;
  updatedAt: Scalars['Date']['output'];
};

export enum ScheduledBackgroundOperationStatus {
  Canceled = 'CANCELED',
  Dispatched = 'DISPATCHED',
  Dispatching = 'DISPATCHING',
  Failed = 'FAILED',
  Scheduled = 'SCHEDULED',
}

export enum ScheduledBackgroundOperationType {
  SyncTicketingData = 'SYNC_TICKETING_DATA',
}

export type SearchFirebaseIdentitiesByNameInput = {
  name: Scalars['String']['input'];
};

export type SearchFirebaseIdentitiesInput = {
  prefix: Scalars['String']['input'];
};

export type SearchForOrganizationInput = {
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchLoginAuditLogsInput = {
  from: Scalars['Date']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  prefix: Scalars['String']['input'];
  to: Scalars['Date']['input'];
};

export enum SelectedRdProjectCategory {
  Excluded = 'EXCLUDED',
  RdCredit = 'RD_CREDIT',
  Section_174Only = 'SECTION_174_ONLY',
}

export type SelectedRdProjectCategoryFilterComparison = {
  eq?: InputMaybe<SelectedRdProjectCategory>;
  gt?: InputMaybe<SelectedRdProjectCategory>;
  gte?: InputMaybe<SelectedRdProjectCategory>;
  iLike?: InputMaybe<SelectedRdProjectCategory>;
  in?: InputMaybe<Array<SelectedRdProjectCategory>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<SelectedRdProjectCategory>;
  lt?: InputMaybe<SelectedRdProjectCategory>;
  lte?: InputMaybe<SelectedRdProjectCategory>;
  neq?: InputMaybe<SelectedRdProjectCategory>;
  notILike?: InputMaybe<SelectedRdProjectCategory>;
  notIn?: InputMaybe<Array<SelectedRdProjectCategory>>;
  notLike?: InputMaybe<SelectedRdProjectCategory>;
};

export enum SelectedSredProjectCategory {
  NotStartedOrNone = 'NOT_STARTED_OR_NONE',
  SredCredit = 'SRED_CREDIT',
}

export type SelectedSredProjectCategoryFilterComparison = {
  eq?: InputMaybe<SelectedSredProjectCategory>;
  gt?: InputMaybe<SelectedSredProjectCategory>;
  gte?: InputMaybe<SelectedSredProjectCategory>;
  iLike?: InputMaybe<SelectedSredProjectCategory>;
  in?: InputMaybe<Array<SelectedSredProjectCategory>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<SelectedSredProjectCategory>;
  lt?: InputMaybe<SelectedSredProjectCategory>;
  lte?: InputMaybe<SelectedSredProjectCategory>;
  neq?: InputMaybe<SelectedSredProjectCategory>;
  notILike?: InputMaybe<SelectedSredProjectCategory>;
  notIn?: InputMaybe<Array<SelectedSredProjectCategory>>;
  notLike?: InputMaybe<SelectedSredProjectCategory>;
};

export type SendMagicLinkEmailInput = {
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type SendResetPasswordEmailInput = {
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type SentinelEmail = {
  __typename?: 'SentinelEmail';
  company?: Maybe<SentinelEmailCompany>;
  companyId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  detectedCount?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastDetectedAt?: Maybe<Scalars['Date']['output']>;
  raisedByCompanyId?: Maybe<Scalars['ID']['output']>;
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  resolvedByUserId?: Maybe<Scalars['ID']['output']>;
  status: SentinelEmailStatus;
};

export type SentinelEmailCompany = {
  __typename?: 'SentinelEmailCompany';
  id: Scalars['ID']['output'];
  shortName: Scalars['String']['output'];
};

export enum SentinelEmailDecision {
  NotSentinel = 'NOT_SENTINEL',
  Sentinel = 'SENTINEL',
}

export enum SentinelEmailScope {
  Company = 'COMPANY',
  Global = 'GLOBAL',
}

export enum SentinelEmailStatus {
  NotSentinel = 'NOT_SENTINEL',
  Pending = 'PENDING',
  Sentinel = 'SENTINEL',
}

export type ServerInfo = {
  __typename?: 'ServerInfo';
  version: Scalars['String']['output'];
};

export type SetAscProjectApprovalInput = {
  /** Optional comment to store for the approved month */
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type SettleSentinelEmailInput = {
  decision: SentinelEmailDecision;
  scope?: InputMaybe<SentinelEmailScope>;
};

export type SingleTenantDomainRedirect = {
  __typename?: 'SingleTenantDomainRedirect';
  emailDomain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  redirectUrl: Scalars['String']['output'];
};

export type SnowflakeConfigurationInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  details: Array<SnowflakeDetailInput>;
};

export type SnowflakeDetail = {
  __typename?: 'SnowflakeDetail';
  type: SnowflakeDetailsType;
  value: Scalars['String']['output'];
};

export type SnowflakeDetailInput = {
  type: SnowflakeDetailsType;
  value: Scalars['String']['input'];
};

export enum SnowflakeDetailsType {
  Account = 'ACCOUNT',
  Changelog = 'CHANGELOG',
  Collections = 'COLLECTIONS',
  StatusToStatusCategory = 'STATUS_TO_STATUS_CATEGORY',
  Teams = 'TEAMS',
  Tickets = 'TICKETS',
  Users = 'USERS',
}

export type SnowflakeTicketingToken = {
  __typename?: 'SnowflakeTicketingToken';
  accessTokenLastFour: Scalars['String']['output'];
  details: Array<SnowflakeDetail>;
  id: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

/** Sort Directions */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** Sort Nulls Options */
export enum SortNulls {
  NullsFirst = 'NULLS_FIRST',
  NullsLast = 'NULLS_LAST',
}

export enum SredCategory {
  ContractorArmsLength = 'CONTRACTOR_ARMS_LENGTH',
  ContractorNonArmsLength = 'CONTRACTOR_NON_ARMS_LENGTH',
  Employee = 'EMPLOYEE',
  MaterialsConsumed = 'MATERIALS_CONSUMED',
  MaterialsTransformed = 'MATERIALS_TRANSFORMED',
  NonSred = 'NON_SRED',
  Overhead = 'OVERHEAD',
  Unknown = 'UNKNOWN',
}

export type SredCategoryFilterComparison = {
  eq?: InputMaybe<SredCategory>;
  gt?: InputMaybe<SredCategory>;
  gte?: InputMaybe<SredCategory>;
  iLike?: InputMaybe<SredCategory>;
  in?: InputMaybe<Array<SredCategory>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<SredCategory>;
  lt?: InputMaybe<SredCategory>;
  lte?: InputMaybe<SredCategory>;
  neq?: InputMaybe<SredCategory>;
  notILike?: InputMaybe<SredCategory>;
  notIn?: InputMaybe<Array<SredCategory>>;
  notLike?: InputMaybe<SredCategory>;
};

export enum SredClusterType {
  DeterministicHasRoot = 'DETERMINISTIC_HAS_ROOT',
  DeterministicNoRoot = 'DETERMINISTIC_NO_ROOT',
  ManuallyCreated = 'MANUALLY_CREATED',
  Merged = 'MERGED',
  SmartMain = 'SMART_MAIN',
  SmartNoise = 'SMART_NOISE',
}

export enum SredDocumentationStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  NotApplicable = 'NOT_APPLICABLE',
}

export type SredDocumentationStatusFilterComparison = {
  eq?: InputMaybe<SredDocumentationStatus>;
  gt?: InputMaybe<SredDocumentationStatus>;
  gte?: InputMaybe<SredDocumentationStatus>;
  iLike?: InputMaybe<SredDocumentationStatus>;
  in?: InputMaybe<Array<SredDocumentationStatus>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<SredDocumentationStatus>;
  lt?: InputMaybe<SredDocumentationStatus>;
  lte?: InputMaybe<SredDocumentationStatus>;
  neq?: InputMaybe<SredDocumentationStatus>;
  notILike?: InputMaybe<SredDocumentationStatus>;
  notIn?: InputMaybe<Array<SredDocumentationStatus>>;
  notLike?: InputMaybe<SredDocumentationStatus>;
};

export enum SredEmployeeType {
  Direct = 'DIRECT',
  Supervisor = 'SUPERVISOR',
  Support = 'SUPPORT',
}

export type SredEmployeeTypeFilterComparison = {
  eq?: InputMaybe<SredEmployeeType>;
  gt?: InputMaybe<SredEmployeeType>;
  gte?: InputMaybe<SredEmployeeType>;
  iLike?: InputMaybe<SredEmployeeType>;
  in?: InputMaybe<Array<SredEmployeeType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<SredEmployeeType>;
  lt?: InputMaybe<SredEmployeeType>;
  lte?: InputMaybe<SredEmployeeType>;
  neq?: InputMaybe<SredEmployeeType>;
  notILike?: InputMaybe<SredEmployeeType>;
  notIn?: InputMaybe<Array<SredEmployeeType>>;
  notLike?: InputMaybe<SredEmployeeType>;
};

export type SredPayrollExpense = {
  __typename?: 'SredPayrollExpense';
  /** null for any user without financial permissions */
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  managerName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  payrollProvider?: Maybe<PayrollProvider>;
  province?: Maybe<Scalars['String']['output']>;
  /** null for any user without financial permissions */
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  sredCategory: SredCategory;
  sredContributorId: Scalars['String']['output'];
  sredEligiblePercentage: Scalars['Int']['output'];
  sredEmployeeType?: Maybe<SredEmployeeType>;
  sredPayrollExpenseId?: Maybe<Scalars['String']['output']>;
  sredTaxCreditId: Scalars['String']['output'];
  terminationDate?: Maybe<Scalars['String']['output']>;
  ticketingProviders: Array<TicketingProvider>;
  title?: Maybe<Scalars['String']['output']>;
  wageType?: Maybe<CaWageType>;
};

export type SredPayrollExpenseAggregateFilter = {
  amountCents?: InputMaybe<BigIntFilterComparison>;
  and?: InputMaybe<Array<SredPayrollExpenseAggregateFilter>>;
  costCenter?: InputMaybe<StringFieldComparison>;
  department?: InputMaybe<StringFieldComparison>;
  entity?: InputMaybe<StringFieldComparison>;
  hireDate?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  managerName?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SredPayrollExpenseAggregateFilter>>;
  payrollProvider?: InputMaybe<PayrollProviderFilterComparison>;
  province?: InputMaybe<StringFieldComparison>;
  qualifiedAmountCents?: InputMaybe<BigIntFilterComparison>;
  sredCategory?: InputMaybe<SredCategoryFilterComparison>;
  sredEligiblePercentage?: InputMaybe<FloatFieldComparison>;
  sredEmployeeType?: InputMaybe<SredEmployeeTypeFilterComparison>;
  terminationDate?: InputMaybe<StringFieldComparison>;
  title?: InputMaybe<StringFieldComparison>;
  wageType?: InputMaybe<CaWageTypeFilterComparison>;
};

export type SredPayrollExpenseAggregateGroupBy = {
  __typename?: 'SredPayrollExpenseAggregateGroupBy';
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  managerName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payrollProvider?: Maybe<PayrollProvider>;
  province?: Maybe<Scalars['String']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  sredCategory?: Maybe<SredCategory>;
  sredEligiblePercentage?: Maybe<Scalars['Float']['output']>;
  sredEmployeeType?: Maybe<SredEmployeeType>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  wageType?: Maybe<CaWageType>;
};

export type SredPayrollExpenseAvgAggregate = {
  __typename?: 'SredPayrollExpenseAvgAggregate';
  amountCents?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['Float']['output']>;
  sredEligiblePercentage?: Maybe<Scalars['Float']['output']>;
};

export type SredPayrollExpenseConnection = {
  __typename?: 'SredPayrollExpenseConnection';
  /** Array of edges. */
  edges: Array<SredPayrollExpenseEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type SredPayrollExpenseCountAggregate = {
  __typename?: 'SredPayrollExpenseCountAggregate';
  amountCents?: Maybe<Scalars['Int']['output']>;
  costCenter?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Scalars['Int']['output']>;
  entity?: Maybe<Scalars['Int']['output']>;
  hireDate?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  managerName?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  payrollProvider?: Maybe<Scalars['Int']['output']>;
  province?: Maybe<Scalars['Int']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['Int']['output']>;
  sredCategory?: Maybe<Scalars['Int']['output']>;
  sredEligiblePercentage?: Maybe<Scalars['Int']['output']>;
  sredEmployeeType?: Maybe<Scalars['Int']['output']>;
  terminationDate?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['Int']['output']>;
  wageType?: Maybe<Scalars['Int']['output']>;
};

export type SredPayrollExpenseEdge = {
  __typename?: 'SredPayrollExpenseEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the SredPayrollExpense */
  node: SredPayrollExpense;
};

export type SredPayrollExpenseFilter = {
  amountCents?: InputMaybe<BigIntFilterComparison>;
  and?: InputMaybe<Array<SredPayrollExpenseFilter>>;
  costCenter?: InputMaybe<StringFieldComparison>;
  department?: InputMaybe<StringFieldComparison>;
  entity?: InputMaybe<StringFieldComparison>;
  hireDate?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  managerName?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SredPayrollExpenseFilter>>;
  payrollProvider?: InputMaybe<PayrollProviderFilterComparison>;
  province?: InputMaybe<StringFieldComparison>;
  qualifiedAmountCents?: InputMaybe<BigIntFilterComparison>;
  sredCategory?: InputMaybe<SredCategoryFilterComparison>;
  sredEligiblePercentage?: InputMaybe<FloatFieldComparison>;
  sredEmployeeType?: InputMaybe<SredEmployeeTypeFilterComparison>;
  terminationDate?: InputMaybe<StringFieldComparison>;
  title?: InputMaybe<StringFieldComparison>;
  wageType?: InputMaybe<CaWageTypeFilterComparison>;
};

export type SredPayrollExpenseMaxAggregate = {
  __typename?: 'SredPayrollExpenseMaxAggregate';
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  managerName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payrollProvider?: Maybe<PayrollProvider>;
  province?: Maybe<Scalars['String']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  sredCategory?: Maybe<SredCategory>;
  sredEligiblePercentage?: Maybe<Scalars['Float']['output']>;
  sredEmployeeType?: Maybe<SredEmployeeType>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  wageType?: Maybe<CaWageType>;
};

export type SredPayrollExpenseMinAggregate = {
  __typename?: 'SredPayrollExpenseMinAggregate';
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  managerName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payrollProvider?: Maybe<PayrollProvider>;
  province?: Maybe<Scalars['String']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  sredCategory?: Maybe<SredCategory>;
  sredEligiblePercentage?: Maybe<Scalars['Float']['output']>;
  sredEmployeeType?: Maybe<SredEmployeeType>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  wageType?: Maybe<CaWageType>;
};

export type SredPayrollExpenseSort = {
  direction: SortDirection;
  field: SredPayrollExpenseSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SredPayrollExpenseSortFields {
  AmountCents = 'amountCents',
  CostCenter = 'costCenter',
  Department = 'department',
  Entity = 'entity',
  HireDate = 'hireDate',
  Id = 'id',
  ManagerName = 'managerName',
  Name = 'name',
  PayrollProvider = 'payrollProvider',
  Province = 'province',
  QualifiedAmountCents = 'qualifiedAmountCents',
  SredCategory = 'sredCategory',
  SredEligiblePercentage = 'sredEligiblePercentage',
  SredEmployeeType = 'sredEmployeeType',
  TerminationDate = 'terminationDate',
  Title = 'title',
  WageType = 'wageType',
}

export type SredPayrollExpenseSumAggregate = {
  __typename?: 'SredPayrollExpenseSumAggregate';
  amountCents?: Maybe<Scalars['Float']['output']>;
  qualifiedAmountCents?: Maybe<Scalars['Float']['output']>;
  sredEligiblePercentage?: Maybe<Scalars['Float']['output']>;
};

export type SredPayrollExpenseUniqueCountAggregate = {
  __typename?: 'SredPayrollExpenseUniqueCountAggregate';
  costCenter: Scalars['Int']['output'];
  department: Scalars['Int']['output'];
  entity: Scalars['Int']['output'];
  managerName: Scalars['Int']['output'];
  province: Scalars['Int']['output'];
  sredCategory: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
};

export type SredPayrollExpensesSummary = {
  __typename?: 'SredPayrollExpensesSummary';
  avg?: Maybe<SredPayrollExpenseAvgAggregate>;
  count?: Maybe<SredPayrollExpenseCountAggregate>;
  groupBy?: Maybe<SredPayrollExpenseAggregateGroupBy>;
  max?: Maybe<SredPayrollExpenseMaxAggregate>;
  min?: Maybe<SredPayrollExpenseMinAggregate>;
  sum?: Maybe<SredPayrollExpenseSumAggregate>;
  uniqueCount?: Maybe<SredPayrollExpenseUniqueCountAggregate>;
};

export type SredPayrollExpensesSummaryFilter = {
  amountCents?: InputMaybe<BigIntFilterComparison>;
  and?: InputMaybe<Array<SredPayrollExpenseAggregateFilter>>;
  costCenter?: InputMaybe<StringFieldComparison>;
  department?: InputMaybe<StringFieldComparison>;
  entity?: InputMaybe<StringFieldComparison>;
  hireDate?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  managerName?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SredPayrollExpenseAggregateFilter>>;
  payrollProvider?: InputMaybe<PayrollProviderFilterComparison>;
  province?: InputMaybe<StringFieldComparison>;
  qualifiedAmountCents?: InputMaybe<BigIntFilterComparison>;
  sredCategory?: InputMaybe<SredCategoryFilterComparison>;
  sredEligiblePercentage?: InputMaybe<FloatFieldComparison>;
  sredEmployeeType?: InputMaybe<SredEmployeeTypeFilterComparison>;
  terminationDate?: InputMaybe<StringFieldComparison>;
  title?: InputMaybe<StringFieldComparison>;
  wageType?: InputMaybe<CaWageTypeFilterComparison>;
};

export enum SredProcessingState {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  NeverProcessed = 'NEVER_PROCESSED',
}

export type SredProject = {
  __typename?: 'SredProject';
  aiGuidance?: Maybe<Scalars['String']['output']>;
  appliedResearch?: Maybe<Scalars['Boolean']['output']>;
  approvalComment?: Maybe<Scalars['String']['output']>;
  approvalTime?: Maybe<Scalars['DateTime']['output']>;
  basicResearch?: Maybe<Scalars['Boolean']['output']>;
  clusterType: SredClusterType;
  consideredForSred: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  experimentalDevelopment?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  processingState: SredProcessingState;
  product?: Maybe<Product>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwner?: Maybe<SredProjectOwner>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  provincialEligibility?: Maybe<Array<Province>>;
  selectedCategory: SelectedSredProjectCategory;
  sredDocumentationStatus: SredDocumentationStatus;
  sredEligibleDate?: Maybe<Scalars['String']['output']>;
  sredTaxCreditId: Scalars['ID']['output'];
  supportingDocuments: Array<FileUpload>;
  supportingWork?: Maybe<Scalars['String']['output']>;
  systematicInvestigation?: Maybe<Scalars['String']['output']>;
  technologicalAdvancement?: Maybe<Scalars['String']['output']>;
  technologicalUncertainty?: Maybe<Scalars['String']['output']>;
  ticketCount: Scalars['Int']['output'];
  workInCanadaPercentage?: Maybe<Scalars['Int']['output']>;
  workstreamNames: Array<Scalars['String']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type SredProjectAggregateGroupBy = {
  __typename?: 'SredProjectAggregateGroupBy';
  aiGuidance?: Maybe<Scalars['String']['output']>;
  appliedResearch?: Maybe<Scalars['Boolean']['output']>;
  basicResearch?: Maybe<Scalars['Boolean']['output']>;
  consideredForSred?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  experimentalDevelopment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  selectedCategory?: Maybe<SelectedSredProjectCategory>;
  sredDocumentationStatus?: Maybe<SredDocumentationStatus>;
  sredEligibleDate?: Maybe<Scalars['String']['output']>;
  systematicInvestigation?: Maybe<Scalars['String']['output']>;
  technologicalAdvancement?: Maybe<Scalars['String']['output']>;
  technologicalUncertainty?: Maybe<Scalars['String']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workInCanadaPercentage?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type SredProjectAvgAggregate = {
  __typename?: 'SredProjectAvgAggregate';
  ticketCount?: Maybe<Scalars['Float']['output']>;
};

export type SredProjectConnection = {
  __typename?: 'SredProjectConnection';
  /** Array of edges. */
  edges: Array<SredProjectEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type SredProjectCountAggregate = {
  __typename?: 'SredProjectCountAggregate';
  aiGuidance?: Maybe<Scalars['Int']['output']>;
  appliedResearch?: Maybe<Scalars['Int']['output']>;
  basicResearch?: Maybe<Scalars['Int']['output']>;
  consideredForSred?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['Int']['output']>;
  experimentalDevelopment?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['Int']['output']>;
  projectOwnerId?: Maybe<Scalars['Int']['output']>;
  projectOwnerName?: Maybe<Scalars['Int']['output']>;
  selectedCategory?: Maybe<Scalars['Int']['output']>;
  sredDocumentationStatus?: Maybe<Scalars['Int']['output']>;
  sredEligibleDate?: Maybe<Scalars['Int']['output']>;
  systematicInvestigation?: Maybe<Scalars['Int']['output']>;
  technologicalAdvancement?: Maybe<Scalars['Int']['output']>;
  technologicalUncertainty?: Maybe<Scalars['Int']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workInCanadaPercentage?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['Int']['output']>;
};

export type SredProjectEdge = {
  __typename?: 'SredProjectEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the SredProject */
  node: SredProject;
};

export type SredProjectFilter = {
  aiGuidance?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<SredProjectFilter>>;
  appliedResearch?: InputMaybe<BooleanFieldComparison>;
  basicResearch?: InputMaybe<BooleanFieldComparison>;
  consideredForSred?: InputMaybe<BooleanFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  experimentalDevelopment?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SredProjectFilter>>;
  productName?: InputMaybe<StringFieldComparison>;
  projectOwnerId?: InputMaybe<IdFilterComparison>;
  projectOwnerName?: InputMaybe<StringFieldComparison>;
  selectedCategory?: InputMaybe<SelectedSredProjectCategoryFilterComparison>;
  sredDocumentationStatus?: InputMaybe<SredDocumentationStatusFilterComparison>;
  sredEligibleDate?: InputMaybe<StringFieldComparison>;
  systematicInvestigation?: InputMaybe<StringFieldComparison>;
  technologicalAdvancement?: InputMaybe<StringFieldComparison>;
  technologicalUncertainty?: InputMaybe<StringFieldComparison>;
  ticketCount?: InputMaybe<IntFieldComparison>;
  workInCanadaPercentage?: InputMaybe<IntFieldComparison>;
  workstreamNamesSearch?: InputMaybe<StringFieldComparison>;
};

export type SredProjectMaxAggregate = {
  __typename?: 'SredProjectMaxAggregate';
  aiGuidance?: Maybe<Scalars['String']['output']>;
  appliedResearch?: Maybe<Scalars['Boolean']['output']>;
  basicResearch?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  experimentalDevelopment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  selectedCategory?: Maybe<SelectedSredProjectCategory>;
  sredDocumentationStatus?: Maybe<SredDocumentationStatus>;
  sredEligibleDate?: Maybe<Scalars['String']['output']>;
  systematicInvestigation?: Maybe<Scalars['String']['output']>;
  technologicalAdvancement?: Maybe<Scalars['String']['output']>;
  technologicalUncertainty?: Maybe<Scalars['String']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workInCanadaPercentage?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type SredProjectMinAggregate = {
  __typename?: 'SredProjectMinAggregate';
  aiGuidance?: Maybe<Scalars['String']['output']>;
  appliedResearch?: Maybe<Scalars['Boolean']['output']>;
  basicResearch?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  experimentalDevelopment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  projectOwnerId?: Maybe<Scalars['ID']['output']>;
  projectOwnerName?: Maybe<Scalars['String']['output']>;
  selectedCategory?: Maybe<SelectedSredProjectCategory>;
  sredDocumentationStatus?: Maybe<SredDocumentationStatus>;
  sredEligibleDate?: Maybe<Scalars['String']['output']>;
  systematicInvestigation?: Maybe<Scalars['String']['output']>;
  technologicalAdvancement?: Maybe<Scalars['String']['output']>;
  technologicalUncertainty?: Maybe<Scalars['String']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  workInCanadaPercentage?: Maybe<Scalars['Int']['output']>;
  workstreamNamesSearch?: Maybe<Scalars['String']['output']>;
};

export type SredProjectOwner = {
  __typename?: 'SredProjectOwner';
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SredProjectSort = {
  direction: SortDirection;
  field: SredProjectSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SredProjectSortFields {
  AiGuidance = 'aiGuidance',
  AppliedResearch = 'appliedResearch',
  BasicResearch = 'basicResearch',
  ConsideredForSred = 'consideredForSred',
  Description = 'description',
  ExperimentalDevelopment = 'experimentalDevelopment',
  Id = 'id',
  Name = 'name',
  ProductName = 'productName',
  ProjectOwnerId = 'projectOwnerId',
  ProjectOwnerName = 'projectOwnerName',
  SelectedCategory = 'selectedCategory',
  SredDocumentationStatus = 'sredDocumentationStatus',
  SredEligibleDate = 'sredEligibleDate',
  SystematicInvestigation = 'systematicInvestigation',
  TechnologicalAdvancement = 'technologicalAdvancement',
  TechnologicalUncertainty = 'technologicalUncertainty',
  TicketCount = 'ticketCount',
  WorkInCanadaPercentage = 'workInCanadaPercentage',
  WorkstreamNamesSearch = 'workstreamNamesSearch',
}

export type SredProjectSumAggregate = {
  __typename?: 'SredProjectSumAggregate';
  ticketCount?: Maybe<Scalars['Float']['output']>;
};

export type SredTaxCredit = {
  __typename?: 'SredTaxCredit';
  id: Scalars['ID']['output'];
};

export type StartProcessingTicketingDataInput = {
  analysisTypes: Array<AnalysisType>;
  endDateOfPeriod: Scalars['String']['input'];
  startDateOfPeriod: Scalars['String']['input'];
};

export enum State {
  Alabama = 'ALABAMA',
  Alaska = 'ALASKA',
  AmericanSamoa = 'AMERICAN_SAMOA',
  Arizona = 'ARIZONA',
  Arkansas = 'ARKANSAS',
  California = 'CALIFORNIA',
  Colorado = 'COLORADO',
  Connecticut = 'CONNECTICUT',
  Delaware = 'DELAWARE',
  DistrictOfColumbia = 'DISTRICT_OF_COLUMBIA',
  FederatedStatesOfMicronesia = 'FEDERATED_STATES_OF_MICRONESIA',
  Florida = 'FLORIDA',
  Georgia = 'GEORGIA',
  Guam = 'GUAM',
  Hawaii = 'HAWAII',
  Idaho = 'IDAHO',
  Illinois = 'ILLINOIS',
  Indiana = 'INDIANA',
  Iowa = 'IOWA',
  Kansas = 'KANSAS',
  Kentucky = 'KENTUCKY',
  Louisiana = 'LOUISIANA',
  Maine = 'MAINE',
  MarshallIslands = 'MARSHALL_ISLANDS',
  Maryland = 'MARYLAND',
  Massachusetts = 'MASSACHUSETTS',
  Michigan = 'MICHIGAN',
  Minnesota = 'MINNESOTA',
  Mississippi = 'MISSISSIPPI',
  Missouri = 'MISSOURI',
  Montana = 'MONTANA',
  Nebraska = 'NEBRASKA',
  Nevada = 'NEVADA',
  NewHampshire = 'NEW_HAMPSHIRE',
  NewJersey = 'NEW_JERSEY',
  NewMexico = 'NEW_MEXICO',
  NewYork = 'NEW_YORK',
  NorthernMarianaIslands = 'NORTHERN_MARIANA_ISLANDS',
  NorthCarolina = 'NORTH_CAROLINA',
  NorthDakota = 'NORTH_DAKOTA',
  Ohio = 'OHIO',
  Oklahoma = 'OKLAHOMA',
  Oregon = 'OREGON',
  Palau = 'PALAU',
  Pennsylvania = 'PENNSYLVANIA',
  PuertoRico = 'PUERTO_RICO',
  RhodeIsland = 'RHODE_ISLAND',
  SouthCarolina = 'SOUTH_CAROLINA',
  SouthDakota = 'SOUTH_DAKOTA',
  Tennessee = 'TENNESSEE',
  Texas = 'TEXAS',
  Utah = 'UTAH',
  Vermont = 'VERMONT',
  Virginia = 'VIRGINIA',
  VirginIslands = 'VIRGIN_ISLANDS',
  Washington = 'WASHINGTON',
  WestVirginia = 'WEST_VIRGINIA',
  Wisconsin = 'WISCONSIN',
  Wyoming = 'WYOMING',
}

export type StateRdTaxCreditDocument = {
  __typename?: 'StateRdTaxCreditDocument';
  allowAccessDatetime?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  state: State;
  stateTaxCreditFormFileName?: Maybe<Scalars['String']['output']>;
  /** null for any user without financial permissions */
  stateTaxCreditFormUrl?: Maybe<Scalars['String']['output']>;
};

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notILike?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SupervisorIdentificationResult = {
  __typename?: 'SupervisorIdentificationResult';
  nonSupervisorIds: Array<Scalars['String']['output']>;
  supervisorCount: Scalars['Int']['output'];
  supervisorIds: Array<Scalars['String']['output']>;
};

export type SyncAccountingProviderResult = {
  __typename?: 'SyncAccountingProviderResult';
  success: Scalars['Boolean']['output'];
};

export type SyncConfigurationRd = {
  __typename?: 'SyncConfigurationRd';
  businessComponentMatchThreshold?: Maybe<Scalars['Float']['output']>;
  businessComponentMethod?: Maybe<RdBusinessComponentSource>;
  businessComponentParams?: Maybe<BusinessComponentParams>;
  clusteringMode: ClusteringMode;
  dataCleaningStrategy: DataCleaningStrategy;
  id: Scalars['ID']['output'];
  maxNumberOfClusters: Scalars['Int']['output'];
  minNumberOfClusters: Scalars['Int']['output'];
  minNumberOfTicketsPerCluster: Scalars['Int']['output'];
  usePartitionByWorkstream: Scalars['Boolean']['output'];
};

export type SyncConfigurationRdInput = {
  businessComponentMethod?: InputMaybe<RdBusinessComponentSource>;
  businessComponentParams?: InputMaybe<BusinessComponentParamsInput>;
  clusteringMode: ClusteringMode;
  dataCleaningStrategy: DataCleaningStrategy;
  maxNumberOfClusters: Scalars['Int']['input'];
  minNumberOfClusters: Scalars['Int']['input'];
  minNumberOfTicketsPerCluster: Scalars['Int']['input'];
  usePartitionByWorkstream: Scalars['Boolean']['input'];
};

export type SyncConfigurationsAscExcludedWorkstreamRo = {
  __typename?: 'SyncConfigurationsAscExcludedWorkstreamRo';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  syncConfigurationAscId: Scalars['ID']['output'];
  ticketingProviderWorkstreamId: Scalars['ID']['output'];
};

export type SyncPayrollProviderResult = {
  __typename?: 'SyncPayrollProviderResult';
  errors?: Maybe<Array<TabularDataParseError>>;
  success: Scalars['Boolean']['output'];
};

export type SyncPeriodModel = {
  __typename?: 'SyncPeriodModel';
  firstDayOfPeriod: Scalars['String']['output'];
  lastDayOfPeriod: Scalars['String']['output'];
};

export type SyncTicketingDataScheduleModel = {
  __typename?: 'SyncTicketingDataScheduleModel';
  analysisTypes: Array<AnalysisType>;
  ascConfigPreConfirmed: Scalars['Boolean']['output'];
  syncPeriod: SyncPeriodModel;
  ticketingTokenId: Scalars['ID']['output'];
};

export type SyncedAccountingProviders = {
  __typename?: 'SyncedAccountingProviders';
  id: Scalars['ID']['output'];
  originalSyncDate: Scalars['String']['output'];
  providerName: AccountingProvider;
};

export type SyncedPayrollMonthExpense = {
  __typename?: 'SyncedPayrollMonthExpense';
  fileUpload?: Maybe<FileUpload>;
  id: Scalars['ID']['output'];
  originalSyncDate: Scalars['String']['output'];
  period: MonthYearPeriod;
};

export type SyncedPayrollProviders = {
  __typename?: 'SyncedPayrollProviders';
  id: Scalars['ID']['output'];
  originalSyncDate: Scalars['String']['output'];
  providerName: PayrollProvider;
};

export type SyncedProviders = {
  __typename?: 'SyncedProviders';
  accountingProviders: Array<SyncedAccountingProviders>;
  id: Scalars['ID']['output'];
  payrollProviders: Array<SyncedPayrollProviders>;
  ticketingProviders: Array<SyncedTicketingProviders>;
};

export type SyncedRdPayrollCost = {
  __typename?: 'SyncedRdPayrollCost';
  fileUpload: FileUpload;
  id: Scalars['ID']['output'];
  originalSyncDate: Scalars['String']['output'];
  provider: PayrollProvider;
};

export type SyncedTicketingProviders = {
  __typename?: 'SyncedTicketingProviders';
  id: Scalars['ID']['output'];
  originalSyncDate: Scalars['String']['output'];
  providerName: TicketingProvider;
};

export enum TabularDataErrorCode {
  DisallowedValue = 'DISALLOWED_VALUE',
  DuplicatedValue = 'DUPLICATED_VALUE',
  EmptyFile = 'EMPTY_FILE',
  InvalidDate = 'INVALID_DATE',
  InvalidEmail = 'INVALID_EMAIL',
  InvalidPercentage = 'INVALID_PERCENTAGE',
  InvalidSheetCount = 'INVALID_SHEET_COUNT',
  InvalidTotalPercentage = 'INVALID_TOTAL_PERCENTAGE',
  InvalidValue = 'INVALID_VALUE',
  MissingAtLeastOneColumnHeader = 'MISSING_AT_LEAST_ONE_COLUMN_HEADER',
  MissingColumn = 'MISSING_COLUMN',
  MissingColumnHeaders = 'MISSING_COLUMN_HEADERS',
  MissingValue = 'MISSING_VALUE',
  NonNumericValue = 'NON_NUMERIC_VALUE',
  NonPositiveNumericValue = 'NON_POSITIVE_NUMERIC_VALUE',
  NoValidRowsFound = 'NO_VALID_ROWS_FOUND',
  UnrecognizedColumn = 'UNRECOGNIZED_COLUMN',
  UnrecognizedValue = 'UNRECOGNIZED_VALUE',
  WrongTemplate = 'WRONG_TEMPLATE',
}

export type TabularDataParseError = {
  __typename?: 'TabularDataParseError';
  code: TabularDataErrorCode;
  column?: Maybe<Scalars['String']['output']>;
  row?: Maybe<Scalars['Int']['output']>;
  sheet?: Maybe<Scalars['String']['output']>;
  source: TabularDataSource;
  value?: Maybe<Scalars['String']['output']>;
};

export enum TabularDataSource {
  Csv = 'CSV',
  Excel = 'EXCEL',
  Other = 'OTHER',
}

export type TaskDetails = {
  __typename?: 'TaskDetails';
  payload?: Maybe<Scalars['String']['output']>;
  queueName: Scalars['String']['output'];
  targetUrl: Scalars['String']['output'];
};

export enum TaxAuthority {
  Alabama = 'ALABAMA',
  Alaska = 'ALASKA',
  AmericanSamoa = 'AMERICAN_SAMOA',
  Arizona = 'ARIZONA',
  Arkansas = 'ARKANSAS',
  California = 'CALIFORNIA',
  Colorado = 'COLORADO',
  Connecticut = 'CONNECTICUT',
  Delaware = 'DELAWARE',
  DistrictOfColumbia = 'DISTRICT_OF_COLUMBIA',
  Federal = 'FEDERAL',
  FederatedStatesOfMicronesia = 'FEDERATED_STATES_OF_MICRONESIA',
  Florida = 'FLORIDA',
  Georgia = 'GEORGIA',
  Guam = 'GUAM',
  Hawaii = 'HAWAII',
  Idaho = 'IDAHO',
  Illinois = 'ILLINOIS',
  Indiana = 'INDIANA',
  Iowa = 'IOWA',
  Kansas = 'KANSAS',
  Kentucky = 'KENTUCKY',
  Louisiana = 'LOUISIANA',
  Maine = 'MAINE',
  MarshallIslands = 'MARSHALL_ISLANDS',
  Maryland = 'MARYLAND',
  Massachusetts = 'MASSACHUSETTS',
  Michigan = 'MICHIGAN',
  Minnesota = 'MINNESOTA',
  Mississippi = 'MISSISSIPPI',
  Missouri = 'MISSOURI',
  Montana = 'MONTANA',
  Nebraska = 'NEBRASKA',
  Nevada = 'NEVADA',
  NewHampshire = 'NEW_HAMPSHIRE',
  NewJersey = 'NEW_JERSEY',
  NewMexico = 'NEW_MEXICO',
  NewYork = 'NEW_YORK',
  NorthernMarianaIslands = 'NORTHERN_MARIANA_ISLANDS',
  NorthCarolina = 'NORTH_CAROLINA',
  NorthDakota = 'NORTH_DAKOTA',
  Ohio = 'OHIO',
  Oklahoma = 'OKLAHOMA',
  Oregon = 'OREGON',
  Palau = 'PALAU',
  Pennsylvania = 'PENNSYLVANIA',
  PuertoRico = 'PUERTO_RICO',
  RhodeIsland = 'RHODE_ISLAND',
  SouthCarolina = 'SOUTH_CAROLINA',
  SouthDakota = 'SOUTH_DAKOTA',
  Tennessee = 'TENNESSEE',
  Texas = 'TEXAS',
  Utah = 'UTAH',
  Vermont = 'VERMONT',
  Virginia = 'VIRGINIA',
  VirginIslands = 'VIRGIN_ISLANDS',
  Washington = 'WASHINGTON',
  WestVirginia = 'WEST_VIRGINIA',
  Wisconsin = 'WISCONSIN',
  Wyoming = 'WYOMING',
}

export enum TicketGroupingKind {
  GroupingCollection = 'GROUPING_COLLECTION',
  GroupingTicket = 'GROUPING_TICKET',
  NoParent = 'NO_PARENT',
}

export enum TicketingAcquisitionMethod {
  File = 'FILE',
  GithubApp = 'GITHUB_APP',
  MergeDev = 'MERGE_DEV',
  Snowflake = 'SNOWFLAKE',
}

export enum TicketingEntityType {
  Collections = 'COLLECTIONS',
  Teams = 'TEAMS',
  Tickets = 'TICKETS',
  Users = 'USERS',
}

export enum TicketingProvider {
  Asana = 'ASANA',
  AzureDevops = 'AZURE_DEVOPS',
  GithubIssues = 'GITHUB_ISSUES',
  JiraCloud = 'JIRA_CLOUD',
  JiraDataCenter = 'JIRA_DATA_CENTER',
  Linear = 'LINEAR',
  Shortcut = 'SHORTCUT',
  Trello = 'TRELLO',
}

export type TicketingProviderSyncEvent = {
  __typename?: 'TicketingProviderSyncEvent';
  acquisitionMethod: TicketingAcquisitionMethod;
  analysisTypes: Array<AnalysisType>;
  ascPartitionClusterConfigurationsConfirmedDatetime?: Maybe<Scalars['Date']['output']>;
  backgroundOperationId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  firstDateOfPeriod: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isValidation: Scalars['Boolean']['output'];
  lastDateOfPeriod: Scalars['String']['output'];
  provider: TicketingProvider;
  rdPartitionClusterConfigurationsConfirmedDatetime?: Maybe<Scalars['Date']['output']>;
};

export type TicketingProviderUser = {
  __typename?: 'TicketingProviderUser';
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ticketingProvider: TicketingProvider;
};

export type TicketingProviderWorkstream = {
  __typename?: 'TicketingProviderWorkstream';
  amid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
};

export type TicketingToken = {
  __typename?: 'TicketingToken';
  acquisitionMethod: TicketingAcquisitionMethod;
  clusterHierarchyTypes?: Maybe<DeterministicClusteringObjectLevel>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  installationStatus?: Maybe<GitHubInstallationStatus>;
  lastSuccessfulSync?: Maybe<TicketingTokenLastSuccessfulSync>;
  needsRelink?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  pendingScheduledSyncCount?: Maybe<Scalars['Int']['output']>;
  ticketingProvider: TicketingProvider;
};

export type TicketingTokenLastSuccessfulSync = {
  __typename?: 'TicketingTokenLastSuccessfulSync';
  acquisitionMethod: TicketingAcquisitionMethod;
  at: Scalars['Date']['output'];
};

export type TicketingUser = {
  __typename?: 'TicketingUser';
  companyId: Scalars['String']['output'];
  contributorId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  provider: TicketingProvider;
  rdTaxCreditId: Scalars['String']['output'];
};

export type TicketingUserAggregateGroupBy = {
  __typename?: 'TicketingUserAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rdTaxCreditId?: Maybe<Scalars['String']['output']>;
};

export type TicketingUserConnection = {
  __typename?: 'TicketingUserConnection';
  /** Array of edges. */
  edges: Array<TicketingUserEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type TicketingUserCountAggregate = {
  __typename?: 'TicketingUserCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  rdTaxCreditId?: Maybe<Scalars['Int']['output']>;
};

export type TicketingUserEdge = {
  __typename?: 'TicketingUserEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TicketingUser */
  node: TicketingUser;
};

export type TicketingUserFilter = {
  and?: InputMaybe<Array<TicketingUserFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<TicketingUserFilter>>;
  rdTaxCreditId?: InputMaybe<StringFieldComparison>;
};

export type TicketingUserMaxAggregate = {
  __typename?: 'TicketingUserMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rdTaxCreditId?: Maybe<Scalars['String']['output']>;
};

export type TicketingUserMinAggregate = {
  __typename?: 'TicketingUserMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rdTaxCreditId?: Maybe<Scalars['String']['output']>;
};

export type TicketingUserSort = {
  direction: SortDirection;
  field: TicketingUserSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum TicketingUserSortFields {
  Id = 'id',
  Name = 'name',
  RdTaxCreditId = 'rdTaxCreditId',
}

export enum TimesheetEffortUnit {
  Hour = 'HOUR',
  Percent = 'PERCENT',
}

export type TimesheetRdReport = {
  __typename?: 'TimesheetRdReport';
  flowStatus: TimesheetRdReportFlowStatus;
  matchSummary: TimesheetRdReportMatchSummary;
  projects: Array<TimesheetRdReportProject>;
  unmatchedUsers: Array<TimesheetRdReportUserRow>;
};

export type TimesheetRdReportFlowStatus = {
  __typename?: 'TimesheetRdReportFlowStatus';
  hasData: Scalars['Boolean']['output'];
  lastRunComplete: Scalars['Boolean']['output'];
  lastRunPaused: Scalars['Boolean']['output'];
  lastRunState?: Maybe<Scalars['String']['output']>;
};

export type TimesheetRdReportMatchSummary = {
  __typename?: 'TimesheetRdReportMatchSummary';
  matchedByManual: Scalars['Int']['output'];
  matchedByName: Scalars['Int']['output'];
  matchedByPid: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unmatched: Scalars['Int']['output'];
};

export type TimesheetRdReportProject = {
  __typename?: 'TimesheetRdReportProject';
  projectName: Scalars['String']['output'];
  rdProjectId: Scalars['ID']['output'];
  userCount: Scalars['Int']['output'];
};

export type TimesheetRdReportUserRow = {
  __typename?: 'TimesheetRdReportUserRow';
  contributorName: Scalars['String']['output'];
  isMatched: Scalars['Boolean']['output'];
  matchScore?: Maybe<Scalars['Float']['output']>;
  matchTier?: Maybe<Scalars['String']['output']>;
  pid: Scalars['String']['output'];
  rdTaxCreditContributorId?: Maybe<Scalars['ID']['output']>;
  rdTimesheetUserId: Scalars['ID']['output'];
};

export type TimesheetSyncEvent = {
  __typename?: 'TimesheetSyncEvent';
  createdAt: Scalars['String']['output'];
  effortUnit: TimesheetEffortUnit;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TokenValidationIssue = {
  __typename?: 'TokenValidationIssue';
  /** The API endpoint tested (e.g., "/api/3/search/jql", "/user/orgs") */
  endpoint: Scalars['String']['output'];
  /** Actionable instructions on how to resolve the issue */
  hint: Scalars['String']['output'];
  /** The method name that failed (e.g., "getTickets", "listOrganizations") */
  method: Scalars['String']['output'];
  /** Human-readable description of what failed */
  name: Scalars['String']['output'];
  /** Purpose of this check (e.g., "Ticket sync", "Organization discovery") */
  purpose: Scalars['String']['output'];
};

export type UpdateAccountingExpenseInput = {
  amountCents?: InputMaybe<Scalars['Float']['input']>;
  countryAlpha2?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  rdCategory?: InputMaybe<RdCategory>;
  reason?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAllowAccessToDocumentInput = {
  allowAccess: Scalars['Boolean']['input'];
  documentType: DocumentType;
  taxAuthority: TaxAuthority;
};

export type UpdateAscProjectCapitalizableProjectClusteringOverrideInput = {
  /** INCLUDED, EXCLUDED, or null to reset to default capitalization rule */
  override?: InputMaybe<CapitalizableProjectClusteringOverride>;
};

export type UpdateAscProjectCapitalizationInput = {
  capitalizationEndDate?: InputMaybe<Scalars['Date']['input']>;
  capitalizationStartDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateAscProjectInput = {
  customFieldLaunchDate?: InputMaybe<Scalars['Date']['input']>;
  customFieldTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  projectOwnerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCompanyFiscalYearEndInput = {
  fiscalYearEndMonth: Scalars['Int']['input'];
};

export type UpdateCompanyOfficerInput = {
  isOfficer: Scalars['Boolean']['input'];
};

export type UpdateCompanySettingsInput = {
  approvedForLlmTraining?: InputMaybe<Scalars['Boolean']['input']>;
  approvedForOtherAiTraining?: InputMaybe<Scalars['Boolean']['input']>;
  ascLockedUntilMonthYear?: InputMaybe<Scalars['String']['input']>;
  fuzzyMatchThreshold?: InputMaybe<Scalars['Float']['input']>;
  isPiiRedacted?: InputMaybe<Scalars['Boolean']['input']>;
  llmProvider?: InputMaybe<LlmProvider>;
  rdContributorCombineLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateContributorAllocationForAscInput = {
  allocationPercents: Array<AscProjectAllocationPercentInput>;
  contributorId: Scalars['ID']['input'];
  nonProjectPercent: Scalars['Float']['input'];
};

export type UpdateContributorInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFiscalYearInput = {
  isEnabled: Scalars['Boolean']['input'];
};

export type UpdatePayrollExpenseInput = {
  amountCents?: InputMaybe<Scalars['Float']['input']>;
  countryAlpha2?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRdExpenseProjectAllocationsInput = {
  rdProjectAllocationPercents: Array<RdProjectAllocationPercentInput>;
};

export type UpdateRdProjectInput = {
  aiGuidance?: InputMaybe<Scalars['String']['input']>;
  approvalComment?: InputMaybe<Scalars['String']['input']>;
  approvalTime?: InputMaybe<Scalars['String']['input']>;
  businessComponent?: InputMaybe<ProjectBusinessComponent>;
  businessPurpose?: InputMaybe<ProjectBusinessPurpose>;
  clusterType?: InputMaybe<RdClusterType>;
  consideredForRd?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disallowances?: InputMaybe<Array<ProjectDisallowance>>;
  fiscalYearId?: InputMaybe<Scalars['String']['input']>;
  improvedAspects?: InputMaybe<Array<ProjectPurposeImprovedAspect>>;
  isCustomerFacingDevelopment?: InputMaybe<Scalars['Boolean']['input']>;
  isInnovativeAndRisky?: InputMaybe<Scalars['Boolean']['input']>;
  isSection174Eligible?: InputMaybe<Scalars['Boolean']['input']>;
  isTechnicallyUncertain?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processOfExperimentation?: InputMaybe<Scalars['String']['input']>;
  processingState?: InputMaybe<ProcessingProjectState>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  projectOwnerId?: InputMaybe<Scalars['ID']['input']>;
  projectOwnerName?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<ProjectPurpose>;
  rdDocumentationStatus?: InputMaybe<RdDocumentationStatus>;
  selectedCategory?: InputMaybe<SelectedRdProjectCategory>;
  technicalChallenges?: InputMaybe<Scalars['String']['input']>;
  ticketCount?: InputMaybe<Scalars['Int']['input']>;
  workstreamNames?: InputMaybe<Array<Scalars['String']['input']>>;
  workstreamNamesSearch?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSingleTenantDomainRedirectInput = {
  emailDomain: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type UpdateUserInput = {
  fullName: Scalars['String']['input'];
};

export type UploadAccountingExpenseCsvResult = {
  __typename?: 'UploadAccountingExpenseCsvResult';
  accountingQres?: Maybe<Array<AccountingQre>>;
  errors?: Maybe<Array<TabularDataParseError>>;
};

export enum UploadAction {
  Resumable = 'RESUMABLE',
  Write = 'WRITE',
}

export type UploadAscWageReportResult = {
  __typename?: 'UploadAscWageReportResult';
  errors?: Maybe<Array<ExcelParseError>>;
};

export type UploadCsvToMoveTicketsToAscProjects = {
  __typename?: 'UploadCsvToMoveTicketsToAscProjects';
  success: Scalars['Boolean']['output'];
};

export type UploadCsvToMoveTicketsToRdProjects = {
  __typename?: 'UploadCsvToMoveTicketsToRdProjects';
  success: Scalars['Boolean']['output'];
};

export type UploadPayrollExpenseCsvResult = {
  __typename?: 'UploadPayrollExpenseCsvResult';
  errors?: Maybe<Array<TabularDataParseError>>;
  payrollQres?: Maybe<Array<PayrollQre>>;
};

export type UploadRdExpenseProjectAllocationReportInput = {
  providerType: ProviderType;
};

export type UploadRdExpenseProjectAllocationReportResult = {
  __typename?: 'UploadRdExpenseProjectAllocationReportResult';
  errors?: Maybe<Array<ExcelParseError>>;
};

export type UploadUrl = {
  __typename?: 'UploadUrl';
  /** This will be the file cloud storage permanent URL if the upload is successful */
  permanentUrl: Scalars['String']['output'];
  /** Use this URL to upload the file to the cloud storage. */
  signedUrl: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  allowRealCompanyDatetime?: Maybe<Scalars['Date']['output']>;
  companies: Array<Company>;
  companyScopes: Array<CompanyScopes>;
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  enterpriseSsoExemptDatetime?: Maybe<Scalars['Date']['output']>;
  firebaseUserId: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastLoginDatetime: Scalars['Date']['output'];
  organization?: Maybe<Organization>;
  organizationScope?: Maybe<OrganizationScope>;
  pendingOrFailedStatusCompanyInvitations: Array<CompanyInvitation>;
  pendingOrFailedStatusOrganizationInvitations: Array<OrganizationInvitation>;
  phone?: Maybe<Scalars['String']['output']>;
  thomsonReutersConsumerKey?: Maybe<Scalars['String']['output']>;
  userAttributes: UserAttributes;
};

export type UserAttributes = {
  __typename?: 'UserAttributes';
  crmContactId?: Maybe<Scalars['String']['output']>;
  isSsoOnboarding?: Maybe<Scalars['Boolean']['output']>;
  viewedWelcomeMessageTaxYear?: Maybe<Scalars['Int']['output']>;
};

export type UserIdWithRole = {
  __typename?: 'UserIdWithRole';
  isSuperUser: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type ValidateTicketingTokenOutput = {
  __typename?: 'ValidateTicketingTokenOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  failedChecks: Array<TokenValidationIssue>;
  /** Populated for GitHub tokens only */
  github?: Maybe<GithubTokenDetails>;
  isValid: Scalars['Boolean']['output'];
};

export enum ValueType {
  Cents = 'CENTS',
  Dollar = 'DOLLAR',
  Fraction = 'FRACTION',
  Percent = 'PERCENT',
  Text = 'TEXT',
}

export enum WageType {
  Contractor = 'CONTRACTOR',
  W2 = 'W2',
}

export type GetUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'User';
    id: string;
    fullName: string;
    email: string;
    phone?: string | null;
    firebaseUserId: string;
    allowRealCompanyDatetime?: string | null;
    organizationScope?: OrganizationScope | null;
    thomsonReutersConsumerKey?: string | null;
    userAttributes: {
      __typename?: 'UserAttributes';
      viewedWelcomeMessageTaxYear?: number | null;
      isSsoOnboarding?: boolean | null;
    };
    companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
    pendingOrFailedStatusOrganizationInvitations: Array<{
      __typename?: 'OrganizationInvitation';
      id: string;
      derivedState: string;
    }>;
    companies: Array<{ __typename?: 'Company'; id: string }>;
    organization?: {
      __typename?: 'Organization';
      id: string;
      photoUrl?: string | null;
      name: string;
      isAccountingFirm: boolean;
      members: Array<{
        __typename?: 'User';
        id: string;
        email: string;
        fullName: string;
        organizationScope?: OrganizationScope | null;
        companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
      }>;
      invitedMembers: Array<{
        __typename?: 'OrganizationInvitation';
        id: string;
        email: string;
        scope: OrganizationScope;
        expiresAt: string;
        revokedAt?: string | null;
        acceptedAt?: string | null;
        derivedState: string;
      }>;
    } | null;
  };
};

export type GetOrganizationMembersCsvQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationMembersCsvQuery = {
  __typename?: 'Query';
  getOrganizationMembersCsv: {
    __typename?: 'Report';
    columnNames: Array<string>;
    resultCsv: string;
    signedUrl?: string | null;
  };
};

export type GetUserFromAuthQueryVariables = Exact<{
  firebaseUserId: Scalars['String']['input'];
}>;

export type GetUserFromAuthQuery = {
  __typename?: 'Query';
  getUserFromAuth?: { __typename?: 'UserIdWithRole'; userId: string; isSuperUser: boolean } | null;
};

export type ProvisionCurrentUserMutationVariables = Exact<{ [key: string]: never }>;

export type ProvisionCurrentUserMutation = { __typename?: 'Mutation'; provisionCurrentUser: boolean };

export type ReconcileUserStateMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type ReconcileUserStateMutation = {
  __typename?: 'Mutation';
  reconcileUserState: { __typename?: 'User'; id: string };
};

export type ReportLoginFailureMutationVariables = Exact<{
  input: ReportLoginFailureInput;
}>;

export type ReportLoginFailureMutation = { __typename?: 'Mutation'; reportLoginFailure: boolean };

export type UpdateCompanyQuestionsMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  questions: CompanyQuestionsInput;
}>;

export type UpdateCompanyQuestionsMutation = {
  __typename?: 'Mutation';
  updateCompanyQuestions: {
    __typename?: 'Company';
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
    priorYearQREs?: Array<{ __typename?: 'PriorYearQRE'; year: number; amount?: number | null }> | null;
    priorYearRevenues: Array<{
      __typename?: 'PriorYearRevenue';
      id: string;
      revenueCents?: number | null;
      year: number;
      revenueSource: RevenueSource;
    }>;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
  };
};

export type GetPriorYearRevenuesQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetPriorYearRevenuesQuery = {
  __typename?: 'Query';
  getCompany: {
    __typename?: 'Company';
    id: string;
    priorYearRevenues: Array<{
      __typename?: 'PriorYearRevenue';
      id: string;
      revenueCents?: number | null;
      year: number;
      taxYearStartDate: string;
      taxYearEndDate: string;
      revenueSource: RevenueSource;
    }>;
  };
};

export type RecordDownloadDocumentMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  documentInput: DocumentInput;
}>;

export type RecordDownloadDocumentMutation = {
  __typename?: 'Mutation';
  recordDownloadDocument: { __typename?: 'DocumentEvent'; id: string };
};

export type RecordSubmitDocumentsMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  documentInputs: Array<DocumentInput> | DocumentInput;
}>;

export type RecordSubmitDocumentsMutation = {
  __typename?: 'Mutation';
  recordSubmitDocuments: Array<{ __typename?: 'DocumentEvent'; id: string }>;
};

export type GetAscProjectsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  filter?: AscProjectFilter;
  paging?: CursorPaging;
  sorting?: Array<AscProjectSort> | AscProjectSort;
}>;

export type GetAscProjectsQuery = {
  __typename?: 'Query';
  getAscProjects: {
    __typename?: 'AscProjectConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'AscProjectEdge';
      cursor: any;
      node: {
        __typename?: 'AscProject';
        id: string;
        name: string;
        description?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        capitalizationStartDate?: string | null;
        capitalizationEndDate?: string | null;
        capitalizationEndDateExtendedFrom?: string | null;
        capitalizationStatus: CapitalizationStatus;
        predictedCapitalizationStatus?: PredictedCapitalizationStatus | null;
        predictedCapitalizationStatusReason?: string | null;
        predictedCapitalizationStartDate?: string | null;
        predictedCapitalizationEndDate?: string | null;
        predictedCapitalizationEndDateReason?: string | null;
        capitalizableProjectClusteringOverride?: CapitalizableProjectClusteringOverride | null;
        customFieldTeams?: Array<string> | null;
        customFieldLaunchDate?: string | null;
        workstreamNames: Array<string>;
        ticketCount: number;
        projectOwnerId?: string | null;
        clusterType: AscClusterType;
        isDeterministic: boolean;
        projectOwner?: { __typename?: 'AscProjectOwner'; id: string; fullName: string } | null;
        product?: { __typename?: 'Product'; id: string; name: string } | null;
      };
    }>;
  };
};

export type GetAscProjectQueryVariables = Exact<{
  ascProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type GetAscProjectQuery = {
  __typename?: 'Query';
  getAscProject: {
    __typename?: 'AscProject';
    id: string;
    name: string;
    description?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    capitalizationStartDate?: string | null;
    capitalizationEndDate?: string | null;
    capitalizationEndDateExtendedFrom?: string | null;
    capitalizationStatus: CapitalizationStatus;
    predictedCapitalizationStatus?: PredictedCapitalizationStatus | null;
    predictedCapitalizationStatusReason?: string | null;
    predictedCapitalizationStartDate?: string | null;
    predictedCapitalizationEndDate?: string | null;
    predictedCapitalizationEndDateReason?: string | null;
    capitalizableProjectClusteringOverride?: CapitalizableProjectClusteringOverride | null;
    customFieldTeams?: Array<string> | null;
    customFieldLaunchDate?: string | null;
    workstreamNames: Array<string>;
    ticketCount: number;
    projectOwnerId?: string | null;
    clusterType: AscClusterType;
    isDeterministic: boolean;
    projectOwner?: { __typename?: 'AscProjectOwner'; id: string; fullName: string } | null;
    product?: { __typename?: 'Product'; id: string; name: string } | null;
  };
};

export type GetRdProjectQueryVariables = Exact<{
  rdProjectId: Scalars['ID']['input'];
}>;

export type GetRdProjectQuery = {
  __typename?: 'Query';
  getRdProject: {
    __typename?: 'RdProject';
    id: string;
    name: string;
    description?: string | null;
    purpose?: ProjectPurpose | null;
    businessComponent?: ProjectBusinessComponent | null;
    businessPurpose?: ProjectBusinessPurpose | null;
    consideredForRd: boolean;
    isSection174Eligible: boolean;
    disallowances?: Array<ProjectDisallowance> | null;
    improvedAspects?: Array<ProjectPurposeImprovedAspect> | null;
    technicalChallenges?: string | null;
    processOfExperimentation?: string | null;
    selectedCategory: SelectedRdProjectCategory;
    rdDocumentationStatus: RdDocumentationStatus;
    projectOwnerId?: string | null;
    workstreamNames: Array<string>;
    workstreamNamesSearch?: string | null;
    ticketCount: number;
    processingState: ProcessingProjectState;
    clusterType: RdClusterType;
    approvalTime?: string | null;
    approvalComment?: string | null;
    aiGuidance?: string | null;
    isTechnicallyUncertain?: boolean | null;
    isCustomerFacingDevelopment?: boolean | null;
    isInnovativeAndRisky?: boolean | null;
    projectOwner?: { __typename?: 'RdProjectOwner'; id: string; fullName: string } | null;
    rdDetermination?: {
      __typename?: 'ProjectRdDetermination';
      id: string;
      isTechnicalInNature: boolean;
      isTechnicalInNatureSource?: DeterminationSource | null;
      hasQualifiedPurpose: QualifiedPurposeDetermination;
      hasQualifiedPurposeSource?: DeterminationSource | null;
      qualifiedPurposeReasoning: string;
      qualifiedPurposeReasoningSource?: DeterminationSource | null;
      hasTechnicalUncertainties: boolean;
      technicalInNatureShare: number;
      projectRdDeterminationUncertainties: Array<{
        __typename?: 'ProjectRdDeterminationUncertainty';
        id: string;
        uncertainty: string;
      }>;
    } | null;
    supportingDocuments: Array<{
      __typename?: 'FileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      isValid?: boolean | null;
      payrollMonthExpenseSyncEventId?: string | null;
      payrollProviderSyncEventId?: string | null;
      period?: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      } | null;
    }>;
    product?: { __typename?: 'Product'; id: string; name: string } | null;
  };
};

export type GetRdProjectsQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  filter?: RdProjectFilter;
  paging?: CursorPaging;
  sorting?: Array<RdProjectSort> | RdProjectSort;
}>;

export type GetRdProjectsQuery = {
  __typename?: 'Query';
  getRdProjects: {
    __typename?: 'RdProjectConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'RdProjectEdge';
      cursor: any;
      node: {
        __typename?: 'RdProject';
        id: string;
        name: string;
        description?: string | null;
        purpose?: ProjectPurpose | null;
        businessComponent?: ProjectBusinessComponent | null;
        businessPurpose?: ProjectBusinessPurpose | null;
        consideredForRd: boolean;
        isSection174Eligible: boolean;
        disallowances?: Array<ProjectDisallowance> | null;
        improvedAspects?: Array<ProjectPurposeImprovedAspect> | null;
        technicalChallenges?: string | null;
        processOfExperimentation?: string | null;
        selectedCategory: SelectedRdProjectCategory;
        rdDocumentationStatus: RdDocumentationStatus;
        projectOwnerId?: string | null;
        workstreamNames: Array<string>;
        workstreamNamesSearch?: string | null;
        ticketCount: number;
        processingState: ProcessingProjectState;
        clusterType: RdClusterType;
        approvalTime?: string | null;
        approvalComment?: string | null;
        aiGuidance?: string | null;
        isTechnicallyUncertain?: boolean | null;
        isCustomerFacingDevelopment?: boolean | null;
        isInnovativeAndRisky?: boolean | null;
        projectOwner?: { __typename?: 'RdProjectOwner'; id: string; fullName: string } | null;
        rdDetermination?: {
          __typename?: 'ProjectRdDetermination';
          id: string;
          isTechnicalInNature: boolean;
          isTechnicalInNatureSource?: DeterminationSource | null;
          hasQualifiedPurpose: QualifiedPurposeDetermination;
          hasQualifiedPurposeSource?: DeterminationSource | null;
          qualifiedPurposeReasoning: string;
          qualifiedPurposeReasoningSource?: DeterminationSource | null;
          hasTechnicalUncertainties: boolean;
          technicalInNatureShare: number;
          projectRdDeterminationUncertainties: Array<{
            __typename?: 'ProjectRdDeterminationUncertainty';
            id: string;
            uncertainty: string;
          }>;
        } | null;
        supportingDocuments: Array<{
          __typename?: 'FileUpload';
          id: string;
          createdAt: string;
          fileName: string;
          signedUrl: string;
          isValid?: boolean | null;
          payrollMonthExpenseSyncEventId?: string | null;
          payrollProviderSyncEventId?: string | null;
          period?: {
            __typename?: 'MonthYearPeriod';
            startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
            endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
          } | null;
        }>;
        product?: { __typename?: 'Product'; id: string; name: string } | null;
      };
    }>;
  };
};

export type GetSredProjectsQueryVariables = Exact<{
  sredTaxCreditId: Scalars['ID']['input'];
  filter?: SredProjectFilter;
  paging?: CursorPaging;
  sorting?: Array<SredProjectSort> | SredProjectSort;
}>;

export type GetSredProjectsQuery = {
  __typename?: 'Query';
  getSredProjects: {
    __typename?: 'SredProjectConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'SredProjectEdge';
      cursor: any;
      node: {
        __typename?: 'SredProject';
        id: string;
        name: string;
        description?: string | null;
        consideredForSred: boolean;
        selectedCategory: SelectedSredProjectCategory;
        sredDocumentationStatus: SredDocumentationStatus;
        projectOwnerId?: string | null;
        workstreamNames: Array<string>;
        workstreamNamesSearch?: string | null;
        ticketCount: number;
        processingState: SredProcessingState;
        clusterType: SredClusterType;
        approvalTime?: any | null;
        approvalComment?: string | null;
        aiGuidance?: string | null;
        appliedResearch?: boolean | null;
        basicResearch?: boolean | null;
        experimentalDevelopment?: boolean | null;
        systematicInvestigation?: string | null;
        technologicalAdvancement?: string | null;
        technologicalUncertainty?: string | null;
        supportingWork?: string | null;
        provincialEligibility?: Array<Province> | null;
        workInCanadaPercentage?: number | null;
        sredEligibleDate?: string | null;
        productName?: string | null;
        projectOwnerName?: string | null;
        projectOwner?: { __typename?: 'SredProjectOwner'; id: string; fullName: string } | null;
        supportingDocuments: Array<{
          __typename?: 'FileUpload';
          id: string;
          createdAt: string;
          fileName: string;
          signedUrl: string;
          isValid?: boolean | null;
          payrollMonthExpenseSyncEventId?: string | null;
          payrollProviderSyncEventId?: string | null;
          period?: {
            __typename?: 'MonthYearPeriod';
            startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
            endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
          } | null;
        }>;
        product?: { __typename?: 'Product'; id: string; name: string } | null;
      };
    }>;
  };
};

export type GetRdProjectsSummaryQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  filter?: InputMaybe<RdProjectsSummaryFilter>;
}>;

export type GetRdProjectsSummaryQuery = {
  __typename?: 'Query';
  getRdProjectsSummary: {
    __typename?: 'RdProjectsSummary';
    count?: { __typename?: 'RdProjectCountAggregate'; name?: number | null } | null;
    avg?: { __typename?: 'RdProjectAvgAggregate'; ticketCount?: number | null } | null;
  };
};

export type UpdateAscProjectMutationVariables = Exact<{
  ascProjectId: Scalars['ID']['input'];
  updateAscProjectInput: UpdateAscProjectInput;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type UpdateAscProjectMutation = {
  __typename?: 'Mutation';
  updateAscProject: {
    __typename?: 'AscProject';
    id: string;
    name: string;
    description?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    capitalizationStartDate?: string | null;
    capitalizationEndDate?: string | null;
    capitalizationEndDateExtendedFrom?: string | null;
    capitalizationStatus: CapitalizationStatus;
    predictedCapitalizationStatus?: PredictedCapitalizationStatus | null;
    predictedCapitalizationStatusReason?: string | null;
    predictedCapitalizationStartDate?: string | null;
    predictedCapitalizationEndDate?: string | null;
    predictedCapitalizationEndDateReason?: string | null;
    capitalizableProjectClusteringOverride?: CapitalizableProjectClusteringOverride | null;
    customFieldTeams?: Array<string> | null;
    customFieldLaunchDate?: string | null;
    workstreamNames: Array<string>;
    ticketCount: number;
    projectOwnerId?: string | null;
    clusterType: AscClusterType;
    isDeterministic: boolean;
    projectOwner?: { __typename?: 'AscProjectOwner'; id: string; fullName: string } | null;
    product?: { __typename?: 'Product'; id: string; name: string } | null;
  };
};

export type UpdateAscProjectCapitalizationMutationVariables = Exact<{
  ascProjectId: Scalars['ID']['input'];
  updateAscProjectCapitalizationInput: UpdateAscProjectCapitalizationInput;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type UpdateAscProjectCapitalizationMutation = {
  __typename?: 'Mutation';
  updateAscProjectCapitalization: {
    __typename?: 'AscProject';
    id: string;
    name: string;
    description?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    capitalizationStartDate?: string | null;
    capitalizationEndDate?: string | null;
    capitalizationEndDateExtendedFrom?: string | null;
    capitalizationStatus: CapitalizationStatus;
    predictedCapitalizationStatus?: PredictedCapitalizationStatus | null;
    predictedCapitalizationStatusReason?: string | null;
    predictedCapitalizationStartDate?: string | null;
    predictedCapitalizationEndDate?: string | null;
    predictedCapitalizationEndDateReason?: string | null;
    capitalizableProjectClusteringOverride?: CapitalizableProjectClusteringOverride | null;
    customFieldTeams?: Array<string> | null;
    customFieldLaunchDate?: string | null;
    workstreamNames: Array<string>;
    ticketCount: number;
    projectOwnerId?: string | null;
    clusterType: AscClusterType;
    isDeterministic: boolean;
    projectOwner?: { __typename?: 'AscProjectOwner'; id: string; fullName: string } | null;
    product?: { __typename?: 'Product'; id: string; name: string } | null;
  };
};

export type GetAscProjectApprovalStatusQueryVariables = Exact<{
  ascProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type GetAscProjectApprovalStatusQuery = {
  __typename?: 'Query';
  getAscProject: {
    __typename?: 'AscProject';
    id: string;
    approvalStatus?: {
      __typename?: 'AscProjectApprovalStatusResult';
      ascProjectId: string;
      fiscalYearId: string;
      periodName: PeriodName;
      status: AscProjectApprovalStatus;
      periodApprovalByUserId?: string | null;
      periodApprovalDatetime?: string | null;
      periodApprovalComment?: string | null;
      approvedThroughMonthYear?: string | null;
    } | null;
  };
};

export type UpdateRdProjectMutationVariables = Exact<{
  rdProjectId: Scalars['ID']['input'];
  updateRdProjectInput: UpdateRdProjectInput;
}>;

export type UpdateRdProjectMutation = {
  __typename?: 'Mutation';
  updateRdProject: {
    __typename?: 'RdProject';
    id: string;
    name: string;
    description?: string | null;
    purpose?: ProjectPurpose | null;
    businessComponent?: ProjectBusinessComponent | null;
    businessPurpose?: ProjectBusinessPurpose | null;
    consideredForRd: boolean;
    isSection174Eligible: boolean;
    disallowances?: Array<ProjectDisallowance> | null;
    improvedAspects?: Array<ProjectPurposeImprovedAspect> | null;
    technicalChallenges?: string | null;
    processOfExperimentation?: string | null;
    selectedCategory: SelectedRdProjectCategory;
    rdDocumentationStatus: RdDocumentationStatus;
    projectOwnerId?: string | null;
    workstreamNames: Array<string>;
    workstreamNamesSearch?: string | null;
    ticketCount: number;
    processingState: ProcessingProjectState;
    clusterType: RdClusterType;
    approvalTime?: string | null;
    approvalComment?: string | null;
    aiGuidance?: string | null;
    isTechnicallyUncertain?: boolean | null;
    isCustomerFacingDevelopment?: boolean | null;
    isInnovativeAndRisky?: boolean | null;
    projectOwner?: { __typename?: 'RdProjectOwner'; id: string; fullName: string } | null;
    rdDetermination?: {
      __typename?: 'ProjectRdDetermination';
      id: string;
      isTechnicalInNature: boolean;
      isTechnicalInNatureSource?: DeterminationSource | null;
      hasQualifiedPurpose: QualifiedPurposeDetermination;
      hasQualifiedPurposeSource?: DeterminationSource | null;
      qualifiedPurposeReasoning: string;
      qualifiedPurposeReasoningSource?: DeterminationSource | null;
      hasTechnicalUncertainties: boolean;
      technicalInNatureShare: number;
      projectRdDeterminationUncertainties: Array<{
        __typename?: 'ProjectRdDeterminationUncertainty';
        id: string;
        uncertainty: string;
      }>;
    } | null;
    supportingDocuments: Array<{
      __typename?: 'FileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      isValid?: boolean | null;
      payrollMonthExpenseSyncEventId?: string | null;
      payrollProviderSyncEventId?: string | null;
      period?: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      } | null;
    }>;
    product?: { __typename?: 'Product'; id: string; name: string } | null;
  };
};

export type MergeAscProjectsMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  input: MergeAscProjectsInput;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type MergeAscProjectsMutation = {
  __typename?: 'Mutation';
  mergeAscProjects: {
    __typename?: 'AscProject';
    id: string;
    name: string;
    description?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    capitalizationStartDate?: string | null;
    capitalizationEndDate?: string | null;
    capitalizationEndDateExtendedFrom?: string | null;
    capitalizationStatus: CapitalizationStatus;
    predictedCapitalizationStatus?: PredictedCapitalizationStatus | null;
    predictedCapitalizationStatusReason?: string | null;
    predictedCapitalizationStartDate?: string | null;
    predictedCapitalizationEndDate?: string | null;
    predictedCapitalizationEndDateReason?: string | null;
    capitalizableProjectClusteringOverride?: CapitalizableProjectClusteringOverride | null;
    customFieldTeams?: Array<string> | null;
    customFieldLaunchDate?: string | null;
    workstreamNames: Array<string>;
    ticketCount: number;
    projectOwnerId?: string | null;
    clusterType: AscClusterType;
    isDeterministic: boolean;
    projectOwner?: { __typename?: 'AscProjectOwner'; id: string; fullName: string } | null;
    product?: { __typename?: 'Product'; id: string; name: string } | null;
  };
};

export type UpdateAscProjectCapitalizableProjectClusteringOverrideMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  ascProjectId: Scalars['ID']['input'];
  updateAscProjectCapitalizableProjectClusteringOverrideInput: UpdateAscProjectCapitalizableProjectClusteringOverrideInput;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type UpdateAscProjectCapitalizableProjectClusteringOverrideMutation = {
  __typename?: 'Mutation';
  updateAscProjectCapitalizableProjectClusteringOverride: {
    __typename?: 'AscProject';
    id: string;
    name: string;
    description?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    capitalizationStartDate?: string | null;
    capitalizationEndDate?: string | null;
    capitalizationEndDateExtendedFrom?: string | null;
    capitalizationStatus: CapitalizationStatus;
    predictedCapitalizationStatus?: PredictedCapitalizationStatus | null;
    predictedCapitalizationStatusReason?: string | null;
    predictedCapitalizationStartDate?: string | null;
    predictedCapitalizationEndDate?: string | null;
    predictedCapitalizationEndDateReason?: string | null;
    capitalizableProjectClusteringOverride?: CapitalizableProjectClusteringOverride | null;
    customFieldTeams?: Array<string> | null;
    customFieldLaunchDate?: string | null;
    workstreamNames: Array<string>;
    ticketCount: number;
    projectOwnerId?: string | null;
    clusterType: AscClusterType;
    isDeterministic: boolean;
    projectOwner?: { __typename?: 'AscProjectOwner'; id: string; fullName: string } | null;
    product?: { __typename?: 'Product'; id: string; name: string } | null;
  };
};

export type BatchUpdateAscProjectCapitalizableProjectClusteringOverrideMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  batchUpdateAscProjectCapitalizableProjectClusteringOverrideInput: BatchUpdateAscProjectCapitalizableProjectClusteringOverrideInput;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type BatchUpdateAscProjectCapitalizableProjectClusteringOverrideMutation = {
  __typename?: 'Mutation';
  batchUpdateAscProjectCapitalizableProjectClusteringOverride: Array<{
    __typename?: 'AscProject';
    id: string;
    name: string;
    description?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    capitalizationStartDate?: string | null;
    capitalizationEndDate?: string | null;
    capitalizationEndDateExtendedFrom?: string | null;
    capitalizationStatus: CapitalizationStatus;
    predictedCapitalizationStatus?: PredictedCapitalizationStatus | null;
    predictedCapitalizationStatusReason?: string | null;
    predictedCapitalizationStartDate?: string | null;
    predictedCapitalizationEndDate?: string | null;
    predictedCapitalizationEndDateReason?: string | null;
    capitalizableProjectClusteringOverride?: CapitalizableProjectClusteringOverride | null;
    customFieldTeams?: Array<string> | null;
    customFieldLaunchDate?: string | null;
    workstreamNames: Array<string>;
    ticketCount: number;
    projectOwnerId?: string | null;
    clusterType: AscClusterType;
    isDeterministic: boolean;
    projectOwner?: { __typename?: 'AscProjectOwner'; id: string; fullName: string } | null;
    product?: { __typename?: 'Product'; id: string; name: string } | null;
  }>;
};

export type MergeRdProjectsMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  input: MergeRdProjectsInput;
}>;

export type MergeRdProjectsMutation = {
  __typename?: 'Mutation';
  mergeRdProjects: {
    __typename?: 'BackgroundOperation';
    id: string;
    progressPercent: number;
    createdAt: string;
    operationName: BackgroundOperationName;
  };
};

export type GetRdProjectCountForDetailsUpdateQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  scope: RdProjectDetailsUpdateScope;
}>;

export type GetRdProjectCountForDetailsUpdateQuery = {
  __typename?: 'Query';
  getRdProjectCountForDetailsUpdate: number;
};

export type RegenerateRdProjectDetailsMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  input: RegenerateRdProjectDetailsInput;
}>;

export type RegenerateRdProjectDetailsMutation = {
  __typename?: 'Mutation';
  regenerateRdProjectDetails: {
    __typename?: 'DistributedFlowState';
    id: string;
    backgroundOperation: { __typename?: 'BackgroundOperation'; id: string; progressPercent: number };
  };
};

export type MoveTicketsToAscProjectMutationVariables = Exact<{
  ascProjectId: Scalars['ID']['input'];
  input: MoveTicketsToAscProjectInput;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type MoveTicketsToAscProjectMutation = {
  __typename?: 'Mutation';
  moveTicketsToAscProject: {
    __typename?: 'MoveTicketsToAscProjectOutput';
    ascProjects: Array<{
      __typename?: 'AscProject';
      id: string;
      name: string;
      description?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      capitalizationStartDate?: string | null;
      capitalizationEndDate?: string | null;
      capitalizationEndDateExtendedFrom?: string | null;
      capitalizationStatus: CapitalizationStatus;
      predictedCapitalizationStatus?: PredictedCapitalizationStatus | null;
      predictedCapitalizationStatusReason?: string | null;
      predictedCapitalizationStartDate?: string | null;
      predictedCapitalizationEndDate?: string | null;
      predictedCapitalizationEndDateReason?: string | null;
      capitalizableProjectClusteringOverride?: CapitalizableProjectClusteringOverride | null;
      customFieldTeams?: Array<string> | null;
      customFieldLaunchDate?: string | null;
      workstreamNames: Array<string>;
      ticketCount: number;
      projectOwnerId?: string | null;
      clusterType: AscClusterType;
      isDeterministic: boolean;
      projectOwner?: { __typename?: 'AscProjectOwner'; id: string; fullName: string } | null;
      product?: { __typename?: 'Product'; id: string; name: string } | null;
    }>;
    contributors: Array<{
      __typename?: 'Contributor';
      id: string;
      name?: string | null;
      ascProjectsPerContributor: Array<{
        __typename?: 'AscProjectPerContributor';
        id: string;
        ascProject: { __typename?: 'AscProject'; id: string; name: string };
        ascProjectMonthsPerContributor: Array<{
          __typename?: 'AscProjectMonthPerContributor';
          id: string;
          month: number;
          year: number;
          allocationPercent: number;
          useAllocationPercent?: number | null;
        }>;
      }>;
    }>;
  };
};

export type MoveTicketsToRdProjectMutationVariables = Exact<{
  rdProjectId: Scalars['ID']['input'];
  input: MoveTicketsToRdProjectInput;
}>;

export type MoveTicketsToRdProjectMutation = {
  __typename?: 'Mutation';
  moveTicketsToRdProject: {
    __typename?: 'MoveTicketsToRdProjectOutput';
    rdProjects: Array<{
      __typename?: 'RdProject';
      id: string;
      name: string;
      description?: string | null;
      purpose?: ProjectPurpose | null;
      businessComponent?: ProjectBusinessComponent | null;
      businessPurpose?: ProjectBusinessPurpose | null;
      consideredForRd: boolean;
      isSection174Eligible: boolean;
      disallowances?: Array<ProjectDisallowance> | null;
      improvedAspects?: Array<ProjectPurposeImprovedAspect> | null;
      technicalChallenges?: string | null;
      processOfExperimentation?: string | null;
      selectedCategory: SelectedRdProjectCategory;
      rdDocumentationStatus: RdDocumentationStatus;
      projectOwnerId?: string | null;
      workstreamNames: Array<string>;
      workstreamNamesSearch?: string | null;
      ticketCount: number;
      processingState: ProcessingProjectState;
      clusterType: RdClusterType;
      approvalTime?: string | null;
      approvalComment?: string | null;
      aiGuidance?: string | null;
      isTechnicallyUncertain?: boolean | null;
      isCustomerFacingDevelopment?: boolean | null;
      isInnovativeAndRisky?: boolean | null;
      projectOwner?: { __typename?: 'RdProjectOwner'; id: string; fullName: string } | null;
      rdDetermination?: {
        __typename?: 'ProjectRdDetermination';
        id: string;
        isTechnicalInNature: boolean;
        isTechnicalInNatureSource?: DeterminationSource | null;
        hasQualifiedPurpose: QualifiedPurposeDetermination;
        hasQualifiedPurposeSource?: DeterminationSource | null;
        qualifiedPurposeReasoning: string;
        qualifiedPurposeReasoningSource?: DeterminationSource | null;
        hasTechnicalUncertainties: boolean;
        technicalInNatureShare: number;
        projectRdDeterminationUncertainties: Array<{
          __typename?: 'ProjectRdDeterminationUncertainty';
          id: string;
          uncertainty: string;
        }>;
      } | null;
      supportingDocuments: Array<{
        __typename?: 'FileUpload';
        id: string;
        createdAt: string;
        fileName: string;
        signedUrl: string;
        isValid?: boolean | null;
        payrollMonthExpenseSyncEventId?: string | null;
        payrollProviderSyncEventId?: string | null;
        period?: {
          __typename?: 'MonthYearPeriod';
          startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
          endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        } | null;
      }>;
      product?: { __typename?: 'Product'; id: string; name: string } | null;
    }>;
  };
};

export type GetAscProjectTpTicketsQueryVariables = Exact<{
  ascProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  sorting?: InputMaybe<Array<AscProjectTpTicketsViewSort> | AscProjectTpTicketsViewSort>;
  filter?: InputMaybe<AscProjectTpTicketsViewFilter>;
  paging?: InputMaybe<CursorPaging>;
}>;

export type GetAscProjectTpTicketsQuery = {
  __typename?: 'Query';
  getAscProjectTpTickets: {
    __typename?: 'AscProjectTpTicketsViewConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'AscProjectTpTicketsViewEdge';
      cursor: any;
      node: {
        __typename?: 'AscProjectTpTicketsView';
        id: string;
        ascProjectId: string;
        contributorId: string;
        contributorName: string;
        identifier: string;
        ticketUrl?: string | null;
        name: string;
        completedDatetime?: string | null;
        predictedEffortDays: number;
        groupingTicketingProviderTicketId?: string | null;
        groupingTicketingProviderCollectionId?: string | null;
        matchingConfidence?: AscMatchingConfidence | null;
        matchingReasoning?: string | null;
        matchingMethod?: AscMatchMethod | null;
      };
    }>;
  };
};

export type GetRdProjectTpTicketsQueryVariables = Exact<{
  rdProjectId: Scalars['ID']['input'];
  sorting?: InputMaybe<Array<RdProjectTpTicketsViewSort> | RdProjectTpTicketsViewSort>;
  filter?: InputMaybe<RdProjectTpTicketsViewFilter>;
  paging?: InputMaybe<CursorPaging>;
}>;

export type GetRdProjectTpTicketsQuery = {
  __typename?: 'Query';
  getRdProjectTpTickets: {
    __typename?: 'RdProjectTpTicketsViewConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'RdProjectTpTicketsViewEdge';
      cursor: any;
      node: {
        __typename?: 'RdProjectTpTicketsView';
        id: string;
        rdProjectId: string;
        rdTaxCreditContributorId: string;
        contributorName: string;
        identifier: string;
        ticketUrl?: string | null;
        name: string;
        description?: string | null;
        completedDatetime?: string | null;
        collectionName?: string | null;
        predictedEffortDays: number;
        groupingTicketingProviderTicketId?: string | null;
        groupingTicketingProviderCollectionId?: string | null;
      };
    }>;
  };
};

export type GetAscProjectTeamMembersQueryVariables = Exact<{
  ascProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  filter?: InputMaybe<AscProjectTeamMemberFilter>;
  sorting?: InputMaybe<Array<AscProjectTeamMemberSort> | AscProjectTeamMemberSort>;
  paging?: InputMaybe<CursorPaging>;
}>;

export type GetAscProjectTeamMembersQuery = {
  __typename?: 'Query';
  getAscProjectTeamMembers: {
    __typename?: 'AscProjectTeamMemberConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'AscProjectTeamMemberEdge';
      cursor: any;
      node: {
        __typename?: 'AscProjectTeamMember';
        contributorId: string;
        contributorName?: string | null;
        contributorEmail?: string | null;
        allocationPercent: number;
        periodName: PeriodName;
        ascProjectId?: string | null;
        fiscalYearId: string;
      };
    }>;
  };
};

export type GetRdProjectTeamMembersQueryVariables = Exact<{
  rdProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  filter?: InputMaybe<RdProjectTeamMemberFilter>;
  sorting?: InputMaybe<Array<RdProjectTeamMemberSort> | RdProjectTeamMemberSort>;
  paging?: InputMaybe<CursorPaging>;
}>;

export type GetRdProjectTeamMembersQuery = {
  __typename?: 'Query';
  getRdProjectTeamMembers: {
    __typename?: 'RdProjectTeamMemberConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'RdProjectTeamMemberEdge';
      cursor: any;
      node: {
        __typename?: 'RdProjectTeamMember';
        rdTaxCreditContributorId: string;
        contributorName?: string | null;
        contributorEmail?: string | null;
        allocationPercent: number;
        rdProjectId: string;
        rdExpenseId: string;
        fiscalYearId: string;
      };
    }>;
  };
};

export type SyncPayrollProviderMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  payrollProvider: PayrollProvider;
}>;

export type SyncPayrollProviderMutation = {
  __typename?: 'Mutation';
  syncPayrollProvider: {
    __typename?: 'SyncPayrollProviderResult';
    success: boolean;
    errors?: Array<{
      __typename?: 'TabularDataParseError';
      code: TabularDataErrorCode;
      source: TabularDataSource;
      row?: number | null;
      column?: string | null;
      sheet?: string | null;
      value?: string | null;
    }> | null;
  };
};

export type SyncAccountingProviderMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  provider: Scalars['String']['input'];
}>;

export type SyncAccountingProviderMutation = {
  __typename?: 'Mutation';
  syncAccountingProvider: { __typename?: 'SyncAccountingProviderResult'; success: boolean };
};

export type GetMergeDevLinkTokenQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: GetMergeDevLinkTokenInput;
}>;

export type GetMergeDevLinkTokenQuery = { __typename?: 'Query'; getMergeDevLinkToken?: string | null };

export type CreateMergeDevAccessTokenForAccountingMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: CreateMergeDevAccessTokenForAccountingInput;
}>;

export type CreateMergeDevAccessTokenForAccountingMutation = {
  __typename?: 'Mutation';
  createMergeDevAccessTokenForAccounting: {
    __typename?: 'Company';
    id: string;
    accountingTokens: Array<{
      __typename?: 'AccountingToken';
      id: string;
      createdAt: string;
      accountingProvider: AccountingProvider;
      acquisitionMethod: AccountingAcquisitionMethod;
    }>;
  };
};

export type CreateMergeDevAccessTokenForTicketingMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: CreateMergeDevAccessTokenForTicketingInput;
}>;

export type CreateMergeDevAccessTokenForTicketingMutation = {
  __typename?: 'Mutation';
  createMergeDevAccessTokenForTicketing: {
    __typename?: 'Company';
    id: string;
    ticketingTokens: Array<{ __typename?: 'TicketingToken'; id: string; ticketingProvider: TicketingProvider }>;
  };
};

export type GetTicketingConnectionsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetTicketingConnectionsQuery = {
  __typename?: 'Query';
  getCompany: {
    __typename?: 'Company';
    id: string;
    gitHubAppAvailable: boolean;
    ticketingTokens: Array<{
      __typename?: 'TicketingToken';
      id: string;
      ticketingProvider: TicketingProvider;
      acquisitionMethod: TicketingAcquisitionMethod;
      installationStatus?: GitHubInstallationStatus | null;
      createdAt: string;
      organization?: string | null;
      pendingScheduledSyncCount?: number | null;
      needsRelink?: boolean | null;
      lastSuccessfulSync?: {
        __typename?: 'TicketingTokenLastSuccessfulSync';
        at: string;
        acquisitionMethod: TicketingAcquisitionMethod;
      } | null;
    }>;
  };
};

export type DisconnectTicketingTokenMutationVariables = Exact<{
  ticketingTokenId: Scalars['ID']['input'];
}>;

export type DisconnectTicketingTokenMutation = {
  __typename?: 'Mutation';
  disconnectTicketingToken: {
    __typename?: 'DisconnectTicketingTokenOutput';
    ticketingTokenId: string;
    scheduledSyncsCancelled: number;
  };
};

export type CreateGitHubAppInstallUrlMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: CreateGitHubAppInstallUrlInput;
}>;

export type CreateGitHubAppInstallUrlMutation = { __typename?: 'Mutation'; createGitHubAppInstallUrl: string };

export type CreateGitHubAppAuthorizationUrlMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: CreateGitHubAppAuthorizationUrlInput;
}>;

export type CreateGitHubAppAuthorizationUrlMutation = {
  __typename?: 'Mutation';
  createGitHubAppAuthorizationUrl: string;
};

export type CreateNewFinchAccessTokenMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  finchAuthCode: Scalars['String']['input'];
  provider: PayrollProvider;
}>;

export type CreateNewFinchAccessTokenMutation = {
  __typename?: 'Mutation';
  createFinchAccessToken: {
    __typename?: 'Company';
    id: string;
    payrollTokens: Array<{
      __typename?: 'PayrollToken';
      id: string;
      createdAt: string;
      payrollProvider: PayrollProvider;
      finchScopeType?: FinchScopeType | null;
    }>;
  };
};

export type ProvisionEmailPasswordUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  continueUrl?: InputMaybe<Scalars['String']['input']>;
}>;

export type ProvisionEmailPasswordUserMutation = { __typename?: 'Mutation'; provisionEmailPasswordUser: boolean };

export type OnboardUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  fullName: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
}>;

export type OnboardUserMutation = {
  __typename?: 'Mutation';
  onboardUser: {
    __typename?: 'User';
    id: string;
    fullName: string;
    email: string;
    phone?: string | null;
    firebaseUserId: string;
    allowRealCompanyDatetime?: string | null;
    organizationScope?: OrganizationScope | null;
    thomsonReutersConsumerKey?: string | null;
    companies: Array<{
      __typename?: 'Company';
      id: string;
      legalName: string;
      shortName: string;
      companyCreationType: CompanyCreationType;
      organizationId: string;
      isPiiRedacted: boolean;
      ascLockedUntilMonthYear?: string | null;
      lastCompletedAscSyncPeriodEnd?: string | null;
      syncConfigurationAsc?: {
        __typename?: 'AscSyncConfiguration';
        id: string;
        clusteringMethod: ClusteringMethod;
      } | null;
      businessQuestions: {
        __typename?: 'BusinessQuestions';
        fiscalYearEndMonth?: number | null;
        gustoCompanyId?: string | null;
      };
    }>;
    userAttributes: {
      __typename?: 'UserAttributes';
      viewedWelcomeMessageTaxYear?: number | null;
      isSsoOnboarding?: boolean | null;
    };
    companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
    pendingOrFailedStatusOrganizationInvitations: Array<{
      __typename?: 'OrganizationInvitation';
      id: string;
      derivedState: string;
    }>;
    organization?: {
      __typename?: 'Organization';
      id: string;
      photoUrl?: string | null;
      name: string;
      isAccountingFirm: boolean;
      members: Array<{
        __typename?: 'User';
        id: string;
        email: string;
        fullName: string;
        organizationScope?: OrganizationScope | null;
        companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
      }>;
      invitedMembers: Array<{
        __typename?: 'OrganizationInvitation';
        id: string;
        email: string;
        scope: OrganizationScope;
        expiresAt: string;
        revokedAt?: string | null;
        acceptedAt?: string | null;
        derivedState: string;
      }>;
    } | null;
  };
};

export type AddOrganizationInvitationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  addOrganizationInvitationInput: AddOrganizationInvitationInput;
}>;

export type AddOrganizationInvitationMutation = {
  __typename?: 'Mutation';
  addOrganizationInvitation: {
    __typename?: 'OrganizationInvitation';
    id: string;
    email: string;
    scope: OrganizationScope;
    expiresAt: string;
    revokedAt?: string | null;
    acceptedAt?: string | null;
    derivedState: string;
  };
};

export type DeleteOrganizationInvitationMutationVariables = Exact<{
  organizationInvitationId: Scalars['ID']['input'];
}>;

export type DeleteOrganizationInvitationMutation = {
  __typename?: 'Mutation';
  deleteOrganizationInvitation: { __typename?: 'OrganizationInvitation'; id: string };
};

export type AcceptInvitationMutationVariables = Exact<{
  acceptInvitationInput: AcceptInvitationInput;
}>;

export type AcceptInvitationMutation = {
  __typename?: 'Mutation';
  acceptInvitation: { __typename?: 'OrganizationInvitation'; id: string; organizationId: string };
};

export type ResendOrganizationInvitationMutationVariables = Exact<{
  organizationInvitationId: Scalars['ID']['input'];
}>;

export type ResendOrganizationInvitationMutation = {
  __typename?: 'Mutation';
  resendOrganizationInvitation: { __typename?: 'OrganizationInvitation'; id: string };
};

export type ResendMyOrganizationInvitationMutationVariables = Exact<{
  organizationInvitationId: Scalars['ID']['input'];
}>;

export type ResendMyOrganizationInvitationMutation = {
  __typename?: 'Mutation';
  resendMyOrganizationInvitation: { __typename?: 'OrganizationInvitation'; id: string };
};

export type RemoveUserAccessFromOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type RemoveUserAccessFromOrganizationMutation = {
  __typename?: 'Mutation';
  removeUserAccessFromOrganization: number;
};

export type UpdateUserAccessInOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  replaceUserAccessInOrganizationInput: ReplaceUserAccessInOrganizationInput;
}>;

export type UpdateUserAccessInOrganizationMutation = {
  __typename?: 'Mutation';
  replaceUserAccessInOrganization: string;
};

export type CreateCompanyForOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  createCompanyForOrganizationInput: CreateCompanyForOrganizationInput;
}>;

export type CreateCompanyForOrganizationMutation = {
  __typename?: 'Mutation';
  createCompanyForOrganization: {
    __typename?: 'Company';
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    members: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      fullName: string;
      companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
    }>;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
  };
};

export type DeleteCompanyMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type DeleteCompanyMutation = { __typename?: 'Mutation'; deleteCompany: string };

export type GetCompanyQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetCompanyQuery = {
  __typename?: 'Query';
  getCompany: {
    __typename?: 'Company';
    syncedTicketingProviders: Array<TicketingProvider>;
    gitHubAppAvailable: boolean;
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
    priorYearQREs?: Array<{
      __typename?: 'PriorYearQRE';
      year: number;
      amount?: number | null;
      taxYearStartDate: string;
      taxYearEndDate: string;
    }> | null;
    accountingTokens: Array<{
      __typename?: 'AccountingToken';
      id: string;
      createdAt: string;
      accountingProvider: AccountingProvider;
      acquisitionMethod: AccountingAcquisitionMethod;
    }>;
    payrollTokens: Array<{
      __typename?: 'PayrollToken';
      id: string;
      createdAt: string;
      payrollProvider: PayrollProvider;
      finchScopeType?: FinchScopeType | null;
    }>;
    ticketingTokens: Array<{
      __typename?: 'TicketingToken';
      id: string;
      ticketingProvider: TicketingProvider;
      acquisitionMethod: TicketingAcquisitionMethod;
      installationStatus?: GitHubInstallationStatus | null;
      organization?: string | null;
    }>;
    bulkTicketingDataUploads: Array<{
      __typename?: 'BulkTicketingDataFileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      ticketingProvider: FileUploadTicketingProvider;
      ticketingEntityType: TicketingEntityType;
      isValid?: boolean | null;
    }>;
    bulkPriorYearTaxDocumentUploads: Array<{
      __typename?: 'FileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      isValid?: boolean | null;
      payrollMonthExpenseSyncEventId?: string | null;
      payrollProviderSyncEventId?: string | null;
      period?: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      } | null;
    }>;
    syncedPayrollMonthExpense: Array<{
      __typename?: 'SyncedPayrollMonthExpense';
      id: string;
      originalSyncDate: string;
      period: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      };
      fileUpload?: {
        __typename?: 'FileUpload';
        id: string;
        createdAt: string;
        fileName: string;
        signedUrl: string;
        isValid?: boolean | null;
        payrollMonthExpenseSyncEventId?: string | null;
        payrollProviderSyncEventId?: string | null;
        period?: {
          __typename?: 'MonthYearPeriod';
          startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
          endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        } | null;
      } | null;
    }>;
    timesheetUploads: Array<{
      __typename?: 'FileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      isValid?: boolean | null;
      payrollMonthExpenseSyncEventId?: string | null;
      payrollProviderSyncEventId?: string | null;
      period?: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      } | null;
    }>;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
  };
};

export type GetGithubEmailMappingDataQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetGithubEmailMappingDataQuery = {
  __typename?: 'Query';
  getCompany: {
    __typename?: 'Company';
    id: string;
    githubEmailMappingUploads: Array<{
      __typename?: 'FileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      isValid?: boolean | null;
      payrollMonthExpenseSyncEventId?: string | null;
      payrollProviderSyncEventId?: string | null;
      period?: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      } | null;
    }>;
  };
};

export type GetCompaniesForUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type GetCompaniesForUserQuery = {
  __typename?: 'Query';
  getCompaniesForUser?: Array<{
    __typename?: 'Company';
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    members: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      fullName: string;
      companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
    }>;
    invitedMembers: Array<{
      __typename?: 'CompanyInvitation';
      id: string;
      email: string;
      scope: CompanyScope;
      acceptedAt?: string | null;
      companyId: string;
    }>;
    fiscalYears: Array<{
      __typename?: 'FiscalYear';
      id: string;
      rdTaxCredit?: { __typename?: 'RDTaxCredit'; id: string; lastUpdatedAt?: string | null } | null;
    }>;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
  }> | null;
};

export type GetRdExpenseQueryVariables = Exact<{
  rdExpenseId: Scalars['ID']['input'];
}>;

export type GetRdExpenseQuery = {
  __typename?: 'Query';
  getRdExpense: {
    __typename?: 'RdExpense';
    id: string;
    rdCategory: RdCategory;
    rdCategoryConfidence: number;
    accountingQre?: {
      __typename?: 'AccountingQre';
      id: string;
      name: string;
      qualifiedAmountCents?: number | null;
      amountCents?: number | null;
      qreRdPercentage: number;
      accountingProvider?: AccountingProvider | null;
      state?: string | null;
      country?: string | null;
      account?: string | null;
      department?: string | null;
      costCenter?: string | null;
      entity?: string | null;
      rdCategory: RdCategory;
      fiscalYearId: string;
      accountingExpenseId: string;
    } | null;
    payrollQre?: {
      __typename?: 'PayrollQre';
      id: string;
      name: string;
      email?: string | null;
      title?: string | null;
      department?: string | null;
      managerName?: string | null;
      hireDate?: string | null;
      terminationDate?: string | null;
      costCenter?: string | null;
      entity?: string | null;
      qualifiedAmountCents?: number | null;
      amountCents?: number | null;
      qreRdPercentage: number;
      payrollProvider?: PayrollProvider | null;
      ticketingProviders: Array<TicketingProvider>;
      state?: string | null;
      country?: string | null;
      rdCategory: RdCategory;
      rdTaxCreditContributorId: string;
      payrollExpenseId?: string | null;
      isOfficer: boolean;
    } | null;
  };
};

export type GetRdExpenseProjectAllocationReportQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  providerType: ProviderType;
}>;

export type GetRdExpenseProjectAllocationReportQuery = {
  __typename?: 'Query';
  getRdExpenseProjectAllocationReport: { __typename?: 'RdExpenseProjectAllocationReportRo'; signedUrl: string };
};

export type GetAscWageReportQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type GetAscWageReportQuery = {
  __typename?: 'Query';
  getAscWageReport: { __typename?: 'AscWageReportResult'; signedUrl: string };
};

export type UploadAscWageReportMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  file: Scalars['Upload']['input'];
}>;

export type UploadAscWageReportMutation = {
  __typename?: 'Mutation';
  uploadAscWageReport: {
    __typename?: 'UploadAscWageReportResult';
    errors?: Array<{
      __typename?: 'ExcelParseError';
      type: ExcelParseErrorType;
      row?: number | null;
      column?: string | null;
      value?: string | null;
    }> | null;
  };
};

export type UploadRdExpenseProjectAllocationReportMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  uploadRdExpenseProjectAllocationReportInput: UploadRdExpenseProjectAllocationReportInput;
  file: Scalars['Upload']['input'];
}>;

export type UploadRdExpenseProjectAllocationReportMutation = {
  __typename?: 'Mutation';
  uploadRdExpenseProjectAllocationReport: {
    __typename?: 'UploadRdExpenseProjectAllocationReportResult';
    errors?: Array<{
      __typename?: 'ExcelParseError';
      type: ExcelParseErrorType;
      row?: number | null;
      column?: string | null;
      value?: string | null;
    }> | null;
  };
};

export type UploadPayrollExpenseCsvMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  payrollProvider: PayrollProvider;
  file: Scalars['Upload']['input'];
}>;

export type UploadPayrollExpenseCsvMutation = {
  __typename?: 'Mutation';
  uploadPayrollExpenseCsv: {
    __typename?: 'UploadPayrollExpenseCsvResult';
    payrollQres?: Array<{ __typename?: 'PayrollQre'; id: string }> | null;
    errors?: Array<{
      __typename?: 'TabularDataParseError';
      source: TabularDataSource;
      code: TabularDataErrorCode;
      row?: number | null;
      column?: string | null;
      value?: string | null;
    }> | null;
  };
};

export type UploadAccountingExpenseCsvMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  accountingProvider: AccountingProvider;
  file: Scalars['Upload']['input'];
}>;

export type UploadAccountingExpenseCsvMutation = {
  __typename?: 'Mutation';
  uploadAccountingExpenseCsv: {
    __typename?: 'UploadAccountingExpenseCsvResult';
    accountingQres?: Array<{ __typename?: 'AccountingQre'; id: string }> | null;
    errors?: Array<{
      __typename?: 'TabularDataParseError';
      source: TabularDataSource;
      code: TabularDataErrorCode;
      row?: number | null;
      column?: string | null;
      value?: string | null;
    }> | null;
  };
};

export type IsVersionOutdatedQueryVariables = Exact<{ [key: string]: never }>;

export type IsVersionOutdatedQuery = { __typename?: 'Query'; isVersionOutdated: boolean };

export type GetSyncedProvidersQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
}>;

export type GetSyncedProvidersQuery = {
  __typename?: 'Query';
  getFiscalYear: {
    __typename?: 'FiscalYear';
    id: string;
    syncedProviders: {
      __typename?: 'SyncedProviders';
      id: string;
      accountingProviders: Array<{
        __typename?: 'SyncedAccountingProviders';
        id: string;
        providerName: AccountingProvider;
        originalSyncDate: string;
      }>;
      payrollProviders: Array<{
        __typename?: 'SyncedPayrollProviders';
        id: string;
        providerName: PayrollProvider;
        originalSyncDate: string;
      }>;
      ticketingProviders: Array<{
        __typename?: 'SyncedTicketingProviders';
        id: string;
        providerName: TicketingProvider;
        originalSyncDate: string;
      }>;
    };
  };
};

export type UpdateAccountingExpenseMutationVariables = Exact<{
  accountingExpenseId: Scalars['ID']['input'];
  updateAccountingExpenseInput: UpdateAccountingExpenseInput;
}>;

export type UpdateAccountingExpenseMutation = {
  __typename?: 'Mutation';
  updateAccountingExpense: {
    __typename?: 'AccountingExpense';
    id: string;
    displayName: string;
    amountCents: number;
    createdAt: string;
    accountingQre: {
      __typename?: 'AccountingQre';
      id: string;
      name: string;
      qualifiedAmountCents?: number | null;
      amountCents?: number | null;
      qreRdPercentage: number;
      accountingProvider?: AccountingProvider | null;
      state?: string | null;
      country?: string | null;
      account?: string | null;
      department?: string | null;
      costCenter?: string | null;
      entity?: string | null;
      rdCategory: RdCategory;
      fiscalYearId: string;
      accountingExpenseId: string;
    };
    projectPerAccountingExpense: Array<{
      __typename?: 'ProjectPerAccountingExpense';
      id: string;
      rdProjectId: string;
      allocationPercentNotRounded: number;
    }>;
  };
};

export type DeleteAccountingTokensByCompanyAndProviderMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  accountingProvider: AccountingProvider;
}>;

export type DeleteAccountingTokensByCompanyAndProviderMutation = {
  __typename?: 'Mutation';
  deleteAccountingTokensByCompanyAndProvider: { __typename?: 'DeleteAccountingTokensResult'; ids: Array<string> };
};

export type DeletePayrollTokensByCompanyAndProviderMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  payrollProvider: PayrollProvider;
}>;

export type DeletePayrollTokensByCompanyAndProviderMutation = {
  __typename?: 'Mutation';
  deletePayrollTokensByCompanyAndProvider: { __typename?: 'DeletePayrollTokensResult'; ids: Array<string> };
};

export type GetContributorQueryVariables = Exact<{
  contributorId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type GetContributorQuery = {
  __typename?: 'Query';
  getContributor: {
    __typename?: 'Contributor';
    id: string;
    name?: string | null;
    ascProjectsPerContributor: Array<{
      __typename?: 'AscProjectPerContributor';
      id: string;
      ascProject: { __typename?: 'AscProject'; id: string; name: string };
      ascProjectMonthsPerContributor: Array<{
        __typename?: 'AscProjectMonthPerContributor';
        id: string;
        month: number;
        year: number;
        allocationPercent: number;
        useAllocationPercent?: number | null;
      }>;
    }>;
  };
};

export type CombineContributorMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  input: CombineContributorInput;
}>;

export type CombineContributorMutation = {
  __typename?: 'Mutation';
  combineContributor: { __typename?: 'Contributor'; id: string; name?: string | null };
};

export type UpdateContributorAllocationsForAscMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  input: UpdateContributorAllocationForAscInput;
}>;

export type UpdateContributorAllocationsForAscMutation = {
  __typename?: 'Mutation';
  updateContributorAllocationsForAsc: number;
};

export type GenerateAscReportMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type GenerateAscReportMutation = {
  __typename?: 'Mutation';
  generateAscReport: { __typename?: 'DistributedFlowState'; id: string };
};

export type GenerateRdProjectsReportMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
}>;

export type GenerateRdProjectsReportMutation = {
  __typename?: 'Mutation';
  generateRdProjectsReport: { __typename?: 'DistributedFlowState'; id: string };
};

export type GetAndSaveRdProjectsReportSignedUrlMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
}>;

export type GetAndSaveRdProjectsReportSignedUrlMutation = {
  __typename?: 'Mutation';
  getAndSaveRdProjectsReportSignedUrl: { __typename?: 'RdCreditsReportRo'; signedUrl: string };
};

export type GetAndSaveAscReportSignedUrlMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type GetAndSaveAscReportSignedUrlMutation = {
  __typename?: 'Mutation';
  getAndSaveAscReportSignedUrl: { __typename?: 'AscReportRo'; signedUrl: string };
};

export type GetCompanyQuestionsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetCompanyQuestionsQuery = {
  __typename?: 'Query';
  getCompany: {
    __typename?: 'Company';
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
    questionSections: Array<{
      __typename?: 'QuestionSection';
      id: string;
      sectionCode: QuestionSectionCode;
      displayText: string;
      displaySubtext?: string | null;
      displayOrder: number;
      questions: Array<{
        __typename?: 'Question';
        id: string;
        questionId: string;
        questionCode: QuestionCode;
        displayText: string;
        displayOrder: number;
        displaySubtext?: string | null;
        placeholder?: string | null;
        inputType: InputType;
        answerType: AnswerType;
        answerValue?: string | null;
        questionChoices?: Array<{
          __typename?: 'QuestionChoice';
          id: string;
          choiceCode: ChoiceCode;
          displayText: string;
          displayOrder: number;
          displaySubtext?: string | null;
          selected: boolean;
        }> | null;
        parentQuestionChoice?: { __typename?: 'ParentQuestionChoice'; id: string; parentQuestionId: string } | null;
      }>;
    }>;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
  };
};

export type UpdateFiscalYearProcessingTicketingDataStateMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  processingTicketingDataState: ProcessingTicketingDataState;
}>;

export type UpdateFiscalYearProcessingTicketingDataStateMutation = {
  __typename?: 'Mutation';
  updateFiscalYearProcessingTicketingDataState: {
    __typename?: 'FiscalYear';
    id: string;
    processingTicketingDataState: ProcessingTicketingDataState;
  };
};

export type GetGaapOnboardingFlowStatusQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetGaapOnboardingFlowStatusQuery = {
  __typename?: 'Query';
  getGaapOnboardingFlowStatus: { __typename?: 'GaapOnboardingFlowStatus'; percentCompleted: number };
};

export type GetDocumentsQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
}>;

export type GetDocumentsQuery = {
  __typename?: 'Query';
  getDocuments: {
    __typename?: 'Documents';
    id: string;
    federalRdTaxCreditDocuments?: {
      __typename?: 'FederalRdTaxCreditDocuments';
      id: string;
      filingMethod: FilingMethod;
      isReducedCredit: boolean;
      taxCreditFormFileName?: string | null;
      taxCreditFormUrl?: string | null;
      taxCreditFormStatus: DocumentStatus;
      taxCreditFormMissingInformation?: Array<string> | null;
      taxCreditFormGeneratedDate?: string | null;
      taxWriteUpPdfFileName?: string | null;
      taxWriteUpPdfUrl?: string | null;
      taxWriteUpStatus: DocumentStatus;
      taxWriteUpMissingInformation?: Array<string> | null;
      taxWriteUpGeneratedDate?: string | null;
    } | null;
    stateRdTaxCreditDocuments: Array<{
      __typename?: 'StateRdTaxCreditDocument';
      id: string;
      state: State;
      stateTaxCreditFormFileName?: string | null;
      stateTaxCreditFormUrl?: string | null;
      allowAccessDatetime?: string | null;
    }>;
  };
};

export type GetFederalDocumentStatusesQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
}>;

export type GetFederalDocumentStatusesQuery = {
  __typename?: 'Query';
  getFederalDocumentStatuses: {
    __typename?: 'FederalDocumentStatuses';
    taxCreditFormStatus: DocumentStatus;
    taxWriteUpStatus: DocumentStatus;
  };
};

export type GetLatestFederalDocumentStatusesForCompanyQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetLatestFederalDocumentStatusesForCompanyQuery = {
  __typename?: 'Query';
  getLatestFederalDocumentStatusesForCompany?: {
    __typename?: 'FederalDocumentStatuses';
    taxCreditFormStatus: DocumentStatus;
    taxWriteUpStatus: DocumentStatus;
  } | null;
};

export type GetStateDocumentStatusQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
}>;

export type GetStateDocumentStatusQuery = { __typename?: 'Query'; getStateDocumentStatus: boolean };

export type GetAllDocumentsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetAllDocumentsQuery = {
  __typename?: 'Query';
  getAllDocuments: Array<{
    __typename?: 'Documents';
    id: string;
    federalRdTaxCreditDocuments?: {
      __typename?: 'FederalRdTaxCreditDocuments';
      id: string;
      filingMethod: FilingMethod;
      isReducedCredit: boolean;
      taxCreditFormFileName?: string | null;
      taxCreditFormUrl?: string | null;
      taxCreditFormStatus: DocumentStatus;
      taxCreditFormMissingInformation?: Array<string> | null;
      taxCreditFormGeneratedDate?: string | null;
      taxWriteUpPdfFileName?: string | null;
      taxWriteUpPdfUrl?: string | null;
      taxWriteUpStatus: DocumentStatus;
      taxWriteUpMissingInformation?: Array<string> | null;
      taxWriteUpGeneratedDate?: string | null;
    } | null;
    stateRdTaxCreditDocuments: Array<{
      __typename?: 'StateRdTaxCreditDocument';
      id: string;
      state: State;
      stateTaxCreditFormFileName?: string | null;
      stateTaxCreditFormUrl?: string | null;
      allowAccessDatetime?: string | null;
    }>;
  }>;
};

export type GetQuestionSectionsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetQuestionSectionsQuery = {
  __typename?: 'Query';
  getCompany: {
    __typename?: 'Company';
    id: string;
    questionSections: Array<{
      __typename?: 'QuestionSection';
      id: string;
      sectionCode: QuestionSectionCode;
      displayText: string;
      displaySubtext?: string | null;
      displayOrder: number;
      questions: Array<{
        __typename?: 'Question';
        id: string;
        questionId: string;
        questionCode: QuestionCode;
        displayText: string;
        displayOrder: number;
        displaySubtext?: string | null;
        placeholder?: string | null;
        inputType: InputType;
        answerType: AnswerType;
        answerValue?: string | null;
        questionChoices?: Array<{
          __typename?: 'QuestionChoice';
          id: string;
          choiceCode: ChoiceCode;
          displayText: string;
          displayOrder: number;
          displaySubtext?: string | null;
          selected: boolean;
        }> | null;
        parentQuestionChoice?: { __typename?: 'ParentQuestionChoice'; id: string; parentQuestionId: string } | null;
      }>;
    }>;
  };
};

export type UpdateCompanyQuestionMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  companyQuestionInput: CompanyQuestionInput;
}>;

export type UpdateCompanyQuestionMutation = {
  __typename?: 'Mutation';
  updateCompanyQuestion: { __typename?: 'Question'; id: string };
};

export type CreateFiscalYearMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  createFiscalYearInput: CreateFiscalYearInput;
}>;

export type CreateFiscalYearMutation = {
  __typename?: 'Mutation';
  createFiscalYear: {
    __typename?: 'FiscalYear';
    id: string;
    year: number;
    taxYearStartDate: string;
    taxYearEndDate: string;
    productType: ProductType;
    enabledDatetime?: string | null;
  };
};

export type UpdatePayrollExpenseMutationVariables = Exact<{
  payrollExpenseId: Scalars['ID']['input'];
  input: UpdatePayrollExpenseInput;
}>;

export type UpdatePayrollExpenseMutation = {
  __typename?: 'Mutation';
  updatePayrollExpense: {
    __typename?: 'PayrollQre';
    id: string;
    name: string;
    email?: string | null;
    title?: string | null;
    department?: string | null;
    managerName?: string | null;
    hireDate?: string | null;
    terminationDate?: string | null;
    costCenter?: string | null;
    entity?: string | null;
    qualifiedAmountCents?: number | null;
    amountCents?: number | null;
    qreRdPercentage: number;
    payrollProvider?: PayrollProvider | null;
    ticketingProviders: Array<TicketingProvider>;
    state?: string | null;
    country?: string | null;
    rdCategory: RdCategory;
    rdTaxCreditContributorId: string;
    payrollExpenseId?: string | null;
    isOfficer: boolean;
  };
};

export type UpdateRdExpenseProjectAllocationsMutationVariables = Exact<{
  rdExpenseId: Scalars['ID']['input'];
  updateRdExpenseProjectAllocationsInput: UpdateRdExpenseProjectAllocationsInput;
}>;

export type UpdateRdExpenseProjectAllocationsMutation = {
  __typename?: 'Mutation';
  updateRdExpenseProjectAllocations: {
    __typename?: 'RdExpense';
    id: string;
    rdCategory: RdCategory;
    rdCategoryConfidence: number;
    accountingQre?: {
      __typename?: 'AccountingQre';
      id: string;
      name: string;
      qualifiedAmountCents?: number | null;
      amountCents?: number | null;
      qreRdPercentage: number;
      accountingProvider?: AccountingProvider | null;
      state?: string | null;
      country?: string | null;
      account?: string | null;
      department?: string | null;
      costCenter?: string | null;
      entity?: string | null;
      rdCategory: RdCategory;
      fiscalYearId: string;
      accountingExpenseId: string;
    } | null;
    payrollQre?: {
      __typename?: 'PayrollQre';
      id: string;
      name: string;
      email?: string | null;
      title?: string | null;
      department?: string | null;
      managerName?: string | null;
      hireDate?: string | null;
      terminationDate?: string | null;
      costCenter?: string | null;
      entity?: string | null;
      qualifiedAmountCents?: number | null;
      amountCents?: number | null;
      qreRdPercentage: number;
      payrollProvider?: PayrollProvider | null;
      ticketingProviders: Array<TicketingProvider>;
      state?: string | null;
      country?: string | null;
      rdCategory: RdCategory;
      rdTaxCreditContributorId: string;
      payrollExpenseId?: string | null;
      isOfficer: boolean;
    } | null;
  };
};

export type ApplyWeightedRdPercentageToExpensesMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  applyWeightedRdPercentageToExpensesInput: ApplyWeightedRdPercentageToExpensesInput;
  filter?: InputMaybe<PayrollQreFilter>;
}>;

export type ApplyWeightedRdPercentageToExpensesMutation = {
  __typename?: 'Mutation';
  applyWeightedRdPercentageToExpenses: { __typename?: 'ApplyWeightedRdPercentageToExpensesResult'; success: boolean };
};

export type GetAllFiscalYearsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetAllFiscalYearsQuery = {
  __typename?: 'Query';
  getCompany: {
    __typename?: 'Company';
    id: string;
    fiscalYears: Array<{
      __typename?: 'FiscalYear';
      id: string;
      year: number;
      taxYearStartDate: string;
      taxYearEndDate: string;
      productType: ProductType;
      enabledDatetime?: string | null;
    }>;
  };
};

export type GetAccountingExpenseQueryVariables = Exact<{
  accountingExpenseId: Scalars['ID']['input'];
}>;

export type GetAccountingExpenseQuery = {
  __typename?: 'Query';
  getAccountingExpense: {
    __typename?: 'AccountingExpense';
    id: string;
    displayName: string;
    amountCents: number;
    createdAt: string;
    accountingQre: {
      __typename?: 'AccountingQre';
      id: string;
      name: string;
      qualifiedAmountCents?: number | null;
      amountCents?: number | null;
      qreRdPercentage: number;
      accountingProvider?: AccountingProvider | null;
      state?: string | null;
      country?: string | null;
      account?: string | null;
      department?: string | null;
      costCenter?: string | null;
      entity?: string | null;
      rdCategory: RdCategory;
      fiscalYearId: string;
      accountingExpenseId: string;
    };
    projectPerAccountingExpense: Array<{
      __typename?: 'ProjectPerAccountingExpense';
      id: string;
      rdProjectId: string;
      allocationPercentNotRounded: number;
    }>;
  };
};

export type GetAccountingQresQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  sorting?: InputMaybe<Array<AccountingQreSort> | AccountingQreSort>;
  filter?: InputMaybe<AccountingQreFilter>;
  paging?: InputMaybe<CursorPaging>;
}>;

export type GetAccountingQresQuery = {
  __typename?: 'Query';
  getAccountingQres: {
    __typename?: 'AccountingQreConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'AccountingQreEdge';
      cursor: any;
      node: {
        __typename?: 'AccountingQre';
        id: string;
        name: string;
        qualifiedAmountCents?: number | null;
        amountCents?: number | null;
        qreRdPercentage: number;
        accountingProvider?: AccountingProvider | null;
        state?: string | null;
        country?: string | null;
        account?: string | null;
        department?: string | null;
        costCenter?: string | null;
        entity?: string | null;
        rdCategory: RdCategory;
        fiscalYearId: string;
        accountingExpenseId: string;
      };
    }>;
  };
};

export type GetPayrollExpenseQueryVariables = Exact<{
  payrollExpenseId: Scalars['ID']['input'];
}>;

export type GetPayrollExpenseQuery = {
  __typename?: 'Query';
  getPayrollExpense: {
    __typename?: 'PayrollExpense';
    id: string;
    amountCents?: number | null;
    payrollProvider: PayrollProvider;
    wageType?: WageType | null;
    payrollQre: {
      __typename?: 'PayrollQre';
      id: string;
      name: string;
      email?: string | null;
      title?: string | null;
      department?: string | null;
      managerName?: string | null;
      hireDate?: string | null;
      terminationDate?: string | null;
      costCenter?: string | null;
      entity?: string | null;
      qualifiedAmountCents?: number | null;
      amountCents?: number | null;
      qreRdPercentage: number;
      payrollProvider?: PayrollProvider | null;
      ticketingProviders: Array<TicketingProvider>;
      state?: string | null;
      country?: string | null;
      rdCategory: RdCategory;
      rdTaxCreditContributorId: string;
      payrollExpenseId?: string | null;
      isOfficer: boolean;
    };
  };
};

export type GetRdExpenseProjectAllocationsQueryVariables = Exact<{
  rdExpenseId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  filter?: RdExpenseProjectAllocationFilter;
  paging?: CursorPaging;
  sorting?: Array<RdExpenseProjectAllocationSort> | RdExpenseProjectAllocationSort;
}>;

export type GetRdExpenseProjectAllocationsQuery = {
  __typename?: 'Query';
  getRdExpenseProjectAllocations: {
    __typename?: 'RdExpenseProjectAllocationConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'RdExpenseProjectAllocationEdge';
      cursor: any;
      node: {
        __typename?: 'RdExpenseProjectAllocation';
        id: string;
        rdProjectId: string;
        allocationPercentNotRounded: number;
        projectName: string;
        project: {
          __typename?: 'AllocationProjectDetails';
          id: string;
          name: string;
          consideredForRd: boolean;
          isSection174Eligible: boolean;
        };
      };
    }>;
  };
};

export type GetAscContributorProjectAllocationsQueryVariables = Exact<{
  contributorId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  filter?: AscContributorProjectAllocationFilter;
  paging?: CursorPaging;
  sorting?: Array<AscContributorProjectAllocationSort> | AscContributorProjectAllocationSort;
}>;

export type GetAscContributorProjectAllocationsQuery = {
  __typename?: 'Query';
  getAscContributorProjectAllocations: {
    __typename?: 'AscContributorProjectAllocationConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'AscContributorProjectAllocationEdge';
      cursor: any;
      node: {
        __typename?: 'AscContributorProjectAllocation';
        id: string;
        ascProjectId: string;
        contributorId: string;
        allocationPercentAvg: number;
        ascProjectName: string;
        capitalizationStatus: CapitalizationStatus;
        capitalizationStartDate?: string | null;
        capitalizationEndDate?: string | null;
        clusterType: AscClusterType;
      };
    }>;
  };
};

export type GetPayrollQresQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  sorting?: InputMaybe<Array<PayrollQreSort> | PayrollQreSort>;
  filter?: InputMaybe<PayrollQreFilter>;
  paging?: InputMaybe<CursorPaging>;
}>;

export type GetPayrollQresQuery = {
  __typename?: 'Query';
  getPayrollQres: {
    __typename?: 'PayrollQreConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'PayrollQreEdge';
      cursor: any;
      node: {
        __typename?: 'PayrollQre';
        id: string;
        name: string;
        email?: string | null;
        title?: string | null;
        department?: string | null;
        managerName?: string | null;
        hireDate?: string | null;
        terminationDate?: string | null;
        costCenter?: string | null;
        entity?: string | null;
        qualifiedAmountCents?: number | null;
        amountCents?: number | null;
        qreRdPercentage: number;
        payrollProvider?: PayrollProvider | null;
        ticketingProviders: Array<TicketingProvider>;
        state?: string | null;
        country?: string | null;
        rdCategory: RdCategory;
        rdTaxCreditContributorId: string;
        payrollExpenseId?: string | null;
        isOfficer: boolean;
      };
    }>;
  };
};

export type GetFiscalYearQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
}>;

export type GetFiscalYearQuery = {
  __typename?: 'Query';
  getFiscalYear: {
    __typename?: 'FiscalYear';
    id: string;
    year: number;
    taxYearStartDate: string;
    taxYearEndDate: string;
    lockedForCustomers: boolean;
    productType: ProductType;
    enabledDatetime?: string | null;
    companyId: string;
    processingTicketingDataState: ProcessingTicketingDataState;
    syncedProviders: {
      __typename?: 'SyncedProviders';
      id: string;
      accountingProviders: Array<{
        __typename?: 'SyncedAccountingProviders';
        id: string;
        providerName: AccountingProvider;
        originalSyncDate: string;
      }>;
      payrollProviders: Array<{
        __typename?: 'SyncedPayrollProviders';
        id: string;
        providerName: PayrollProvider;
        originalSyncDate: string;
      }>;
      ticketingProviders: Array<{
        __typename?: 'SyncedTicketingProviders';
        id: string;
        providerName: TicketingProvider;
        originalSyncDate: string;
      }>;
    };
    syncedRdPayrollCost: Array<{
      __typename?: 'SyncedRdPayrollCost';
      id: string;
      originalSyncDate: string;
      provider: PayrollProvider;
      fileUpload: {
        __typename?: 'FileUpload';
        id: string;
        createdAt: string;
        fileName: string;
        signedUrl: string;
        isValid?: boolean | null;
        payrollMonthExpenseSyncEventId?: string | null;
        payrollProviderSyncEventId?: string | null;
        period?: {
          __typename?: 'MonthYearPeriod';
          startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
          endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        } | null;
      };
    }>;
    rdTaxCredit?: { __typename?: 'RDTaxCredit'; id: string; lastUpdatedAt?: string | null } | null;
    sredTaxCredit?: { __typename?: 'SredTaxCredit'; id: string } | null;
  };
};

export type GetTicketingUsersQueryVariables = Exact<{
  sorting?: InputMaybe<Array<TicketingUserSort> | TicketingUserSort>;
  filter?: InputMaybe<TicketingUserFilter>;
  companyId: Scalars['ID']['input'];
  rdTaxCreditId: Scalars['ID']['input'];
  paging?: InputMaybe<CursorPaging>;
}>;

export type GetTicketingUsersQuery = {
  __typename?: 'Query';
  getTicketingUsers: {
    __typename?: 'TicketingUserConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'TicketingUserEdge';
      cursor: any;
      node: {
        __typename?: 'TicketingUser';
        id: string;
        name?: string | null;
        email?: string | null;
        provider: TicketingProvider;
        contributorId: string;
      };
    }>;
  };
};

export type CreateAscProjectMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  createAscProjectInput: CreateAscProjectInput;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type CreateAscProjectMutation = {
  __typename?: 'Mutation';
  createAscProject: {
    __typename?: 'AscProject';
    id: string;
    name: string;
    description?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    capitalizationStartDate?: string | null;
    capitalizationEndDate?: string | null;
    capitalizationEndDateExtendedFrom?: string | null;
    capitalizationStatus: CapitalizationStatus;
    predictedCapitalizationStatus?: PredictedCapitalizationStatus | null;
    predictedCapitalizationStatusReason?: string | null;
    predictedCapitalizationStartDate?: string | null;
    predictedCapitalizationEndDate?: string | null;
    predictedCapitalizationEndDateReason?: string | null;
    capitalizableProjectClusteringOverride?: CapitalizableProjectClusteringOverride | null;
    customFieldTeams?: Array<string> | null;
    customFieldLaunchDate?: string | null;
    workstreamNames: Array<string>;
    ticketCount: number;
    projectOwnerId?: string | null;
    clusterType: AscClusterType;
    isDeterministic: boolean;
    projectOwner?: { __typename?: 'AscProjectOwner'; id: string; fullName: string } | null;
    product?: { __typename?: 'Product'; id: string; name: string } | null;
  };
};

export type CreateRdProjectMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  createRdProjectInput: CreateRdProjectInput;
}>;

export type CreateRdProjectMutation = {
  __typename?: 'Mutation';
  createRdProject: {
    __typename?: 'RdProject';
    id: string;
    name: string;
    description?: string | null;
    purpose?: ProjectPurpose | null;
    businessComponent?: ProjectBusinessComponent | null;
    businessPurpose?: ProjectBusinessPurpose | null;
    consideredForRd: boolean;
    isSection174Eligible: boolean;
    disallowances?: Array<ProjectDisallowance> | null;
    improvedAspects?: Array<ProjectPurposeImprovedAspect> | null;
    technicalChallenges?: string | null;
    processOfExperimentation?: string | null;
    selectedCategory: SelectedRdProjectCategory;
    rdDocumentationStatus: RdDocumentationStatus;
    projectOwnerId?: string | null;
    workstreamNames: Array<string>;
    workstreamNamesSearch?: string | null;
    ticketCount: number;
    processingState: ProcessingProjectState;
    clusterType: RdClusterType;
    approvalTime?: string | null;
    approvalComment?: string | null;
    aiGuidance?: string | null;
    isTechnicallyUncertain?: boolean | null;
    isCustomerFacingDevelopment?: boolean | null;
    isInnovativeAndRisky?: boolean | null;
    projectOwner?: { __typename?: 'RdProjectOwner'; id: string; fullName: string } | null;
    rdDetermination?: {
      __typename?: 'ProjectRdDetermination';
      id: string;
      isTechnicalInNature: boolean;
      isTechnicalInNatureSource?: DeterminationSource | null;
      hasQualifiedPurpose: QualifiedPurposeDetermination;
      hasQualifiedPurposeSource?: DeterminationSource | null;
      qualifiedPurposeReasoning: string;
      qualifiedPurposeReasoningSource?: DeterminationSource | null;
      hasTechnicalUncertainties: boolean;
      technicalInNatureShare: number;
      projectRdDeterminationUncertainties: Array<{
        __typename?: 'ProjectRdDeterminationUncertainty';
        id: string;
        uncertainty: string;
      }>;
    } | null;
    supportingDocuments: Array<{
      __typename?: 'FileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      isValid?: boolean | null;
      payrollMonthExpenseSyncEventId?: string | null;
      payrollProviderSyncEventId?: string | null;
      period?: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      } | null;
    }>;
    product?: { __typename?: 'Product'; id: string; name: string } | null;
  };
};

export type DeleteAscProjectMutationVariables = Exact<{
  ascProjectId: Scalars['ID']['input'];
}>;

export type DeleteAscProjectMutation = {
  __typename?: 'Mutation';
  deleteAscProject: { __typename?: 'AscProjectDeletionResult'; success: boolean };
};

export type GetAscPeriodLockStatusQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type GetAscPeriodLockStatusQuery = {
  __typename?: 'Query';
  getAscPeriodLockStatus: {
    __typename?: 'AscPeriodLockStatus';
    fiscalYearId: string;
    periodName: PeriodName;
    isLocked: boolean;
    monthLockStates: Array<{ __typename?: 'AscMonthLockState'; monthYear: string; isLocked: boolean }>;
  };
};

export type SetAscPeriodLockMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  isLocked: Scalars['Boolean']['input'];
}>;

export type SetAscPeriodLockMutation = {
  __typename?: 'Mutation';
  setAscPeriodLock: {
    __typename?: 'AscPeriodLockStatus';
    fiscalYearId: string;
    periodName: PeriodName;
    isLocked: boolean;
    monthLockStates: Array<{ __typename?: 'AscMonthLockState'; monthYear: string; isLocked: boolean }>;
  };
};

export type SetAscProjectApprovalMutationVariables = Exact<{
  ascProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  setAscProjectApprovalInput: SetAscProjectApprovalInput;
}>;

export type SetAscProjectApprovalMutation = {
  __typename?: 'Mutation';
  setAscProjectApproval: {
    __typename?: 'AscProject';
    id: string;
    approvalStatus?: {
      __typename?: 'AscProjectApprovalStatusResult';
      ascProjectId: string;
      fiscalYearId: string;
      periodName: PeriodName;
      status: AscProjectApprovalStatus;
      periodApprovalByUserId?: string | null;
      periodApprovalDatetime?: string | null;
      periodApprovalComment?: string | null;
      approvedThroughMonthYear?: string | null;
    } | null;
  };
};

export type ClearAscProjectApprovalMutationVariables = Exact<{
  ascProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type ClearAscProjectApprovalMutation = {
  __typename?: 'Mutation';
  clearAscProjectApproval: {
    __typename?: 'AscProject';
    id: string;
    approvalStatus?: {
      __typename?: 'AscProjectApprovalStatusResult';
      ascProjectId: string;
      fiscalYearId: string;
      periodName: PeriodName;
      status: AscProjectApprovalStatus;
      periodApprovalByUserId?: string | null;
      periodApprovalDatetime?: string | null;
      periodApprovalComment?: string | null;
      approvedThroughMonthYear?: string | null;
    } | null;
  };
};

export type DeleteRdProjectMutationVariables = Exact<{
  rdProjectId: Scalars['ID']['input'];
}>;

export type DeleteRdProjectMutation = {
  __typename?: 'Mutation';
  deleteRdProject: { __typename?: 'RdProjectDeletionResult'; success: boolean };
};

export type UpdateRdTaxCreditOverridesMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  rdTaxCreditOverrides: RdTaxCreditOverridesInput;
}>;

export type UpdateRdTaxCreditOverridesMutation = {
  __typename?: 'Mutation';
  updateRdTaxCreditOverrides: {
    __typename?: 'FederalRdTaxCreditDocuments';
    id: string;
    filingMethod: FilingMethod;
    isReducedCredit: boolean;
  };
};

export type GetCreditEstimateQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
}>;

export type GetCreditEstimateQuery = {
  __typename?: 'Query';
  getCreditEstimate:
    | {
        __typename?: 'Form6765Values';
        id: string;
        isEstimateCalculation: boolean;
        ascMethodCreditCents: number;
        regularMethodCreditCents: number;
        wagesQreCents: number;
        suppliesQreCents: number;
        cloudQreCents: number;
        contractorQreCents: number;
        totalQreCents: number;
      }
    | { __typename?: 'MissingValue'; reason: string };
};

export type AllowRealCompanyMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type AllowRealCompanyMutation = {
  __typename?: 'Mutation';
  allowRealCompany: {
    __typename?: 'User';
    id: string;
    fullName: string;
    email: string;
    phone?: string | null;
    firebaseUserId: string;
    allowRealCompanyDatetime?: string | null;
    organizationScope?: OrganizationScope | null;
    thomsonReutersConsumerKey?: string | null;
    userAttributes: {
      __typename?: 'UserAttributes';
      viewedWelcomeMessageTaxYear?: number | null;
      isSsoOnboarding?: boolean | null;
    };
    companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
    pendingOrFailedStatusOrganizationInvitations: Array<{
      __typename?: 'OrganizationInvitation';
      id: string;
      derivedState: string;
    }>;
    companies: Array<{ __typename?: 'Company'; id: string }>;
    organization?: {
      __typename?: 'Organization';
      id: string;
      photoUrl?: string | null;
      name: string;
      isAccountingFirm: boolean;
      members: Array<{
        __typename?: 'User';
        id: string;
        email: string;
        fullName: string;
        organizationScope?: OrganizationScope | null;
        companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
      }>;
      invitedMembers: Array<{
        __typename?: 'OrganizationInvitation';
        id: string;
        email: string;
        scope: OrganizationScope;
        expiresAt: string;
        revokedAt?: string | null;
        acceptedAt?: string | null;
        derivedState: string;
      }>;
    } | null;
  };
};

export type CreateContributorMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  input: CreateContributorInput;
}>;

export type CreateContributorMutation = {
  __typename?: 'Mutation';
  createContributor: { __typename?: 'Contributor'; id: string; name?: string | null };
};

export type SendEmailVerificationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  continueUrl?: InputMaybe<Scalars['String']['input']>;
}>;

export type SendEmailVerificationMutation = { __typename?: 'Mutation'; sendEmailVerification: string };

export type SendMagicLinkEmailMutationVariables = Exact<{
  sendMagicLinkEmailInput: SendMagicLinkEmailInput;
}>;

export type SendMagicLinkEmailMutation = { __typename?: 'Mutation'; sendMagicLinkEmail: boolean };

export type SendResetPasswordEmailMutationVariables = Exact<{
  sendResetPasswordEmailInput: SendResetPasswordEmailInput;
}>;

export type SendResetPasswordEmailMutation = { __typename?: 'Mutation'; sendResetPasswordEmail: boolean };

export type DeleteAccountingSyncEventForFiscalYearMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  accountingProviderSyncEventId: Scalars['ID']['input'];
}>;

export type DeleteAccountingSyncEventForFiscalYearMutation = {
  __typename?: 'Mutation';
  deleteAccountingSyncEventForFiscalYear: {
    __typename?: 'DeleteAccountingSyncEventForFiscalYearResult';
    deletedAccountingProviderSyncEventId: string;
  };
};

export type DeletePayrollSyncEventForFiscalYearMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  payrollProviderSyncEventId: Scalars['ID']['input'];
}>;

export type DeletePayrollSyncEventForFiscalYearMutation = {
  __typename?: 'Mutation';
  deletePayrollSyncEventForFiscalYear: {
    __typename?: 'DeletePayrollSyncEventForFiscalYearResult';
    deletedPayrollProviderSyncEventId: string;
  };
};

export type DeletePayrollMonthExpenseSyncEventMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  payrollMonthExpenseSyncEventId: Scalars['ID']['input'];
}>;

export type DeletePayrollMonthExpenseSyncEventMutation = {
  __typename?: 'Mutation';
  deletePayrollMonthExpenseSyncEvent: {
    __typename?: 'DeletePayrollMonthExpenseSyncEventResult';
    deletedPayrollMonthExpenseSyncEventId: string;
  };
};

export type GetRdProjectSupportingDocumentSignedUploadUrlMutationVariables = Exact<{
  rdProjectId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
}>;

export type GetRdProjectSupportingDocumentSignedUploadUrlMutation = {
  __typename?: 'Mutation';
  getRdProjectSupportingDocumentSignedUploadUrl: { __typename?: 'UploadUrl'; signedUrl: string; permanentUrl: string };
};

export type AddRdProjectSupportingDocumentMutationVariables = Exact<{
  rdProjectId: Scalars['ID']['input'];
  input: AddRdProjectSupportingDocumentInput;
}>;

export type AddRdProjectSupportingDocumentMutation = {
  __typename?: 'Mutation';
  addRdProjectSupportingDocument: {
    __typename?: 'RdProject';
    id: string;
    processingState: ProcessingProjectState;
    supportingDocuments: Array<{
      __typename?: 'FileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      isValid?: boolean | null;
      payrollMonthExpenseSyncEventId?: string | null;
      payrollProviderSyncEventId?: string | null;
      period?: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      } | null;
    }>;
  };
};

export type RemoveRdProjectSupportingDocumentMutationVariables = Exact<{
  fileUploadId: Scalars['ID']['input'];
}>;

export type RemoveRdProjectSupportingDocumentMutation = {
  __typename?: 'Mutation';
  removeRdProjectSupportingDocument: {
    __typename?: 'RdProject';
    id: string;
    processingState: ProcessingProjectState;
    supportingDocuments: Array<{
      __typename?: 'FileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      isValid?: boolean | null;
      payrollMonthExpenseSyncEventId?: string | null;
      payrollProviderSyncEventId?: string | null;
      period?: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      } | null;
    }>;
  };
};

export type GenerateRdDetailsMutationVariables = Exact<{
  rdProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  input: GenerateRdDetailsInput;
}>;

export type GenerateRdDetailsMutation = {
  __typename?: 'Mutation';
  generateRdDetails: {
    __typename?: 'RdProject';
    id: string;
    name: string;
    description?: string | null;
    processingState: ProcessingProjectState;
    technicalChallenges?: string | null;
    processOfExperimentation?: string | null;
    rdDetermination?: {
      __typename?: 'ProjectRdDetermination';
      id: string;
      isTechnicalInNature: boolean;
      isTechnicalInNatureSource?: DeterminationSource | null;
      hasQualifiedPurpose: QualifiedPurposeDetermination;
      hasQualifiedPurposeSource?: DeterminationSource | null;
      qualifiedPurposeReasoning: string;
      qualifiedPurposeReasoningSource?: DeterminationSource | null;
      hasTechnicalUncertainties: boolean;
      technicalInNatureShare: number;
      projectRdDeterminationUncertainties: Array<{
        __typename?: 'ProjectRdDeterminationUncertainty';
        id: string;
        uncertainty: string;
      }>;
    } | null;
  };
};

export type UpdateRdProjectEligibilityMutationVariables = Exact<{
  rdProjectId: Scalars['ID']['input'];
  rdProjectEligibilityAnswersInput: RdProjectEligibilityAnswersInput;
}>;

export type UpdateRdProjectEligibilityMutation = {
  __typename?: 'Mutation';
  updateRdProjectEligibility: {
    __typename?: 'RdProject';
    id: string;
    name: string;
    description?: string | null;
    purpose?: ProjectPurpose | null;
    businessComponent?: ProjectBusinessComponent | null;
    businessPurpose?: ProjectBusinessPurpose | null;
    consideredForRd: boolean;
    isSection174Eligible: boolean;
    disallowances?: Array<ProjectDisallowance> | null;
    improvedAspects?: Array<ProjectPurposeImprovedAspect> | null;
    technicalChallenges?: string | null;
    processOfExperimentation?: string | null;
    selectedCategory: SelectedRdProjectCategory;
    rdDocumentationStatus: RdDocumentationStatus;
    projectOwnerId?: string | null;
    workstreamNames: Array<string>;
    workstreamNamesSearch?: string | null;
    ticketCount: number;
    processingState: ProcessingProjectState;
    clusterType: RdClusterType;
    approvalTime?: string | null;
    approvalComment?: string | null;
    aiGuidance?: string | null;
    isTechnicallyUncertain?: boolean | null;
    isCustomerFacingDevelopment?: boolean | null;
    isInnovativeAndRisky?: boolean | null;
    projectOwner?: { __typename?: 'RdProjectOwner'; id: string; fullName: string } | null;
    rdDetermination?: {
      __typename?: 'ProjectRdDetermination';
      id: string;
      isTechnicalInNature: boolean;
      isTechnicalInNatureSource?: DeterminationSource | null;
      hasQualifiedPurpose: QualifiedPurposeDetermination;
      hasQualifiedPurposeSource?: DeterminationSource | null;
      qualifiedPurposeReasoning: string;
      qualifiedPurposeReasoningSource?: DeterminationSource | null;
      hasTechnicalUncertainties: boolean;
      technicalInNatureShare: number;
      projectRdDeterminationUncertainties: Array<{
        __typename?: 'ProjectRdDeterminationUncertainty';
        id: string;
        uncertainty: string;
      }>;
    } | null;
    supportingDocuments: Array<{
      __typename?: 'FileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      isValid?: boolean | null;
      payrollMonthExpenseSyncEventId?: string | null;
      payrollProviderSyncEventId?: string | null;
      period?: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      } | null;
    }>;
    product?: { __typename?: 'Product'; id: string; name: string } | null;
  };
};

export type GenerateElevatorPitchMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GenerateElevatorPitchMutation = {
  __typename?: 'Mutation';
  generateElevatorPitch: {
    __typename?: 'Question';
    id: string;
    questionId: string;
    questionCode: QuestionCode;
    displayText: string;
    displayOrder: number;
    displaySubtext?: string | null;
    placeholder?: string | null;
    inputType: InputType;
    answerType: AnswerType;
    answerValue?: string | null;
    questionChoices?: Array<{
      __typename?: 'QuestionChoice';
      id: string;
      choiceCode: ChoiceCode;
      displayText: string;
      displayOrder: number;
      displaySubtext?: string | null;
      selected: boolean;
    }> | null;
    parentQuestionChoice?: { __typename?: 'ParentQuestionChoice'; id: string; parentQuestionId: string } | null;
  };
};

export type GetTicketingDataSignedUploadUrlMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  action: UploadAction;
}>;

export type GetTicketingDataSignedUploadUrlMutation = {
  __typename?: 'Mutation';
  getTicketingDataSignedUploadUrl: { __typename?: 'UploadUrl'; signedUrl: string; permanentUrl: string };
};

export type GetPriorYearTaxDocumentSignedUploadUrlMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
}>;

export type GetPriorYearTaxDocumentSignedUploadUrlMutation = {
  __typename?: 'Mutation';
  getPriorYearTaxDocumentSignedUploadUrl: { __typename?: 'UploadUrl'; signedUrl: string; permanentUrl: string };
};

export type AddCompanyBulkTicketingDataFileMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  input: AddCompanyBulkTicketingDataInput;
}>;

export type AddCompanyBulkTicketingDataFileMutation = {
  __typename?: 'Mutation';
  addCompanyBulkTicketingDataFile: {
    __typename?: 'Company';
    id: string;
    bulkTicketingDataUploads: Array<{
      __typename?: 'BulkTicketingDataFileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      ticketingProvider: FileUploadTicketingProvider;
      ticketingEntityType: TicketingEntityType;
      isValid?: boolean | null;
    }>;
  };
};

export type RemoveCompanyBulkTicketingDataFileMutationVariables = Exact<{
  fileUploadId: Scalars['ID']['input'];
}>;

export type RemoveCompanyBulkTicketingDataFileMutation = {
  __typename?: 'Mutation';
  removeCompanyBulkTicketingDataFile: {
    __typename?: 'Company';
    id: string;
    bulkTicketingDataUploads: Array<{
      __typename?: 'BulkTicketingDataFileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      ticketingProvider: FileUploadTicketingProvider;
      ticketingEntityType: TicketingEntityType;
      isValid?: boolean | null;
    }>;
  };
};

export type AddPriorYearTaxDocumentMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  input: AddPriorYearTaxDocumentInput;
}>;

export type AddPriorYearTaxDocumentMutation = {
  __typename?: 'Mutation';
  addPriorYearTaxDocument: {
    __typename?: 'Company';
    id: string;
    bulkPriorYearTaxDocumentUploads: Array<{
      __typename?: 'FileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      isValid?: boolean | null;
      payrollMonthExpenseSyncEventId?: string | null;
      payrollProviderSyncEventId?: string | null;
      period?: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      } | null;
    }>;
  };
};

export type RemovePriorYearTaxDocumentMutationVariables = Exact<{
  fileUploadId: Scalars['ID']['input'];
}>;

export type RemovePriorYearTaxDocumentMutation = {
  __typename?: 'Mutation';
  removePriorYearTaxDocument: {
    __typename?: 'Company';
    id: string;
    bulkPriorYearTaxDocumentUploads: Array<{
      __typename?: 'FileUpload';
      id: string;
      createdAt: string;
      fileName: string;
      signedUrl: string;
      isValid?: boolean | null;
      payrollMonthExpenseSyncEventId?: string | null;
      payrollProviderSyncEventId?: string | null;
      period?: {
        __typename?: 'MonthYearPeriod';
        startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
        endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      } | null;
    }>;
  };
};

export type GetAscWagesQueryVariables = Exact<{
  sorting?: InputMaybe<Array<AscWageSort> | AscWageSort>;
  filter?: InputMaybe<AscWageFilter>;
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  paging?: InputMaybe<CursorPaging>;
}>;

export type GetAscWagesQuery = {
  __typename?: 'Query';
  getAscWages: {
    __typename?: 'AscWageConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'AscWageEdge';
      cursor: any;
      node: {
        __typename?: 'AscWage';
        id: string;
        name?: string | null;
        titles?: string | null;
        departments?: string | null;
        managerNames?: string | null;
        hireDates?: string | null;
        terminationDates?: string | null;
        costCenters?: string | null;
        entities?: string | null;
        totalCompensationCents?: number | null;
        salaryCompensationCents?: number | null;
        stockCompensationCents?: number | null;
        capitalizedTotalCompensationCents?: number | null;
        allocationPercent: number;
        countries?: string | null;
        contributorId: string;
        hasCompleteDataInPeriod: boolean;
        fiscalYearId: string;
        periodName: PeriodName;
      };
    }>;
  };
};

export type GetAscWageQueryVariables = Exact<{
  ascWageId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type GetAscWageQuery = {
  __typename?: 'Query';
  getAscWage: {
    __typename?: 'AscWage';
    id: string;
    name?: string | null;
    titles?: string | null;
    departments?: string | null;
    managerNames?: string | null;
    hireDates?: string | null;
    terminationDates?: string | null;
    costCenters?: string | null;
    entities?: string | null;
    totalCompensationCents?: number | null;
    salaryCompensationCents?: number | null;
    stockCompensationCents?: number | null;
    capitalizedTotalCompensationCents?: number | null;
    allocationPercent: number;
    countries?: string | null;
    contributorId: string;
    hasCompleteDataInPeriod: boolean;
    fiscalYearId: string;
    periodName: PeriodName;
  };
};

export type GetPayrollQreSummaryQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  filter?: InputMaybe<PayrollQreSummaryFilter>;
}>;

export type GetPayrollQreSummaryQuery = {
  __typename?: 'Query';
  getPayrollQreSummary: {
    __typename?: 'PayrollQreSummary';
    avg?: { __typename?: 'PayrollQreAvgAggregate'; qreRdPercentage?: number | null } | null;
    count?: { __typename?: 'PayrollQreCountAggregate'; name?: number | null } | null;
    sum?: {
      __typename?: 'PayrollQreSumAggregate';
      amountCents?: number | null;
      qualifiedAmountCents?: number | null;
    } | null;
    uniqueCount?: {
      __typename?: 'PayrollQreUniqueCountAggregate';
      costCenter: number;
      country: number;
      department: number;
      entity: number;
      managerName: number;
      rdCategory: number;
      state: number;
      title: number;
    } | null;
  };
};

export type GetSredPayrollExpensesQueryVariables = Exact<{
  sredTaxCreditId: Scalars['ID']['input'];
  sorting?: InputMaybe<Array<SredPayrollExpenseSort> | SredPayrollExpenseSort>;
  filter?: InputMaybe<SredPayrollExpenseFilter>;
  paging?: InputMaybe<CursorPaging>;
}>;

export type GetSredPayrollExpensesQuery = {
  __typename?: 'Query';
  getSredPayrollExpenses: {
    __typename?: 'SredPayrollExpenseConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
      endCursor?: any | null;
    };
    edges: Array<{
      __typename?: 'SredPayrollExpenseEdge';
      cursor: any;
      node: {
        __typename?: 'SredPayrollExpense';
        id: string;
        name: string;
        title?: string | null;
        department?: string | null;
        managerName?: string | null;
        hireDate?: string | null;
        terminationDate?: string | null;
        costCenter?: string | null;
        entity?: string | null;
        wageType?: CaWageType | null;
        province?: string | null;
        sredEmployeeType?: SredEmployeeType | null;
        qualifiedAmountCents?: number | null;
        amountCents?: number | null;
        sredEligiblePercentage: number;
        payrollProvider?: PayrollProvider | null;
        ticketingProviders: Array<TicketingProvider>;
        sredCategory: SredCategory;
        sredContributorId: string;
        sredPayrollExpenseId?: string | null;
        sredTaxCreditId: string;
      };
    }>;
  };
};

export type GetSredPayrollExpensesSummaryQueryVariables = Exact<{
  sredTaxCreditId: Scalars['ID']['input'];
  filter?: InputMaybe<SredPayrollExpensesSummaryFilter>;
}>;

export type GetSredPayrollExpensesSummaryQuery = {
  __typename?: 'Query';
  getSredPayrollExpensesSummary: {
    __typename?: 'SredPayrollExpensesSummary';
    avg?: { __typename?: 'SredPayrollExpenseAvgAggregate'; sredEligiblePercentage?: number | null } | null;
    count?: { __typename?: 'SredPayrollExpenseCountAggregate'; name?: number | null } | null;
    sum?: {
      __typename?: 'SredPayrollExpenseSumAggregate';
      amountCents?: number | null;
      qualifiedAmountCents?: number | null;
    } | null;
    uniqueCount?: {
      __typename?: 'SredPayrollExpenseUniqueCountAggregate';
      costCenter: number;
      department: number;
      entity: number;
      managerName: number;
      province: number;
      sredCategory: number;
      title: number;
    } | null;
  };
};

export type GetAccountingQreSummaryQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  filter?: InputMaybe<AccountingQreSummaryFilter>;
}>;

export type GetAccountingQreSummaryQuery = {
  __typename?: 'Query';
  getAccountingQreSummary: {
    __typename?: 'AccountingQreSummary';
    avg?: { __typename?: 'AccountingQreAvgAggregate'; qreRdPercentage?: number | null } | null;
    count?: { __typename?: 'AccountingQreCountAggregate'; name?: number | null } | null;
    sum?: {
      __typename?: 'AccountingQreSumAggregate';
      amountCents?: number | null;
      qualifiedAmountCents?: number | null;
    } | null;
    uniqueCount?: {
      __typename?: 'AccountingQreUniqueCountAggregate';
      account: number;
      costCenter: number;
      country: number;
      department: number;
      entity: number;
      rdCategory: number;
      state: number;
    } | null;
  };
};

export type GetAscWageSummaryQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  filter?: InputMaybe<AscWageSummaryFilter>;
}>;

export type GetAscWageSummaryQuery = {
  __typename?: 'Query';
  getAscWageSummary: {
    __typename?: 'AscWageSummary';
    avg?: { __typename?: 'AscWageAvgAggregate'; allocationPercent?: number | null } | null;
    count?: { __typename?: 'AscWageCountAggregate'; name?: number | null } | null;
    sum?: {
      __typename?: 'AscWageSumAggregate';
      capitalizedTotalCompensationCents?: number | null;
      salaryCompensationCents?: number | null;
      stockCompensationCents?: number | null;
      totalCompensationCents?: number | null;
    } | null;
  };
};

export type GetAscProjectsSummaryQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  filter?: InputMaybe<AscProjectsSummaryFilter>;
}>;

export type GetAscProjectsSummaryQuery = {
  __typename?: 'Query';
  getAscProjectsSummary: {
    __typename?: 'AscProjectsSummary';
    count?: { __typename?: 'AscProjectCountAggregate'; name?: number | null } | null;
  };
};

export type GetBackgroundOperationsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetBackgroundOperationsQuery = {
  __typename?: 'Query';
  getBackgroundOperations: Array<{
    __typename?: 'BackgroundOperation';
    id: string;
    createdAt: string;
    name: BackgroundOperationName;
    progressPercent: number;
  }>;
};

export type UpdateShortYearPeriodMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  shortYearPeriod: MonthYearPeriodInput;
}>;

export type UpdateShortYearPeriodMutation = {
  __typename?: 'Mutation';
  updateShortYearPeriod: {
    __typename?: 'Company';
    id: string;
    priorYearRevenues: Array<{
      __typename?: 'PriorYearRevenue';
      id: string;
      revenueCents?: number | null;
      year: number;
      taxYearStartDate: string;
      taxYearEndDate: string;
      revenueSource: RevenueSource;
    }>;
    priorYearQREs?: Array<{
      __typename?: 'PriorYearQRE';
      year: number;
      amount?: number | null;
      taxYearStartDate: string;
      taxYearEndDate: string;
    }> | null;
  };
};

export type UpdatePriorYearQreMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  taxYearStartDate: Scalars['String']['input'];
  amountCents: Scalars['BigInt']['input'];
}>;

export type UpdatePriorYearQreMutation = {
  __typename?: 'Mutation';
  updatePriorYearQre: {
    __typename?: 'Company';
    id: string;
    priorYearQREs?: Array<{
      __typename?: 'PriorYearQRE';
      year: number;
      amount?: number | null;
      taxYearStartDate: string;
      taxYearEndDate: string;
    }> | null;
  };
};

export type UpdatePriorYearRevenueMutationVariables = Exact<{
  priorYearRevenueId: Scalars['ID']['input'];
  revenueCents: Scalars['BigInt']['input'];
}>;

export type UpdatePriorYearRevenueMutation = {
  __typename?: 'Mutation';
  updatePriorYearRevenue: {
    __typename?: 'PriorYearRevenue';
    id: string;
    revenueCents?: number | null;
    year: number;
    taxYearStartDate: string;
    taxYearEndDate: string;
    revenueSource: RevenueSource;
  };
};

export type GetProductsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetProductsQuery = {
  __typename?: 'Query';
  getProducts: Array<{ __typename?: 'Product'; id: string; name: string }>;
};

export type CreateProductMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  createProductInput: CreateProductInput;
}>;

export type CreateProductMutation = {
  __typename?: 'Mutation';
  createProduct: { __typename?: 'Product'; id: string; name: string };
};

export type UpdateProductMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  updateProductInput: UpdateProductInput;
}>;

export type UpdateProductMutation = {
  __typename?: 'Mutation';
  updateProduct: { __typename?: 'Product'; id: string; name: string };
};

export type DeleteProductMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;

export type DeleteProductMutation = { __typename?: 'Mutation'; deleteProduct: { __typename?: 'Product'; id: string } };

export type GetFinchSessionQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  provider: Scalars['String']['input'];
}>;

export type GetFinchSessionQuery = {
  __typename?: 'Query';
  getFinchSession: { __typename?: 'FinchSession'; sessionId: string };
};

export type GetCompanyOfficerPayrollQresQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
}>;

export type GetCompanyOfficerPayrollQresQuery = {
  __typename?: 'Query';
  getCompanyOfficerPayrollQres: Array<{
    __typename?: 'PayrollQre';
    id: string;
    name: string;
    email?: string | null;
    title?: string | null;
    department?: string | null;
    managerName?: string | null;
    hireDate?: string | null;
    terminationDate?: string | null;
    costCenter?: string | null;
    entity?: string | null;
    qualifiedAmountCents?: number | null;
    amountCents?: number | null;
    qreRdPercentage: number;
    payrollProvider?: PayrollProvider | null;
    ticketingProviders: Array<TicketingProvider>;
    state?: string | null;
    country?: string | null;
    rdCategory: RdCategory;
    rdTaxCreditContributorId: string;
    payrollExpenseId?: string | null;
    isOfficer: boolean;
  }>;
};

export type SearchForPotentialCompanyOfficersQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  searchTerm: Scalars['String']['input'];
}>;

export type SearchForPotentialCompanyOfficersQuery = {
  __typename?: 'Query';
  searchForPotentialCompanyOfficers: Array<{
    __typename?: 'PayrollQre';
    id: string;
    name: string;
    email?: string | null;
    title?: string | null;
    department?: string | null;
    managerName?: string | null;
    hireDate?: string | null;
    terminationDate?: string | null;
    costCenter?: string | null;
    entity?: string | null;
    qualifiedAmountCents?: number | null;
    amountCents?: number | null;
    qreRdPercentage: number;
    payrollProvider?: PayrollProvider | null;
    ticketingProviders: Array<TicketingProvider>;
    state?: string | null;
    country?: string | null;
    rdCategory: RdCategory;
    rdTaxCreditContributorId: string;
    payrollExpenseId?: string | null;
    isOfficer: boolean;
  }>;
};

export type UpdateCompanyOfficerMutationVariables = Exact<{
  payrollExpenseId: Scalars['ID']['input'];
  input: UpdateCompanyOfficerInput;
}>;

export type UpdateCompanyOfficerMutation = {
  __typename?: 'Mutation';
  updateCompanyOfficer: {
    __typename?: 'PayrollQre';
    id: string;
    name: string;
    email?: string | null;
    title?: string | null;
    department?: string | null;
    managerName?: string | null;
    hireDate?: string | null;
    terminationDate?: string | null;
    costCenter?: string | null;
    entity?: string | null;
    qualifiedAmountCents?: number | null;
    amountCents?: number | null;
    qreRdPercentage: number;
    payrollProvider?: PayrollProvider | null;
    ticketingProviders: Array<TicketingProvider>;
    state?: string | null;
    country?: string | null;
    rdCategory: RdCategory;
    rdTaxCreditContributorId: string;
    payrollExpenseId?: string | null;
    isOfficer: boolean;
  };
};

export type GetUnfinishedSyncEventsInPeriodByAnalysisTypeQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  analysisType: AnalysisType;
}>;

export type GetUnfinishedSyncEventsInPeriodByAnalysisTypeQuery = {
  __typename?: 'Query';
  getUnfinishedSyncEventsInPeriodByAnalysisType?: {
    __typename?: 'MonthYearPeriod';
    startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
    endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
  } | null;
};

export type StartProcessingTicketingDataMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  ticketingTokenId: Scalars['ID']['input'];
  input: StartProcessingTicketingDataInput;
}>;

export type StartProcessingTicketingDataMutation = {
  __typename?: 'Mutation';
  startProcessingTicketingData: {
    __typename?: 'Company';
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
  };
};

export type GetOneSchemaJwtMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type GetOneSchemaJwtMutation = { __typename?: 'Mutation'; getOneSchemaJwt: string };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: { __typename?: 'User'; id: string; fullName: string; email: string; phone?: string | null };
};

export type GetTimesheetFileSignedUploadUrlMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  effortUnit: TimesheetEffortUnit;
  name: Scalars['String']['input'];
}>;

export type GetTimesheetFileSignedUploadUrlMutation = {
  __typename?: 'Mutation';
  getTimesheetFileSignedUploadUrl: { __typename?: 'UploadUrl'; signedUrl: string; permanentUrl: string };
};

export type AddTimesheetFileMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  addTimesheetFileInput: AddTimesheetFileInput;
}>;

export type AddTimesheetFileMutation = {
  __typename?: 'Mutation';
  addTimesheetFile: {
    __typename?: 'Company';
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
  };
};

export type GetAscCostSignedUploadUrlMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
}>;

export type GetAscCostSignedUploadUrlMutation = {
  __typename?: 'Mutation';
  getAscCostSignedUploadUrl: { __typename?: 'UploadUrl'; signedUrl: string; permanentUrl: string };
};

export type GetRdPayrollCostSignedUploadUrlMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
}>;

export type GetRdPayrollCostSignedUploadUrlMutation = {
  __typename?: 'Mutation';
  getRdPayrollCostSignedUploadUrl: { __typename?: 'UploadUrl'; signedUrl: string; permanentUrl: string };
};

export type AddRdPayrollCostFileMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  addRdPayrollCostFileInput: AddRdPayrollCostFileInput;
}>;

export type AddRdPayrollCostFileMutation = {
  __typename?: 'Mutation';
  addRdPayrollCostFile: {
    __typename?: 'Company';
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
  };
};

export type AddAscCostFileMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  addAscCostFileInput: AddAscCostFileInput;
}>;

export type AddAscCostFileMutation = {
  __typename?: 'Mutation';
  addAscCostFile: {
    __typename?: 'Company';
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
  };
};

export type GetAscProjectsFileSignedUploadUrlMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
}>;

export type GetAscProjectsFileSignedUploadUrlMutation = {
  __typename?: 'Mutation';
  getAscProjectsFileSignedUploadUrl: { __typename?: 'UploadUrl'; signedUrl: string; permanentUrl: string };
};

export type AddAscProjectsFileMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  input: AddAscProjectsFileInput;
}>;

export type AddAscProjectsFileMutation = {
  __typename?: 'Mutation';
  addAscProjectsFile: {
    __typename?: 'Company';
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
  };
};

export type GetRdProjectsFileSignedUploadUrlMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
}>;

export type GetRdProjectsFileSignedUploadUrlMutation = {
  __typename?: 'Mutation';
  getRdProjectsFileSignedUploadUrl: { __typename?: 'UploadUrl'; signedUrl: string; permanentUrl: string };
};

export type AddRdProjectsFileMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  input: AddRdProjectsFileInput;
}>;

export type AddRdProjectsFileMutation = {
  __typename?: 'Mutation';
  addRdProjectsFile: {
    __typename?: 'Company';
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
  };
};

export type GetGithubEmailMappingSignedUploadUrlMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetGithubEmailMappingSignedUploadUrlMutation = {
  __typename?: 'Mutation';
  getGithubEmailMappingSignedUploadUrl: { __typename?: 'UploadUrl'; signedUrl: string; permanentUrl: string };
};

export type AddGithubEmailMappingFileMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  input: AddGithubEmailMappingFileInput;
}>;

export type AddGithubEmailMappingFileMutation = {
  __typename?: 'Mutation';
  addGithubEmailMappingFile: {
    __typename?: 'Company';
    id: string;
    legalName: string;
    shortName: string;
    companyCreationType: CompanyCreationType;
    organizationId: string;
    isPiiRedacted: boolean;
    ascLockedUntilMonthYear?: string | null;
    lastCompletedAscSyncPeriodEnd?: string | null;
    syncConfigurationAsc?: {
      __typename?: 'AscSyncConfiguration';
      id: string;
      clusteringMethod: ClusteringMethod;
    } | null;
    businessQuestions: {
      __typename?: 'BusinessQuestions';
      fiscalYearEndMonth?: number | null;
      gustoCompanyId?: string | null;
    };
  };
};

export type GetAscProjectGroupingTicketsOrCollectionsQueryVariables = Exact<{
  ascProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAscProjectGroupingTicketsOrCollectionsQuery = {
  __typename?: 'Query';
  getAscProjectGroupingTicketsOrCollections: Array<{
    __typename?: 'AscGroupingTicketOrCollection';
    id: string;
    identifier?: string | null;
    name: string;
    kind: TicketGroupingKind;
    ticketType?: string | null;
    count: number;
    ascProjectId: string;
    fiscalYearId: string;
    periodName: PeriodName;
    matchingReasoning?: string | null;
    isMatchedInLatestSync: boolean;
  }>;
};

export type GetRdProjectGroupingTicketsOrCollectionsQueryVariables = Exact<{
  rdProjectId: Scalars['ID']['input'];
  fiscalYearId: Scalars['ID']['input'];
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetRdProjectGroupingTicketsOrCollectionsQuery = {
  __typename?: 'Query';
  getRdProjectGroupingTicketsOrCollections: Array<{
    __typename?: 'RdGroupingTicketOrCollection';
    id: string;
    identifier: string;
    name: string;
    kind: TicketGroupingKind;
    ticketType?: string | null;
    count: number;
    rdProjectId: string;
    fiscalYearId: string;
  }>;
};

export type GetMergedRdProjectIdQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  backgroundOperationId: Scalars['ID']['input'];
}>;

export type GetMergedRdProjectIdQuery = { __typename?: 'Query'; getMergedRdProjectId?: string | null };

export type GetAscSnapshotDocumentEventsQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
}>;

export type GetAscSnapshotDocumentEventsQuery = {
  __typename?: 'Query';
  getAscSnapshotDocumentEvents: Array<{
    __typename?: 'DocumentEvent';
    id: string;
    documentType: DocumentType;
    eventType: DocumentEventType;
    fiscalYearId: string;
    periodName: PeriodName;
    period: {
      __typename?: 'MonthYearPeriod';
      startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
    };
  }>;
};

export type GetLatestAscReportDocumentEventQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
}>;

export type GetLatestAscReportDocumentEventQuery = {
  __typename?: 'Query';
  getLatestAscReportDocumentEvent?: {
    __typename?: 'DocumentEvent';
    createdAt: string;
    id: string;
    documentType: DocumentType;
    eventType: DocumentEventType;
    fiscalYearId: string;
    periodName: PeriodName;
    period: {
      __typename?: 'MonthYearPeriod';
      startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
    };
  } | null;
};

export type GetDocumentEventSignedUrlQueryVariables = Exact<{
  documentEventId: Scalars['ID']['input'];
}>;

export type GetDocumentEventSignedUrlQuery = { __typename?: 'Query'; getDocumentEventSignedUrl: string };

export type ApplyWeightedCapitalizedPercentageToContributorsMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  periodName: PeriodName;
  input: ApplyWeightedCapitalizedPercentageToContributorInput;
}>;

export type ApplyWeightedCapitalizedPercentageToContributorsMutation = {
  __typename?: 'Mutation';
  applyWeightedCapitalizedPercentageToContributors: {
    __typename?: 'ApplyWeightedCapitalizedPercentageToContributorsResult';
    success: boolean;
  };
};

export type GetRdTaxCreditContributorQueryVariables = Exact<{
  rdTaxCreditContributorId: Scalars['ID']['input'];
}>;

export type GetRdTaxCreditContributorQuery = {
  __typename?: 'Query';
  getRdTaxCreditContributor: {
    __typename?: 'RdTaxCreditContributor';
    id: string;
    canonicalName: string;
    canonicalEmail?: string | null;
    rdTaxCreditId: string;
    ticketingProviderUsers: Array<{
      __typename?: 'TicketingProviderUser';
      id: string;
      fullName?: string | null;
      ticketingProvider: TicketingProvider;
    }>;
  };
};

export type LinkTicketingProviderUserToRdTaxCreditContributorMutationVariables = Exact<{
  rdTaxCreditContributorId: Scalars['ID']['input'];
  ticketingProviderUserId: Scalars['ID']['input'];
}>;

export type LinkTicketingProviderUserToRdTaxCreditContributorMutation = {
  __typename?: 'Mutation';
  linkTicketingProviderUserToPayrollExpense: {
    __typename?: 'RdTaxCreditContributor';
    id: string;
    canonicalName: string;
    canonicalEmail?: string | null;
    rdTaxCreditId: string;
    ticketingProviderUsers: Array<{
      __typename?: 'TicketingProviderUser';
      id: string;
      fullName?: string | null;
      ticketingProvider: TicketingProvider;
    }>;
  };
};

export type UnlinkTicketingProviderUserFromRdTaxCreditContributorMutationVariables = Exact<{
  rdTaxCreditContributorId: Scalars['ID']['input'];
  ticketingProviderUserId: Scalars['ID']['input'];
}>;

export type UnlinkTicketingProviderUserFromRdTaxCreditContributorMutation = {
  __typename?: 'Mutation';
  unlinkTicketingProviderUserFromRdTaxCreditContributor: {
    __typename?: 'RdTaxCreditContributor';
    id: string;
    canonicalName: string;
    canonicalEmail?: string | null;
    rdTaxCreditId: string;
    ticketingProviderUsers: Array<{
      __typename?: 'TicketingProviderUser';
      id: string;
      fullName?: string | null;
      ticketingProvider: TicketingProvider;
    }>;
  };
};

export type GetSupervisorRdAnalysisPreviewQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  expenseIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter?: InputMaybe<PayrollQreFilter>;
}>;

export type GetSupervisorRdAnalysisPreviewQuery = {
  __typename?: 'Query';
  getSupervisorRdAnalysisPreview: { __typename?: 'Report'; columnNames: Array<string>; resultCsv: string };
};

export type GetSupervisorsInExpensesQueryVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  expenseIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type GetSupervisorsInExpensesQuery = {
  __typename?: 'Query';
  getSupervisorsInExpenses: {
    __typename?: 'SupervisorIdentificationResult';
    supervisorIds: Array<string>;
    supervisorCount: number;
    nonSupervisorIds: Array<string>;
  };
};

export type ApplySupervisorRdPercentageMutationVariables = Exact<{
  fiscalYearId: Scalars['ID']['input'];
  expenseIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PayrollQreFilter>;
}>;

export type ApplySupervisorRdPercentageMutation = {
  __typename?: 'Mutation';
  applySupervisorRdPercentage: {
    __typename?: 'BackgroundOperation';
    id: string;
    createdAt: string;
    name: BackgroundOperationName;
    progressPercent: number;
  };
};

export type GetSingleTenantRedirectUrlQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type GetSingleTenantRedirectUrlQuery = { __typename?: 'Query'; getSingleTenantRedirectUrl?: string | null };

export type AccountingExpenseFragment = {
  __typename?: 'AccountingExpense';
  id: string;
  displayName: string;
  amountCents: number;
  createdAt: string;
};

export type AccountingQreFragment = {
  __typename?: 'AccountingQre';
  id: string;
  name: string;
  qualifiedAmountCents?: number | null;
  amountCents?: number | null;
  qreRdPercentage: number;
  accountingProvider?: AccountingProvider | null;
  state?: string | null;
  country?: string | null;
  account?: string | null;
  department?: string | null;
  costCenter?: string | null;
  entity?: string | null;
  rdCategory: RdCategory;
  fiscalYearId: string;
  accountingExpenseId: string;
};

export type ApplyWeightedCapitalizedPercentToContributorsResultFragment = {
  __typename?: 'ApplyWeightedCapitalizedPercentageToContributorsResult';
  success: boolean;
};

export type ApplyWeightedRdPercentageToExpensesResultFragment = {
  __typename?: 'ApplyWeightedRdPercentageToExpensesResult';
  success: boolean;
};

export type AscContributorProjectAllocationFragment = {
  __typename?: 'AscContributorProjectAllocation';
  id: string;
  ascProjectId: string;
  contributorId: string;
  allocationPercentAvg: number;
  ascProjectName: string;
  capitalizationStatus: CapitalizationStatus;
  capitalizationStartDate?: string | null;
  capitalizationEndDate?: string | null;
  clusterType: AscClusterType;
};

export type AscGroupingTicketOrCollectionFragment = {
  __typename?: 'AscGroupingTicketOrCollection';
  id: string;
  identifier?: string | null;
  name: string;
  kind: TicketGroupingKind;
  ticketType?: string | null;
  count: number;
  ascProjectId: string;
  fiscalYearId: string;
  periodName: PeriodName;
  matchingReasoning?: string | null;
  isMatchedInLatestSync: boolean;
};

export type AscPeriodLockStatusFragment = {
  __typename?: 'AscPeriodLockStatus';
  fiscalYearId: string;
  periodName: PeriodName;
  isLocked: boolean;
  monthLockStates: Array<{ __typename?: 'AscMonthLockState'; monthYear: string; isLocked: boolean }>;
};

export type AscProjectFragment = {
  __typename?: 'AscProject';
  id: string;
  name: string;
  description?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  capitalizationStartDate?: string | null;
  capitalizationEndDate?: string | null;
  capitalizationEndDateExtendedFrom?: string | null;
  capitalizationStatus: CapitalizationStatus;
  predictedCapitalizationStatus?: PredictedCapitalizationStatus | null;
  predictedCapitalizationStatusReason?: string | null;
  predictedCapitalizationStartDate?: string | null;
  predictedCapitalizationEndDate?: string | null;
  predictedCapitalizationEndDateReason?: string | null;
  capitalizableProjectClusteringOverride?: CapitalizableProjectClusteringOverride | null;
  customFieldTeams?: Array<string> | null;
  customFieldLaunchDate?: string | null;
  workstreamNames: Array<string>;
  ticketCount: number;
  projectOwnerId?: string | null;
  clusterType: AscClusterType;
  isDeterministic: boolean;
  projectOwner?: { __typename?: 'AscProjectOwner'; id: string; fullName: string } | null;
  product?: { __typename?: 'Product'; id: string; name: string } | null;
};

export type AscProjectApprovedStatusFragment = {
  __typename?: 'AscProjectApprovalStatusResult';
  ascProjectId: string;
  fiscalYearId: string;
  periodName: PeriodName;
  status: AscProjectApprovalStatus;
  periodApprovalByUserId?: string | null;
  periodApprovalDatetime?: string | null;
  periodApprovalComment?: string | null;
  approvedThroughMonthYear?: string | null;
};

export type AscProjectTeamMemberFragment = {
  __typename?: 'AscProjectTeamMember';
  contributorId: string;
  contributorName?: string | null;
  contributorEmail?: string | null;
  allocationPercent: number;
  periodName: PeriodName;
  ascProjectId?: string | null;
  fiscalYearId: string;
};

export type AscProjectTpTicketsViewFragment = {
  __typename?: 'AscProjectTpTicketsView';
  id: string;
  ascProjectId: string;
  contributorId: string;
  contributorName: string;
  identifier: string;
  ticketUrl?: string | null;
  name: string;
  completedDatetime?: string | null;
  predictedEffortDays: number;
  groupingTicketingProviderTicketId?: string | null;
  groupingTicketingProviderCollectionId?: string | null;
  matchingConfidence?: AscMatchingConfidence | null;
  matchingReasoning?: string | null;
  matchingMethod?: AscMatchMethod | null;
};

export type AscWageFragment = {
  __typename?: 'AscWage';
  id: string;
  name?: string | null;
  titles?: string | null;
  departments?: string | null;
  managerNames?: string | null;
  hireDates?: string | null;
  terminationDates?: string | null;
  costCenters?: string | null;
  entities?: string | null;
  totalCompensationCents?: number | null;
  salaryCompensationCents?: number | null;
  stockCompensationCents?: number | null;
  capitalizedTotalCompensationCents?: number | null;
  allocationPercent: number;
  countries?: string | null;
  contributorId: string;
  hasCompleteDataInPeriod: boolean;
  fiscalYearId: string;
  periodName: PeriodName;
};

export type BulkTicketingDataFileUploadFragment = {
  __typename?: 'BulkTicketingDataFileUpload';
  id: string;
  createdAt: string;
  fileName: string;
  signedUrl: string;
  ticketingProvider: FileUploadTicketingProvider;
  ticketingEntityType: TicketingEntityType;
  isValid?: boolean | null;
};

export type BusinessQuestionsFragment = {
  __typename?: 'BusinessQuestions';
  fiscalYearEndMonth?: number | null;
  gustoCompanyId?: string | null;
};

export type CompanyFragment = {
  __typename?: 'Company';
  id: string;
  legalName: string;
  shortName: string;
  companyCreationType: CompanyCreationType;
  organizationId: string;
  isPiiRedacted: boolean;
  ascLockedUntilMonthYear?: string | null;
  lastCompletedAscSyncPeriodEnd?: string | null;
  syncConfigurationAsc?: { __typename?: 'AscSyncConfiguration'; id: string; clusteringMethod: ClusteringMethod } | null;
  businessQuestions: {
    __typename?: 'BusinessQuestions';
    fiscalYearEndMonth?: number | null;
    gustoCompanyId?: string | null;
  };
};

export type CompanyInvitationFragment = {
  __typename?: 'CompanyInvitation';
  id: string;
  email: string;
  scope: CompanyScope;
  acceptedAt?: string | null;
  companyId: string;
};

export type ContributorFragment = { __typename?: 'Contributor'; id: string; name?: string | null };

export type CursorPageInfoFragment = {
  __typename?: 'PageInfo';
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
  startCursor?: any | null;
  endCursor?: any | null;
};

export type DocumentEventFragment = {
  __typename?: 'DocumentEvent';
  id: string;
  documentType: DocumentType;
  eventType: DocumentEventType;
  fiscalYearId: string;
  periodName: PeriodName;
  period: {
    __typename?: 'MonthYearPeriod';
    startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
    endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
  };
};

export type FederalRdTaxCreditDocumentsFragment = {
  __typename?: 'FederalRdTaxCreditDocuments';
  id: string;
  filingMethod: FilingMethod;
  isReducedCredit: boolean;
  taxCreditFormFileName?: string | null;
  taxCreditFormUrl?: string | null;
  taxCreditFormStatus: DocumentStatus;
  taxCreditFormMissingInformation?: Array<string> | null;
  taxCreditFormGeneratedDate?: string | null;
  taxWriteUpPdfFileName?: string | null;
  taxWriteUpPdfUrl?: string | null;
  taxWriteUpStatus: DocumentStatus;
  taxWriteUpMissingInformation?: Array<string> | null;
  taxWriteUpGeneratedDate?: string | null;
};

export type FileUploadFragment = {
  __typename?: 'FileUpload';
  id: string;
  createdAt: string;
  fileName: string;
  signedUrl: string;
  isValid?: boolean | null;
  payrollMonthExpenseSyncEventId?: string | null;
  payrollProviderSyncEventId?: string | null;
  period?: {
    __typename?: 'MonthYearPeriod';
    startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
    endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
  } | null;
};

export type FiscalYearFragment = {
  __typename?: 'FiscalYear';
  id: string;
  year: number;
  taxYearStartDate: string;
  taxYearEndDate: string;
  productType: ProductType;
  enabledDatetime?: string | null;
};

export type FourPartTestFragment = {
  __typename?: 'FourPartTest';
  id: string;
  industries: Array<string>;
  tools?: Array<string> | null;
  researchActivities?: Array<string> | null;
};

export type GetAccountingExpenseFragment = {
  __typename?: 'AccountingExpense';
  id: string;
  displayName: string;
  amountCents: number;
  createdAt: string;
  accountingQre: {
    __typename?: 'AccountingQre';
    id: string;
    name: string;
    qualifiedAmountCents?: number | null;
    amountCents?: number | null;
    qreRdPercentage: number;
    accountingProvider?: AccountingProvider | null;
    state?: string | null;
    country?: string | null;
    account?: string | null;
    department?: string | null;
    costCenter?: string | null;
    entity?: string | null;
    rdCategory: RdCategory;
    fiscalYearId: string;
    accountingExpenseId: string;
  };
  projectPerAccountingExpense: Array<{
    __typename?: 'ProjectPerAccountingExpense';
    id: string;
    rdProjectId: string;
    allocationPercentNotRounded: number;
  }>;
};

export type GetContributorFragment = {
  __typename?: 'Contributor';
  id: string;
  name?: string | null;
  ascProjectsPerContributor: Array<{
    __typename?: 'AscProjectPerContributor';
    id: string;
    ascProject: { __typename?: 'AscProject'; id: string; name: string };
    ascProjectMonthsPerContributor: Array<{
      __typename?: 'AscProjectMonthPerContributor';
      id: string;
      month: number;
      year: number;
      allocationPercent: number;
      useAllocationPercent?: number | null;
    }>;
  }>;
};

export type GetPayrollExpenseFragment = {
  __typename?: 'PayrollExpense';
  id: string;
  amountCents?: number | null;
  payrollProvider: PayrollProvider;
  wageType?: WageType | null;
  payrollQre: {
    __typename?: 'PayrollQre';
    id: string;
    name: string;
    email?: string | null;
    title?: string | null;
    department?: string | null;
    managerName?: string | null;
    hireDate?: string | null;
    terminationDate?: string | null;
    costCenter?: string | null;
    entity?: string | null;
    qualifiedAmountCents?: number | null;
    amountCents?: number | null;
    qreRdPercentage: number;
    payrollProvider?: PayrollProvider | null;
    ticketingProviders: Array<TicketingProvider>;
    state?: string | null;
    country?: string | null;
    rdCategory: RdCategory;
    rdTaxCreditContributorId: string;
    payrollExpenseId?: string | null;
    isOfficer: boolean;
  };
};

export type GetRdExpenseFragment = {
  __typename?: 'RdExpense';
  id: string;
  rdCategory: RdCategory;
  rdCategoryConfidence: number;
  accountingQre?: {
    __typename?: 'AccountingQre';
    id: string;
    name: string;
    qualifiedAmountCents?: number | null;
    amountCents?: number | null;
    qreRdPercentage: number;
    accountingProvider?: AccountingProvider | null;
    state?: string | null;
    country?: string | null;
    account?: string | null;
    department?: string | null;
    costCenter?: string | null;
    entity?: string | null;
    rdCategory: RdCategory;
    fiscalYearId: string;
    accountingExpenseId: string;
  } | null;
  payrollQre?: {
    __typename?: 'PayrollQre';
    id: string;
    name: string;
    email?: string | null;
    title?: string | null;
    department?: string | null;
    managerName?: string | null;
    hireDate?: string | null;
    terminationDate?: string | null;
    costCenter?: string | null;
    entity?: string | null;
    qualifiedAmountCents?: number | null;
    amountCents?: number | null;
    qreRdPercentage: number;
    payrollProvider?: PayrollProvider | null;
    ticketingProviders: Array<TicketingProvider>;
    state?: string | null;
    country?: string | null;
    rdCategory: RdCategory;
    rdTaxCreditContributorId: string;
    payrollExpenseId?: string | null;
    isOfficer: boolean;
  } | null;
};

export type GetRdTaxCreditContributorFragment = {
  __typename?: 'RdTaxCreditContributor';
  id: string;
  canonicalName: string;
  canonicalEmail?: string | null;
  rdTaxCreditId: string;
  ticketingProviderUsers: Array<{
    __typename?: 'TicketingProviderUser';
    id: string;
    fullName?: string | null;
    ticketingProvider: TicketingProvider;
  }>;
};

export type MemberFragment = {
  __typename?: 'User';
  id: string;
  email: string;
  fullName: string;
  companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
};

export type OrganizationFragment = {
  __typename?: 'Organization';
  id: string;
  photoUrl?: string | null;
  name: string;
  isAccountingFirm: boolean;
  members: Array<{
    __typename?: 'User';
    id: string;
    email: string;
    fullName: string;
    organizationScope?: OrganizationScope | null;
    companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
  }>;
  invitedMembers: Array<{
    __typename?: 'OrganizationInvitation';
    id: string;
    email: string;
    scope: OrganizationScope;
    expiresAt: string;
    revokedAt?: string | null;
    acceptedAt?: string | null;
    derivedState: string;
  }>;
};

export type PayrollExpenseFragment = {
  __typename?: 'PayrollExpense';
  id: string;
  amountCents?: number | null;
  payrollProvider: PayrollProvider;
  wageType?: WageType | null;
};

export type PayrollQreFragment = {
  __typename?: 'PayrollQre';
  id: string;
  name: string;
  email?: string | null;
  title?: string | null;
  department?: string | null;
  managerName?: string | null;
  hireDate?: string | null;
  terminationDate?: string | null;
  costCenter?: string | null;
  entity?: string | null;
  qualifiedAmountCents?: number | null;
  amountCents?: number | null;
  qreRdPercentage: number;
  payrollProvider?: PayrollProvider | null;
  ticketingProviders: Array<TicketingProvider>;
  state?: string | null;
  country?: string | null;
  rdCategory: RdCategory;
  rdTaxCreditContributorId: string;
  payrollExpenseId?: string | null;
  isOfficer: boolean;
};

export type PayrollTokenFragment = {
  __typename?: 'PayrollToken';
  id: string;
  createdAt: string;
  payrollProvider: PayrollProvider;
  finchScopeType?: FinchScopeType | null;
};

export type ProductFragment = { __typename?: 'Product'; id: string; name: string };

export type AscProjectMonthPerContributorFragment = {
  __typename?: 'AscProjectMonthPerContributor';
  id: string;
  month: number;
  year: number;
  allocationPercent: number;
  useAllocationPercent?: number | null;
};

export type ProjectPerAccountingExpenseFragment = {
  __typename?: 'ProjectPerAccountingExpense';
  id: string;
  rdProjectId: string;
  allocationPercentNotRounded: number;
};

export type ProjectPerRdExpenseFragment = {
  __typename?: 'ProjectPerRdExpense';
  id: string;
  rdProjectId: string;
  allocationPercentNotRounded: number;
};

export type ProjectRdDeterminationFragment = {
  __typename?: 'ProjectRdDetermination';
  id: string;
  isTechnicalInNature: boolean;
  isTechnicalInNatureSource?: DeterminationSource | null;
  hasQualifiedPurpose: QualifiedPurposeDetermination;
  hasQualifiedPurposeSource?: DeterminationSource | null;
  qualifiedPurposeReasoning: string;
  qualifiedPurposeReasoningSource?: DeterminationSource | null;
  hasTechnicalUncertainties: boolean;
  technicalInNatureShare: number;
  projectRdDeterminationUncertainties: Array<{
    __typename?: 'ProjectRdDeterminationUncertainty';
    id: string;
    uncertainty: string;
  }>;
};

export type QuestionFragment = {
  __typename?: 'Question';
  id: string;
  questionId: string;
  questionCode: QuestionCode;
  displayText: string;
  displayOrder: number;
  displaySubtext?: string | null;
  placeholder?: string | null;
  inputType: InputType;
  answerType: AnswerType;
  answerValue?: string | null;
  questionChoices?: Array<{
    __typename?: 'QuestionChoice';
    id: string;
    choiceCode: ChoiceCode;
    displayText: string;
    displayOrder: number;
    displaySubtext?: string | null;
    selected: boolean;
  }> | null;
  parentQuestionChoice?: { __typename?: 'ParentQuestionChoice'; id: string; parentQuestionId: string } | null;
};

export type QuestionSectionFragment = {
  __typename?: 'QuestionSection';
  id: string;
  sectionCode: QuestionSectionCode;
  displayText: string;
  displaySubtext?: string | null;
  displayOrder: number;
  questions: Array<{
    __typename?: 'Question';
    id: string;
    questionId: string;
    questionCode: QuestionCode;
    displayText: string;
    displayOrder: number;
    displaySubtext?: string | null;
    placeholder?: string | null;
    inputType: InputType;
    answerType: AnswerType;
    answerValue?: string | null;
    questionChoices?: Array<{
      __typename?: 'QuestionChoice';
      id: string;
      choiceCode: ChoiceCode;
      displayText: string;
      displayOrder: number;
      displaySubtext?: string | null;
      selected: boolean;
    }> | null;
    parentQuestionChoice?: { __typename?: 'ParentQuestionChoice'; id: string; parentQuestionId: string } | null;
  }>;
};

export type RdExpenseFragment = {
  __typename?: 'RdExpense';
  id: string;
  rdCategory: RdCategory;
  rdCategoryConfidence: number;
};

export type RdExpenseProjectAllocationFragment = {
  __typename?: 'RdExpenseProjectAllocation';
  id: string;
  rdProjectId: string;
  allocationPercentNotRounded: number;
  projectName: string;
  project: {
    __typename?: 'AllocationProjectDetails';
    id: string;
    name: string;
    consideredForRd: boolean;
    isSection174Eligible: boolean;
  };
};

export type RdGroupingTicketOrCollectionFragment = {
  __typename?: 'RdGroupingTicketOrCollection';
  id: string;
  identifier: string;
  name: string;
  kind: TicketGroupingKind;
  ticketType?: string | null;
  count: number;
  rdProjectId: string;
  fiscalYearId: string;
};

export type RdProjectFragment = {
  __typename?: 'RdProject';
  id: string;
  name: string;
  description?: string | null;
  purpose?: ProjectPurpose | null;
  businessComponent?: ProjectBusinessComponent | null;
  businessPurpose?: ProjectBusinessPurpose | null;
  consideredForRd: boolean;
  isSection174Eligible: boolean;
  disallowances?: Array<ProjectDisallowance> | null;
  improvedAspects?: Array<ProjectPurposeImprovedAspect> | null;
  technicalChallenges?: string | null;
  processOfExperimentation?: string | null;
  selectedCategory: SelectedRdProjectCategory;
  rdDocumentationStatus: RdDocumentationStatus;
  projectOwnerId?: string | null;
  workstreamNames: Array<string>;
  workstreamNamesSearch?: string | null;
  ticketCount: number;
  processingState: ProcessingProjectState;
  clusterType: RdClusterType;
  approvalTime?: string | null;
  approvalComment?: string | null;
  aiGuidance?: string | null;
  isTechnicallyUncertain?: boolean | null;
  isCustomerFacingDevelopment?: boolean | null;
  isInnovativeAndRisky?: boolean | null;
  projectOwner?: { __typename?: 'RdProjectOwner'; id: string; fullName: string } | null;
  rdDetermination?: {
    __typename?: 'ProjectRdDetermination';
    id: string;
    isTechnicalInNature: boolean;
    isTechnicalInNatureSource?: DeterminationSource | null;
    hasQualifiedPurpose: QualifiedPurposeDetermination;
    hasQualifiedPurposeSource?: DeterminationSource | null;
    qualifiedPurposeReasoning: string;
    qualifiedPurposeReasoningSource?: DeterminationSource | null;
    hasTechnicalUncertainties: boolean;
    technicalInNatureShare: number;
    projectRdDeterminationUncertainties: Array<{
      __typename?: 'ProjectRdDeterminationUncertainty';
      id: string;
      uncertainty: string;
    }>;
  } | null;
  supportingDocuments: Array<{
    __typename?: 'FileUpload';
    id: string;
    createdAt: string;
    fileName: string;
    signedUrl: string;
    isValid?: boolean | null;
    payrollMonthExpenseSyncEventId?: string | null;
    payrollProviderSyncEventId?: string | null;
    period?: {
      __typename?: 'MonthYearPeriod';
      startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
    } | null;
  }>;
  product?: { __typename?: 'Product'; id: string; name: string } | null;
};

export type RdProjectTeamMemberFragment = {
  __typename?: 'RdProjectTeamMember';
  rdTaxCreditContributorId: string;
  contributorName?: string | null;
  contributorEmail?: string | null;
  allocationPercent: number;
  rdProjectId: string;
  rdExpenseId: string;
  fiscalYearId: string;
};

export type RdProjectTpTicketsViewFragment = {
  __typename?: 'RdProjectTpTicketsView';
  id: string;
  rdProjectId: string;
  rdTaxCreditContributorId: string;
  contributorName: string;
  identifier: string;
  ticketUrl?: string | null;
  name: string;
  description?: string | null;
  completedDatetime?: string | null;
  collectionName?: string | null;
  predictedEffortDays: number;
  groupingTicketingProviderTicketId?: string | null;
  groupingTicketingProviderCollectionId?: string | null;
};

export type RdTaxCreditContributorFragment = {
  __typename?: 'RdTaxCreditContributor';
  id: string;
  canonicalName: string;
  canonicalEmail?: string | null;
  rdTaxCreditId: string;
};

export type RdTaxQuestionsFragment = {
  __typename?: 'RDTaxQuestions';
  fiscalYearEndsInDec?: boolean | null;
  monthAndDayOfTaxYearEnd?: string | null;
  furthestVisitedExpense?: ExpenseCategory | null;
  hasAnAccountant?: boolean | null;
  hasClaimedErc?: boolean | null;
  hasFiledTaxReturn?: boolean | null;
  hasFiledExtension?: boolean | null;
  hasFundedResearch?: boolean | null;
  hasMadeFiveMillion?: boolean | null;
  hasPayrollEin?: boolean | null;
  hasTaxableIncome?: boolean | null;
  hasTaxableIncomeAfterDeduction?: boolean | null;
  hasW2Employees?: boolean | null;
  haveBooksFinalized?: boolean | null;
  howIsYourBusinessEntityTaxed?: string | null;
  isProfitable?: boolean | null;
  payrollEin?: string | null;
  payrollProviders?: Array<string> | null;
  receivedFundingTypes?: Array<string> | null;
};

export type SredPayrollExpenseFragment = {
  __typename?: 'SredPayrollExpense';
  id: string;
  name: string;
  title?: string | null;
  department?: string | null;
  managerName?: string | null;
  hireDate?: string | null;
  terminationDate?: string | null;
  costCenter?: string | null;
  entity?: string | null;
  wageType?: CaWageType | null;
  province?: string | null;
  sredEmployeeType?: SredEmployeeType | null;
  qualifiedAmountCents?: number | null;
  amountCents?: number | null;
  sredEligiblePercentage: number;
  payrollProvider?: PayrollProvider | null;
  ticketingProviders: Array<TicketingProvider>;
  sredCategory: SredCategory;
  sredContributorId: string;
  sredPayrollExpenseId?: string | null;
  sredTaxCreditId: string;
};

export type SredProjectFragment = {
  __typename?: 'SredProject';
  id: string;
  name: string;
  description?: string | null;
  consideredForSred: boolean;
  selectedCategory: SelectedSredProjectCategory;
  sredDocumentationStatus: SredDocumentationStatus;
  projectOwnerId?: string | null;
  workstreamNames: Array<string>;
  workstreamNamesSearch?: string | null;
  ticketCount: number;
  processingState: SredProcessingState;
  clusterType: SredClusterType;
  approvalTime?: any | null;
  approvalComment?: string | null;
  aiGuidance?: string | null;
  appliedResearch?: boolean | null;
  basicResearch?: boolean | null;
  experimentalDevelopment?: boolean | null;
  systematicInvestigation?: string | null;
  technologicalAdvancement?: string | null;
  technologicalUncertainty?: string | null;
  supportingWork?: string | null;
  provincialEligibility?: Array<Province> | null;
  workInCanadaPercentage?: number | null;
  sredEligibleDate?: string | null;
  productName?: string | null;
  projectOwnerName?: string | null;
  projectOwner?: { __typename?: 'SredProjectOwner'; id: string; fullName: string } | null;
  supportingDocuments: Array<{
    __typename?: 'FileUpload';
    id: string;
    createdAt: string;
    fileName: string;
    signedUrl: string;
    isValid?: boolean | null;
    payrollMonthExpenseSyncEventId?: string | null;
    payrollProviderSyncEventId?: string | null;
    period?: {
      __typename?: 'MonthYearPeriod';
      startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
    } | null;
  }>;
  product?: { __typename?: 'Product'; id: string; name: string } | null;
};

export type StateRdTaxCreditDocumentFragment = {
  __typename?: 'StateRdTaxCreditDocument';
  id: string;
  state: State;
  stateTaxCreditFormFileName?: string | null;
  stateTaxCreditFormUrl?: string | null;
  allowAccessDatetime?: string | null;
};

export type SyncedPayrollMonthExpenseFragment = {
  __typename?: 'SyncedPayrollMonthExpense';
  id: string;
  originalSyncDate: string;
  period: {
    __typename?: 'MonthYearPeriod';
    startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
    endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
  };
  fileUpload?: {
    __typename?: 'FileUpload';
    id: string;
    createdAt: string;
    fileName: string;
    signedUrl: string;
    isValid?: boolean | null;
    payrollMonthExpenseSyncEventId?: string | null;
    payrollProviderSyncEventId?: string | null;
    period?: {
      __typename?: 'MonthYearPeriod';
      startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
    } | null;
  } | null;
};

export type SyncedProvidersFragment = {
  __typename?: 'SyncedProviders';
  id: string;
  accountingProviders: Array<{
    __typename?: 'SyncedAccountingProviders';
    id: string;
    providerName: AccountingProvider;
    originalSyncDate: string;
  }>;
  payrollProviders: Array<{
    __typename?: 'SyncedPayrollProviders';
    id: string;
    providerName: PayrollProvider;
    originalSyncDate: string;
  }>;
  ticketingProviders: Array<{
    __typename?: 'SyncedTicketingProviders';
    id: string;
    providerName: TicketingProvider;
    originalSyncDate: string;
  }>;
};

export type SyncedRdPayrollCostFragment = {
  __typename?: 'SyncedRdPayrollCost';
  id: string;
  originalSyncDate: string;
  provider: PayrollProvider;
  fileUpload: {
    __typename?: 'FileUpload';
    id: string;
    createdAt: string;
    fileName: string;
    signedUrl: string;
    isValid?: boolean | null;
    payrollMonthExpenseSyncEventId?: string | null;
    payrollProviderSyncEventId?: string | null;
    period?: {
      __typename?: 'MonthYearPeriod';
      startMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
      endMonthYear: { __typename?: 'MonthYear'; month: number; year: number };
    } | null;
  };
};

export type TicketingProviderSyncEventFragment = {
  __typename?: 'TicketingProviderSyncEvent';
  id: string;
  createdAt: string;
  provider: TicketingProvider;
  acquisitionMethod: TicketingAcquisitionMethod;
  firstDateOfPeriod: string;
  lastDateOfPeriod: string;
  ascPartitionClusterConfigurationsConfirmedDatetime?: string | null;
  rdPartitionClusterConfigurationsConfirmedDatetime?: string | null;
};

export type TicketingProviderUserFragment = {
  __typename?: 'TicketingProviderUser';
  id: string;
  fullName?: string | null;
  ticketingProvider: TicketingProvider;
};

export type TicketingUserFragment = {
  __typename?: 'TicketingUser';
  id: string;
  name?: string | null;
  email?: string | null;
  provider: TicketingProvider;
  contributorId: string;
};

export type UserFragment = {
  __typename?: 'User';
  id: string;
  fullName: string;
  email: string;
  phone?: string | null;
  firebaseUserId: string;
  allowRealCompanyDatetime?: string | null;
  organizationScope?: OrganizationScope | null;
  thomsonReutersConsumerKey?: string | null;
  userAttributes: {
    __typename?: 'UserAttributes';
    viewedWelcomeMessageTaxYear?: number | null;
    isSsoOnboarding?: boolean | null;
  };
  companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
  pendingOrFailedStatusOrganizationInvitations: Array<{
    __typename?: 'OrganizationInvitation';
    id: string;
    derivedState: string;
  }>;
  companies: Array<{ __typename?: 'Company'; id: string }>;
  organization?: {
    __typename?: 'Organization';
    id: string;
    photoUrl?: string | null;
    name: string;
    isAccountingFirm: boolean;
    members: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      fullName: string;
      organizationScope?: OrganizationScope | null;
      companyScopes: Array<{ __typename?: 'CompanyScopes'; id: string; companyId: string; scope: CompanyScope }>;
    }>;
    invitedMembers: Array<{
      __typename?: 'OrganizationInvitation';
      id: string;
      email: string;
      scope: OrganizationScope;
      expiresAt: string;
      revokedAt?: string | null;
      acceptedAt?: string | null;
      derivedState: string;
    }>;
  } | null;
};

export type AccountingExpenseKeySpecifier = (
  | 'account'
  | 'accountingQre'
  | 'amountCents'
  | 'costCenter'
  | 'createdAt'
  | 'department'
  | 'displayName'
  | 'entity'
  | 'fiscalYearId'
  | 'id'
  | 'projectPerAccountingExpense'
  | AccountingExpenseKeySpecifier
)[];
export type AccountingExpenseFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountingQre?: FieldPolicy<any> | FieldReadFunction<any>;
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  projectPerAccountingExpense?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingQreKeySpecifier = (
  | 'account'
  | 'accountingExpenseId'
  | 'accountingProvider'
  | 'amountCents'
  | 'costCenter'
  | 'country'
  | 'department'
  | 'entity'
  | 'fiscalYearId'
  | 'id'
  | 'name'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | 'rdCategory'
  | 'state'
  | AccountingQreKeySpecifier
)[];
export type AccountingQreFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountingExpenseId?: FieldPolicy<any> | FieldReadFunction<any>;
  accountingProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingQreAggregateGroupByKeySpecifier = (
  | 'account'
  | 'accountingProvider'
  | 'amountCents'
  | 'costCenter'
  | 'country'
  | 'department'
  | 'entity'
  | 'id'
  | 'name'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | 'rdCategory'
  | 'state'
  | AccountingQreAggregateGroupByKeySpecifier
)[];
export type AccountingQreAggregateGroupByFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountingProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingQreAvgAggregateKeySpecifier = (
  | 'amountCents'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | AccountingQreAvgAggregateKeySpecifier
)[];
export type AccountingQreAvgAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingQreConnectionKeySpecifier = ('edges' | 'pageInfo' | AccountingQreConnectionKeySpecifier)[];
export type AccountingQreConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingQreCountAggregateKeySpecifier = (
  | 'account'
  | 'accountingProvider'
  | 'amountCents'
  | 'costCenter'
  | 'country'
  | 'department'
  | 'entity'
  | 'id'
  | 'name'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | 'rdCategory'
  | 'state'
  | AccountingQreCountAggregateKeySpecifier
)[];
export type AccountingQreCountAggregateFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountingProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingQreEdgeKeySpecifier = ('cursor' | 'node' | AccountingQreEdgeKeySpecifier)[];
export type AccountingQreEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingQreMaxAggregateKeySpecifier = (
  | 'account'
  | 'accountingProvider'
  | 'amountCents'
  | 'costCenter'
  | 'country'
  | 'department'
  | 'entity'
  | 'id'
  | 'name'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | 'rdCategory'
  | 'state'
  | AccountingQreMaxAggregateKeySpecifier
)[];
export type AccountingQreMaxAggregateFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountingProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingQreMinAggregateKeySpecifier = (
  | 'account'
  | 'accountingProvider'
  | 'amountCents'
  | 'costCenter'
  | 'country'
  | 'department'
  | 'entity'
  | 'id'
  | 'name'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | 'rdCategory'
  | 'state'
  | AccountingQreMinAggregateKeySpecifier
)[];
export type AccountingQreMinAggregateFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountingProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingQreSumAggregateKeySpecifier = (
  | 'amountCents'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | AccountingQreSumAggregateKeySpecifier
)[];
export type AccountingQreSumAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingQreSummaryKeySpecifier = (
  | 'avg'
  | 'count'
  | 'groupBy'
  | 'max'
  | 'min'
  | 'sum'
  | 'uniqueCount'
  | AccountingQreSummaryKeySpecifier
)[];
export type AccountingQreSummaryFieldPolicy = {
  avg?: FieldPolicy<any> | FieldReadFunction<any>;
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  groupBy?: FieldPolicy<any> | FieldReadFunction<any>;
  max?: FieldPolicy<any> | FieldReadFunction<any>;
  min?: FieldPolicy<any> | FieldReadFunction<any>;
  sum?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingQreUniqueCountAggregateKeySpecifier = (
  | 'account'
  | 'costCenter'
  | 'country'
  | 'department'
  | 'entity'
  | 'rdCategory'
  | 'state'
  | AccountingQreUniqueCountAggregateKeySpecifier
)[];
export type AccountingQreUniqueCountAggregateFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountingTokenKeySpecifier = (
  | 'accountingProvider'
  | 'acquisitionMethod'
  | 'createdAt'
  | 'id'
  | AccountingTokenKeySpecifier
)[];
export type AccountingTokenFieldPolicy = {
  accountingProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  acquisitionMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AllocationProjectDetailsKeySpecifier = (
  | 'consideredForRd'
  | 'id'
  | 'isSection174Eligible'
  | 'name'
  | AllocationProjectDetailsKeySpecifier
)[];
export type AllocationProjectDetailsFieldPolicy = {
  consideredForRd?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isSection174Eligible?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ApplyWeightedCapitalizedPercentageToContributorsResultKeySpecifier = (
  | 'success'
  | 'summary'
  | ApplyWeightedCapitalizedPercentageToContributorsResultKeySpecifier
)[];
export type ApplyWeightedCapitalizedPercentageToContributorsResultFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
  summary?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ApplyWeightedCapitalizedPercentageToContributorsSummaryKeySpecifier = (
  | 'contributorsProcessed'
  | 'totalRecordsAffected'
  | 'totalRecordsCreated'
  | 'totalRecordsUpdated'
  | ApplyWeightedCapitalizedPercentageToContributorsSummaryKeySpecifier
)[];
export type ApplyWeightedCapitalizedPercentageToContributorsSummaryFieldPolicy = {
  contributorsProcessed?: FieldPolicy<any> | FieldReadFunction<any>;
  totalRecordsAffected?: FieldPolicy<any> | FieldReadFunction<any>;
  totalRecordsCreated?: FieldPolicy<any> | FieldReadFunction<any>;
  totalRecordsUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ApplyWeightedRdPercentageToExpensesResultKeySpecifier = (
  | 'success'
  | ApplyWeightedRdPercentageToExpensesResultKeySpecifier
)[];
export type ApplyWeightedRdPercentageToExpensesResultFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscContributorProjectAllocationKeySpecifier = (
  | 'allocationPercentAvg'
  | 'ascProjectId'
  | 'ascProjectName'
  | 'capitalizationEndDate'
  | 'capitalizationStartDate'
  | 'capitalizationStatus'
  | 'clusterType'
  | 'companyId'
  | 'contributorId'
  | 'fiscalYearId'
  | 'id'
  | 'periodName'
  | AscContributorProjectAllocationKeySpecifier
)[];
export type AscContributorProjectAllocationFieldPolicy = {
  allocationPercentAvg?: FieldPolicy<any> | FieldReadFunction<any>;
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  ascProjectName?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  clusterType?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscContributorProjectAllocationAggregateGroupByKeySpecifier = (
  | 'ascProjectName'
  | 'id'
  | AscContributorProjectAllocationAggregateGroupByKeySpecifier
)[];
export type AscContributorProjectAllocationAggregateGroupByFieldPolicy = {
  ascProjectName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscContributorProjectAllocationConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AscContributorProjectAllocationConnectionKeySpecifier
)[];
export type AscContributorProjectAllocationConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscContributorProjectAllocationCountAggregateKeySpecifier = (
  | 'ascProjectName'
  | 'id'
  | AscContributorProjectAllocationCountAggregateKeySpecifier
)[];
export type AscContributorProjectAllocationCountAggregateFieldPolicy = {
  ascProjectName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscContributorProjectAllocationEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AscContributorProjectAllocationEdgeKeySpecifier
)[];
export type AscContributorProjectAllocationEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscContributorProjectAllocationMaxAggregateKeySpecifier = (
  | 'ascProjectName'
  | 'id'
  | AscContributorProjectAllocationMaxAggregateKeySpecifier
)[];
export type AscContributorProjectAllocationMaxAggregateFieldPolicy = {
  ascProjectName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscContributorProjectAllocationMinAggregateKeySpecifier = (
  | 'ascProjectName'
  | 'id'
  | AscContributorProjectAllocationMinAggregateKeySpecifier
)[];
export type AscContributorProjectAllocationMinAggregateFieldPolicy = {
  ascProjectName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscCostCsvResultRoKeySpecifier = ('permanentUrl' | 'signedUrl' | AscCostCsvResultRoKeySpecifier)[];
export type AscCostCsvResultRoFieldPolicy = {
  permanentUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  signedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscGroupingTicketOrCollectionKeySpecifier = (
  | 'ascProjectId'
  | 'count'
  | 'fiscalYearId'
  | 'id'
  | 'identifier'
  | 'isMatchedInLatestSync'
  | 'kind'
  | 'matchingConfidence'
  | 'matchingReasoning'
  | 'name'
  | 'periodName'
  | 'ticketType'
  | AscGroupingTicketOrCollectionKeySpecifier
)[];
export type AscGroupingTicketOrCollectionFieldPolicy = {
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  isMatchedInLatestSync?: FieldPolicy<any> | FieldReadFunction<any>;
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
  matchingConfidence?: FieldPolicy<any> | FieldReadFunction<any>;
  matchingReasoning?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscMonthLockStateKeySpecifier = ('isLocked' | 'monthYear' | AscMonthLockStateKeySpecifier)[];
export type AscMonthLockStateFieldPolicy = {
  isLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  monthYear?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscPeriodLockStatusKeySpecifier = (
  | 'fiscalYearId'
  | 'isLocked'
  | 'monthLockStates'
  | 'periodName'
  | AscPeriodLockStatusKeySpecifier
)[];
export type AscPeriodLockStatusFieldPolicy = {
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  isLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  monthLockStates?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectKeySpecifier = (
  | 'approvalStatus'
  | 'capitalizableProjectClusteringOverride'
  | 'capitalizationEndDate'
  | 'capitalizationEndDateExtendedFrom'
  | 'capitalizationStartDate'
  | 'capitalizationStatus'
  | 'clusterType'
  | 'companyId'
  | 'customFieldLaunchDate'
  | 'customFieldTeams'
  | 'description'
  | 'endDate'
  | 'endMonthYear'
  | 'id'
  | 'isDeterministic'
  | 'name'
  | 'predictedCapitalizationEndDate'
  | 'predictedCapitalizationEndDateReason'
  | 'predictedCapitalizationStartDate'
  | 'predictedCapitalizationStatus'
  | 'predictedCapitalizationStatusReason'
  | 'product'
  | 'productName'
  | 'projectOwner'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'startDate'
  | 'startMonthYear'
  | 'ticketCount'
  | 'workstreamNames'
  | 'workstreamNamesSearch'
  | AscProjectKeySpecifier
)[];
export type AscProjectFieldPolicy = {
  approvalStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizableProjectClusteringOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDateExtendedFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  clusterType?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  customFieldLaunchDate?: FieldPolicy<any> | FieldReadFunction<any>;
  customFieldTeams?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  endMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDeterministic?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationEndDateReason?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStatusReason?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwner?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  startMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNames?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectAggregateGroupByKeySpecifier = (
  | 'capitalizableProjectClusteringOverride'
  | 'capitalizationEndDate'
  | 'capitalizationEndDateExtendedFrom'
  | 'capitalizationStartDate'
  | 'capitalizationStatus'
  | 'clusterType'
  | 'companyId'
  | 'customFieldLaunchDate'
  | 'description'
  | 'endDate'
  | 'endMonthYear'
  | 'id'
  | 'isDeterministic'
  | 'name'
  | 'predictedCapitalizationEndDate'
  | 'predictedCapitalizationStartDate'
  | 'predictedCapitalizationStatus'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'startDate'
  | 'startMonthYear'
  | 'ticketCount'
  | 'workstreamNamesSearch'
  | AscProjectAggregateGroupByKeySpecifier
)[];
export type AscProjectAggregateGroupByFieldPolicy = {
  capitalizableProjectClusteringOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDateExtendedFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  clusterType?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  customFieldLaunchDate?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  endMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDeterministic?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  startMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectApprovalStatusResultKeySpecifier = (
  | 'approvedThroughMonthYear'
  | 'ascProjectId'
  | 'fiscalYearId'
  | 'periodApprovalByUserFullName'
  | 'periodApprovalByUserId'
  | 'periodApprovalComment'
  | 'periodApprovalDatetime'
  | 'periodName'
  | 'status'
  | AscProjectApprovalStatusResultKeySpecifier
)[];
export type AscProjectApprovalStatusResultFieldPolicy = {
  approvedThroughMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodApprovalByUserFullName?: FieldPolicy<any> | FieldReadFunction<any>;
  periodApprovalByUserId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodApprovalComment?: FieldPolicy<any> | FieldReadFunction<any>;
  periodApprovalDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectAvgAggregateKeySpecifier = ('ticketCount' | AscProjectAvgAggregateKeySpecifier)[];
export type AscProjectAvgAggregateFieldPolicy = {
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectConnectionKeySpecifier = ('edges' | 'pageInfo' | AscProjectConnectionKeySpecifier)[];
export type AscProjectConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectCountAggregateKeySpecifier = (
  | 'capitalizableProjectClusteringOverride'
  | 'capitalizationEndDate'
  | 'capitalizationEndDateExtendedFrom'
  | 'capitalizationStartDate'
  | 'capitalizationStatus'
  | 'clusterType'
  | 'companyId'
  | 'customFieldLaunchDate'
  | 'description'
  | 'endDate'
  | 'endMonthYear'
  | 'id'
  | 'isDeterministic'
  | 'name'
  | 'predictedCapitalizationEndDate'
  | 'predictedCapitalizationStartDate'
  | 'predictedCapitalizationStatus'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'startDate'
  | 'startMonthYear'
  | 'ticketCount'
  | 'workstreamNamesSearch'
  | AscProjectCountAggregateKeySpecifier
)[];
export type AscProjectCountAggregateFieldPolicy = {
  capitalizableProjectClusteringOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDateExtendedFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  clusterType?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  customFieldLaunchDate?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  endMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDeterministic?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  startMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectDeletionResultKeySpecifier = ('success' | AscProjectDeletionResultKeySpecifier)[];
export type AscProjectDeletionResultFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectEdgeKeySpecifier = ('cursor' | 'node' | AscProjectEdgeKeySpecifier)[];
export type AscProjectEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectMaxAggregateKeySpecifier = (
  | 'capitalizableProjectClusteringOverride'
  | 'capitalizationEndDate'
  | 'capitalizationEndDateExtendedFrom'
  | 'capitalizationStartDate'
  | 'capitalizationStatus'
  | 'clusterType'
  | 'companyId'
  | 'customFieldLaunchDate'
  | 'description'
  | 'endDate'
  | 'endMonthYear'
  | 'id'
  | 'name'
  | 'predictedCapitalizationEndDate'
  | 'predictedCapitalizationStartDate'
  | 'predictedCapitalizationStatus'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'startDate'
  | 'startMonthYear'
  | 'ticketCount'
  | 'workstreamNamesSearch'
  | AscProjectMaxAggregateKeySpecifier
)[];
export type AscProjectMaxAggregateFieldPolicy = {
  capitalizableProjectClusteringOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDateExtendedFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  clusterType?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  customFieldLaunchDate?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  endMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  startMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectMinAggregateKeySpecifier = (
  | 'capitalizableProjectClusteringOverride'
  | 'capitalizationEndDate'
  | 'capitalizationEndDateExtendedFrom'
  | 'capitalizationStartDate'
  | 'capitalizationStatus'
  | 'clusterType'
  | 'companyId'
  | 'customFieldLaunchDate'
  | 'description'
  | 'endDate'
  | 'endMonthYear'
  | 'id'
  | 'name'
  | 'predictedCapitalizationEndDate'
  | 'predictedCapitalizationStartDate'
  | 'predictedCapitalizationStatus'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'startDate'
  | 'startMonthYear'
  | 'ticketCount'
  | 'workstreamNamesSearch'
  | AscProjectMinAggregateKeySpecifier
)[];
export type AscProjectMinAggregateFieldPolicy = {
  capitalizableProjectClusteringOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDateExtendedFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  clusterType?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  customFieldLaunchDate?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  endMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  startMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectMonthPerContributorKeySpecifier = (
  | 'allocationPercent'
  | 'id'
  | 'month'
  | 'useAllocationPercent'
  | 'year'
  | AscProjectMonthPerContributorKeySpecifier
)[];
export type AscProjectMonthPerContributorFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  month?: FieldPolicy<any> | FieldReadFunction<any>;
  useAllocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  year?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectOwnerKeySpecifier = ('fullName' | 'id' | AscProjectOwnerKeySpecifier)[];
export type AscProjectOwnerFieldPolicy = {
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectPerContributorKeySpecifier = (
  | 'ascProject'
  | 'ascProjectMonthsPerContributor'
  | 'id'
  | AscProjectPerContributorKeySpecifier
)[];
export type AscProjectPerContributorFieldPolicy = {
  ascProject?: FieldPolicy<any> | FieldReadFunction<any>;
  ascProjectMonthsPerContributor?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectReportKeySpecifier = ('columnNames' | 'excelData' | AscProjectReportKeySpecifier)[];
export type AscProjectReportFieldPolicy = {
  columnNames?: FieldPolicy<any> | FieldReadFunction<any>;
  excelData?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectSumAggregateKeySpecifier = ('ticketCount' | AscProjectSumAggregateKeySpecifier)[];
export type AscProjectSumAggregateFieldPolicy = {
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTeamMemberKeySpecifier = (
  | 'allocationPercent'
  | 'ascProjectId'
  | 'contributorEmail'
  | 'contributorId'
  | 'contributorName'
  | 'fiscalYearId'
  | 'periodName'
  | AscProjectTeamMemberKeySpecifier
)[];
export type AscProjectTeamMemberFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTeamMemberAggregateGroupByKeySpecifier = (
  | 'allocationPercent'
  | 'ascProjectId'
  | 'contributorId'
  | 'contributorName'
  | 'fiscalYearId'
  | 'periodName'
  | AscProjectTeamMemberAggregateGroupByKeySpecifier
)[];
export type AscProjectTeamMemberAggregateGroupByFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTeamMemberAvgAggregateKeySpecifier = (
  | 'allocationPercent'
  | AscProjectTeamMemberAvgAggregateKeySpecifier
)[];
export type AscProjectTeamMemberAvgAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTeamMemberConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AscProjectTeamMemberConnectionKeySpecifier
)[];
export type AscProjectTeamMemberConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTeamMemberCountAggregateKeySpecifier = (
  | 'allocationPercent'
  | 'ascProjectId'
  | 'contributorId'
  | 'contributorName'
  | 'fiscalYearId'
  | 'periodName'
  | AscProjectTeamMemberCountAggregateKeySpecifier
)[];
export type AscProjectTeamMemberCountAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTeamMemberEdgeKeySpecifier = ('cursor' | 'node' | AscProjectTeamMemberEdgeKeySpecifier)[];
export type AscProjectTeamMemberEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTeamMemberMaxAggregateKeySpecifier = (
  | 'allocationPercent'
  | 'ascProjectId'
  | 'contributorId'
  | 'contributorName'
  | 'fiscalYearId'
  | 'periodName'
  | AscProjectTeamMemberMaxAggregateKeySpecifier
)[];
export type AscProjectTeamMemberMaxAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTeamMemberMinAggregateKeySpecifier = (
  | 'allocationPercent'
  | 'ascProjectId'
  | 'contributorId'
  | 'contributorName'
  | 'fiscalYearId'
  | 'periodName'
  | AscProjectTeamMemberMinAggregateKeySpecifier
)[];
export type AscProjectTeamMemberMinAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTeamMemberSumAggregateKeySpecifier = (
  | 'allocationPercent'
  | AscProjectTeamMemberSumAggregateKeySpecifier
)[];
export type AscProjectTeamMemberSumAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTpTicketsViewKeySpecifier = (
  | 'ascProjectId'
  | 'completedDatetime'
  | 'contributorId'
  | 'contributorName'
  | 'fiscalYearId'
  | 'groupingTicketingProviderCollectionId'
  | 'groupingTicketingProviderTicketId'
  | 'id'
  | 'identifier'
  | 'matchingConfidence'
  | 'matchingMethod'
  | 'matchingReasoning'
  | 'name'
  | 'parentId'
  | 'periodName'
  | 'predictedEffortDays'
  | 'ticketUrl'
  | 'workstreamId'
  | 'workstreamName'
  | AscProjectTpTicketsViewKeySpecifier
)[];
export type AscProjectTpTicketsViewFieldPolicy = {
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  completedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderCollectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderTicketId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  matchingConfidence?: FieldPolicy<any> | FieldReadFunction<any>;
  matchingMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  matchingReasoning?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  parentId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamId?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTpTicketsViewAggregateGroupByKeySpecifier = (
  | 'ascProjectId'
  | 'completedDatetime'
  | 'contributorId'
  | 'contributorName'
  | 'fiscalYearId'
  | 'groupingTicketingProviderCollectionId'
  | 'groupingTicketingProviderTicketId'
  | 'id'
  | 'identifier'
  | 'name'
  | 'parentId'
  | 'periodName'
  | 'predictedEffortDays'
  | 'ticketUrl'
  | 'workstreamId'
  | 'workstreamName'
  | AscProjectTpTicketsViewAggregateGroupByKeySpecifier
)[];
export type AscProjectTpTicketsViewAggregateGroupByFieldPolicy = {
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  completedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderCollectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderTicketId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  parentId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamId?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTpTicketsViewAvgAggregateKeySpecifier = (
  | 'predictedEffortDays'
  | AscProjectTpTicketsViewAvgAggregateKeySpecifier
)[];
export type AscProjectTpTicketsViewAvgAggregateFieldPolicy = {
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTpTicketsViewConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AscProjectTpTicketsViewConnectionKeySpecifier
)[];
export type AscProjectTpTicketsViewConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTpTicketsViewCountAggregateKeySpecifier = (
  | 'ascProjectId'
  | 'completedDatetime'
  | 'contributorId'
  | 'contributorName'
  | 'fiscalYearId'
  | 'groupingTicketingProviderCollectionId'
  | 'groupingTicketingProviderTicketId'
  | 'id'
  | 'identifier'
  | 'name'
  | 'parentId'
  | 'periodName'
  | 'predictedEffortDays'
  | 'ticketUrl'
  | 'workstreamId'
  | 'workstreamName'
  | AscProjectTpTicketsViewCountAggregateKeySpecifier
)[];
export type AscProjectTpTicketsViewCountAggregateFieldPolicy = {
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  completedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderCollectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderTicketId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  parentId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamId?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTpTicketsViewEdgeKeySpecifier = ('cursor' | 'node' | AscProjectTpTicketsViewEdgeKeySpecifier)[];
export type AscProjectTpTicketsViewEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTpTicketsViewMaxAggregateKeySpecifier = (
  | 'ascProjectId'
  | 'completedDatetime'
  | 'contributorId'
  | 'contributorName'
  | 'fiscalYearId'
  | 'groupingTicketingProviderCollectionId'
  | 'groupingTicketingProviderTicketId'
  | 'id'
  | 'identifier'
  | 'name'
  | 'parentId'
  | 'periodName'
  | 'predictedEffortDays'
  | 'ticketUrl'
  | 'workstreamId'
  | 'workstreamName'
  | AscProjectTpTicketsViewMaxAggregateKeySpecifier
)[];
export type AscProjectTpTicketsViewMaxAggregateFieldPolicy = {
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  completedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderCollectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderTicketId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  parentId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamId?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTpTicketsViewMinAggregateKeySpecifier = (
  | 'ascProjectId'
  | 'completedDatetime'
  | 'contributorId'
  | 'contributorName'
  | 'fiscalYearId'
  | 'groupingTicketingProviderCollectionId'
  | 'groupingTicketingProviderTicketId'
  | 'id'
  | 'identifier'
  | 'name'
  | 'parentId'
  | 'periodName'
  | 'predictedEffortDays'
  | 'ticketUrl'
  | 'workstreamId'
  | 'workstreamName'
  | AscProjectTpTicketsViewMinAggregateKeySpecifier
)[];
export type AscProjectTpTicketsViewMinAggregateFieldPolicy = {
  ascProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  completedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderCollectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderTicketId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  parentId?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamId?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectTpTicketsViewSumAggregateKeySpecifier = (
  | 'predictedEffortDays'
  | AscProjectTpTicketsViewSumAggregateKeySpecifier
)[];
export type AscProjectTpTicketsViewSumAggregateFieldPolicy = {
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectUniqueCountAggregateKeySpecifier = (
  | 'capitalizableProjectClusteringOverride'
  | 'capitalizationEndDate'
  | 'capitalizationEndDateExtendedFrom'
  | 'capitalizationStartDate'
  | 'capitalizationStatus'
  | 'clusterType'
  | 'companyId'
  | 'customFieldLaunchDate'
  | 'description'
  | 'endDate'
  | 'endMonthYear'
  | 'id'
  | 'isDeterministic'
  | 'name'
  | 'predictedCapitalizationEndDate'
  | 'predictedCapitalizationStartDate'
  | 'predictedCapitalizationStatus'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'startDate'
  | 'startMonthYear'
  | 'ticketCount'
  | 'workstreamNamesSearch'
  | AscProjectUniqueCountAggregateKeySpecifier
)[];
export type AscProjectUniqueCountAggregateFieldPolicy = {
  capitalizableProjectClusteringOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationEndDateExtendedFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  clusterType?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  customFieldLaunchDate?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  endMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDeterministic?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedCapitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  startMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscProjectsSummaryKeySpecifier = (
  | 'avg'
  | 'count'
  | 'groupBy'
  | 'max'
  | 'min'
  | 'sum'
  | 'uniqueCount'
  | AscProjectsSummaryKeySpecifier
)[];
export type AscProjectsSummaryFieldPolicy = {
  avg?: FieldPolicy<any> | FieldReadFunction<any>;
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  groupBy?: FieldPolicy<any> | FieldReadFunction<any>;
  max?: FieldPolicy<any> | FieldReadFunction<any>;
  min?: FieldPolicy<any> | FieldReadFunction<any>;
  sum?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscReportRoKeySpecifier = ('signedUrl' | AscReportRoKeySpecifier)[];
export type AscReportRoFieldPolicy = {
  signedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscSyncConfigurationKeySpecifier = (
  | 'ascTicketGroupLevel'
  | 'booleanTruthyStatus'
  | 'clusterDurationObjectiveFnWeight'
  | 'clusteringMethod'
  | 'customFieldCapitalizationMappings'
  | 'id'
  | 'jiraCapitalizationCustomFieldId'
  | 'matchingAggressiveness'
  | 'maxNumberOfClusters'
  | 'maxTargetClusterDuration'
  | 'minNumberOfClusters'
  | 'minNumberOfTicketsPerCluster'
  | 'minTargetClusterDuration'
  | 'parentlessTicketMatching'
  | 'useDeterministic'
  | 'usePartitionByWorkstream'
  | AscSyncConfigurationKeySpecifier
)[];
export type AscSyncConfigurationFieldPolicy = {
  ascTicketGroupLevel?: FieldPolicy<any> | FieldReadFunction<any>;
  booleanTruthyStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  clusterDurationObjectiveFnWeight?: FieldPolicy<any> | FieldReadFunction<any>;
  clusteringMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  customFieldCapitalizationMappings?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  jiraCapitalizationCustomFieldId?: FieldPolicy<any> | FieldReadFunction<any>;
  matchingAggressiveness?: FieldPolicy<any> | FieldReadFunction<any>;
  maxNumberOfClusters?: FieldPolicy<any> | FieldReadFunction<any>;
  maxTargetClusterDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  minNumberOfClusters?: FieldPolicy<any> | FieldReadFunction<any>;
  minNumberOfTicketsPerCluster?: FieldPolicy<any> | FieldReadFunction<any>;
  minTargetClusterDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  parentlessTicketMatching?: FieldPolicy<any> | FieldReadFunction<any>;
  useDeterministic?: FieldPolicy<any> | FieldReadFunction<any>;
  usePartitionByWorkstream?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageKeySpecifier = (
  | 'allocationPercent'
  | 'capitalizedSalaryCompensationCents'
  | 'capitalizedStockCompensationCents'
  | 'capitalizedTotalCompensationCents'
  | 'contributorId'
  | 'costCenters'
  | 'countries'
  | 'departments'
  | 'employeeIds'
  | 'entities'
  | 'fiscalYearId'
  | 'hasCompleteDataInPeriod'
  | 'hireDates'
  | 'id'
  | 'managerIds'
  | 'managerNames'
  | 'name'
  | 'periodName'
  | 'salaryCompensationCents'
  | 'stockCompensationCents'
  | 'terminationDates'
  | 'titles'
  | 'totalCompensationCents'
  | AscWageKeySpecifier
)[];
export type AscWageFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedSalaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedStockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedTotalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenters?: FieldPolicy<any> | FieldReadFunction<any>;
  countries?: FieldPolicy<any> | FieldReadFunction<any>;
  departments?: FieldPolicy<any> | FieldReadFunction<any>;
  employeeIds?: FieldPolicy<any> | FieldReadFunction<any>;
  entities?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  hasCompleteDataInPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDates?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerIds?: FieldPolicy<any> | FieldReadFunction<any>;
  managerNames?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  stockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDates?: FieldPolicy<any> | FieldReadFunction<any>;
  titles?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageAggregateGroupByKeySpecifier = (
  | 'allocationPercent'
  | 'capitalizedSalaryCompensationCents'
  | 'capitalizedStockCompensationCents'
  | 'capitalizedTotalCompensationCents'
  | 'contributorId'
  | 'costCenters'
  | 'countries'
  | 'departments'
  | 'employeeIds'
  | 'entities'
  | 'fiscalYearId'
  | 'hasCompleteDataInPeriod'
  | 'hireDates'
  | 'id'
  | 'managerIds'
  | 'managerNames'
  | 'name'
  | 'periodName'
  | 'salaryCompensationCents'
  | 'stockCompensationCents'
  | 'terminationDates'
  | 'titles'
  | 'totalCompensationCents'
  | AscWageAggregateGroupByKeySpecifier
)[];
export type AscWageAggregateGroupByFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedSalaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedStockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedTotalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenters?: FieldPolicy<any> | FieldReadFunction<any>;
  countries?: FieldPolicy<any> | FieldReadFunction<any>;
  departments?: FieldPolicy<any> | FieldReadFunction<any>;
  employeeIds?: FieldPolicy<any> | FieldReadFunction<any>;
  entities?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  hasCompleteDataInPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDates?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerIds?: FieldPolicy<any> | FieldReadFunction<any>;
  managerNames?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  stockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDates?: FieldPolicy<any> | FieldReadFunction<any>;
  titles?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageAvgAggregateKeySpecifier = (
  | 'allocationPercent'
  | 'capitalizedSalaryCompensationCents'
  | 'capitalizedStockCompensationCents'
  | 'capitalizedTotalCompensationCents'
  | 'salaryCompensationCents'
  | 'stockCompensationCents'
  | 'totalCompensationCents'
  | AscWageAvgAggregateKeySpecifier
)[];
export type AscWageAvgAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedSalaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedStockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedTotalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  stockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageConnectionKeySpecifier = ('edges' | 'pageInfo' | AscWageConnectionKeySpecifier)[];
export type AscWageConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageCountAggregateKeySpecifier = (
  | 'allocationPercent'
  | 'capitalizedSalaryCompensationCents'
  | 'capitalizedStockCompensationCents'
  | 'capitalizedTotalCompensationCents'
  | 'contributorId'
  | 'costCenters'
  | 'countries'
  | 'departments'
  | 'employeeIds'
  | 'entities'
  | 'fiscalYearId'
  | 'hasCompleteDataInPeriod'
  | 'hireDates'
  | 'id'
  | 'managerIds'
  | 'managerNames'
  | 'name'
  | 'periodName'
  | 'salaryCompensationCents'
  | 'stockCompensationCents'
  | 'terminationDates'
  | 'titles'
  | 'totalCompensationCents'
  | AscWageCountAggregateKeySpecifier
)[];
export type AscWageCountAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedSalaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedStockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedTotalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenters?: FieldPolicy<any> | FieldReadFunction<any>;
  countries?: FieldPolicy<any> | FieldReadFunction<any>;
  departments?: FieldPolicy<any> | FieldReadFunction<any>;
  employeeIds?: FieldPolicy<any> | FieldReadFunction<any>;
  entities?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  hasCompleteDataInPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDates?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerIds?: FieldPolicy<any> | FieldReadFunction<any>;
  managerNames?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  stockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDates?: FieldPolicy<any> | FieldReadFunction<any>;
  titles?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageEdgeKeySpecifier = ('cursor' | 'node' | AscWageEdgeKeySpecifier)[];
export type AscWageEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageMaxAggregateKeySpecifier = (
  | 'allocationPercent'
  | 'capitalizedSalaryCompensationCents'
  | 'capitalizedStockCompensationCents'
  | 'capitalizedTotalCompensationCents'
  | 'contributorId'
  | 'costCenters'
  | 'countries'
  | 'departments'
  | 'employeeIds'
  | 'entities'
  | 'fiscalYearId'
  | 'hireDates'
  | 'id'
  | 'managerIds'
  | 'managerNames'
  | 'name'
  | 'periodName'
  | 'salaryCompensationCents'
  | 'stockCompensationCents'
  | 'terminationDates'
  | 'titles'
  | 'totalCompensationCents'
  | AscWageMaxAggregateKeySpecifier
)[];
export type AscWageMaxAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedSalaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedStockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedTotalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenters?: FieldPolicy<any> | FieldReadFunction<any>;
  countries?: FieldPolicy<any> | FieldReadFunction<any>;
  departments?: FieldPolicy<any> | FieldReadFunction<any>;
  employeeIds?: FieldPolicy<any> | FieldReadFunction<any>;
  entities?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDates?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerIds?: FieldPolicy<any> | FieldReadFunction<any>;
  managerNames?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  stockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDates?: FieldPolicy<any> | FieldReadFunction<any>;
  titles?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageMinAggregateKeySpecifier = (
  | 'allocationPercent'
  | 'capitalizedSalaryCompensationCents'
  | 'capitalizedStockCompensationCents'
  | 'capitalizedTotalCompensationCents'
  | 'contributorId'
  | 'costCenters'
  | 'countries'
  | 'departments'
  | 'employeeIds'
  | 'entities'
  | 'fiscalYearId'
  | 'hireDates'
  | 'id'
  | 'managerIds'
  | 'managerNames'
  | 'name'
  | 'periodName'
  | 'salaryCompensationCents'
  | 'stockCompensationCents'
  | 'terminationDates'
  | 'titles'
  | 'totalCompensationCents'
  | AscWageMinAggregateKeySpecifier
)[];
export type AscWageMinAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedSalaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedStockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedTotalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenters?: FieldPolicy<any> | FieldReadFunction<any>;
  countries?: FieldPolicy<any> | FieldReadFunction<any>;
  departments?: FieldPolicy<any> | FieldReadFunction<any>;
  employeeIds?: FieldPolicy<any> | FieldReadFunction<any>;
  entities?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDates?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerIds?: FieldPolicy<any> | FieldReadFunction<any>;
  managerNames?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  stockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDates?: FieldPolicy<any> | FieldReadFunction<any>;
  titles?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageReportResultKeySpecifier = ('signedUrl' | AscWageReportResultKeySpecifier)[];
export type AscWageReportResultFieldPolicy = {
  signedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageSumAggregateKeySpecifier = (
  | 'allocationPercent'
  | 'capitalizedSalaryCompensationCents'
  | 'capitalizedStockCompensationCents'
  | 'capitalizedTotalCompensationCents'
  | 'salaryCompensationCents'
  | 'stockCompensationCents'
  | 'totalCompensationCents'
  | AscWageSumAggregateKeySpecifier
)[];
export type AscWageSumAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedSalaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedStockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  capitalizedTotalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  salaryCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  stockCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCompensationCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageSummaryKeySpecifier = (
  | 'avg'
  | 'count'
  | 'groupBy'
  | 'max'
  | 'min'
  | 'sum'
  | 'uniqueCount'
  | AscWageSummaryKeySpecifier
)[];
export type AscWageSummaryFieldPolicy = {
  avg?: FieldPolicy<any> | FieldReadFunction<any>;
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  groupBy?: FieldPolicy<any> | FieldReadFunction<any>;
  max?: FieldPolicy<any> | FieldReadFunction<any>;
  min?: FieldPolicy<any> | FieldReadFunction<any>;
  sum?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AscWageUniqueCountAggregateKeySpecifier = (
  | 'countries'
  | 'departments'
  | 'titles'
  | AscWageUniqueCountAggregateKeySpecifier
)[];
export type AscWageUniqueCountAggregateFieldPolicy = {
  countries?: FieldPolicy<any> | FieldReadFunction<any>;
  departments?: FieldPolicy<any> | FieldReadFunction<any>;
  titles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BackgroundOperationKeySpecifier = (
  | 'createdAt'
  | 'id'
  | 'name'
  | 'progressPercent'
  | BackgroundOperationKeySpecifier
)[];
export type BackgroundOperationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  progressPercent?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BulkDeleteAscProjectsResultKeySpecifier = (
  | 'pmasDeleted'
  | 'projectsDeleted'
  | 'ticketsUnassigned'
  | BulkDeleteAscProjectsResultKeySpecifier
)[];
export type BulkDeleteAscProjectsResultFieldPolicy = {
  pmasDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
  projectsDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketsUnassigned?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BulkDeleteEmptyRdProjectsResultKeySpecifier = (
  | 'deletedProjectIds'
  | 'excludedEmptyProjectIds'
  | 'totalExcludedEmptyProjects'
  | 'totalProjectsDeleted'
  | BulkDeleteEmptyRdProjectsResultKeySpecifier
)[];
export type BulkDeleteEmptyRdProjectsResultFieldPolicy = {
  deletedProjectIds?: FieldPolicy<any> | FieldReadFunction<any>;
  excludedEmptyProjectIds?: FieldPolicy<any> | FieldReadFunction<any>;
  totalExcludedEmptyProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  totalProjectsDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BulkTicketingDataFileUploadKeySpecifier = (
  | 'createdAt'
  | 'fileName'
  | 'id'
  | 'isValid'
  | 'payrollMonthExpenseSyncEventId'
  | 'payrollProviderSyncEventId'
  | 'period'
  | 'signedUrl'
  | 'ticketingEntityType'
  | 'ticketingProvider'
  | BulkTicketingDataFileUploadKeySpecifier
)[];
export type BulkTicketingDataFileUploadFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  fileName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isValid?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollMonthExpenseSyncEventId?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProviderSyncEventId?: FieldPolicy<any> | FieldReadFunction<any>;
  period?: FieldPolicy<any> | FieldReadFunction<any>;
  signedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingEntityType?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingProvider?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BulkUpdateRdProjectsProductByCsvResultKeySpecifier = (
  | 'productsCreated'
  | 'rdProjectsUpdated'
  | 'success'
  | BulkUpdateRdProjectsProductByCsvResultKeySpecifier
)[];
export type BulkUpdateRdProjectsProductByCsvResultFieldPolicy = {
  productsCreated?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectsUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessComponentParamsKeySpecifier = (
  | 'maxExpectedProjectsOverride'
  | 'maxTicketShareOverride'
  | 'minExpectedProjectsOverride'
  | BusinessComponentParamsKeySpecifier
)[];
export type BusinessComponentParamsFieldPolicy = {
  maxExpectedProjectsOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  maxTicketShareOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  minExpectedProjectsOverride?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessQuestionsKeySpecifier = (
  | 'firstDayOfTicketingSyncPeriod'
  | 'fiscalYearEndMonth'
  | 'gustoCompanyId'
  | 'lastDayOfTicketingSyncPeriod'
  | BusinessQuestionsKeySpecifier
)[];
export type BusinessQuestionsFieldPolicy = {
  firstDayOfTicketingSyncPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearEndMonth?: FieldPolicy<any> | FieldReadFunction<any>;
  gustoCompanyId?: FieldPolicy<any> | FieldReadFunction<any>;
  lastDayOfTicketingSyncPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CaSredSyncConfigurationRoKeySpecifier = (
  | 'companyId'
  | 'dataCleaningStrategy'
  | 'id'
  | 'maxNumberOfClusters'
  | 'minNumberOfClusters'
  | 'minNumberOfTicketsPerCluster'
  | 'usePartitionByWorkstream'
  | CaSredSyncConfigurationRoKeySpecifier
)[];
export type CaSredSyncConfigurationRoFieldPolicy = {
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  dataCleaningStrategy?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  maxNumberOfClusters?: FieldPolicy<any> | FieldReadFunction<any>;
  minNumberOfClusters?: FieldPolicy<any> | FieldReadFunction<any>;
  minNumberOfTicketsPerCluster?: FieldPolicy<any> | FieldReadFunction<any>;
  usePartitionByWorkstream?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CalculateAllocationsRdResultKeySpecifier = (
  | 'rdExpenseProjectsDeleted'
  | 'rdExpenseProjectsInserted'
  | 'rdExpenseProjectsUpdated'
  | CalculateAllocationsRdResultKeySpecifier
)[];
export type CalculateAllocationsRdResultFieldPolicy = {
  rdExpenseProjectsDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
  rdExpenseProjectsInserted?: FieldPolicy<any> | FieldReadFunction<any>;
  rdExpenseProjectsUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyKeySpecifier = (
  | 'accountingTokens'
  | 'approvedForLlmTraining'
  | 'approvedForOtherAiTraining'
  | 'ascLockedUntilMonthYear'
  | 'bulkPriorYearTaxDocumentUploads'
  | 'bulkTicketingDataUploads'
  | 'businessQuestions'
  | 'companyCreationType'
  | 'fiscalYears'
  | 'fuzzyMatchThreshold'
  | 'gitHubAppAvailable'
  | 'githubEmailMappingUploads'
  | 'id'
  | 'invitedMembers'
  | 'isPiiRedacted'
  | 'lastCompletedAscSyncPeriodEnd'
  | 'legalName'
  | 'llmProvider'
  | 'members'
  | 'organization'
  | 'organizationId'
  | 'payrollTokens'
  | 'priorYearQREs'
  | 'priorYearRevenues'
  | 'questionSections'
  | 'questions'
  | 'rdContributorCombineLimit'
  | 'shortName'
  | 'syncConfigurationAsc'
  | 'syncConfigurationRd'
  | 'syncedPayrollMonthExpense'
  | 'syncedTicketingProviders'
  | 'ticketingTokens'
  | 'timesheetUploads'
  | CompanyKeySpecifier
)[];
export type CompanyFieldPolicy = {
  accountingTokens?: FieldPolicy<any> | FieldReadFunction<any>;
  approvedForLlmTraining?: FieldPolicy<any> | FieldReadFunction<any>;
  approvedForOtherAiTraining?: FieldPolicy<any> | FieldReadFunction<any>;
  ascLockedUntilMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  bulkPriorYearTaxDocumentUploads?: FieldPolicy<any> | FieldReadFunction<any>;
  bulkTicketingDataUploads?: FieldPolicy<any> | FieldReadFunction<any>;
  businessQuestions?: FieldPolicy<any> | FieldReadFunction<any>;
  companyCreationType?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYears?: FieldPolicy<any> | FieldReadFunction<any>;
  fuzzyMatchThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  gitHubAppAvailable?: FieldPolicy<any> | FieldReadFunction<any>;
  githubEmailMappingUploads?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  invitedMembers?: FieldPolicy<any> | FieldReadFunction<any>;
  isPiiRedacted?: FieldPolicy<any> | FieldReadFunction<any>;
  lastCompletedAscSyncPeriodEnd?: FieldPolicy<any> | FieldReadFunction<any>;
  legalName?: FieldPolicy<any> | FieldReadFunction<any>;
  llmProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  members?: FieldPolicy<any> | FieldReadFunction<any>;
  organization?: FieldPolicy<any> | FieldReadFunction<any>;
  organizationId?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollTokens?: FieldPolicy<any> | FieldReadFunction<any>;
  priorYearQREs?: FieldPolicy<any> | FieldReadFunction<any>;
  priorYearRevenues?: FieldPolicy<any> | FieldReadFunction<any>;
  questionSections?: FieldPolicy<any> | FieldReadFunction<any>;
  questions?: FieldPolicy<any> | FieldReadFunction<any>;
  rdContributorCombineLimit?: FieldPolicy<any> | FieldReadFunction<any>;
  shortName?: FieldPolicy<any> | FieldReadFunction<any>;
  syncConfigurationAsc?: FieldPolicy<any> | FieldReadFunction<any>;
  syncConfigurationRd?: FieldPolicy<any> | FieldReadFunction<any>;
  syncedPayrollMonthExpense?: FieldPolicy<any> | FieldReadFunction<any>;
  syncedTicketingProviders?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingTokens?: FieldPolicy<any> | FieldReadFunction<any>;
  timesheetUploads?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyInvitationKeySpecifier = (
  | 'acceptedAt'
  | 'company'
  | 'companyId'
  | 'email'
  | 'id'
  | 'scope'
  | CompanyInvitationKeySpecifier
)[];
export type CompanyInvitationFieldPolicy = {
  acceptedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  scope?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompanyScopesKeySpecifier = ('companyId' | 'id' | 'scope' | CompanyScopesKeySpecifier)[];
export type CompanyScopesFieldPolicy = {
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  scope?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ContributorKeySpecifier = (
  | 'ascProjectsPerContributor'
  | 'emails'
  | 'hasLinkedTpUsers'
  | 'id'
  | 'name'
  | 'ticketingProviderUsers'
  | ContributorKeySpecifier
)[];
export type ContributorFieldPolicy = {
  ascProjectsPerContributor?: FieldPolicy<any> | FieldReadFunction<any>;
  emails?: FieldPolicy<any> | FieldReadFunction<any>;
  hasLinkedTpUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingProviderUsers?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreatorRdWageAllocationResultKeySpecifier = (
  | 'cappedEmployeeNames'
  | 'changelogCsvData'
  | 'duplicateCreatorRdRowNames'
  | 'skippedAmountEmployeeNames'
  | 'unallocatedEmployeeNames'
  | 'unchangedEmployeeNames'
  | 'unmatchedEmployeeNames'
  | 'updatedEmployeeNames'
  | 'wageExcelData'
  | 'warnings'
  | CreatorRdWageAllocationResultKeySpecifier
)[];
export type CreatorRdWageAllocationResultFieldPolicy = {
  cappedEmployeeNames?: FieldPolicy<any> | FieldReadFunction<any>;
  changelogCsvData?: FieldPolicy<any> | FieldReadFunction<any>;
  duplicateCreatorRdRowNames?: FieldPolicy<any> | FieldReadFunction<any>;
  skippedAmountEmployeeNames?: FieldPolicy<any> | FieldReadFunction<any>;
  unallocatedEmployeeNames?: FieldPolicy<any> | FieldReadFunction<any>;
  unchangedEmployeeNames?: FieldPolicy<any> | FieldReadFunction<any>;
  unmatchedEmployeeNames?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedEmployeeNames?: FieldPolicy<any> | FieldReadFunction<any>;
  wageExcelData?: FieldPolicy<any> | FieldReadFunction<any>;
  warnings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomFieldCapitalizationMappingKeySpecifier = (
  | 'capitalizationStatus'
  | 'id'
  | 'matcher'
  | CustomFieldCapitalizationMappingKeySpecifier
)[];
export type CustomFieldCapitalizationMappingFieldPolicy = {
  capitalizationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  matcher?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteAccountingSyncEventForFiscalYearResultKeySpecifier = (
  | 'deletedAccountingProviderSyncEventId'
  | DeleteAccountingSyncEventForFiscalYearResultKeySpecifier
)[];
export type DeleteAccountingSyncEventForFiscalYearResultFieldPolicy = {
  deletedAccountingProviderSyncEventId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteAccountingTokensResultKeySpecifier = ('ids' | DeleteAccountingTokensResultKeySpecifier)[];
export type DeleteAccountingTokensResultFieldPolicy = {
  ids?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeletePayrollMonthExpenseSyncEventResultKeySpecifier = (
  | 'deletedPayrollMonthExpenseSyncEventId'
  | DeletePayrollMonthExpenseSyncEventResultKeySpecifier
)[];
export type DeletePayrollMonthExpenseSyncEventResultFieldPolicy = {
  deletedPayrollMonthExpenseSyncEventId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeletePayrollSyncEventForFiscalYearResultKeySpecifier = (
  | 'deletedPayrollProviderSyncEventId'
  | DeletePayrollSyncEventForFiscalYearResultKeySpecifier
)[];
export type DeletePayrollSyncEventForFiscalYearResultFieldPolicy = {
  deletedPayrollProviderSyncEventId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeletePayrollTokensResultKeySpecifier = ('ids' | DeletePayrollTokensResultKeySpecifier)[];
export type DeletePayrollTokensResultFieldPolicy = {
  ids?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DemoAccountInitializationKeySpecifier = (
  | 'companyId'
  | 'companyName'
  | 'counts'
  | DemoAccountInitializationKeySpecifier
)[];
export type DemoAccountInitializationFieldPolicy = {
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  counts?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DemoAccountReadinessKeySpecifier = (
  | 'projectsEvaluated'
  | 'projectsTotal'
  | 'ready'
  | DemoAccountReadinessKeySpecifier
)[];
export type DemoAccountReadinessFieldPolicy = {
  projectsEvaluated?: FieldPolicy<any> | FieldReadFunction<any>;
  projectsTotal?: FieldPolicy<any> | FieldReadFunction<any>;
  ready?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DemoBundleConflictKeySpecifier = (
  | 'existingCompanyId'
  | 'existingCompanyName'
  | DemoBundleConflictKeySpecifier
)[];
export type DemoBundleConflictFieldPolicy = {
  existingCompanyId?: FieldPolicy<any> | FieldReadFunction<any>;
  existingCompanyName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DemoBundleCountsKeySpecifier = (
  | 'allocations'
  | 'employees'
  | 'patents'
  | 'projects'
  | DemoBundleCountsKeySpecifier
)[];
export type DemoBundleCountsFieldPolicy = {
  allocations?: FieldPolicy<any> | FieldReadFunction<any>;
  employees?: FieldPolicy<any> | FieldReadFunction<any>;
  patents?: FieldPolicy<any> | FieldReadFunction<any>;
  projects?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DemoBundleIdentityKeySpecifier = ('companyName' | 'taxYear' | 'website' | DemoBundleIdentityKeySpecifier)[];
export type DemoBundleIdentityFieldPolicy = {
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  taxYear?: FieldPolicy<any> | FieldReadFunction<any>;
  website?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DemoBundlePreflightReportKeySpecifier = (
  | 'conflict'
  | 'counts'
  | 'errors'
  | 'identity'
  | 'valid'
  | DemoBundlePreflightReportKeySpecifier
)[];
export type DemoBundlePreflightReportFieldPolicy = {
  conflict?: FieldPolicy<any> | FieldReadFunction<any>;
  counts?: FieldPolicy<any> | FieldReadFunction<any>;
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  identity?: FieldPolicy<any> | FieldReadFunction<any>;
  valid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DisconnectTicketingTokenOutputKeySpecifier = (
  | 'scheduledSyncsCancelled'
  | 'ticketingTokenId'
  | DisconnectTicketingTokenOutputKeySpecifier
)[];
export type DisconnectTicketingTokenOutputFieldPolicy = {
  scheduledSyncsCancelled?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingTokenId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DistributedFlowStateKeySpecifier = (
  | 'backgroundOperation'
  | 'backgroundOperationId'
  | 'company'
  | 'createdAt'
  | 'distributedFlowDag'
  | 'id'
  | 'isPausedDatetime'
  | 'jobExecutionStateCounts'
  | 'jobExecutions'
  | 'status'
  | DistributedFlowStateKeySpecifier
)[];
export type DistributedFlowStateFieldPolicy = {
  backgroundOperation?: FieldPolicy<any> | FieldReadFunction<any>;
  backgroundOperationId?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  distributedFlowDag?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isPausedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  jobExecutionStateCounts?: FieldPolicy<any> | FieldReadFunction<any>;
  jobExecutions?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DocumentEventKeySpecifier = (
  | 'createdAt'
  | 'documentType'
  | 'eventType'
  | 'fiscalYearId'
  | 'id'
  | 'period'
  | 'periodName'
  | 'taxAuthority'
  | DocumentEventKeySpecifier
)[];
export type DocumentEventFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  documentType?: FieldPolicy<any> | FieldReadFunction<any>;
  eventType?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  period?: FieldPolicy<any> | FieldReadFunction<any>;
  periodName?: FieldPolicy<any> | FieldReadFunction<any>;
  taxAuthority?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DocumentsKeySpecifier = (
  | 'federalRdTaxCreditDocuments'
  | 'form6765Values'
  | 'id'
  | 'stateRdTaxCreditDocuments'
  | 'year'
  | DocumentsKeySpecifier
)[];
export type DocumentsFieldPolicy = {
  federalRdTaxCreditDocuments?: FieldPolicy<any> | FieldReadFunction<any>;
  form6765Values?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  stateRdTaxCreditDocuments?: FieldPolicy<any> | FieldReadFunction<any>;
  year?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExcelParseErrorKeySpecifier = ('column' | 'row' | 'type' | 'value' | ExcelParseErrorKeySpecifier)[];
export type ExcelParseErrorFieldPolicy = {
  column?: FieldPolicy<any> | FieldReadFunction<any>;
  row?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FederalDocumentStatusesKeySpecifier = (
  | 'taxCreditFormStatus'
  | 'taxWriteUpStatus'
  | FederalDocumentStatusesKeySpecifier
)[];
export type FederalDocumentStatusesFieldPolicy = {
  taxCreditFormStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  taxWriteUpStatus?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FederalRdTaxCreditDocumentsKeySpecifier = (
  | 'allowAccessForm6765Datetime'
  | 'allowAccessRdWriteupDatetime'
  | 'filingMethod'
  | 'id'
  | 'isIncomeCredit'
  | 'isReducedCredit'
  | 'payrollCreditFormFileName'
  | 'payrollCreditFormUrl'
  | 'taxCreditFormFileName'
  | 'taxCreditFormGeneratedDate'
  | 'taxCreditFormMissingInformation'
  | 'taxCreditFormStatus'
  | 'taxCreditFormUrl'
  | 'taxWriteUpGeneratedDate'
  | 'taxWriteUpMissingInformation'
  | 'taxWriteUpPdfFileName'
  | 'taxWriteUpPdfUrl'
  | 'taxWriteUpStatus'
  | FederalRdTaxCreditDocumentsKeySpecifier
)[];
export type FederalRdTaxCreditDocumentsFieldPolicy = {
  allowAccessForm6765Datetime?: FieldPolicy<any> | FieldReadFunction<any>;
  allowAccessRdWriteupDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  filingMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isIncomeCredit?: FieldPolicy<any> | FieldReadFunction<any>;
  isReducedCredit?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollCreditFormFileName?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollCreditFormUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  taxCreditFormFileName?: FieldPolicy<any> | FieldReadFunction<any>;
  taxCreditFormGeneratedDate?: FieldPolicy<any> | FieldReadFunction<any>;
  taxCreditFormMissingInformation?: FieldPolicy<any> | FieldReadFunction<any>;
  taxCreditFormStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  taxCreditFormUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  taxWriteUpGeneratedDate?: FieldPolicy<any> | FieldReadFunction<any>;
  taxWriteUpMissingInformation?: FieldPolicy<any> | FieldReadFunction<any>;
  taxWriteUpPdfFileName?: FieldPolicy<any> | FieldReadFunction<any>;
  taxWriteUpPdfUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  taxWriteUpStatus?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FileUploadKeySpecifier = (
  | 'createdAt'
  | 'fileName'
  | 'id'
  | 'isValid'
  | 'payrollMonthExpenseSyncEventId'
  | 'payrollProviderSyncEventId'
  | 'period'
  | 'signedUrl'
  | FileUploadKeySpecifier
)[];
export type FileUploadFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  fileName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isValid?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollMonthExpenseSyncEventId?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProviderSyncEventId?: FieldPolicy<any> | FieldReadFunction<any>;
  period?: FieldPolicy<any> | FieldReadFunction<any>;
  signedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FinchSessionKeySpecifier = ('sessionId' | FinchSessionKeySpecifier)[];
export type FinchSessionFieldPolicy = {
  sessionId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FirebaseIdentityAccountModelKeySpecifier = (
  | 'createdAt'
  | 'disabled'
  | 'displayName'
  | 'email'
  | 'emailVerified'
  | 'lastSignInAt'
  | 'providers'
  | 'uid'
  | FirebaseIdentityAccountModelKeySpecifier
)[];
export type FirebaseIdentityAccountModelFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  disabled?: FieldPolicy<any> | FieldReadFunction<any>;
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  emailVerified?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSignInAt?: FieldPolicy<any> | FieldReadFunction<any>;
  providers?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FirebaseIdentityModelKeySpecifier = (
  | 'account'
  | 'email'
  | 'enterpriseSsoExempt'
  | 'firebaseUserId'
  | 'fullName'
  | 'nameMatchScore'
  | 'userId'
  | FirebaseIdentityModelKeySpecifier
)[];
export type FirebaseIdentityModelFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  enterpriseSsoExempt?: FieldPolicy<any> | FieldReadFunction<any>;
  firebaseUserId?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  nameMatchScore?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FirebaseIdentityProviderModelKeySpecifier = (
  | 'email'
  | 'providerId'
  | FirebaseIdentityProviderModelKeySpecifier
)[];
export type FirebaseIdentityProviderModelFieldPolicy = {
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  providerId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FiscalYearKeySpecifier = (
  | 'companyId'
  | 'enabledDatetime'
  | 'id'
  | 'lockedForCustomers'
  | 'processingTicketingDataState'
  | 'productType'
  | 'rdTaxCredit'
  | 'rdTaxCreditId'
  | 'sredTaxCredit'
  | 'syncedProviders'
  | 'syncedRdPayrollCost'
  | 'taxYearEndDate'
  | 'taxYearStartDate'
  | 'year'
  | FiscalYearKeySpecifier
)[];
export type FiscalYearFieldPolicy = {
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lockedForCustomers?: FieldPolicy<any> | FieldReadFunction<any>;
  processingTicketingDataState?: FieldPolicy<any> | FieldReadFunction<any>;
  productType?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCredit?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditId?: FieldPolicy<any> | FieldReadFunction<any>;
  sredTaxCredit?: FieldPolicy<any> | FieldReadFunction<any>;
  syncedProviders?: FieldPolicy<any> | FieldReadFunction<any>;
  syncedRdPayrollCost?: FieldPolicy<any> | FieldReadFunction<any>;
  taxYearEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  taxYearStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  year?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type Form6765ValuesKeySpecifier = (
  | 'ascMethodCreditCents'
  | 'cloudQreCents'
  | 'contractorQreCents'
  | 'formLines'
  | 'id'
  | 'isEstimateCalculation'
  | 'isPayrollCreditEligible'
  | 'regularMethodCreditCents'
  | 'suppliesQreCents'
  | 'totalQreCents'
  | 'wagesQreCents'
  | 'year'
  | Form6765ValuesKeySpecifier
)[];
export type Form6765ValuesFieldPolicy = {
  ascMethodCreditCents?: FieldPolicy<any> | FieldReadFunction<any>;
  cloudQreCents?: FieldPolicy<any> | FieldReadFunction<any>;
  contractorQreCents?: FieldPolicy<any> | FieldReadFunction<any>;
  formLines?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isEstimateCalculation?: FieldPolicy<any> | FieldReadFunction<any>;
  isPayrollCreditEligible?: FieldPolicy<any> | FieldReadFunction<any>;
  regularMethodCreditCents?: FieldPolicy<any> | FieldReadFunction<any>;
  suppliesQreCents?: FieldPolicy<any> | FieldReadFunction<any>;
  totalQreCents?: FieldPolicy<any> | FieldReadFunction<any>;
  wagesQreCents?: FieldPolicy<any> | FieldReadFunction<any>;
  year?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FormLineItemKeySpecifier = ('line' | 'metadata' | 'type' | 'value' | FormLineItemKeySpecifier)[];
export type FormLineItemFieldPolicy = {
  line?: FieldPolicy<any> | FieldReadFunction<any>;
  metadata?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FormLineItemMetadataKeySpecifier = ('label' | 'steps' | 'valueCents' | FormLineItemMetadataKeySpecifier)[];
export type FormLineItemMetadataFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  steps?: FieldPolicy<any> | FieldReadFunction<any>;
  valueCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FourPartTestKeySpecifier = (
  | 'id'
  | 'industries'
  | 'rdTaxCreditId'
  | 'researchActivities'
  | 'tools'
  | FourPartTestKeySpecifier
)[];
export type FourPartTestFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  industries?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditId?: FieldPolicy<any> | FieldReadFunction<any>;
  researchActivities?: FieldPolicy<any> | FieldReadFunction<any>;
  tools?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GaapOnboardingFlowStatusKeySpecifier = ('percentCompleted' | GaapOnboardingFlowStatusKeySpecifier)[];
export type GaapOnboardingFlowStatusFieldPolicy = {
  percentCompleted?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GithubTokenDetailsKeySpecifier = (
  | 'observedOrganizations'
  | 'storedOrganization'
  | GithubTokenDetailsKeySpecifier
)[];
export type GithubTokenDetailsFieldPolicy = {
  observedOrganizations?: FieldPolicy<any> | FieldReadFunction<any>;
  storedOrganization?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JiraFieldMetadataKeySpecifier = (
  | 'category'
  | 'categoryErrorMessage'
  | 'fieldId'
  | 'id'
  | 'name'
  | 'rawFieldType'
  | JiraFieldMetadataKeySpecifier
)[];
export type JiraFieldMetadataFieldPolicy = {
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  fieldId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  rawFieldType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobExecutionKeySpecifier = (
  | 'attemptCount'
  | 'createdAt'
  | 'enqueuingJobExecutionId'
  | 'fileId'
  | 'id'
  | 'jobId'
  | 'jobState'
  | 'paginationId'
  | 'queueName'
  | 'requeueDatetime'
  | 'statusId'
  | 'taskDetails'
  | JobExecutionKeySpecifier
)[];
export type JobExecutionFieldPolicy = {
  attemptCount?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  enqueuingJobExecutionId?: FieldPolicy<any> | FieldReadFunction<any>;
  fileId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  jobId?: FieldPolicy<any> | FieldReadFunction<any>;
  jobState?: FieldPolicy<any> | FieldReadFunction<any>;
  paginationId?: FieldPolicy<any> | FieldReadFunction<any>;
  queueName?: FieldPolicy<any> | FieldReadFunction<any>;
  requeueDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  statusId?: FieldPolicy<any> | FieldReadFunction<any>;
  taskDetails?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type JobExecutionStateCountsKeySpecifier = (
  | 'blockedCount'
  | 'completedCount'
  | 'failedAndDequeuedCount'
  | 'failedCount'
  | 'queuedCount'
  | 'runningCount'
  | 'totalCount'
  | JobExecutionStateCountsKeySpecifier
)[];
export type JobExecutionStateCountsFieldPolicy = {
  blockedCount?: FieldPolicy<any> | FieldReadFunction<any>;
  completedCount?: FieldPolicy<any> | FieldReadFunction<any>;
  failedAndDequeuedCount?: FieldPolicy<any> | FieldReadFunction<any>;
  failedCount?: FieldPolicy<any> | FieldReadFunction<any>;
  queuedCount?: FieldPolicy<any> | FieldReadFunction<any>;
  runningCount?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LegacyDocumentsKeySpecifier = (
  | 'federalRdTaxForm'
  | 'federalRdTaxWriteUp'
  | 'id'
  | 'stateRdTaxCreditDocuments'
  | 'year'
  | LegacyDocumentsKeySpecifier
)[];
export type LegacyDocumentsFieldPolicy = {
  federalRdTaxForm?: FieldPolicy<any> | FieldReadFunction<any>;
  federalRdTaxWriteUp?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  stateRdTaxCreditDocuments?: FieldPolicy<any> | FieldReadFunction<any>;
  year?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LegacyFederalRdTaxCreditDocumentsRoKeySpecifier = (
  | 'filingMethod'
  | 'isIncomeCredit'
  | 'isReducedCredit'
  | 'name'
  | 'taxFilingId'
  | 'url'
  | LegacyFederalRdTaxCreditDocumentsRoKeySpecifier
)[];
export type LegacyFederalRdTaxCreditDocumentsRoFieldPolicy = {
  filingMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  isIncomeCredit?: FieldPolicy<any> | FieldReadFunction<any>;
  isReducedCredit?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  taxFilingId?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LegacyFederalRdTaxWriteUpDocumentsRoKeySpecifier = (
  | 'name'
  | 'url'
  | LegacyFederalRdTaxWriteUpDocumentsRoKeySpecifier
)[];
export type LegacyFederalRdTaxWriteUpDocumentsRoFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LegacyStateRdTaxCreditDocumentsRoKeySpecifier = (
  | 'name'
  | 'state'
  | 'url'
  | LegacyStateRdTaxCreditDocumentsRoKeySpecifier
)[];
export type LegacyStateRdTaxCreditDocumentsRoFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LoginAuditLogKeySpecifier = (
  | 'createdAt'
  | 'email'
  | 'id'
  | 'ipAddress'
  | 'isSuccessful'
  | 'method'
  | 'note'
  | 'rejectionReason'
  | 'reportedByClient'
  | LoginAuditLogKeySpecifier
)[];
export type LoginAuditLogFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  ipAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  isSuccessful?: FieldPolicy<any> | FieldReadFunction<any>;
  method?: FieldPolicy<any> | FieldReadFunction<any>;
  note?: FieldPolicy<any> | FieldReadFunction<any>;
  rejectionReason?: FieldPolicy<any> | FieldReadFunction<any>;
  reportedByClient?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MissingValueKeySpecifier = ('reason' | MissingValueKeySpecifier)[];
export type MissingValueFieldPolicy = {
  reason?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MonthYearKeySpecifier = ('month' | 'year' | MonthYearKeySpecifier)[];
export type MonthYearFieldPolicy = {
  month?: FieldPolicy<any> | FieldReadFunction<any>;
  year?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MonthYearPeriodKeySpecifier = ('endMonthYear' | 'startMonthYear' | MonthYearPeriodKeySpecifier)[];
export type MonthYearPeriodFieldPolicy = {
  endMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
  startMonthYear?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MoveTicketsToAscProjectOutputKeySpecifier = (
  | 'ascProjects'
  | 'contributors'
  | MoveTicketsToAscProjectOutputKeySpecifier
)[];
export type MoveTicketsToAscProjectOutputFieldPolicy = {
  ascProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  contributors?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MoveTicketsToRdProjectOutputKeySpecifier = (
  | 'rdProjects'
  | 'rdTaxCreditContributors'
  | MoveTicketsToRdProjectOutputKeySpecifier
)[];
export type MoveTicketsToRdProjectOutputFieldPolicy = {
  rdProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditContributors?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutationKeySpecifier = (
  | 'acceptInvitation'
  | 'addAscCostFile'
  | 'addAscProjectsFile'
  | 'addCompanyBulkTicketingDataFile'
  | 'addGithubEmailMappingFile'
  | 'addOrganizationInvitation'
  | 'addPriorYearTaxDocument'
  | 'addRdBusinessComponentsFile'
  | 'addRdPayrollCostFile'
  | 'addRdProjectSupportingDocument'
  | 'addRdProjectsFile'
  | 'addSentinelEmail'
  | 'addTimesheetFile'
  | 'allocateCreatorRdWagePercentages'
  | 'allowRealCompany'
  | 'applySupervisorRdPercentage'
  | 'applyWeightedCapitalizedPercentageToContributors'
  | 'applyWeightedRdPercentageToExpenses'
  | 'approveRdBusinessComponentSyncEvent'
  | 'approveRdProject'
  | 'batchUpdateAscProjectCapitalizableProjectClusteringOverride'
  | 'bulkDeleteAscProjectsInPeriod'
  | 'bulkDeleteEmptyRdProjectsForFiscalYear'
  | 'bulkRecalculateAscAllocations'
  | 'bulkRecalculateRdAllocations'
  | 'bulkUpdateRdProjectsProductByCsv'
  | 'calculateAllocationsRd'
  | 'cancelScheduledBackgroundOperation'
  | 'changeSentinelEmailScope'
  | 'clearAscProjectApproval'
  | 'clearBackgroundOperation'
  | 'clearReportOrImportOperations'
  | 'clearSyncTicketingData'
  | 'combineContributor'
  | 'copyCompany'
  | 'createAscProject'
  | 'createCompanyForOrganization'
  | 'createContributor'
  | 'createFinchAccessToken'
  | 'createFiscalYear'
  | 'createGitHubAppAuthorizationUrl'
  | 'createGitHubAppInstallUrl'
  | 'createMergeDevAccessTokenForAccounting'
  | 'createMergeDevAccessTokenForTicketing'
  | 'createProduct'
  | 'createRdBusinessComponent'
  | 'createRdProject'
  | 'createScheduledBackgroundOperation'
  | 'createSingleTenantDomainRedirect'
  | 'deleteAccountingSyncEventForFiscalYear'
  | 'deleteAccountingTokensByCompanyAndProvider'
  | 'deleteAscProject'
  | 'deleteCompany'
  | 'deleteFirebaseIdentity'
  | 'deleteOrganizationInvitation'
  | 'deletePayrollMonthExpenseSyncEvent'
  | 'deletePayrollSyncEventForFiscalYear'
  | 'deletePayrollTokensByCompanyAndProvider'
  | 'deleteProduct'
  | 'deleteRdBusinessComponent'
  | 'deleteRdProject'
  | 'deleteSingleTenantDomainRedirect'
  | 'disconnectTicketingToken'
  | 'generateAscCostCsv'
  | 'generateAscReport'
  | 'generateDocument'
  | 'generateElevatorPitch'
  | 'generateFederalRdWriteup'
  | 'generateRdDetails'
  | 'generateRdFromTimesheets'
  | 'generateRdProjectsReport'
  | 'getAndSaveAscReportSignedUrl'
  | 'getAndSaveRdProjectsReportSignedUrl'
  | 'getAscCostSignedUploadUrl'
  | 'getAscProjectsFileSignedUploadUrl'
  | 'getDemoAccountBundleSignedUploadUrl'
  | 'getGithubEmailMappingSignedUploadUrl'
  | 'getOneSchemaJwt'
  | 'getPriorYearTaxDocumentSignedUploadUrl'
  | 'getRdBusinessComponentsFileSignedUploadUrl'
  | 'getRdPayrollCostSignedUploadUrl'
  | 'getRdProjectSupportingDocumentSignedUploadUrl'
  | 'getRdProjectsFileSignedUploadUrl'
  | 'getTicketingDataSignedUploadUrl'
  | 'getTimesheetFileSignedUploadUrl'
  | 'initializeDemoAccount'
  | 'linkTicketingProviderUserToPayrollExpense'
  | 'markJobAsFailed'
  | 'mergeAscProjects'
  | 'mergeRdProjects'
  | 'moveTicketsToAscProject'
  | 'moveTicketsToRdProject'
  | 'onboardUser'
  | 'overrideQualifiedPurpose'
  | 'provisionCurrentUser'
  | 'provisionEmailPasswordUser'
  | 'queueIsolatedCoordinator'
  | 'reconcileUserState'
  | 'recordDownloadDocument'
  | 'recordSubmitDocuments'
  | 'refreshGithubOrganization'
  | 'regenerateAscCapitalizationDetermination'
  | 'regenerateRdProjectDetails'
  | 'rematchRdBusinessComponentSyncEvent'
  | 'removeCompanyBulkTicketingDataFile'
  | 'removePriorYearTaxDocument'
  | 'removeRdProjectSupportingDocument'
  | 'removeSentinelEmail'
  | 'removeUserAccessFromOrganization'
  | 'replaceUserAccessInOrganization'
  | 'reportLoginFailure'
  | 'requeueJob'
  | 'resendMyOrganizationInvitation'
  | 'resendOrganizationInvitation'
  | 'restartOnboardingFlow'
  | 'resyncTicketingDataInPeriod'
  | 'sendEmailVerification'
  | 'sendMagicLinkEmail'
  | 'sendOnboardingFlowCompleteEmail'
  | 'sendResetPasswordEmail'
  | 'setAscPeriodLock'
  | 'setAscProjectApproval'
  | 'setDistributedFlowStateIsPaused'
  | 'setUserEnterpriseSsoExemption'
  | 'settleSentinelEmail'
  | 'startProcessingTicketingData'
  | 'syncAccountingProvider'
  | 'syncPayrollProvider'
  | 'syncTicketingFiles'
  | 'unlinkTicketingProviderUserFromRdTaxCreditContributor'
  | 'updateAccountingExpense'
  | 'updateAllowAccessToDocument'
  | 'updateAscProject'
  | 'updateAscProjectCapitalizableProjectClusteringOverride'
  | 'updateAscProjectCapitalization'
  | 'updateAscProjectCapitalizationSuperUser'
  | 'updateCompanyFiscalYearEnd'
  | 'updateCompanyOfficer'
  | 'updateCompanyQuestion'
  | 'updateCompanyQuestions'
  | 'updateCompanySettings'
  | 'updateContributor'
  | 'updateContributorAllocationsForAsc'
  | 'updateFiscalYear'
  | 'updateFiscalYearProcessingTicketingDataState'
  | 'updateIpWhitelist'
  | 'updateLockedForCustomers'
  | 'updatePayrollExpense'
  | 'updatePriorYearQre'
  | 'updatePriorYearRevenue'
  | 'updateProduct'
  | 'updateRdBusinessComponent'
  | 'updateRdBusinessComponentMatchThreshold'
  | 'updateRdExpenseProjectAllocations'
  | 'updateRdProject'
  | 'updateRdProjectEligibility'
  | 'updateRdTaxCreditOverrides'
  | 'updateRequiredEnterpriseSsoProviderId'
  | 'updateSent6765'
  | 'updateShortYearPeriod'
  | 'updateSingleTenantDomainRedirect'
  | 'updateUser'
  | 'uploadAccountingExpenseCsv'
  | 'uploadAscWageReport'
  | 'uploadCsvToMoveTicketsToAscProjects'
  | 'uploadCsvToMoveTicketsToRdProjects'
  | 'uploadDocument'
  | 'uploadOrganizationPhoto'
  | 'uploadPayrollExpenseCsv'
  | 'uploadProductListCsv'
  | 'uploadRdExpenseProjectAllocationReport'
  | 'upsertCaSredSyncConfiguration'
  | 'upsertSnowflakeConfiguration'
  | 'upsertSyncConfigurationAsc'
  | 'upsertSyncConfigurationRd'
  | 'validateTicketingToken'
  | MutationKeySpecifier
)[];
export type MutationFieldPolicy = {
  acceptInvitation?: FieldPolicy<any> | FieldReadFunction<any>;
  addAscCostFile?: FieldPolicy<any> | FieldReadFunction<any>;
  addAscProjectsFile?: FieldPolicy<any> | FieldReadFunction<any>;
  addCompanyBulkTicketingDataFile?: FieldPolicy<any> | FieldReadFunction<any>;
  addGithubEmailMappingFile?: FieldPolicy<any> | FieldReadFunction<any>;
  addOrganizationInvitation?: FieldPolicy<any> | FieldReadFunction<any>;
  addPriorYearTaxDocument?: FieldPolicy<any> | FieldReadFunction<any>;
  addRdBusinessComponentsFile?: FieldPolicy<any> | FieldReadFunction<any>;
  addRdPayrollCostFile?: FieldPolicy<any> | FieldReadFunction<any>;
  addRdProjectSupportingDocument?: FieldPolicy<any> | FieldReadFunction<any>;
  addRdProjectsFile?: FieldPolicy<any> | FieldReadFunction<any>;
  addSentinelEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  addTimesheetFile?: FieldPolicy<any> | FieldReadFunction<any>;
  allocateCreatorRdWagePercentages?: FieldPolicy<any> | FieldReadFunction<any>;
  allowRealCompany?: FieldPolicy<any> | FieldReadFunction<any>;
  applySupervisorRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  applyWeightedCapitalizedPercentageToContributors?: FieldPolicy<any> | FieldReadFunction<any>;
  applyWeightedRdPercentageToExpenses?: FieldPolicy<any> | FieldReadFunction<any>;
  approveRdBusinessComponentSyncEvent?: FieldPolicy<any> | FieldReadFunction<any>;
  approveRdProject?: FieldPolicy<any> | FieldReadFunction<any>;
  batchUpdateAscProjectCapitalizableProjectClusteringOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  bulkDeleteAscProjectsInPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  bulkDeleteEmptyRdProjectsForFiscalYear?: FieldPolicy<any> | FieldReadFunction<any>;
  bulkRecalculateAscAllocations?: FieldPolicy<any> | FieldReadFunction<any>;
  bulkRecalculateRdAllocations?: FieldPolicy<any> | FieldReadFunction<any>;
  bulkUpdateRdProjectsProductByCsv?: FieldPolicy<any> | FieldReadFunction<any>;
  calculateAllocationsRd?: FieldPolicy<any> | FieldReadFunction<any>;
  cancelScheduledBackgroundOperation?: FieldPolicy<any> | FieldReadFunction<any>;
  changeSentinelEmailScope?: FieldPolicy<any> | FieldReadFunction<any>;
  clearAscProjectApproval?: FieldPolicy<any> | FieldReadFunction<any>;
  clearBackgroundOperation?: FieldPolicy<any> | FieldReadFunction<any>;
  clearReportOrImportOperations?: FieldPolicy<any> | FieldReadFunction<any>;
  clearSyncTicketingData?: FieldPolicy<any> | FieldReadFunction<any>;
  combineContributor?: FieldPolicy<any> | FieldReadFunction<any>;
  copyCompany?: FieldPolicy<any> | FieldReadFunction<any>;
  createAscProject?: FieldPolicy<any> | FieldReadFunction<any>;
  createCompanyForOrganization?: FieldPolicy<any> | FieldReadFunction<any>;
  createContributor?: FieldPolicy<any> | FieldReadFunction<any>;
  createFinchAccessToken?: FieldPolicy<any> | FieldReadFunction<any>;
  createFiscalYear?: FieldPolicy<any> | FieldReadFunction<any>;
  createGitHubAppAuthorizationUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  createGitHubAppInstallUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  createMergeDevAccessTokenForAccounting?: FieldPolicy<any> | FieldReadFunction<any>;
  createMergeDevAccessTokenForTicketing?: FieldPolicy<any> | FieldReadFunction<any>;
  createProduct?: FieldPolicy<any> | FieldReadFunction<any>;
  createRdBusinessComponent?: FieldPolicy<any> | FieldReadFunction<any>;
  createRdProject?: FieldPolicy<any> | FieldReadFunction<any>;
  createScheduledBackgroundOperation?: FieldPolicy<any> | FieldReadFunction<any>;
  createSingleTenantDomainRedirect?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteAccountingSyncEventForFiscalYear?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteAccountingTokensByCompanyAndProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteAscProject?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteCompany?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteFirebaseIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteOrganizationInvitation?: FieldPolicy<any> | FieldReadFunction<any>;
  deletePayrollMonthExpenseSyncEvent?: FieldPolicy<any> | FieldReadFunction<any>;
  deletePayrollSyncEventForFiscalYear?: FieldPolicy<any> | FieldReadFunction<any>;
  deletePayrollTokensByCompanyAndProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteProduct?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteRdBusinessComponent?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteRdProject?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteSingleTenantDomainRedirect?: FieldPolicy<any> | FieldReadFunction<any>;
  disconnectTicketingToken?: FieldPolicy<any> | FieldReadFunction<any>;
  generateAscCostCsv?: FieldPolicy<any> | FieldReadFunction<any>;
  generateAscReport?: FieldPolicy<any> | FieldReadFunction<any>;
  generateDocument?: FieldPolicy<any> | FieldReadFunction<any>;
  generateElevatorPitch?: FieldPolicy<any> | FieldReadFunction<any>;
  generateFederalRdWriteup?: FieldPolicy<any> | FieldReadFunction<any>;
  generateRdDetails?: FieldPolicy<any> | FieldReadFunction<any>;
  generateRdFromTimesheets?: FieldPolicy<any> | FieldReadFunction<any>;
  generateRdProjectsReport?: FieldPolicy<any> | FieldReadFunction<any>;
  getAndSaveAscReportSignedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getAndSaveRdProjectsReportSignedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscCostSignedUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscProjectsFileSignedUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getDemoAccountBundleSignedUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getGithubEmailMappingSignedUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getOneSchemaJwt?: FieldPolicy<any> | FieldReadFunction<any>;
  getPriorYearTaxDocumentSignedUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdBusinessComponentsFileSignedUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdPayrollCostSignedUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdProjectSupportingDocumentSignedUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdProjectsFileSignedUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getTicketingDataSignedUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getTimesheetFileSignedUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  initializeDemoAccount?: FieldPolicy<any> | FieldReadFunction<any>;
  linkTicketingProviderUserToPayrollExpense?: FieldPolicy<any> | FieldReadFunction<any>;
  markJobAsFailed?: FieldPolicy<any> | FieldReadFunction<any>;
  mergeAscProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  mergeRdProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  moveTicketsToAscProject?: FieldPolicy<any> | FieldReadFunction<any>;
  moveTicketsToRdProject?: FieldPolicy<any> | FieldReadFunction<any>;
  onboardUser?: FieldPolicy<any> | FieldReadFunction<any>;
  overrideQualifiedPurpose?: FieldPolicy<any> | FieldReadFunction<any>;
  provisionCurrentUser?: FieldPolicy<any> | FieldReadFunction<any>;
  provisionEmailPasswordUser?: FieldPolicy<any> | FieldReadFunction<any>;
  queueIsolatedCoordinator?: FieldPolicy<any> | FieldReadFunction<any>;
  reconcileUserState?: FieldPolicy<any> | FieldReadFunction<any>;
  recordDownloadDocument?: FieldPolicy<any> | FieldReadFunction<any>;
  recordSubmitDocuments?: FieldPolicy<any> | FieldReadFunction<any>;
  refreshGithubOrganization?: FieldPolicy<any> | FieldReadFunction<any>;
  regenerateAscCapitalizationDetermination?: FieldPolicy<any> | FieldReadFunction<any>;
  regenerateRdProjectDetails?: FieldPolicy<any> | FieldReadFunction<any>;
  rematchRdBusinessComponentSyncEvent?: FieldPolicy<any> | FieldReadFunction<any>;
  removeCompanyBulkTicketingDataFile?: FieldPolicy<any> | FieldReadFunction<any>;
  removePriorYearTaxDocument?: FieldPolicy<any> | FieldReadFunction<any>;
  removeRdProjectSupportingDocument?: FieldPolicy<any> | FieldReadFunction<any>;
  removeSentinelEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  removeUserAccessFromOrganization?: FieldPolicy<any> | FieldReadFunction<any>;
  replaceUserAccessInOrganization?: FieldPolicy<any> | FieldReadFunction<any>;
  reportLoginFailure?: FieldPolicy<any> | FieldReadFunction<any>;
  requeueJob?: FieldPolicy<any> | FieldReadFunction<any>;
  resendMyOrganizationInvitation?: FieldPolicy<any> | FieldReadFunction<any>;
  resendOrganizationInvitation?: FieldPolicy<any> | FieldReadFunction<any>;
  restartOnboardingFlow?: FieldPolicy<any> | FieldReadFunction<any>;
  resyncTicketingDataInPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  sendEmailVerification?: FieldPolicy<any> | FieldReadFunction<any>;
  sendMagicLinkEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  sendOnboardingFlowCompleteEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  sendResetPasswordEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  setAscPeriodLock?: FieldPolicy<any> | FieldReadFunction<any>;
  setAscProjectApproval?: FieldPolicy<any> | FieldReadFunction<any>;
  setDistributedFlowStateIsPaused?: FieldPolicy<any> | FieldReadFunction<any>;
  setUserEnterpriseSsoExemption?: FieldPolicy<any> | FieldReadFunction<any>;
  settleSentinelEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  startProcessingTicketingData?: FieldPolicy<any> | FieldReadFunction<any>;
  syncAccountingProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  syncPayrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  syncTicketingFiles?: FieldPolicy<any> | FieldReadFunction<any>;
  unlinkTicketingProviderUserFromRdTaxCreditContributor?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAccountingExpense?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAllowAccessToDocument?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAscProject?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAscProjectCapitalizableProjectClusteringOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAscProjectCapitalization?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAscProjectCapitalizationSuperUser?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCompanyFiscalYearEnd?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCompanyOfficer?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCompanyQuestion?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCompanyQuestions?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCompanySettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateContributor?: FieldPolicy<any> | FieldReadFunction<any>;
  updateContributorAllocationsForAsc?: FieldPolicy<any> | FieldReadFunction<any>;
  updateFiscalYear?: FieldPolicy<any> | FieldReadFunction<any>;
  updateFiscalYearProcessingTicketingDataState?: FieldPolicy<any> | FieldReadFunction<any>;
  updateIpWhitelist?: FieldPolicy<any> | FieldReadFunction<any>;
  updateLockedForCustomers?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePayrollExpense?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePriorYearQre?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePriorYearRevenue?: FieldPolicy<any> | FieldReadFunction<any>;
  updateProduct?: FieldPolicy<any> | FieldReadFunction<any>;
  updateRdBusinessComponent?: FieldPolicy<any> | FieldReadFunction<any>;
  updateRdBusinessComponentMatchThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  updateRdExpenseProjectAllocations?: FieldPolicy<any> | FieldReadFunction<any>;
  updateRdProject?: FieldPolicy<any> | FieldReadFunction<any>;
  updateRdProjectEligibility?: FieldPolicy<any> | FieldReadFunction<any>;
  updateRdTaxCreditOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  updateRequiredEnterpriseSsoProviderId?: FieldPolicy<any> | FieldReadFunction<any>;
  updateSent6765?: FieldPolicy<any> | FieldReadFunction<any>;
  updateShortYearPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  updateSingleTenantDomainRedirect?: FieldPolicy<any> | FieldReadFunction<any>;
  updateUser?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadAccountingExpenseCsv?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadAscWageReport?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadCsvToMoveTicketsToAscProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadCsvToMoveTicketsToRdProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadDocument?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadOrganizationPhoto?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadPayrollExpenseCsv?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadProductListCsv?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadRdExpenseProjectAllocationReport?: FieldPolicy<any> | FieldReadFunction<any>;
  upsertCaSredSyncConfiguration?: FieldPolicy<any> | FieldReadFunction<any>;
  upsertSnowflakeConfiguration?: FieldPolicy<any> | FieldReadFunction<any>;
  upsertSyncConfigurationAsc?: FieldPolicy<any> | FieldReadFunction<any>;
  upsertSyncConfigurationRd?: FieldPolicy<any> | FieldReadFunction<any>;
  validateTicketingToken?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OnCallShiftKeySpecifier = ('endDate' | 'name' | 'startDate' | 'team' | OnCallShiftKeySpecifier)[];
export type OnCallShiftFieldPolicy = {
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrganizationKeySpecifier = (
  | 'companies'
  | 'id'
  | 'invitedMembers'
  | 'ipWhitelist'
  | 'isAccountingFirm'
  | 'members'
  | 'name'
  | 'photoUrl'
  | 'requiredEnterpriseSsoProviderId'
  | OrganizationKeySpecifier
)[];
export type OrganizationFieldPolicy = {
  companies?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  invitedMembers?: FieldPolicy<any> | FieldReadFunction<any>;
  ipWhitelist?: FieldPolicy<any> | FieldReadFunction<any>;
  isAccountingFirm?: FieldPolicy<any> | FieldReadFunction<any>;
  members?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  photoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  requiredEnterpriseSsoProviderId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrganizationInvitationKeySpecifier = (
  | 'acceptedAt'
  | 'derivedState'
  | 'email'
  | 'expiresAt'
  | 'id'
  | 'organization'
  | 'organizationId'
  | 'revokedAt'
  | 'scope'
  | OrganizationInvitationKeySpecifier
)[];
export type OrganizationInvitationFieldPolicy = {
  acceptedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  derivedState?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  expiresAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  organization?: FieldPolicy<any> | FieldReadFunction<any>;
  organizationId?: FieldPolicy<any> | FieldReadFunction<any>;
  revokedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  scope?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PageInfoKeySpecifier = (
  | 'endCursor'
  | 'hasNextPage'
  | 'hasPreviousPage'
  | 'startCursor'
  | PageInfoKeySpecifier
)[];
export type PageInfoFieldPolicy = {
  endCursor?: FieldPolicy<any> | FieldReadFunction<any>;
  hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>;
  hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>;
  startCursor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ParentQuestionChoiceKeySpecifier = ('id' | 'parentQuestionId' | ParentQuestionChoiceKeySpecifier)[];
export type ParentQuestionChoiceFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  parentQuestionId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollExpenseKeySpecifier = (
  | 'amountCents'
  | 'fiscalYearId'
  | 'id'
  | 'payrollProvider'
  | 'payrollQre'
  | 'wageType'
  | PayrollExpenseKeySpecifier
)[];
export type PayrollExpenseFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollQre?: FieldPolicy<any> | FieldReadFunction<any>;
  wageType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollQreKeySpecifier = (
  | 'amountCents'
  | 'costCenter'
  | 'country'
  | 'department'
  | 'email'
  | 'entity'
  | 'fiscalYearId'
  | 'hireDate'
  | 'id'
  | 'isMatched'
  | 'isOfficer'
  | 'managerName'
  | 'name'
  | 'payrollExpenseId'
  | 'payrollProvider'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | 'rdCategory'
  | 'rdTaxCreditContributorId'
  | 'state'
  | 'terminationDate'
  | 'ticketingProviders'
  | 'title'
  | PayrollQreKeySpecifier
)[];
export type PayrollQreFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isMatched?: FieldPolicy<any> | FieldReadFunction<any>;
  isOfficer?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollExpenseId?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditContributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDate?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingProviders?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollQreAggregateGroupByKeySpecifier = (
  | 'amountCents'
  | 'costCenter'
  | 'country'
  | 'department'
  | 'email'
  | 'entity'
  | 'hireDate'
  | 'id'
  | 'isMatched'
  | 'isOfficer'
  | 'managerName'
  | 'name'
  | 'payrollProvider'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | 'rdCategory'
  | 'state'
  | 'terminationDate'
  | 'title'
  | PayrollQreAggregateGroupByKeySpecifier
)[];
export type PayrollQreAggregateGroupByFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isMatched?: FieldPolicy<any> | FieldReadFunction<any>;
  isOfficer?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDate?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollQreAvgAggregateKeySpecifier = (
  | 'amountCents'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | PayrollQreAvgAggregateKeySpecifier
)[];
export type PayrollQreAvgAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollQreConnectionKeySpecifier = ('edges' | 'pageInfo' | PayrollQreConnectionKeySpecifier)[];
export type PayrollQreConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollQreCountAggregateKeySpecifier = (
  | 'amountCents'
  | 'costCenter'
  | 'country'
  | 'department'
  | 'email'
  | 'entity'
  | 'hireDate'
  | 'id'
  | 'isMatched'
  | 'isOfficer'
  | 'managerName'
  | 'name'
  | 'payrollProvider'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | 'rdCategory'
  | 'state'
  | 'terminationDate'
  | 'title'
  | PayrollQreCountAggregateKeySpecifier
)[];
export type PayrollQreCountAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isMatched?: FieldPolicy<any> | FieldReadFunction<any>;
  isOfficer?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDate?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollQreEdgeKeySpecifier = ('cursor' | 'node' | PayrollQreEdgeKeySpecifier)[];
export type PayrollQreEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollQreMaxAggregateKeySpecifier = (
  | 'amountCents'
  | 'costCenter'
  | 'country'
  | 'department'
  | 'email'
  | 'entity'
  | 'hireDate'
  | 'id'
  | 'managerName'
  | 'name'
  | 'payrollProvider'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | 'rdCategory'
  | 'state'
  | 'terminationDate'
  | 'title'
  | PayrollQreMaxAggregateKeySpecifier
)[];
export type PayrollQreMaxAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDate?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollQreMinAggregateKeySpecifier = (
  | 'amountCents'
  | 'costCenter'
  | 'country'
  | 'department'
  | 'email'
  | 'entity'
  | 'hireDate'
  | 'id'
  | 'managerName'
  | 'name'
  | 'payrollProvider'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | 'rdCategory'
  | 'state'
  | 'terminationDate'
  | 'title'
  | PayrollQreMinAggregateKeySpecifier
)[];
export type PayrollQreMinAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDate?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollQreSumAggregateKeySpecifier = (
  | 'amountCents'
  | 'qreRdPercentage'
  | 'qualifiedAmountCents'
  | PayrollQreSumAggregateKeySpecifier
)[];
export type PayrollQreSumAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollQreSummaryKeySpecifier = (
  | 'avg'
  | 'count'
  | 'groupBy'
  | 'max'
  | 'min'
  | 'sum'
  | 'uniqueCount'
  | PayrollQreSummaryKeySpecifier
)[];
export type PayrollQreSummaryFieldPolicy = {
  avg?: FieldPolicy<any> | FieldReadFunction<any>;
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  groupBy?: FieldPolicy<any> | FieldReadFunction<any>;
  max?: FieldPolicy<any> | FieldReadFunction<any>;
  min?: FieldPolicy<any> | FieldReadFunction<any>;
  sum?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollQreUniqueCountAggregateKeySpecifier = (
  | 'costCenter'
  | 'country'
  | 'department'
  | 'entity'
  | 'managerName'
  | 'rdCategory'
  | 'state'
  | 'title'
  | PayrollQreUniqueCountAggregateKeySpecifier
)[];
export type PayrollQreUniqueCountAggregateFieldPolicy = {
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PayrollTokenKeySpecifier = (
  | 'createdAt'
  | 'finchScopeType'
  | 'id'
  | 'payrollProvider'
  | PayrollTokenKeySpecifier
)[];
export type PayrollTokenFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  finchScopeType?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PreviewAllocationChangeResultKeySpecifier = (
  | 'contributorName'
  | 'currentMethod'
  | 'currentNonProjectTimePercentage'
  | 'currentTotalRdPercentage'
  | 'newNonProjectTimePercentage'
  | 'newTotalRdPercentage'
  | 'projectAllocations'
  | 'rdTaxCreditContributorId'
  | 'targetMethod'
  | 'totalEffortDaysForEligibleProjects'
  | 'totalTicketCount'
  | PreviewAllocationChangeResultKeySpecifier
)[];
export type PreviewAllocationChangeResultFieldPolicy = {
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  currentMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  currentNonProjectTimePercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  currentTotalRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  newNonProjectTimePercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  newTotalRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  projectAllocations?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditContributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  targetMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  totalEffortDaysForEligibleProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  totalTicketCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PreviewAllocationProjectKeySpecifier = (
  | 'currentPercentage'
  | 'isEligibleForRd'
  | 'newPercentage'
  | 'projectName'
  | 'rdProjectId'
  | PreviewAllocationProjectKeySpecifier
)[];
export type PreviewAllocationProjectFieldPolicy = {
  currentPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  isEligibleForRd?: FieldPolicy<any> | FieldReadFunction<any>;
  newPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  projectName?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PriorYearQREKeySpecifier = (
  | 'amount'
  | 'taxYearEndDate'
  | 'taxYearStartDate'
  | 'url'
  | 'year'
  | PriorYearQREKeySpecifier
)[];
export type PriorYearQREFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  taxYearEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  taxYearStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  year?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PriorYearRevenueKeySpecifier = (
  | 'id'
  | 'revenueCents'
  | 'revenueSource'
  | 'taxYearEndDate'
  | 'taxYearStartDate'
  | 'year'
  | PriorYearRevenueKeySpecifier
)[];
export type PriorYearRevenueFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  revenueCents?: FieldPolicy<any> | FieldReadFunction<any>;
  revenueSource?: FieldPolicy<any> | FieldReadFunction<any>;
  taxYearEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  taxYearStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  year?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductKeySpecifier = ('id' | 'name' | ProductKeySpecifier)[];
export type ProductFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProjectPerAccountingExpenseKeySpecifier = (
  | 'allocationPercentNotRounded'
  | 'id'
  | 'rdProjectId'
  | ProjectPerAccountingExpenseKeySpecifier
)[];
export type ProjectPerAccountingExpenseFieldPolicy = {
  allocationPercentNotRounded?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProjectPerRdExpenseKeySpecifier = (
  | 'allocationPercentNotRounded'
  | 'id'
  | 'rdProjectId'
  | ProjectPerRdExpenseKeySpecifier
)[];
export type ProjectPerRdExpenseFieldPolicy = {
  allocationPercentNotRounded?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProjectRdDeterminationKeySpecifier = (
  | 'createsNewProductOrProcess'
  | 'hasQualifiedPurpose'
  | 'hasQualifiedPurposeSource'
  | 'hasTechnicalUncertainties'
  | 'id'
  | 'improvedAspects'
  | 'isTechnicalInNature'
  | 'isTechnicalInNatureSource'
  | 'processOfExperimentationNarrative'
  | 'projectRdDeterminationUncertainties'
  | 'qualifiedPurposeReasoning'
  | 'qualifiedPurposeReasoningSource'
  | 'technicalInNatureShare'
  | 'technicalUncertaintiesNarrative'
  | 'technicalUncertaintiesReasoning'
  | ProjectRdDeterminationKeySpecifier
)[];
export type ProjectRdDeterminationFieldPolicy = {
  createsNewProductOrProcess?: FieldPolicy<any> | FieldReadFunction<any>;
  hasQualifiedPurpose?: FieldPolicy<any> | FieldReadFunction<any>;
  hasQualifiedPurposeSource?: FieldPolicy<any> | FieldReadFunction<any>;
  hasTechnicalUncertainties?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  improvedAspects?: FieldPolicy<any> | FieldReadFunction<any>;
  isTechnicalInNature?: FieldPolicy<any> | FieldReadFunction<any>;
  isTechnicalInNatureSource?: FieldPolicy<any> | FieldReadFunction<any>;
  processOfExperimentationNarrative?: FieldPolicy<any> | FieldReadFunction<any>;
  projectRdDeterminationUncertainties?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedPurposeReasoning?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedPurposeReasoningSource?: FieldPolicy<any> | FieldReadFunction<any>;
  technicalInNatureShare?: FieldPolicy<any> | FieldReadFunction<any>;
  technicalUncertaintiesNarrative?: FieldPolicy<any> | FieldReadFunction<any>;
  technicalUncertaintiesReasoning?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProjectRdDeterminationUncertaintyKeySpecifier = (
  | 'id'
  | 'matchedTicketCount'
  | 'uncertainty'
  | ProjectRdDeterminationUncertaintyKeySpecifier
)[];
export type ProjectRdDeterminationUncertaintyFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  matchedTicketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  uncertainty?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueryKeySpecifier = (
  | 'generateRdProjectNameAndDescription'
  | 'getAccountingExpense'
  | 'getAccountingQreSummary'
  | 'getAccountingQres'
  | 'getAllDocuments'
  | 'getAllLegacyDocuments'
  | 'getAllocationChangePreview'
  | 'getAscContributorProjectAllocations'
  | 'getAscPeriodLockStatus'
  | 'getAscProject'
  | 'getAscProjectCountInDateRange'
  | 'getAscProjectGroupingTicketsOrCollections'
  | 'getAscProjectReport'
  | 'getAscProjectTeamMembers'
  | 'getAscProjectTpTickets'
  | 'getAscProjects'
  | 'getAscProjectsSummary'
  | 'getAscSnapshotDocumentEvents'
  | 'getAscWage'
  | 'getAscWageReport'
  | 'getAscWageSummary'
  | 'getAscWages'
  | 'getBackgroundOperations'
  | 'getBulkTicketingDataFileUploads'
  | 'getCaSredSyncConfiguration'
  | 'getCompaniesForUser'
  | 'getCompany'
  | 'getCompanyOfficerPayrollQres'
  | 'getContributor'
  | 'getCreditEstimate'
  | 'getDemoAccountReadiness'
  | 'getDemoBundlePreflightReport'
  | 'getDistributedFlow'
  | 'getDistributedFlowsForCompany'
  | 'getDocumentEventSignedUrl'
  | 'getDocuments'
  | 'getEmptyRdProjectsDeletionPreview'
  | 'getExcludedWorkstreamsForSyncConfigAscId'
  | 'getFederalDocumentStatuses'
  | 'getFinchSession'
  | 'getFiscalYear'
  | 'getGaapOnboardingFlowStatus'
  | 'getInProgressDistributedFlows'
  | 'getJiraFieldMetadataForCompany'
  | 'getLatestAscReportDocumentEvent'
  | 'getLatestFederalDocumentStatusesForCompany'
  | 'getMergeDevLinkToken'
  | 'getMergedRdProjectId'
  | 'getOnCallRotation'
  | 'getOrganization'
  | 'getOrganizationMembersCsv'
  | 'getPayrollExpense'
  | 'getPayrollQreSummary'
  | 'getPayrollQres'
  | 'getPendingSentinelEmails'
  | 'getProducts'
  | 'getRdBusinessComponentTicketMatches'
  | 'getRdExpense'
  | 'getRdExpenseProjectAllocationReport'
  | 'getRdExpenseProjectAllocations'
  | 'getRdProject'
  | 'getRdProjectCountForDetailsUpdate'
  | 'getRdProjectCountInPeriod'
  | 'getRdProjectGroupingTicketsOrCollections'
  | 'getRdProjectReport'
  | 'getRdProjectTeamMembers'
  | 'getRdProjectTpTickets'
  | 'getRdProjects'
  | 'getRdProjectsSummary'
  | 'getRdTaxCreditContributor'
  | 'getRdTaxCreditContributorsWithAllocation'
  | 'getRdTicketMatchExport'
  | 'getReport'
  | 'getScheduledBackgroundOperationForToken'
  | 'getScheduledBackgroundOperations'
  | 'getSentinelEmails'
  | 'getServerInfo'
  | 'getSingleTenantDomainRedirects'
  | 'getSingleTenantRedirectUrl'
  | 'getSnowflakeConfiguration'
  | 'getSredPayrollExpenses'
  | 'getSredPayrollExpensesSummary'
  | 'getSredProject'
  | 'getSredProjects'
  | 'getStateDocumentStatus'
  | 'getSupervisorRdAnalysisPreview'
  | 'getSupervisorsInExpenses'
  | 'getTicketingProviderSyncEvents'
  | 'getTicketingProviderWorkstreamsForCompany'
  | 'getTicketingUsers'
  | 'getTimesheetRdReport'
  | 'getTimesheetRdReportCsv'
  | 'getTimesheetSyncEvents'
  | 'getUnfinishedSyncEventsInPeriodByAnalysisType'
  | 'getUser'
  | 'getUserFromAuth'
  | 'isVersionOutdated'
  | 'rdExpenseProjects'
  | 'searchFirebaseIdentities'
  | 'searchFirebaseIdentitiesByName'
  | 'searchForCompanies'
  | 'searchForOrganization'
  | 'searchForPotentialCompanyOfficers'
  | 'searchForUsers'
  | 'searchLoginAuditLogs'
  | QueryKeySpecifier
)[];
export type QueryFieldPolicy = {
  generateRdProjectNameAndDescription?: FieldPolicy<any> | FieldReadFunction<any>;
  getAccountingExpense?: FieldPolicy<any> | FieldReadFunction<any>;
  getAccountingQreSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  getAccountingQres?: FieldPolicy<any> | FieldReadFunction<any>;
  getAllDocuments?: FieldPolicy<any> | FieldReadFunction<any>;
  getAllLegacyDocuments?: FieldPolicy<any> | FieldReadFunction<any>;
  getAllocationChangePreview?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscContributorProjectAllocations?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscPeriodLockStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscProject?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscProjectCountInDateRange?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscProjectGroupingTicketsOrCollections?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscProjectReport?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscProjectTeamMembers?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscProjectTpTickets?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscProjectsSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscSnapshotDocumentEvents?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscWage?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscWageReport?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscWageSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  getAscWages?: FieldPolicy<any> | FieldReadFunction<any>;
  getBackgroundOperations?: FieldPolicy<any> | FieldReadFunction<any>;
  getBulkTicketingDataFileUploads?: FieldPolicy<any> | FieldReadFunction<any>;
  getCaSredSyncConfiguration?: FieldPolicy<any> | FieldReadFunction<any>;
  getCompaniesForUser?: FieldPolicy<any> | FieldReadFunction<any>;
  getCompany?: FieldPolicy<any> | FieldReadFunction<any>;
  getCompanyOfficerPayrollQres?: FieldPolicy<any> | FieldReadFunction<any>;
  getContributor?: FieldPolicy<any> | FieldReadFunction<any>;
  getCreditEstimate?: FieldPolicy<any> | FieldReadFunction<any>;
  getDemoAccountReadiness?: FieldPolicy<any> | FieldReadFunction<any>;
  getDemoBundlePreflightReport?: FieldPolicy<any> | FieldReadFunction<any>;
  getDistributedFlow?: FieldPolicy<any> | FieldReadFunction<any>;
  getDistributedFlowsForCompany?: FieldPolicy<any> | FieldReadFunction<any>;
  getDocumentEventSignedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getDocuments?: FieldPolicy<any> | FieldReadFunction<any>;
  getEmptyRdProjectsDeletionPreview?: FieldPolicy<any> | FieldReadFunction<any>;
  getExcludedWorkstreamsForSyncConfigAscId?: FieldPolicy<any> | FieldReadFunction<any>;
  getFederalDocumentStatuses?: FieldPolicy<any> | FieldReadFunction<any>;
  getFinchSession?: FieldPolicy<any> | FieldReadFunction<any>;
  getFiscalYear?: FieldPolicy<any> | FieldReadFunction<any>;
  getGaapOnboardingFlowStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  getInProgressDistributedFlows?: FieldPolicy<any> | FieldReadFunction<any>;
  getJiraFieldMetadataForCompany?: FieldPolicy<any> | FieldReadFunction<any>;
  getLatestAscReportDocumentEvent?: FieldPolicy<any> | FieldReadFunction<any>;
  getLatestFederalDocumentStatusesForCompany?: FieldPolicy<any> | FieldReadFunction<any>;
  getMergeDevLinkToken?: FieldPolicy<any> | FieldReadFunction<any>;
  getMergedRdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  getOnCallRotation?: FieldPolicy<any> | FieldReadFunction<any>;
  getOrganization?: FieldPolicy<any> | FieldReadFunction<any>;
  getOrganizationMembersCsv?: FieldPolicy<any> | FieldReadFunction<any>;
  getPayrollExpense?: FieldPolicy<any> | FieldReadFunction<any>;
  getPayrollQreSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  getPayrollQres?: FieldPolicy<any> | FieldReadFunction<any>;
  getPendingSentinelEmails?: FieldPolicy<any> | FieldReadFunction<any>;
  getProducts?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdBusinessComponentTicketMatches?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdExpense?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdExpenseProjectAllocationReport?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdExpenseProjectAllocations?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdProject?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdProjectCountForDetailsUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdProjectCountInPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdProjectGroupingTicketsOrCollections?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdProjectReport?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdProjectTeamMembers?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdProjectTpTickets?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdProjectsSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdTaxCreditContributor?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdTaxCreditContributorsWithAllocation?: FieldPolicy<any> | FieldReadFunction<any>;
  getRdTicketMatchExport?: FieldPolicy<any> | FieldReadFunction<any>;
  getReport?: FieldPolicy<any> | FieldReadFunction<any>;
  getScheduledBackgroundOperationForToken?: FieldPolicy<any> | FieldReadFunction<any>;
  getScheduledBackgroundOperations?: FieldPolicy<any> | FieldReadFunction<any>;
  getSentinelEmails?: FieldPolicy<any> | FieldReadFunction<any>;
  getServerInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  getSingleTenantDomainRedirects?: FieldPolicy<any> | FieldReadFunction<any>;
  getSingleTenantRedirectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  getSnowflakeConfiguration?: FieldPolicy<any> | FieldReadFunction<any>;
  getSredPayrollExpenses?: FieldPolicy<any> | FieldReadFunction<any>;
  getSredPayrollExpensesSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  getSredProject?: FieldPolicy<any> | FieldReadFunction<any>;
  getSredProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  getStateDocumentStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  getSupervisorRdAnalysisPreview?: FieldPolicy<any> | FieldReadFunction<any>;
  getSupervisorsInExpenses?: FieldPolicy<any> | FieldReadFunction<any>;
  getTicketingProviderSyncEvents?: FieldPolicy<any> | FieldReadFunction<any>;
  getTicketingProviderWorkstreamsForCompany?: FieldPolicy<any> | FieldReadFunction<any>;
  getTicketingUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  getTimesheetRdReport?: FieldPolicy<any> | FieldReadFunction<any>;
  getTimesheetRdReportCsv?: FieldPolicy<any> | FieldReadFunction<any>;
  getTimesheetSyncEvents?: FieldPolicy<any> | FieldReadFunction<any>;
  getUnfinishedSyncEventsInPeriodByAnalysisType?: FieldPolicy<any> | FieldReadFunction<any>;
  getUser?: FieldPolicy<any> | FieldReadFunction<any>;
  getUserFromAuth?: FieldPolicy<any> | FieldReadFunction<any>;
  isVersionOutdated?: FieldPolicy<any> | FieldReadFunction<any>;
  rdExpenseProjects?: FieldPolicy<any> | FieldReadFunction<any>;
  searchFirebaseIdentities?: FieldPolicy<any> | FieldReadFunction<any>;
  searchFirebaseIdentitiesByName?: FieldPolicy<any> | FieldReadFunction<any>;
  searchForCompanies?: FieldPolicy<any> | FieldReadFunction<any>;
  searchForOrganization?: FieldPolicy<any> | FieldReadFunction<any>;
  searchForPotentialCompanyOfficers?: FieldPolicy<any> | FieldReadFunction<any>;
  searchForUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  searchLoginAuditLogs?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionKeySpecifier = (
  | 'answerType'
  | 'answerValue'
  | 'displayOrder'
  | 'displaySubtext'
  | 'displayText'
  | 'id'
  | 'inputType'
  | 'parentQuestionChoice'
  | 'placeholder'
  | 'questionChoices'
  | 'questionCode'
  | 'questionId'
  | QuestionKeySpecifier
)[];
export type QuestionFieldPolicy = {
  answerType?: FieldPolicy<any> | FieldReadFunction<any>;
  answerValue?: FieldPolicy<any> | FieldReadFunction<any>;
  displayOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  displaySubtext?: FieldPolicy<any> | FieldReadFunction<any>;
  displayText?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  inputType?: FieldPolicy<any> | FieldReadFunction<any>;
  parentQuestionChoice?: FieldPolicy<any> | FieldReadFunction<any>;
  placeholder?: FieldPolicy<any> | FieldReadFunction<any>;
  questionChoices?: FieldPolicy<any> | FieldReadFunction<any>;
  questionCode?: FieldPolicy<any> | FieldReadFunction<any>;
  questionId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionChoiceKeySpecifier = (
  | 'choiceCode'
  | 'displayOrder'
  | 'displaySubtext'
  | 'displayText'
  | 'id'
  | 'selected'
  | QuestionChoiceKeySpecifier
)[];
export type QuestionChoiceFieldPolicy = {
  choiceCode?: FieldPolicy<any> | FieldReadFunction<any>;
  displayOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  displaySubtext?: FieldPolicy<any> | FieldReadFunction<any>;
  displayText?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  selected?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionSectionKeySpecifier = (
  | 'displayOrder'
  | 'displaySubtext'
  | 'displayText'
  | 'id'
  | 'questions'
  | 'sectionCode'
  | QuestionSectionKeySpecifier
)[];
export type QuestionSectionFieldPolicy = {
  displayOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  displaySubtext?: FieldPolicy<any> | FieldReadFunction<any>;
  displayText?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  questions?: FieldPolicy<any> | FieldReadFunction<any>;
  sectionCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RDTaxCreditKeySpecifier = (
  | 'acceptedTermsOfServiceDate'
  | 'fiscalYear'
  | 'fourPartTest'
  | 'id'
  | 'lastUpdatedAt'
  | 'rdTaxCreditQuestions'
  | 'sent6765'
  | 'useIncomeCredit'
  | 'useReducedCredit'
  | RDTaxCreditKeySpecifier
)[];
export type RDTaxCreditFieldPolicy = {
  acceptedTermsOfServiceDate?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYear?: FieldPolicy<any> | FieldReadFunction<any>;
  fourPartTest?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditQuestions?: FieldPolicy<any> | FieldReadFunction<any>;
  sent6765?: FieldPolicy<any> | FieldReadFunction<any>;
  useIncomeCredit?: FieldPolicy<any> | FieldReadFunction<any>;
  useReducedCredit?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RDTaxQuestionsKeySpecifier = (
  | 'fiscalYearEndsInDec'
  | 'furthestVisitedExpense'
  | 'hasAnAccountant'
  | 'hasCalendarYearBasis'
  | 'hasClaimedErc'
  | 'hasFiledExtension'
  | 'hasFiledTaxReturn'
  | 'hasFundedResearch'
  | 'hasMadeFiveMillion'
  | 'hasPayrollEin'
  | 'hasTaxableIncome'
  | 'hasTaxableIncomeAfterDeduction'
  | 'hasW2Employees'
  | 'haveBooksFinalized'
  | 'howIsYourBusinessEntityTaxed'
  | 'isProfitable'
  | 'monthAndDayOfTaxYearEnd'
  | 'payrollEin'
  | 'payrollProviders'
  | 'receivedFundingTypes'
  | RDTaxQuestionsKeySpecifier
)[];
export type RDTaxQuestionsFieldPolicy = {
  fiscalYearEndsInDec?: FieldPolicy<any> | FieldReadFunction<any>;
  furthestVisitedExpense?: FieldPolicy<any> | FieldReadFunction<any>;
  hasAnAccountant?: FieldPolicy<any> | FieldReadFunction<any>;
  hasCalendarYearBasis?: FieldPolicy<any> | FieldReadFunction<any>;
  hasClaimedErc?: FieldPolicy<any> | FieldReadFunction<any>;
  hasFiledExtension?: FieldPolicy<any> | FieldReadFunction<any>;
  hasFiledTaxReturn?: FieldPolicy<any> | FieldReadFunction<any>;
  hasFundedResearch?: FieldPolicy<any> | FieldReadFunction<any>;
  hasMadeFiveMillion?: FieldPolicy<any> | FieldReadFunction<any>;
  hasPayrollEin?: FieldPolicy<any> | FieldReadFunction<any>;
  hasTaxableIncome?: FieldPolicy<any> | FieldReadFunction<any>;
  hasTaxableIncomeAfterDeduction?: FieldPolicy<any> | FieldReadFunction<any>;
  hasW2Employees?: FieldPolicy<any> | FieldReadFunction<any>;
  haveBooksFinalized?: FieldPolicy<any> | FieldReadFunction<any>;
  howIsYourBusinessEntityTaxed?: FieldPolicy<any> | FieldReadFunction<any>;
  isProfitable?: FieldPolicy<any> | FieldReadFunction<any>;
  monthAndDayOfTaxYearEnd?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollEin?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProviders?: FieldPolicy<any> | FieldReadFunction<any>;
  receivedFundingTypes?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdBusinessComponentKeySpecifier = (
  | 'businessComponentId'
  | 'canonicalName'
  | 'description'
  | 'keywords'
  | 'minimumExpectedShare'
  | 'source'
  | 'variants'
  | RdBusinessComponentKeySpecifier
)[];
export type RdBusinessComponentFieldPolicy = {
  businessComponentId?: FieldPolicy<any> | FieldReadFunction<any>;
  canonicalName?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  keywords?: FieldPolicy<any> | FieldReadFunction<any>;
  minimumExpectedShare?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
  variants?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdBusinessComponentSyncKeySpecifier = (
  | 'businessComponentSyncId'
  | 'reviewStatus'
  | 'source'
  | RdBusinessComponentSyncKeySpecifier
)[];
export type RdBusinessComponentSyncFieldPolicy = {
  businessComponentSyncId?: FieldPolicy<any> | FieldReadFunction<any>;
  reviewStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdBusinessComponentTicketMatchKeySpecifier = (
  | 'businessComponent'
  | 'ticketCount'
  | 'workstreamNames'
  | RdBusinessComponentTicketMatchKeySpecifier
)[];
export type RdBusinessComponentTicketMatchFieldPolicy = {
  businessComponent?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNames?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdBusinessComponentTicketMatchesKeySpecifier = (
  | 'currentBusinessComponentSync'
  | 'hasSyncConfiguration'
  | 'isRunAwaitingReview'
  | 'matchThreshold'
  | 'matches'
  | RdBusinessComponentTicketMatchesKeySpecifier
)[];
export type RdBusinessComponentTicketMatchesFieldPolicy = {
  currentBusinessComponentSync?: FieldPolicy<any> | FieldReadFunction<any>;
  hasSyncConfiguration?: FieldPolicy<any> | FieldReadFunction<any>;
  isRunAwaitingReview?: FieldPolicy<any> | FieldReadFunction<any>;
  matchThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  matches?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdCreditsReportRoKeySpecifier = ('signedUrl' | RdCreditsReportRoKeySpecifier)[];
export type RdCreditsReportRoFieldPolicy = {
  signedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseKeySpecifier = (
  | 'accountingQre'
  | 'id'
  | 'payrollQre'
  | 'projectPerRdExpense'
  | 'rdCategory'
  | 'rdCategoryConfidence'
  | RdExpenseKeySpecifier
)[];
export type RdExpenseFieldPolicy = {
  accountingQre?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollQre?: FieldPolicy<any> | FieldReadFunction<any>;
  projectPerRdExpense?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  rdCategoryConfidence?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectKeySpecifier = ('id' | 'qreRdPercentage' | 'rdProject' | RdExpenseProjectKeySpecifier)[];
export type RdExpenseProjectFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  qreRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProject?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectAggregateGroupByKeySpecifier = ('id' | RdExpenseProjectAggregateGroupByKeySpecifier)[];
export type RdExpenseProjectAggregateGroupByFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectAllocationKeySpecifier = (
  | 'allocationPercentNotRounded'
  | 'fiscalYearId'
  | 'id'
  | 'project'
  | 'projectName'
  | 'rdExpenseId'
  | 'rdProjectId'
  | RdExpenseProjectAllocationKeySpecifier
)[];
export type RdExpenseProjectAllocationFieldPolicy = {
  allocationPercentNotRounded?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  project?: FieldPolicy<any> | FieldReadFunction<any>;
  projectName?: FieldPolicy<any> | FieldReadFunction<any>;
  rdExpenseId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectAllocationAggregateGroupByKeySpecifier = (
  | 'id'
  | 'projectName'
  | RdExpenseProjectAllocationAggregateGroupByKeySpecifier
)[];
export type RdExpenseProjectAllocationAggregateGroupByFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  projectName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectAllocationConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | RdExpenseProjectAllocationConnectionKeySpecifier
)[];
export type RdExpenseProjectAllocationConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectAllocationCountAggregateKeySpecifier = (
  | 'id'
  | 'projectName'
  | RdExpenseProjectAllocationCountAggregateKeySpecifier
)[];
export type RdExpenseProjectAllocationCountAggregateFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  projectName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectAllocationEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | RdExpenseProjectAllocationEdgeKeySpecifier
)[];
export type RdExpenseProjectAllocationEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectAllocationMaxAggregateKeySpecifier = (
  | 'id'
  | 'projectName'
  | RdExpenseProjectAllocationMaxAggregateKeySpecifier
)[];
export type RdExpenseProjectAllocationMaxAggregateFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  projectName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectAllocationMinAggregateKeySpecifier = (
  | 'id'
  | 'projectName'
  | RdExpenseProjectAllocationMinAggregateKeySpecifier
)[];
export type RdExpenseProjectAllocationMinAggregateFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  projectName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectAllocationReportRoKeySpecifier = (
  | 'signedUrl'
  | RdExpenseProjectAllocationReportRoKeySpecifier
)[];
export type RdExpenseProjectAllocationReportRoFieldPolicy = {
  signedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectConnectionKeySpecifier = ('edges' | 'pageInfo' | RdExpenseProjectConnectionKeySpecifier)[];
export type RdExpenseProjectConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectCountAggregateKeySpecifier = ('id' | RdExpenseProjectCountAggregateKeySpecifier)[];
export type RdExpenseProjectCountAggregateFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectEdgeKeySpecifier = ('cursor' | 'node' | RdExpenseProjectEdgeKeySpecifier)[];
export type RdExpenseProjectEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectMaxAggregateKeySpecifier = ('id' | RdExpenseProjectMaxAggregateKeySpecifier)[];
export type RdExpenseProjectMaxAggregateFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdExpenseProjectMinAggregateKeySpecifier = ('id' | RdExpenseProjectMinAggregateKeySpecifier)[];
export type RdExpenseProjectMinAggregateFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdGroupingTicketOrCollectionKeySpecifier = (
  | 'count'
  | 'fiscalYearId'
  | 'id'
  | 'identifier'
  | 'kind'
  | 'name'
  | 'rdProjectId'
  | 'ticketType'
  | RdGroupingTicketOrCollectionKeySpecifier
)[];
export type RdGroupingTicketOrCollectionFieldPolicy = {
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectKeySpecifier = (
  | 'aiGuidance'
  | 'approvalComment'
  | 'approvalTime'
  | 'businessComponent'
  | 'businessPurpose'
  | 'clusterType'
  | 'consideredForRd'
  | 'description'
  | 'disallowances'
  | 'fiscalYearId'
  | 'id'
  | 'improvedAspects'
  | 'isCustomerFacingDevelopment'
  | 'isInnovativeAndRisky'
  | 'isSection174Eligible'
  | 'isTechnicallyUncertain'
  | 'name'
  | 'processOfExperimentation'
  | 'processingState'
  | 'product'
  | 'productName'
  | 'projectOwner'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'purpose'
  | 'rdDetermination'
  | 'rdDocumentationStatus'
  | 'selectedCategory'
  | 'supportingDocuments'
  | 'technicalChallenges'
  | 'ticketCount'
  | 'workstreamNames'
  | 'workstreamNamesSearch'
  | RdProjectKeySpecifier
)[];
export type RdProjectFieldPolicy = {
  aiGuidance?: FieldPolicy<any> | FieldReadFunction<any>;
  approvalComment?: FieldPolicy<any> | FieldReadFunction<any>;
  approvalTime?: FieldPolicy<any> | FieldReadFunction<any>;
  businessComponent?: FieldPolicy<any> | FieldReadFunction<any>;
  businessPurpose?: FieldPolicy<any> | FieldReadFunction<any>;
  clusterType?: FieldPolicy<any> | FieldReadFunction<any>;
  consideredForRd?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  disallowances?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  improvedAspects?: FieldPolicy<any> | FieldReadFunction<any>;
  isCustomerFacingDevelopment?: FieldPolicy<any> | FieldReadFunction<any>;
  isInnovativeAndRisky?: FieldPolicy<any> | FieldReadFunction<any>;
  isSection174Eligible?: FieldPolicy<any> | FieldReadFunction<any>;
  isTechnicallyUncertain?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  processOfExperimentation?: FieldPolicy<any> | FieldReadFunction<any>;
  processingState?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwner?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  rdDetermination?: FieldPolicy<any> | FieldReadFunction<any>;
  rdDocumentationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  supportingDocuments?: FieldPolicy<any> | FieldReadFunction<any>;
  technicalChallenges?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNames?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectAggregateGroupByKeySpecifier = (
  | 'aiGuidance'
  | 'businessComponent'
  | 'businessPurpose'
  | 'consideredForRd'
  | 'description'
  | 'id'
  | 'isSection174Eligible'
  | 'name'
  | 'processOfExperimentation'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'purpose'
  | 'rdDocumentationStatus'
  | 'selectedCategory'
  | 'technicalChallenges'
  | 'ticketCount'
  | 'workstreamNamesSearch'
  | RdProjectAggregateGroupByKeySpecifier
)[];
export type RdProjectAggregateGroupByFieldPolicy = {
  aiGuidance?: FieldPolicy<any> | FieldReadFunction<any>;
  businessComponent?: FieldPolicy<any> | FieldReadFunction<any>;
  businessPurpose?: FieldPolicy<any> | FieldReadFunction<any>;
  consideredForRd?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isSection174Eligible?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  processOfExperimentation?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  rdDocumentationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  technicalChallenges?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectAvgAggregateKeySpecifier = ('ticketCount' | RdProjectAvgAggregateKeySpecifier)[];
export type RdProjectAvgAggregateFieldPolicy = {
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectConnectionKeySpecifier = ('edges' | 'pageInfo' | RdProjectConnectionKeySpecifier)[];
export type RdProjectConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectCountAggregateKeySpecifier = (
  | 'aiGuidance'
  | 'businessComponent'
  | 'businessPurpose'
  | 'consideredForRd'
  | 'description'
  | 'id'
  | 'isSection174Eligible'
  | 'name'
  | 'processOfExperimentation'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'purpose'
  | 'rdDocumentationStatus'
  | 'selectedCategory'
  | 'technicalChallenges'
  | 'ticketCount'
  | 'workstreamNamesSearch'
  | RdProjectCountAggregateKeySpecifier
)[];
export type RdProjectCountAggregateFieldPolicy = {
  aiGuidance?: FieldPolicy<any> | FieldReadFunction<any>;
  businessComponent?: FieldPolicy<any> | FieldReadFunction<any>;
  businessPurpose?: FieldPolicy<any> | FieldReadFunction<any>;
  consideredForRd?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isSection174Eligible?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  processOfExperimentation?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  rdDocumentationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  technicalChallenges?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectDeletionResultKeySpecifier = ('success' | RdProjectDeletionResultKeySpecifier)[];
export type RdProjectDeletionResultFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectEdgeKeySpecifier = ('cursor' | 'node' | RdProjectEdgeKeySpecifier)[];
export type RdProjectEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectMaxAggregateKeySpecifier = (
  | 'aiGuidance'
  | 'businessComponent'
  | 'businessPurpose'
  | 'description'
  | 'id'
  | 'name'
  | 'processOfExperimentation'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'purpose'
  | 'rdDocumentationStatus'
  | 'selectedCategory'
  | 'technicalChallenges'
  | 'ticketCount'
  | 'workstreamNamesSearch'
  | RdProjectMaxAggregateKeySpecifier
)[];
export type RdProjectMaxAggregateFieldPolicy = {
  aiGuidance?: FieldPolicy<any> | FieldReadFunction<any>;
  businessComponent?: FieldPolicy<any> | FieldReadFunction<any>;
  businessPurpose?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  processOfExperimentation?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  rdDocumentationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  technicalChallenges?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectMinAggregateKeySpecifier = (
  | 'aiGuidance'
  | 'businessComponent'
  | 'businessPurpose'
  | 'description'
  | 'id'
  | 'name'
  | 'processOfExperimentation'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'purpose'
  | 'rdDocumentationStatus'
  | 'selectedCategory'
  | 'technicalChallenges'
  | 'ticketCount'
  | 'workstreamNamesSearch'
  | RdProjectMinAggregateKeySpecifier
)[];
export type RdProjectMinAggregateFieldPolicy = {
  aiGuidance?: FieldPolicy<any> | FieldReadFunction<any>;
  businessComponent?: FieldPolicy<any> | FieldReadFunction<any>;
  businessPurpose?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  processOfExperimentation?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  rdDocumentationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  technicalChallenges?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectNameAndDescriptionKeySpecifier = (
  | 'description'
  | 'id'
  | 'name'
  | RdProjectNameAndDescriptionKeySpecifier
)[];
export type RdProjectNameAndDescriptionFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectOwnerKeySpecifier = ('fullName' | 'id' | RdProjectOwnerKeySpecifier)[];
export type RdProjectOwnerFieldPolicy = {
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectReportKeySpecifier = ('columnNames' | 'excelData' | RdProjectReportKeySpecifier)[];
export type RdProjectReportFieldPolicy = {
  columnNames?: FieldPolicy<any> | FieldReadFunction<any>;
  excelData?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectSumAggregateKeySpecifier = ('ticketCount' | RdProjectSumAggregateKeySpecifier)[];
export type RdProjectSumAggregateFieldPolicy = {
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTeamMemberKeySpecifier = (
  | 'allocationPercent'
  | 'contributorEmail'
  | 'contributorName'
  | 'fiscalYearId'
  | 'rdExpenseId'
  | 'rdProjectId'
  | 'rdTaxCreditContributorId'
  | RdProjectTeamMemberKeySpecifier
)[];
export type RdProjectTeamMemberFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdExpenseId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditContributorId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTeamMemberAggregateGroupByKeySpecifier = (
  | 'allocationPercent'
  | 'contributorName'
  | 'fiscalYearId'
  | 'rdExpenseId'
  | 'rdProjectId'
  | 'rdTaxCreditContributorId'
  | RdProjectTeamMemberAggregateGroupByKeySpecifier
)[];
export type RdProjectTeamMemberAggregateGroupByFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdExpenseId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditContributorId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTeamMemberAvgAggregateKeySpecifier = (
  | 'allocationPercent'
  | RdProjectTeamMemberAvgAggregateKeySpecifier
)[];
export type RdProjectTeamMemberAvgAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTeamMemberConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | RdProjectTeamMemberConnectionKeySpecifier
)[];
export type RdProjectTeamMemberConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTeamMemberCountAggregateKeySpecifier = (
  | 'allocationPercent'
  | 'contributorName'
  | 'fiscalYearId'
  | 'rdExpenseId'
  | 'rdProjectId'
  | 'rdTaxCreditContributorId'
  | RdProjectTeamMemberCountAggregateKeySpecifier
)[];
export type RdProjectTeamMemberCountAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdExpenseId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditContributorId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTeamMemberEdgeKeySpecifier = ('cursor' | 'node' | RdProjectTeamMemberEdgeKeySpecifier)[];
export type RdProjectTeamMemberEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTeamMemberMaxAggregateKeySpecifier = (
  | 'allocationPercent'
  | 'contributorName'
  | 'fiscalYearId'
  | 'rdExpenseId'
  | 'rdProjectId'
  | 'rdTaxCreditContributorId'
  | RdProjectTeamMemberMaxAggregateKeySpecifier
)[];
export type RdProjectTeamMemberMaxAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdExpenseId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditContributorId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTeamMemberMinAggregateKeySpecifier = (
  | 'allocationPercent'
  | 'contributorName'
  | 'fiscalYearId'
  | 'rdExpenseId'
  | 'rdProjectId'
  | 'rdTaxCreditContributorId'
  | RdProjectTeamMemberMinAggregateKeySpecifier
)[];
export type RdProjectTeamMemberMinAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdExpenseId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditContributorId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTeamMemberSumAggregateKeySpecifier = (
  | 'allocationPercent'
  | RdProjectTeamMemberSumAggregateKeySpecifier
)[];
export type RdProjectTeamMemberSumAggregateFieldPolicy = {
  allocationPercent?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTpTicketsViewKeySpecifier = (
  | 'collectionName'
  | 'completedDatetime'
  | 'contributorName'
  | 'description'
  | 'fiscalYearId'
  | 'groupingTicketingProviderCollectionId'
  | 'groupingTicketingProviderTicketId'
  | 'id'
  | 'identifier'
  | 'name'
  | 'predictedEffortDays'
  | 'rdProjectId'
  | 'rdTaxCreditContributorId'
  | 'ticketUrl'
  | RdProjectTpTicketsViewKeySpecifier
)[];
export type RdProjectTpTicketsViewFieldPolicy = {
  collectionName?: FieldPolicy<any> | FieldReadFunction<any>;
  completedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderCollectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderTicketId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditContributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTpTicketsViewAggregateGroupByKeySpecifier = (
  | 'collectionName'
  | 'completedDatetime'
  | 'contributorName'
  | 'fiscalYearId'
  | 'groupingTicketingProviderCollectionId'
  | 'groupingTicketingProviderTicketId'
  | 'id'
  | 'identifier'
  | 'name'
  | 'predictedEffortDays'
  | 'rdProjectId'
  | 'ticketUrl'
  | RdProjectTpTicketsViewAggregateGroupByKeySpecifier
)[];
export type RdProjectTpTicketsViewAggregateGroupByFieldPolicy = {
  collectionName?: FieldPolicy<any> | FieldReadFunction<any>;
  completedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderCollectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderTicketId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTpTicketsViewAvgAggregateKeySpecifier = (
  | 'predictedEffortDays'
  | RdProjectTpTicketsViewAvgAggregateKeySpecifier
)[];
export type RdProjectTpTicketsViewAvgAggregateFieldPolicy = {
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTpTicketsViewConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | RdProjectTpTicketsViewConnectionKeySpecifier
)[];
export type RdProjectTpTicketsViewConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTpTicketsViewCountAggregateKeySpecifier = (
  | 'collectionName'
  | 'completedDatetime'
  | 'contributorName'
  | 'fiscalYearId'
  | 'groupingTicketingProviderCollectionId'
  | 'groupingTicketingProviderTicketId'
  | 'id'
  | 'identifier'
  | 'name'
  | 'predictedEffortDays'
  | 'rdProjectId'
  | 'ticketUrl'
  | RdProjectTpTicketsViewCountAggregateKeySpecifier
)[];
export type RdProjectTpTicketsViewCountAggregateFieldPolicy = {
  collectionName?: FieldPolicy<any> | FieldReadFunction<any>;
  completedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderCollectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderTicketId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTpTicketsViewEdgeKeySpecifier = ('cursor' | 'node' | RdProjectTpTicketsViewEdgeKeySpecifier)[];
export type RdProjectTpTicketsViewEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTpTicketsViewMaxAggregateKeySpecifier = (
  | 'collectionName'
  | 'completedDatetime'
  | 'contributorName'
  | 'fiscalYearId'
  | 'groupingTicketingProviderCollectionId'
  | 'groupingTicketingProviderTicketId'
  | 'id'
  | 'identifier'
  | 'name'
  | 'predictedEffortDays'
  | 'rdProjectId'
  | 'ticketUrl'
  | RdProjectTpTicketsViewMaxAggregateKeySpecifier
)[];
export type RdProjectTpTicketsViewMaxAggregateFieldPolicy = {
  collectionName?: FieldPolicy<any> | FieldReadFunction<any>;
  completedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderCollectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderTicketId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTpTicketsViewMinAggregateKeySpecifier = (
  | 'collectionName'
  | 'completedDatetime'
  | 'contributorName'
  | 'fiscalYearId'
  | 'groupingTicketingProviderCollectionId'
  | 'groupingTicketingProviderTicketId'
  | 'id'
  | 'identifier'
  | 'name'
  | 'predictedEffortDays'
  | 'rdProjectId'
  | 'ticketUrl'
  | RdProjectTpTicketsViewMinAggregateKeySpecifier
)[];
export type RdProjectTpTicketsViewMinAggregateFieldPolicy = {
  collectionName?: FieldPolicy<any> | FieldReadFunction<any>;
  completedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  fiscalYearId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderCollectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  groupingTicketingProviderTicketId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectTpTicketsViewSumAggregateKeySpecifier = (
  | 'predictedEffortDays'
  | RdProjectTpTicketsViewSumAggregateKeySpecifier
)[];
export type RdProjectTpTicketsViewSumAggregateFieldPolicy = {
  predictedEffortDays?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectUniqueCountAggregateKeySpecifier = (
  | 'aiGuidance'
  | 'businessComponent'
  | 'businessPurpose'
  | 'consideredForRd'
  | 'description'
  | 'id'
  | 'isSection174Eligible'
  | 'name'
  | 'processOfExperimentation'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'purpose'
  | 'rdDocumentationStatus'
  | 'selectedCategory'
  | 'technicalChallenges'
  | 'ticketCount'
  | 'workstreamNamesSearch'
  | RdProjectUniqueCountAggregateKeySpecifier
)[];
export type RdProjectUniqueCountAggregateFieldPolicy = {
  aiGuidance?: FieldPolicy<any> | FieldReadFunction<any>;
  businessComponent?: FieldPolicy<any> | FieldReadFunction<any>;
  businessPurpose?: FieldPolicy<any> | FieldReadFunction<any>;
  consideredForRd?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isSection174Eligible?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  processOfExperimentation?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  rdDocumentationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  technicalChallenges?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdProjectsSummaryKeySpecifier = (
  | 'avg'
  | 'count'
  | 'groupBy'
  | 'max'
  | 'min'
  | 'sum'
  | 'uniqueCount'
  | RdProjectsSummaryKeySpecifier
)[];
export type RdProjectsSummaryFieldPolicy = {
  avg?: FieldPolicy<any> | FieldReadFunction<any>;
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  groupBy?: FieldPolicy<any> | FieldReadFunction<any>;
  max?: FieldPolicy<any> | FieldReadFunction<any>;
  min?: FieldPolicy<any> | FieldReadFunction<any>;
  sum?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdTaxCreditContributorKeySpecifier = (
  | 'canonicalEmail'
  | 'canonicalName'
  | 'id'
  | 'rdTaxCreditId'
  | 'ticketingProviderUsers'
  | RdTaxCreditContributorKeySpecifier
)[];
export type RdTaxCreditContributorFieldPolicy = {
  canonicalEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  canonicalName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditId?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingProviderUsers?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdTaxCreditContributorWithAllocationKeySpecifier = (
  | 'allocationMethod'
  | 'canonicalEmail'
  | 'canonicalName'
  | 'id'
  | 'nonProjectTimePercentage'
  | 'title'
  | 'totalRdPercentage'
  | RdTaxCreditContributorWithAllocationKeySpecifier
)[];
export type RdTaxCreditContributorWithAllocationFieldPolicy = {
  allocationMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  canonicalEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  canonicalName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  nonProjectTimePercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  totalRdPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdTaxCreditContributorsWithAllocationPaginatedKeySpecifier = (
  | 'hasNextPage'
  | 'items'
  | 'limit'
  | 'offset'
  | 'totalCount'
  | RdTaxCreditContributorsWithAllocationPaginatedKeySpecifier
)[];
export type RdTaxCreditContributorsWithAllocationPaginatedFieldPolicy = {
  hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  limit?: FieldPolicy<any> | FieldReadFunction<any>;
  offset?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RdTicketMatchExportKeySpecifier = ('fileName' | 'report' | RdTicketMatchExportKeySpecifier)[];
export type RdTicketMatchExportFieldPolicy = {
  fileName?: FieldPolicy<any> | FieldReadFunction<any>;
  report?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReportKeySpecifier = ('columnNames' | 'resultCsv' | 'signedUrl' | ReportKeySpecifier)[];
export type ReportFieldPolicy = {
  columnNames?: FieldPolicy<any> | FieldReadFunction<any>;
  resultCsv?: FieldPolicy<any> | FieldReadFunction<any>;
  signedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScheduledBackgroundOperationModelKeySpecifier = (
  | 'company'
  | 'companyId'
  | 'createdAt'
  | 'failureReason'
  | 'id'
  | 'notifySlack'
  | 'operationType'
  | 'runAt'
  | 'status'
  | 'syncTicketingData'
  | 'updatedAt'
  | ScheduledBackgroundOperationModelKeySpecifier
)[];
export type ScheduledBackgroundOperationModelFieldPolicy = {
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  failureReason?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  notifySlack?: FieldPolicy<any> | FieldReadFunction<any>;
  operationType?: FieldPolicy<any> | FieldReadFunction<any>;
  runAt?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  syncTicketingData?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SentinelEmailKeySpecifier = (
  | 'company'
  | 'companyId'
  | 'createdAt'
  | 'detectedCount'
  | 'email'
  | 'id'
  | 'lastDetectedAt'
  | 'raisedByCompanyId'
  | 'resolvedAt'
  | 'resolvedByUserId'
  | 'status'
  | SentinelEmailKeySpecifier
)[];
export type SentinelEmailFieldPolicy = {
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  detectedCount?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastDetectedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  raisedByCompanyId?: FieldPolicy<any> | FieldReadFunction<any>;
  resolvedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  resolvedByUserId?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SentinelEmailCompanyKeySpecifier = ('id' | 'shortName' | SentinelEmailCompanyKeySpecifier)[];
export type SentinelEmailCompanyFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  shortName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ServerInfoKeySpecifier = ('version' | ServerInfoKeySpecifier)[];
export type ServerInfoFieldPolicy = {
  version?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SingleTenantDomainRedirectKeySpecifier = (
  | 'emailDomain'
  | 'id'
  | 'redirectUrl'
  | SingleTenantDomainRedirectKeySpecifier
)[];
export type SingleTenantDomainRedirectFieldPolicy = {
  emailDomain?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SnowflakeDetailKeySpecifier = ('type' | 'value' | SnowflakeDetailKeySpecifier)[];
export type SnowflakeDetailFieldPolicy = {
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SnowflakeTicketingTokenKeySpecifier = (
  | 'accessTokenLastFour'
  | 'details'
  | 'id'
  | 'userId'
  | SnowflakeTicketingTokenKeySpecifier
)[];
export type SnowflakeTicketingTokenFieldPolicy = {
  accessTokenLastFour?: FieldPolicy<any> | FieldReadFunction<any>;
  details?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredPayrollExpenseKeySpecifier = (
  | 'amountCents'
  | 'costCenter'
  | 'department'
  | 'entity'
  | 'hireDate'
  | 'id'
  | 'managerName'
  | 'name'
  | 'payrollProvider'
  | 'province'
  | 'qualifiedAmountCents'
  | 'sredCategory'
  | 'sredContributorId'
  | 'sredEligiblePercentage'
  | 'sredEmployeeType'
  | 'sredPayrollExpenseId'
  | 'sredTaxCreditId'
  | 'terminationDate'
  | 'ticketingProviders'
  | 'title'
  | 'wageType'
  | SredPayrollExpenseKeySpecifier
)[];
export type SredPayrollExpenseFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  province?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  sredCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  sredContributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligiblePercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEmployeeType?: FieldPolicy<any> | FieldReadFunction<any>;
  sredPayrollExpenseId?: FieldPolicy<any> | FieldReadFunction<any>;
  sredTaxCreditId?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDate?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingProviders?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  wageType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredPayrollExpenseAggregateGroupByKeySpecifier = (
  | 'amountCents'
  | 'costCenter'
  | 'department'
  | 'entity'
  | 'hireDate'
  | 'id'
  | 'managerName'
  | 'name'
  | 'payrollProvider'
  | 'province'
  | 'qualifiedAmountCents'
  | 'sredCategory'
  | 'sredEligiblePercentage'
  | 'sredEmployeeType'
  | 'terminationDate'
  | 'title'
  | 'wageType'
  | SredPayrollExpenseAggregateGroupByKeySpecifier
)[];
export type SredPayrollExpenseAggregateGroupByFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  province?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  sredCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligiblePercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEmployeeType?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDate?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  wageType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredPayrollExpenseAvgAggregateKeySpecifier = (
  | 'amountCents'
  | 'qualifiedAmountCents'
  | 'sredEligiblePercentage'
  | SredPayrollExpenseAvgAggregateKeySpecifier
)[];
export type SredPayrollExpenseAvgAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligiblePercentage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredPayrollExpenseConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | SredPayrollExpenseConnectionKeySpecifier
)[];
export type SredPayrollExpenseConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredPayrollExpenseCountAggregateKeySpecifier = (
  | 'amountCents'
  | 'costCenter'
  | 'department'
  | 'entity'
  | 'hireDate'
  | 'id'
  | 'managerName'
  | 'name'
  | 'payrollProvider'
  | 'province'
  | 'qualifiedAmountCents'
  | 'sredCategory'
  | 'sredEligiblePercentage'
  | 'sredEmployeeType'
  | 'terminationDate'
  | 'title'
  | 'wageType'
  | SredPayrollExpenseCountAggregateKeySpecifier
)[];
export type SredPayrollExpenseCountAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  province?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  sredCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligiblePercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEmployeeType?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDate?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  wageType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredPayrollExpenseEdgeKeySpecifier = ('cursor' | 'node' | SredPayrollExpenseEdgeKeySpecifier)[];
export type SredPayrollExpenseEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredPayrollExpenseMaxAggregateKeySpecifier = (
  | 'amountCents'
  | 'costCenter'
  | 'department'
  | 'entity'
  | 'hireDate'
  | 'id'
  | 'managerName'
  | 'name'
  | 'payrollProvider'
  | 'province'
  | 'qualifiedAmountCents'
  | 'sredCategory'
  | 'sredEligiblePercentage'
  | 'sredEmployeeType'
  | 'terminationDate'
  | 'title'
  | 'wageType'
  | SredPayrollExpenseMaxAggregateKeySpecifier
)[];
export type SredPayrollExpenseMaxAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  province?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  sredCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligiblePercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEmployeeType?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDate?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  wageType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredPayrollExpenseMinAggregateKeySpecifier = (
  | 'amountCents'
  | 'costCenter'
  | 'department'
  | 'entity'
  | 'hireDate'
  | 'id'
  | 'managerName'
  | 'name'
  | 'payrollProvider'
  | 'province'
  | 'qualifiedAmountCents'
  | 'sredCategory'
  | 'sredEligiblePercentage'
  | 'sredEmployeeType'
  | 'terminationDate'
  | 'title'
  | 'wageType'
  | SredPayrollExpenseMinAggregateKeySpecifier
)[];
export type SredPayrollExpenseMinAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  hireDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  province?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  sredCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligiblePercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEmployeeType?: FieldPolicy<any> | FieldReadFunction<any>;
  terminationDate?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  wageType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredPayrollExpenseSumAggregateKeySpecifier = (
  | 'amountCents'
  | 'qualifiedAmountCents'
  | 'sredEligiblePercentage'
  | SredPayrollExpenseSumAggregateKeySpecifier
)[];
export type SredPayrollExpenseSumAggregateFieldPolicy = {
  amountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedAmountCents?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligiblePercentage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredPayrollExpenseUniqueCountAggregateKeySpecifier = (
  | 'costCenter'
  | 'department'
  | 'entity'
  | 'managerName'
  | 'province'
  | 'sredCategory'
  | 'title'
  | SredPayrollExpenseUniqueCountAggregateKeySpecifier
)[];
export type SredPayrollExpenseUniqueCountAggregateFieldPolicy = {
  costCenter?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  entity?: FieldPolicy<any> | FieldReadFunction<any>;
  managerName?: FieldPolicy<any> | FieldReadFunction<any>;
  province?: FieldPolicy<any> | FieldReadFunction<any>;
  sredCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredPayrollExpensesSummaryKeySpecifier = (
  | 'avg'
  | 'count'
  | 'groupBy'
  | 'max'
  | 'min'
  | 'sum'
  | 'uniqueCount'
  | SredPayrollExpensesSummaryKeySpecifier
)[];
export type SredPayrollExpensesSummaryFieldPolicy = {
  avg?: FieldPolicy<any> | FieldReadFunction<any>;
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  groupBy?: FieldPolicy<any> | FieldReadFunction<any>;
  max?: FieldPolicy<any> | FieldReadFunction<any>;
  min?: FieldPolicy<any> | FieldReadFunction<any>;
  sum?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredProjectKeySpecifier = (
  | 'aiGuidance'
  | 'appliedResearch'
  | 'approvalComment'
  | 'approvalTime'
  | 'basicResearch'
  | 'clusterType'
  | 'consideredForSred'
  | 'description'
  | 'experimentalDevelopment'
  | 'id'
  | 'name'
  | 'processingState'
  | 'product'
  | 'productName'
  | 'projectOwner'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'provincialEligibility'
  | 'selectedCategory'
  | 'sredDocumentationStatus'
  | 'sredEligibleDate'
  | 'sredTaxCreditId'
  | 'supportingDocuments'
  | 'supportingWork'
  | 'systematicInvestigation'
  | 'technologicalAdvancement'
  | 'technologicalUncertainty'
  | 'ticketCount'
  | 'workInCanadaPercentage'
  | 'workstreamNames'
  | 'workstreamNamesSearch'
  | SredProjectKeySpecifier
)[];
export type SredProjectFieldPolicy = {
  aiGuidance?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedResearch?: FieldPolicy<any> | FieldReadFunction<any>;
  approvalComment?: FieldPolicy<any> | FieldReadFunction<any>;
  approvalTime?: FieldPolicy<any> | FieldReadFunction<any>;
  basicResearch?: FieldPolicy<any> | FieldReadFunction<any>;
  clusterType?: FieldPolicy<any> | FieldReadFunction<any>;
  consideredForSred?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  experimentalDevelopment?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  processingState?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwner?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  provincialEligibility?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  sredDocumentationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligibleDate?: FieldPolicy<any> | FieldReadFunction<any>;
  sredTaxCreditId?: FieldPolicy<any> | FieldReadFunction<any>;
  supportingDocuments?: FieldPolicy<any> | FieldReadFunction<any>;
  supportingWork?: FieldPolicy<any> | FieldReadFunction<any>;
  systematicInvestigation?: FieldPolicy<any> | FieldReadFunction<any>;
  technologicalAdvancement?: FieldPolicy<any> | FieldReadFunction<any>;
  technologicalUncertainty?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workInCanadaPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNames?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredProjectAggregateGroupByKeySpecifier = (
  | 'aiGuidance'
  | 'appliedResearch'
  | 'basicResearch'
  | 'consideredForSred'
  | 'description'
  | 'experimentalDevelopment'
  | 'id'
  | 'name'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'selectedCategory'
  | 'sredDocumentationStatus'
  | 'sredEligibleDate'
  | 'systematicInvestigation'
  | 'technologicalAdvancement'
  | 'technologicalUncertainty'
  | 'ticketCount'
  | 'workInCanadaPercentage'
  | 'workstreamNamesSearch'
  | SredProjectAggregateGroupByKeySpecifier
)[];
export type SredProjectAggregateGroupByFieldPolicy = {
  aiGuidance?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedResearch?: FieldPolicy<any> | FieldReadFunction<any>;
  basicResearch?: FieldPolicy<any> | FieldReadFunction<any>;
  consideredForSred?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  experimentalDevelopment?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  sredDocumentationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligibleDate?: FieldPolicy<any> | FieldReadFunction<any>;
  systematicInvestigation?: FieldPolicy<any> | FieldReadFunction<any>;
  technologicalAdvancement?: FieldPolicy<any> | FieldReadFunction<any>;
  technologicalUncertainty?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workInCanadaPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredProjectAvgAggregateKeySpecifier = ('ticketCount' | SredProjectAvgAggregateKeySpecifier)[];
export type SredProjectAvgAggregateFieldPolicy = {
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredProjectConnectionKeySpecifier = ('edges' | 'pageInfo' | SredProjectConnectionKeySpecifier)[];
export type SredProjectConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredProjectCountAggregateKeySpecifier = (
  | 'aiGuidance'
  | 'appliedResearch'
  | 'basicResearch'
  | 'consideredForSred'
  | 'description'
  | 'experimentalDevelopment'
  | 'id'
  | 'name'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'selectedCategory'
  | 'sredDocumentationStatus'
  | 'sredEligibleDate'
  | 'systematicInvestigation'
  | 'technologicalAdvancement'
  | 'technologicalUncertainty'
  | 'ticketCount'
  | 'workInCanadaPercentage'
  | 'workstreamNamesSearch'
  | SredProjectCountAggregateKeySpecifier
)[];
export type SredProjectCountAggregateFieldPolicy = {
  aiGuidance?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedResearch?: FieldPolicy<any> | FieldReadFunction<any>;
  basicResearch?: FieldPolicy<any> | FieldReadFunction<any>;
  consideredForSred?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  experimentalDevelopment?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  sredDocumentationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligibleDate?: FieldPolicy<any> | FieldReadFunction<any>;
  systematicInvestigation?: FieldPolicy<any> | FieldReadFunction<any>;
  technologicalAdvancement?: FieldPolicy<any> | FieldReadFunction<any>;
  technologicalUncertainty?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workInCanadaPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredProjectEdgeKeySpecifier = ('cursor' | 'node' | SredProjectEdgeKeySpecifier)[];
export type SredProjectEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredProjectMaxAggregateKeySpecifier = (
  | 'aiGuidance'
  | 'appliedResearch'
  | 'basicResearch'
  | 'description'
  | 'experimentalDevelopment'
  | 'id'
  | 'name'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'selectedCategory'
  | 'sredDocumentationStatus'
  | 'sredEligibleDate'
  | 'systematicInvestigation'
  | 'technologicalAdvancement'
  | 'technologicalUncertainty'
  | 'ticketCount'
  | 'workInCanadaPercentage'
  | 'workstreamNamesSearch'
  | SredProjectMaxAggregateKeySpecifier
)[];
export type SredProjectMaxAggregateFieldPolicy = {
  aiGuidance?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedResearch?: FieldPolicy<any> | FieldReadFunction<any>;
  basicResearch?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  experimentalDevelopment?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  sredDocumentationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligibleDate?: FieldPolicy<any> | FieldReadFunction<any>;
  systematicInvestigation?: FieldPolicy<any> | FieldReadFunction<any>;
  technologicalAdvancement?: FieldPolicy<any> | FieldReadFunction<any>;
  technologicalUncertainty?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workInCanadaPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredProjectMinAggregateKeySpecifier = (
  | 'aiGuidance'
  | 'appliedResearch'
  | 'basicResearch'
  | 'description'
  | 'experimentalDevelopment'
  | 'id'
  | 'name'
  | 'productName'
  | 'projectOwnerId'
  | 'projectOwnerName'
  | 'selectedCategory'
  | 'sredDocumentationStatus'
  | 'sredEligibleDate'
  | 'systematicInvestigation'
  | 'technologicalAdvancement'
  | 'technologicalUncertainty'
  | 'ticketCount'
  | 'workInCanadaPercentage'
  | 'workstreamNamesSearch'
  | SredProjectMinAggregateKeySpecifier
)[];
export type SredProjectMinAggregateFieldPolicy = {
  aiGuidance?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedResearch?: FieldPolicy<any> | FieldReadFunction<any>;
  basicResearch?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  experimentalDevelopment?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  productName?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerId?: FieldPolicy<any> | FieldReadFunction<any>;
  projectOwnerName?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  sredDocumentationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  sredEligibleDate?: FieldPolicy<any> | FieldReadFunction<any>;
  systematicInvestigation?: FieldPolicy<any> | FieldReadFunction<any>;
  technologicalAdvancement?: FieldPolicy<any> | FieldReadFunction<any>;
  technologicalUncertainty?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
  workInCanadaPercentage?: FieldPolicy<any> | FieldReadFunction<any>;
  workstreamNamesSearch?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredProjectOwnerKeySpecifier = ('fullName' | 'id' | SredProjectOwnerKeySpecifier)[];
export type SredProjectOwnerFieldPolicy = {
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredProjectSumAggregateKeySpecifier = ('ticketCount' | SredProjectSumAggregateKeySpecifier)[];
export type SredProjectSumAggregateFieldPolicy = {
  ticketCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SredTaxCreditKeySpecifier = ('id' | SredTaxCreditKeySpecifier)[];
export type SredTaxCreditFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StateRdTaxCreditDocumentKeySpecifier = (
  | 'allowAccessDatetime'
  | 'id'
  | 'state'
  | 'stateTaxCreditFormFileName'
  | 'stateTaxCreditFormUrl'
  | StateRdTaxCreditDocumentKeySpecifier
)[];
export type StateRdTaxCreditDocumentFieldPolicy = {
  allowAccessDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  stateTaxCreditFormFileName?: FieldPolicy<any> | FieldReadFunction<any>;
  stateTaxCreditFormUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SupervisorIdentificationResultKeySpecifier = (
  | 'nonSupervisorIds'
  | 'supervisorCount'
  | 'supervisorIds'
  | SupervisorIdentificationResultKeySpecifier
)[];
export type SupervisorIdentificationResultFieldPolicy = {
  nonSupervisorIds?: FieldPolicy<any> | FieldReadFunction<any>;
  supervisorCount?: FieldPolicy<any> | FieldReadFunction<any>;
  supervisorIds?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncAccountingProviderResultKeySpecifier = ('success' | SyncAccountingProviderResultKeySpecifier)[];
export type SyncAccountingProviderResultFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncConfigurationRdKeySpecifier = (
  | 'businessComponentMatchThreshold'
  | 'businessComponentMethod'
  | 'businessComponentParams'
  | 'clusteringMode'
  | 'dataCleaningStrategy'
  | 'id'
  | 'maxNumberOfClusters'
  | 'minNumberOfClusters'
  | 'minNumberOfTicketsPerCluster'
  | 'usePartitionByWorkstream'
  | SyncConfigurationRdKeySpecifier
)[];
export type SyncConfigurationRdFieldPolicy = {
  businessComponentMatchThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  businessComponentMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  businessComponentParams?: FieldPolicy<any> | FieldReadFunction<any>;
  clusteringMode?: FieldPolicy<any> | FieldReadFunction<any>;
  dataCleaningStrategy?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  maxNumberOfClusters?: FieldPolicy<any> | FieldReadFunction<any>;
  minNumberOfClusters?: FieldPolicy<any> | FieldReadFunction<any>;
  minNumberOfTicketsPerCluster?: FieldPolicy<any> | FieldReadFunction<any>;
  usePartitionByWorkstream?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncConfigurationsAscExcludedWorkstreamRoKeySpecifier = (
  | 'createdAt'
  | 'id'
  | 'syncConfigurationAscId'
  | 'ticketingProviderWorkstreamId'
  | SyncConfigurationsAscExcludedWorkstreamRoKeySpecifier
)[];
export type SyncConfigurationsAscExcludedWorkstreamRoFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  syncConfigurationAscId?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingProviderWorkstreamId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncPayrollProviderResultKeySpecifier = ('errors' | 'success' | SyncPayrollProviderResultKeySpecifier)[];
export type SyncPayrollProviderResultFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncPeriodModelKeySpecifier = ('firstDayOfPeriod' | 'lastDayOfPeriod' | SyncPeriodModelKeySpecifier)[];
export type SyncPeriodModelFieldPolicy = {
  firstDayOfPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  lastDayOfPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncTicketingDataScheduleModelKeySpecifier = (
  | 'analysisTypes'
  | 'ascConfigPreConfirmed'
  | 'syncPeriod'
  | 'ticketingTokenId'
  | SyncTicketingDataScheduleModelKeySpecifier
)[];
export type SyncTicketingDataScheduleModelFieldPolicy = {
  analysisTypes?: FieldPolicy<any> | FieldReadFunction<any>;
  ascConfigPreConfirmed?: FieldPolicy<any> | FieldReadFunction<any>;
  syncPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingTokenId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncedAccountingProvidersKeySpecifier = (
  | 'id'
  | 'originalSyncDate'
  | 'providerName'
  | SyncedAccountingProvidersKeySpecifier
)[];
export type SyncedAccountingProvidersFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  originalSyncDate?: FieldPolicy<any> | FieldReadFunction<any>;
  providerName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncedPayrollMonthExpenseKeySpecifier = (
  | 'fileUpload'
  | 'id'
  | 'originalSyncDate'
  | 'period'
  | SyncedPayrollMonthExpenseKeySpecifier
)[];
export type SyncedPayrollMonthExpenseFieldPolicy = {
  fileUpload?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  originalSyncDate?: FieldPolicy<any> | FieldReadFunction<any>;
  period?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncedPayrollProvidersKeySpecifier = (
  | 'id'
  | 'originalSyncDate'
  | 'providerName'
  | SyncedPayrollProvidersKeySpecifier
)[];
export type SyncedPayrollProvidersFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  originalSyncDate?: FieldPolicy<any> | FieldReadFunction<any>;
  providerName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncedProvidersKeySpecifier = (
  | 'accountingProviders'
  | 'id'
  | 'payrollProviders'
  | 'ticketingProviders'
  | SyncedProvidersKeySpecifier
)[];
export type SyncedProvidersFieldPolicy = {
  accountingProviders?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollProviders?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingProviders?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncedRdPayrollCostKeySpecifier = (
  | 'fileUpload'
  | 'id'
  | 'originalSyncDate'
  | 'provider'
  | SyncedRdPayrollCostKeySpecifier
)[];
export type SyncedRdPayrollCostFieldPolicy = {
  fileUpload?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  originalSyncDate?: FieldPolicy<any> | FieldReadFunction<any>;
  provider?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncedTicketingProvidersKeySpecifier = (
  | 'id'
  | 'originalSyncDate'
  | 'providerName'
  | SyncedTicketingProvidersKeySpecifier
)[];
export type SyncedTicketingProvidersFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  originalSyncDate?: FieldPolicy<any> | FieldReadFunction<any>;
  providerName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TabularDataParseErrorKeySpecifier = (
  | 'code'
  | 'column'
  | 'row'
  | 'sheet'
  | 'source'
  | 'value'
  | TabularDataParseErrorKeySpecifier
)[];
export type TabularDataParseErrorFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  column?: FieldPolicy<any> | FieldReadFunction<any>;
  row?: FieldPolicy<any> | FieldReadFunction<any>;
  sheet?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TaskDetailsKeySpecifier = ('payload' | 'queueName' | 'targetUrl' | TaskDetailsKeySpecifier)[];
export type TaskDetailsFieldPolicy = {
  payload?: FieldPolicy<any> | FieldReadFunction<any>;
  queueName?: FieldPolicy<any> | FieldReadFunction<any>;
  targetUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingProviderSyncEventKeySpecifier = (
  | 'acquisitionMethod'
  | 'analysisTypes'
  | 'ascPartitionClusterConfigurationsConfirmedDatetime'
  | 'backgroundOperationId'
  | 'createdAt'
  | 'firstDateOfPeriod'
  | 'id'
  | 'isValidation'
  | 'lastDateOfPeriod'
  | 'provider'
  | 'rdPartitionClusterConfigurationsConfirmedDatetime'
  | TicketingProviderSyncEventKeySpecifier
)[];
export type TicketingProviderSyncEventFieldPolicy = {
  acquisitionMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  analysisTypes?: FieldPolicy<any> | FieldReadFunction<any>;
  ascPartitionClusterConfigurationsConfirmedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  backgroundOperationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  firstDateOfPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isValidation?: FieldPolicy<any> | FieldReadFunction<any>;
  lastDateOfPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  provider?: FieldPolicy<any> | FieldReadFunction<any>;
  rdPartitionClusterConfigurationsConfirmedDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingProviderUserKeySpecifier = (
  | 'fullName'
  | 'id'
  | 'ticketingProvider'
  | TicketingProviderUserKeySpecifier
)[];
export type TicketingProviderUserFieldPolicy = {
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingProvider?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingProviderWorkstreamKeySpecifier = (
  | 'amid'
  | 'description'
  | 'id'
  | 'key'
  | 'name'
  | 'pid'
  | TicketingProviderWorkstreamKeySpecifier
)[];
export type TicketingProviderWorkstreamFieldPolicy = {
  amid?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  key?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  pid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingTokenKeySpecifier = (
  | 'acquisitionMethod'
  | 'clusterHierarchyTypes'
  | 'createdAt'
  | 'id'
  | 'installationStatus'
  | 'lastSuccessfulSync'
  | 'needsRelink'
  | 'organization'
  | 'pendingScheduledSyncCount'
  | 'ticketingProvider'
  | TicketingTokenKeySpecifier
)[];
export type TicketingTokenFieldPolicy = {
  acquisitionMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  clusterHierarchyTypes?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  installationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSuccessfulSync?: FieldPolicy<any> | FieldReadFunction<any>;
  needsRelink?: FieldPolicy<any> | FieldReadFunction<any>;
  organization?: FieldPolicy<any> | FieldReadFunction<any>;
  pendingScheduledSyncCount?: FieldPolicy<any> | FieldReadFunction<any>;
  ticketingProvider?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingTokenLastSuccessfulSyncKeySpecifier = (
  | 'acquisitionMethod'
  | 'at'
  | TicketingTokenLastSuccessfulSyncKeySpecifier
)[];
export type TicketingTokenLastSuccessfulSyncFieldPolicy = {
  acquisitionMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  at?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingUserKeySpecifier = (
  | 'companyId'
  | 'contributorId'
  | 'email'
  | 'id'
  | 'name'
  | 'provider'
  | 'rdTaxCreditId'
  | TicketingUserKeySpecifier
)[];
export type TicketingUserFieldPolicy = {
  companyId?: FieldPolicy<any> | FieldReadFunction<any>;
  contributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  provider?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingUserAggregateGroupByKeySpecifier = (
  | 'id'
  | 'name'
  | 'rdTaxCreditId'
  | TicketingUserAggregateGroupByKeySpecifier
)[];
export type TicketingUserAggregateGroupByFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingUserConnectionKeySpecifier = ('edges' | 'pageInfo' | TicketingUserConnectionKeySpecifier)[];
export type TicketingUserConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingUserCountAggregateKeySpecifier = (
  | 'id'
  | 'name'
  | 'rdTaxCreditId'
  | TicketingUserCountAggregateKeySpecifier
)[];
export type TicketingUserCountAggregateFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingUserEdgeKeySpecifier = ('cursor' | 'node' | TicketingUserEdgeKeySpecifier)[];
export type TicketingUserEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingUserMaxAggregateKeySpecifier = (
  | 'id'
  | 'name'
  | 'rdTaxCreditId'
  | TicketingUserMaxAggregateKeySpecifier
)[];
export type TicketingUserMaxAggregateFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TicketingUserMinAggregateKeySpecifier = (
  | 'id'
  | 'name'
  | 'rdTaxCreditId'
  | TicketingUserMinAggregateKeySpecifier
)[];
export type TicketingUserMinAggregateFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TimesheetRdReportKeySpecifier = (
  | 'flowStatus'
  | 'matchSummary'
  | 'projects'
  | 'unmatchedUsers'
  | TimesheetRdReportKeySpecifier
)[];
export type TimesheetRdReportFieldPolicy = {
  flowStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  matchSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  projects?: FieldPolicy<any> | FieldReadFunction<any>;
  unmatchedUsers?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TimesheetRdReportFlowStatusKeySpecifier = (
  | 'hasData'
  | 'lastRunComplete'
  | 'lastRunPaused'
  | 'lastRunState'
  | TimesheetRdReportFlowStatusKeySpecifier
)[];
export type TimesheetRdReportFlowStatusFieldPolicy = {
  hasData?: FieldPolicy<any> | FieldReadFunction<any>;
  lastRunComplete?: FieldPolicy<any> | FieldReadFunction<any>;
  lastRunPaused?: FieldPolicy<any> | FieldReadFunction<any>;
  lastRunState?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TimesheetRdReportMatchSummaryKeySpecifier = (
  | 'matchedByManual'
  | 'matchedByName'
  | 'matchedByPid'
  | 'total'
  | 'unmatched'
  | TimesheetRdReportMatchSummaryKeySpecifier
)[];
export type TimesheetRdReportMatchSummaryFieldPolicy = {
  matchedByManual?: FieldPolicy<any> | FieldReadFunction<any>;
  matchedByName?: FieldPolicy<any> | FieldReadFunction<any>;
  matchedByPid?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
  unmatched?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TimesheetRdReportProjectKeySpecifier = (
  | 'projectName'
  | 'rdProjectId'
  | 'userCount'
  | TimesheetRdReportProjectKeySpecifier
)[];
export type TimesheetRdReportProjectFieldPolicy = {
  projectName?: FieldPolicy<any> | FieldReadFunction<any>;
  rdProjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  userCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TimesheetRdReportUserRowKeySpecifier = (
  | 'contributorName'
  | 'isMatched'
  | 'matchScore'
  | 'matchTier'
  | 'pid'
  | 'rdTaxCreditContributorId'
  | 'rdTimesheetUserId'
  | TimesheetRdReportUserRowKeySpecifier
)[];
export type TimesheetRdReportUserRowFieldPolicy = {
  contributorName?: FieldPolicy<any> | FieldReadFunction<any>;
  isMatched?: FieldPolicy<any> | FieldReadFunction<any>;
  matchScore?: FieldPolicy<any> | FieldReadFunction<any>;
  matchTier?: FieldPolicy<any> | FieldReadFunction<any>;
  pid?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTaxCreditContributorId?: FieldPolicy<any> | FieldReadFunction<any>;
  rdTimesheetUserId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TimesheetSyncEventKeySpecifier = (
  | 'createdAt'
  | 'effortUnit'
  | 'id'
  | 'name'
  | TimesheetSyncEventKeySpecifier
)[];
export type TimesheetSyncEventFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  effortUnit?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TokenValidationIssueKeySpecifier = (
  | 'endpoint'
  | 'hint'
  | 'method'
  | 'name'
  | 'purpose'
  | TokenValidationIssueKeySpecifier
)[];
export type TokenValidationIssueFieldPolicy = {
  endpoint?: FieldPolicy<any> | FieldReadFunction<any>;
  hint?: FieldPolicy<any> | FieldReadFunction<any>;
  method?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  purpose?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UploadAccountingExpenseCsvResultKeySpecifier = (
  | 'accountingQres'
  | 'errors'
  | UploadAccountingExpenseCsvResultKeySpecifier
)[];
export type UploadAccountingExpenseCsvResultFieldPolicy = {
  accountingQres?: FieldPolicy<any> | FieldReadFunction<any>;
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UploadAscWageReportResultKeySpecifier = ('errors' | UploadAscWageReportResultKeySpecifier)[];
export type UploadAscWageReportResultFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UploadCsvToMoveTicketsToAscProjectsKeySpecifier = (
  | 'success'
  | UploadCsvToMoveTicketsToAscProjectsKeySpecifier
)[];
export type UploadCsvToMoveTicketsToAscProjectsFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UploadCsvToMoveTicketsToRdProjectsKeySpecifier = (
  | 'success'
  | UploadCsvToMoveTicketsToRdProjectsKeySpecifier
)[];
export type UploadCsvToMoveTicketsToRdProjectsFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UploadPayrollExpenseCsvResultKeySpecifier = (
  | 'errors'
  | 'payrollQres'
  | UploadPayrollExpenseCsvResultKeySpecifier
)[];
export type UploadPayrollExpenseCsvResultFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  payrollQres?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UploadRdExpenseProjectAllocationReportResultKeySpecifier = (
  | 'errors'
  | UploadRdExpenseProjectAllocationReportResultKeySpecifier
)[];
export type UploadRdExpenseProjectAllocationReportResultFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UploadUrlKeySpecifier = ('permanentUrl' | 'signedUrl' | UploadUrlKeySpecifier)[];
export type UploadUrlFieldPolicy = {
  permanentUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  signedUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserKeySpecifier = (
  | 'allowRealCompanyDatetime'
  | 'companies'
  | 'companyScopes'
  | 'createdAt'
  | 'email'
  | 'enterpriseSsoExemptDatetime'
  | 'firebaseUserId'
  | 'fullName'
  | 'id'
  | 'lastLoginDatetime'
  | 'organization'
  | 'organizationScope'
  | 'pendingOrFailedStatusCompanyInvitations'
  | 'pendingOrFailedStatusOrganizationInvitations'
  | 'phone'
  | 'thomsonReutersConsumerKey'
  | 'userAttributes'
  | UserKeySpecifier
)[];
export type UserFieldPolicy = {
  allowRealCompanyDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  companies?: FieldPolicy<any> | FieldReadFunction<any>;
  companyScopes?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  enterpriseSsoExemptDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  firebaseUserId?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastLoginDatetime?: FieldPolicy<any> | FieldReadFunction<any>;
  organization?: FieldPolicy<any> | FieldReadFunction<any>;
  organizationScope?: FieldPolicy<any> | FieldReadFunction<any>;
  pendingOrFailedStatusCompanyInvitations?: FieldPolicy<any> | FieldReadFunction<any>;
  pendingOrFailedStatusOrganizationInvitations?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  thomsonReutersConsumerKey?: FieldPolicy<any> | FieldReadFunction<any>;
  userAttributes?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserAttributesKeySpecifier = (
  | 'crmContactId'
  | 'isSsoOnboarding'
  | 'viewedWelcomeMessageTaxYear'
  | UserAttributesKeySpecifier
)[];
export type UserAttributesFieldPolicy = {
  crmContactId?: FieldPolicy<any> | FieldReadFunction<any>;
  isSsoOnboarding?: FieldPolicy<any> | FieldReadFunction<any>;
  viewedWelcomeMessageTaxYear?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserIdWithRoleKeySpecifier = ('isSuperUser' | 'userId' | UserIdWithRoleKeySpecifier)[];
export type UserIdWithRoleFieldPolicy = {
  isSuperUser?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ValidateTicketingTokenOutputKeySpecifier = (
  | 'errorMessage'
  | 'failedChecks'
  | 'github'
  | 'isValid'
  | ValidateTicketingTokenOutputKeySpecifier
)[];
export type ValidateTicketingTokenOutputFieldPolicy = {
  errorMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  failedChecks?: FieldPolicy<any> | FieldReadFunction<any>;
  github?: FieldPolicy<any> | FieldReadFunction<any>;
  isValid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  AccountingExpense?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AccountingExpenseKeySpecifier | (() => undefined | AccountingExpenseKeySpecifier);
    fields?: AccountingExpenseFieldPolicy;
  };
  AccountingQre?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AccountingQreKeySpecifier | (() => undefined | AccountingQreKeySpecifier);
    fields?: AccountingQreFieldPolicy;
  };
  AccountingQreAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountingQreAggregateGroupByKeySpecifier
      | (() => undefined | AccountingQreAggregateGroupByKeySpecifier);
    fields?: AccountingQreAggregateGroupByFieldPolicy;
  };
  AccountingQreAvgAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountingQreAvgAggregateKeySpecifier
      | (() => undefined | AccountingQreAvgAggregateKeySpecifier);
    fields?: AccountingQreAvgAggregateFieldPolicy;
  };
  AccountingQreConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AccountingQreConnectionKeySpecifier | (() => undefined | AccountingQreConnectionKeySpecifier);
    fields?: AccountingQreConnectionFieldPolicy;
  };
  AccountingQreCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountingQreCountAggregateKeySpecifier
      | (() => undefined | AccountingQreCountAggregateKeySpecifier);
    fields?: AccountingQreCountAggregateFieldPolicy;
  };
  AccountingQreEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AccountingQreEdgeKeySpecifier | (() => undefined | AccountingQreEdgeKeySpecifier);
    fields?: AccountingQreEdgeFieldPolicy;
  };
  AccountingQreMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountingQreMaxAggregateKeySpecifier
      | (() => undefined | AccountingQreMaxAggregateKeySpecifier);
    fields?: AccountingQreMaxAggregateFieldPolicy;
  };
  AccountingQreMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountingQreMinAggregateKeySpecifier
      | (() => undefined | AccountingQreMinAggregateKeySpecifier);
    fields?: AccountingQreMinAggregateFieldPolicy;
  };
  AccountingQreSumAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountingQreSumAggregateKeySpecifier
      | (() => undefined | AccountingQreSumAggregateKeySpecifier);
    fields?: AccountingQreSumAggregateFieldPolicy;
  };
  AccountingQreSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AccountingQreSummaryKeySpecifier | (() => undefined | AccountingQreSummaryKeySpecifier);
    fields?: AccountingQreSummaryFieldPolicy;
  };
  AccountingQreUniqueCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountingQreUniqueCountAggregateKeySpecifier
      | (() => undefined | AccountingQreUniqueCountAggregateKeySpecifier);
    fields?: AccountingQreUniqueCountAggregateFieldPolicy;
  };
  AccountingToken?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AccountingTokenKeySpecifier | (() => undefined | AccountingTokenKeySpecifier);
    fields?: AccountingTokenFieldPolicy;
  };
  AllocationProjectDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AllocationProjectDetailsKeySpecifier | (() => undefined | AllocationProjectDetailsKeySpecifier);
    fields?: AllocationProjectDetailsFieldPolicy;
  };
  ApplyWeightedCapitalizedPercentageToContributorsResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ApplyWeightedCapitalizedPercentageToContributorsResultKeySpecifier
      | (() => undefined | ApplyWeightedCapitalizedPercentageToContributorsResultKeySpecifier);
    fields?: ApplyWeightedCapitalizedPercentageToContributorsResultFieldPolicy;
  };
  ApplyWeightedCapitalizedPercentageToContributorsSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ApplyWeightedCapitalizedPercentageToContributorsSummaryKeySpecifier
      | (() => undefined | ApplyWeightedCapitalizedPercentageToContributorsSummaryKeySpecifier);
    fields?: ApplyWeightedCapitalizedPercentageToContributorsSummaryFieldPolicy;
  };
  ApplyWeightedRdPercentageToExpensesResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ApplyWeightedRdPercentageToExpensesResultKeySpecifier
      | (() => undefined | ApplyWeightedRdPercentageToExpensesResultKeySpecifier);
    fields?: ApplyWeightedRdPercentageToExpensesResultFieldPolicy;
  };
  AscContributorProjectAllocation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscContributorProjectAllocationKeySpecifier
      | (() => undefined | AscContributorProjectAllocationKeySpecifier);
    fields?: AscContributorProjectAllocationFieldPolicy;
  };
  AscContributorProjectAllocationAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscContributorProjectAllocationAggregateGroupByKeySpecifier
      | (() => undefined | AscContributorProjectAllocationAggregateGroupByKeySpecifier);
    fields?: AscContributorProjectAllocationAggregateGroupByFieldPolicy;
  };
  AscContributorProjectAllocationConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscContributorProjectAllocationConnectionKeySpecifier
      | (() => undefined | AscContributorProjectAllocationConnectionKeySpecifier);
    fields?: AscContributorProjectAllocationConnectionFieldPolicy;
  };
  AscContributorProjectAllocationCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscContributorProjectAllocationCountAggregateKeySpecifier
      | (() => undefined | AscContributorProjectAllocationCountAggregateKeySpecifier);
    fields?: AscContributorProjectAllocationCountAggregateFieldPolicy;
  };
  AscContributorProjectAllocationEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscContributorProjectAllocationEdgeKeySpecifier
      | (() => undefined | AscContributorProjectAllocationEdgeKeySpecifier);
    fields?: AscContributorProjectAllocationEdgeFieldPolicy;
  };
  AscContributorProjectAllocationMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscContributorProjectAllocationMaxAggregateKeySpecifier
      | (() => undefined | AscContributorProjectAllocationMaxAggregateKeySpecifier);
    fields?: AscContributorProjectAllocationMaxAggregateFieldPolicy;
  };
  AscContributorProjectAllocationMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscContributorProjectAllocationMinAggregateKeySpecifier
      | (() => undefined | AscContributorProjectAllocationMinAggregateKeySpecifier);
    fields?: AscContributorProjectAllocationMinAggregateFieldPolicy;
  };
  AscCostCsvResultRo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscCostCsvResultRoKeySpecifier | (() => undefined | AscCostCsvResultRoKeySpecifier);
    fields?: AscCostCsvResultRoFieldPolicy;
  };
  AscGroupingTicketOrCollection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscGroupingTicketOrCollectionKeySpecifier
      | (() => undefined | AscGroupingTicketOrCollectionKeySpecifier);
    fields?: AscGroupingTicketOrCollectionFieldPolicy;
  };
  AscMonthLockState?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscMonthLockStateKeySpecifier | (() => undefined | AscMonthLockStateKeySpecifier);
    fields?: AscMonthLockStateFieldPolicy;
  };
  AscPeriodLockStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscPeriodLockStatusKeySpecifier | (() => undefined | AscPeriodLockStatusKeySpecifier);
    fields?: AscPeriodLockStatusFieldPolicy;
  };
  AscProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectKeySpecifier | (() => undefined | AscProjectKeySpecifier);
    fields?: AscProjectFieldPolicy;
  };
  AscProjectAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectAggregateGroupByKeySpecifier
      | (() => undefined | AscProjectAggregateGroupByKeySpecifier);
    fields?: AscProjectAggregateGroupByFieldPolicy;
  };
  AscProjectApprovalStatusResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectApprovalStatusResultKeySpecifier
      | (() => undefined | AscProjectApprovalStatusResultKeySpecifier);
    fields?: AscProjectApprovalStatusResultFieldPolicy;
  };
  AscProjectAvgAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectAvgAggregateKeySpecifier | (() => undefined | AscProjectAvgAggregateKeySpecifier);
    fields?: AscProjectAvgAggregateFieldPolicy;
  };
  AscProjectConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectConnectionKeySpecifier | (() => undefined | AscProjectConnectionKeySpecifier);
    fields?: AscProjectConnectionFieldPolicy;
  };
  AscProjectCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectCountAggregateKeySpecifier | (() => undefined | AscProjectCountAggregateKeySpecifier);
    fields?: AscProjectCountAggregateFieldPolicy;
  };
  AscProjectDeletionResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectDeletionResultKeySpecifier | (() => undefined | AscProjectDeletionResultKeySpecifier);
    fields?: AscProjectDeletionResultFieldPolicy;
  };
  AscProjectEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectEdgeKeySpecifier | (() => undefined | AscProjectEdgeKeySpecifier);
    fields?: AscProjectEdgeFieldPolicy;
  };
  AscProjectMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectMaxAggregateKeySpecifier | (() => undefined | AscProjectMaxAggregateKeySpecifier);
    fields?: AscProjectMaxAggregateFieldPolicy;
  };
  AscProjectMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectMinAggregateKeySpecifier | (() => undefined | AscProjectMinAggregateKeySpecifier);
    fields?: AscProjectMinAggregateFieldPolicy;
  };
  AscProjectMonthPerContributor?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectMonthPerContributorKeySpecifier
      | (() => undefined | AscProjectMonthPerContributorKeySpecifier);
    fields?: AscProjectMonthPerContributorFieldPolicy;
  };
  AscProjectOwner?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectOwnerKeySpecifier | (() => undefined | AscProjectOwnerKeySpecifier);
    fields?: AscProjectOwnerFieldPolicy;
  };
  AscProjectPerContributor?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectPerContributorKeySpecifier | (() => undefined | AscProjectPerContributorKeySpecifier);
    fields?: AscProjectPerContributorFieldPolicy;
  };
  AscProjectReport?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectReportKeySpecifier | (() => undefined | AscProjectReportKeySpecifier);
    fields?: AscProjectReportFieldPolicy;
  };
  AscProjectSumAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectSumAggregateKeySpecifier | (() => undefined | AscProjectSumAggregateKeySpecifier);
    fields?: AscProjectSumAggregateFieldPolicy;
  };
  AscProjectTeamMember?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectTeamMemberKeySpecifier | (() => undefined | AscProjectTeamMemberKeySpecifier);
    fields?: AscProjectTeamMemberFieldPolicy;
  };
  AscProjectTeamMemberAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTeamMemberAggregateGroupByKeySpecifier
      | (() => undefined | AscProjectTeamMemberAggregateGroupByKeySpecifier);
    fields?: AscProjectTeamMemberAggregateGroupByFieldPolicy;
  };
  AscProjectTeamMemberAvgAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTeamMemberAvgAggregateKeySpecifier
      | (() => undefined | AscProjectTeamMemberAvgAggregateKeySpecifier);
    fields?: AscProjectTeamMemberAvgAggregateFieldPolicy;
  };
  AscProjectTeamMemberConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTeamMemberConnectionKeySpecifier
      | (() => undefined | AscProjectTeamMemberConnectionKeySpecifier);
    fields?: AscProjectTeamMemberConnectionFieldPolicy;
  };
  AscProjectTeamMemberCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTeamMemberCountAggregateKeySpecifier
      | (() => undefined | AscProjectTeamMemberCountAggregateKeySpecifier);
    fields?: AscProjectTeamMemberCountAggregateFieldPolicy;
  };
  AscProjectTeamMemberEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectTeamMemberEdgeKeySpecifier | (() => undefined | AscProjectTeamMemberEdgeKeySpecifier);
    fields?: AscProjectTeamMemberEdgeFieldPolicy;
  };
  AscProjectTeamMemberMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTeamMemberMaxAggregateKeySpecifier
      | (() => undefined | AscProjectTeamMemberMaxAggregateKeySpecifier);
    fields?: AscProjectTeamMemberMaxAggregateFieldPolicy;
  };
  AscProjectTeamMemberMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTeamMemberMinAggregateKeySpecifier
      | (() => undefined | AscProjectTeamMemberMinAggregateKeySpecifier);
    fields?: AscProjectTeamMemberMinAggregateFieldPolicy;
  };
  AscProjectTeamMemberSumAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTeamMemberSumAggregateKeySpecifier
      | (() => undefined | AscProjectTeamMemberSumAggregateKeySpecifier);
    fields?: AscProjectTeamMemberSumAggregateFieldPolicy;
  };
  AscProjectTpTicketsView?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectTpTicketsViewKeySpecifier | (() => undefined | AscProjectTpTicketsViewKeySpecifier);
    fields?: AscProjectTpTicketsViewFieldPolicy;
  };
  AscProjectTpTicketsViewAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTpTicketsViewAggregateGroupByKeySpecifier
      | (() => undefined | AscProjectTpTicketsViewAggregateGroupByKeySpecifier);
    fields?: AscProjectTpTicketsViewAggregateGroupByFieldPolicy;
  };
  AscProjectTpTicketsViewAvgAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTpTicketsViewAvgAggregateKeySpecifier
      | (() => undefined | AscProjectTpTicketsViewAvgAggregateKeySpecifier);
    fields?: AscProjectTpTicketsViewAvgAggregateFieldPolicy;
  };
  AscProjectTpTicketsViewConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTpTicketsViewConnectionKeySpecifier
      | (() => undefined | AscProjectTpTicketsViewConnectionKeySpecifier);
    fields?: AscProjectTpTicketsViewConnectionFieldPolicy;
  };
  AscProjectTpTicketsViewCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTpTicketsViewCountAggregateKeySpecifier
      | (() => undefined | AscProjectTpTicketsViewCountAggregateKeySpecifier);
    fields?: AscProjectTpTicketsViewCountAggregateFieldPolicy;
  };
  AscProjectTpTicketsViewEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTpTicketsViewEdgeKeySpecifier
      | (() => undefined | AscProjectTpTicketsViewEdgeKeySpecifier);
    fields?: AscProjectTpTicketsViewEdgeFieldPolicy;
  };
  AscProjectTpTicketsViewMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTpTicketsViewMaxAggregateKeySpecifier
      | (() => undefined | AscProjectTpTicketsViewMaxAggregateKeySpecifier);
    fields?: AscProjectTpTicketsViewMaxAggregateFieldPolicy;
  };
  AscProjectTpTicketsViewMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTpTicketsViewMinAggregateKeySpecifier
      | (() => undefined | AscProjectTpTicketsViewMinAggregateKeySpecifier);
    fields?: AscProjectTpTicketsViewMinAggregateFieldPolicy;
  };
  AscProjectTpTicketsViewSumAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectTpTicketsViewSumAggregateKeySpecifier
      | (() => undefined | AscProjectTpTicketsViewSumAggregateKeySpecifier);
    fields?: AscProjectTpTicketsViewSumAggregateFieldPolicy;
  };
  AscProjectUniqueCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscProjectUniqueCountAggregateKeySpecifier
      | (() => undefined | AscProjectUniqueCountAggregateKeySpecifier);
    fields?: AscProjectUniqueCountAggregateFieldPolicy;
  };
  AscProjectsSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscProjectsSummaryKeySpecifier | (() => undefined | AscProjectsSummaryKeySpecifier);
    fields?: AscProjectsSummaryFieldPolicy;
  };
  AscReportRo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscReportRoKeySpecifier | (() => undefined | AscReportRoKeySpecifier);
    fields?: AscReportRoFieldPolicy;
  };
  AscSyncConfiguration?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscSyncConfigurationKeySpecifier | (() => undefined | AscSyncConfigurationKeySpecifier);
    fields?: AscSyncConfigurationFieldPolicy;
  };
  AscWage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscWageKeySpecifier | (() => undefined | AscWageKeySpecifier);
    fields?: AscWageFieldPolicy;
  };
  AscWageAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscWageAggregateGroupByKeySpecifier | (() => undefined | AscWageAggregateGroupByKeySpecifier);
    fields?: AscWageAggregateGroupByFieldPolicy;
  };
  AscWageAvgAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscWageAvgAggregateKeySpecifier | (() => undefined | AscWageAvgAggregateKeySpecifier);
    fields?: AscWageAvgAggregateFieldPolicy;
  };
  AscWageConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscWageConnectionKeySpecifier | (() => undefined | AscWageConnectionKeySpecifier);
    fields?: AscWageConnectionFieldPolicy;
  };
  AscWageCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscWageCountAggregateKeySpecifier | (() => undefined | AscWageCountAggregateKeySpecifier);
    fields?: AscWageCountAggregateFieldPolicy;
  };
  AscWageEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscWageEdgeKeySpecifier | (() => undefined | AscWageEdgeKeySpecifier);
    fields?: AscWageEdgeFieldPolicy;
  };
  AscWageMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscWageMaxAggregateKeySpecifier | (() => undefined | AscWageMaxAggregateKeySpecifier);
    fields?: AscWageMaxAggregateFieldPolicy;
  };
  AscWageMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscWageMinAggregateKeySpecifier | (() => undefined | AscWageMinAggregateKeySpecifier);
    fields?: AscWageMinAggregateFieldPolicy;
  };
  AscWageReportResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscWageReportResultKeySpecifier | (() => undefined | AscWageReportResultKeySpecifier);
    fields?: AscWageReportResultFieldPolicy;
  };
  AscWageSumAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscWageSumAggregateKeySpecifier | (() => undefined | AscWageSumAggregateKeySpecifier);
    fields?: AscWageSumAggregateFieldPolicy;
  };
  AscWageSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | AscWageSummaryKeySpecifier | (() => undefined | AscWageSummaryKeySpecifier);
    fields?: AscWageSummaryFieldPolicy;
  };
  AscWageUniqueCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AscWageUniqueCountAggregateKeySpecifier
      | (() => undefined | AscWageUniqueCountAggregateKeySpecifier);
    fields?: AscWageUniqueCountAggregateFieldPolicy;
  };
  BackgroundOperation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | BackgroundOperationKeySpecifier | (() => undefined | BackgroundOperationKeySpecifier);
    fields?: BackgroundOperationFieldPolicy;
  };
  BulkDeleteAscProjectsResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BulkDeleteAscProjectsResultKeySpecifier
      | (() => undefined | BulkDeleteAscProjectsResultKeySpecifier);
    fields?: BulkDeleteAscProjectsResultFieldPolicy;
  };
  BulkDeleteEmptyRdProjectsResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BulkDeleteEmptyRdProjectsResultKeySpecifier
      | (() => undefined | BulkDeleteEmptyRdProjectsResultKeySpecifier);
    fields?: BulkDeleteEmptyRdProjectsResultFieldPolicy;
  };
  BulkTicketingDataFileUpload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BulkTicketingDataFileUploadKeySpecifier
      | (() => undefined | BulkTicketingDataFileUploadKeySpecifier);
    fields?: BulkTicketingDataFileUploadFieldPolicy;
  };
  BulkUpdateRdProjectsProductByCsvResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BulkUpdateRdProjectsProductByCsvResultKeySpecifier
      | (() => undefined | BulkUpdateRdProjectsProductByCsvResultKeySpecifier);
    fields?: BulkUpdateRdProjectsProductByCsvResultFieldPolicy;
  };
  BusinessComponentParams?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | BusinessComponentParamsKeySpecifier | (() => undefined | BusinessComponentParamsKeySpecifier);
    fields?: BusinessComponentParamsFieldPolicy;
  };
  BusinessQuestions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | BusinessQuestionsKeySpecifier | (() => undefined | BusinessQuestionsKeySpecifier);
    fields?: BusinessQuestionsFieldPolicy;
  };
  CaSredSyncConfigurationRo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CaSredSyncConfigurationRoKeySpecifier
      | (() => undefined | CaSredSyncConfigurationRoKeySpecifier);
    fields?: CaSredSyncConfigurationRoFieldPolicy;
  };
  CalculateAllocationsRdResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CalculateAllocationsRdResultKeySpecifier
      | (() => undefined | CalculateAllocationsRdResultKeySpecifier);
    fields?: CalculateAllocationsRdResultFieldPolicy;
  };
  Company?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CompanyKeySpecifier | (() => undefined | CompanyKeySpecifier);
    fields?: CompanyFieldPolicy;
  };
  CompanyInvitation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CompanyInvitationKeySpecifier | (() => undefined | CompanyInvitationKeySpecifier);
    fields?: CompanyInvitationFieldPolicy;
  };
  CompanyScopes?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CompanyScopesKeySpecifier | (() => undefined | CompanyScopesKeySpecifier);
    fields?: CompanyScopesFieldPolicy;
  };
  Contributor?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ContributorKeySpecifier | (() => undefined | ContributorKeySpecifier);
    fields?: ContributorFieldPolicy;
  };
  CreatorRdWageAllocationResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatorRdWageAllocationResultKeySpecifier
      | (() => undefined | CreatorRdWageAllocationResultKeySpecifier);
    fields?: CreatorRdWageAllocationResultFieldPolicy;
  };
  CustomFieldCapitalizationMapping?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomFieldCapitalizationMappingKeySpecifier
      | (() => undefined | CustomFieldCapitalizationMappingKeySpecifier);
    fields?: CustomFieldCapitalizationMappingFieldPolicy;
  };
  DeleteAccountingSyncEventForFiscalYearResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteAccountingSyncEventForFiscalYearResultKeySpecifier
      | (() => undefined | DeleteAccountingSyncEventForFiscalYearResultKeySpecifier);
    fields?: DeleteAccountingSyncEventForFiscalYearResultFieldPolicy;
  };
  DeleteAccountingTokensResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteAccountingTokensResultKeySpecifier
      | (() => undefined | DeleteAccountingTokensResultKeySpecifier);
    fields?: DeleteAccountingTokensResultFieldPolicy;
  };
  DeletePayrollMonthExpenseSyncEventResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletePayrollMonthExpenseSyncEventResultKeySpecifier
      | (() => undefined | DeletePayrollMonthExpenseSyncEventResultKeySpecifier);
    fields?: DeletePayrollMonthExpenseSyncEventResultFieldPolicy;
  };
  DeletePayrollSyncEventForFiscalYearResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletePayrollSyncEventForFiscalYearResultKeySpecifier
      | (() => undefined | DeletePayrollSyncEventForFiscalYearResultKeySpecifier);
    fields?: DeletePayrollSyncEventForFiscalYearResultFieldPolicy;
  };
  DeletePayrollTokensResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletePayrollTokensResultKeySpecifier
      | (() => undefined | DeletePayrollTokensResultKeySpecifier);
    fields?: DeletePayrollTokensResultFieldPolicy;
  };
  DemoAccountInitialization?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DemoAccountInitializationKeySpecifier
      | (() => undefined | DemoAccountInitializationKeySpecifier);
    fields?: DemoAccountInitializationFieldPolicy;
  };
  DemoAccountReadiness?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DemoAccountReadinessKeySpecifier | (() => undefined | DemoAccountReadinessKeySpecifier);
    fields?: DemoAccountReadinessFieldPolicy;
  };
  DemoBundleConflict?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DemoBundleConflictKeySpecifier | (() => undefined | DemoBundleConflictKeySpecifier);
    fields?: DemoBundleConflictFieldPolicy;
  };
  DemoBundleCounts?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DemoBundleCountsKeySpecifier | (() => undefined | DemoBundleCountsKeySpecifier);
    fields?: DemoBundleCountsFieldPolicy;
  };
  DemoBundleIdentity?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DemoBundleIdentityKeySpecifier | (() => undefined | DemoBundleIdentityKeySpecifier);
    fields?: DemoBundleIdentityFieldPolicy;
  };
  DemoBundlePreflightReport?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DemoBundlePreflightReportKeySpecifier
      | (() => undefined | DemoBundlePreflightReportKeySpecifier);
    fields?: DemoBundlePreflightReportFieldPolicy;
  };
  DisconnectTicketingTokenOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DisconnectTicketingTokenOutputKeySpecifier
      | (() => undefined | DisconnectTicketingTokenOutputKeySpecifier);
    fields?: DisconnectTicketingTokenOutputFieldPolicy;
  };
  DistributedFlowState?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DistributedFlowStateKeySpecifier | (() => undefined | DistributedFlowStateKeySpecifier);
    fields?: DistributedFlowStateFieldPolicy;
  };
  DocumentEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DocumentEventKeySpecifier | (() => undefined | DocumentEventKeySpecifier);
    fields?: DocumentEventFieldPolicy;
  };
  Documents?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | DocumentsKeySpecifier | (() => undefined | DocumentsKeySpecifier);
    fields?: DocumentsFieldPolicy;
  };
  ExcelParseError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ExcelParseErrorKeySpecifier | (() => undefined | ExcelParseErrorKeySpecifier);
    fields?: ExcelParseErrorFieldPolicy;
  };
  FederalDocumentStatuses?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FederalDocumentStatusesKeySpecifier | (() => undefined | FederalDocumentStatusesKeySpecifier);
    fields?: FederalDocumentStatusesFieldPolicy;
  };
  FederalRdTaxCreditDocuments?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FederalRdTaxCreditDocumentsKeySpecifier
      | (() => undefined | FederalRdTaxCreditDocumentsKeySpecifier);
    fields?: FederalRdTaxCreditDocumentsFieldPolicy;
  };
  FileUpload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FileUploadKeySpecifier | (() => undefined | FileUploadKeySpecifier);
    fields?: FileUploadFieldPolicy;
  };
  FinchSession?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FinchSessionKeySpecifier | (() => undefined | FinchSessionKeySpecifier);
    fields?: FinchSessionFieldPolicy;
  };
  FirebaseIdentityAccountModel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FirebaseIdentityAccountModelKeySpecifier
      | (() => undefined | FirebaseIdentityAccountModelKeySpecifier);
    fields?: FirebaseIdentityAccountModelFieldPolicy;
  };
  FirebaseIdentityModel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FirebaseIdentityModelKeySpecifier | (() => undefined | FirebaseIdentityModelKeySpecifier);
    fields?: FirebaseIdentityModelFieldPolicy;
  };
  FirebaseIdentityProviderModel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FirebaseIdentityProviderModelKeySpecifier
      | (() => undefined | FirebaseIdentityProviderModelKeySpecifier);
    fields?: FirebaseIdentityProviderModelFieldPolicy;
  };
  FiscalYear?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FiscalYearKeySpecifier | (() => undefined | FiscalYearKeySpecifier);
    fields?: FiscalYearFieldPolicy;
  };
  Form6765Values?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | Form6765ValuesKeySpecifier | (() => undefined | Form6765ValuesKeySpecifier);
    fields?: Form6765ValuesFieldPolicy;
  };
  FormLineItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FormLineItemKeySpecifier | (() => undefined | FormLineItemKeySpecifier);
    fields?: FormLineItemFieldPolicy;
  };
  FormLineItemMetadata?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FormLineItemMetadataKeySpecifier | (() => undefined | FormLineItemMetadataKeySpecifier);
    fields?: FormLineItemMetadataFieldPolicy;
  };
  FourPartTest?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FourPartTestKeySpecifier | (() => undefined | FourPartTestKeySpecifier);
    fields?: FourPartTestFieldPolicy;
  };
  GaapOnboardingFlowStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | GaapOnboardingFlowStatusKeySpecifier | (() => undefined | GaapOnboardingFlowStatusKeySpecifier);
    fields?: GaapOnboardingFlowStatusFieldPolicy;
  };
  GithubTokenDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | GithubTokenDetailsKeySpecifier | (() => undefined | GithubTokenDetailsKeySpecifier);
    fields?: GithubTokenDetailsFieldPolicy;
  };
  JiraFieldMetadata?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | JiraFieldMetadataKeySpecifier | (() => undefined | JiraFieldMetadataKeySpecifier);
    fields?: JiraFieldMetadataFieldPolicy;
  };
  JobExecution?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | JobExecutionKeySpecifier | (() => undefined | JobExecutionKeySpecifier);
    fields?: JobExecutionFieldPolicy;
  };
  JobExecutionStateCounts?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | JobExecutionStateCountsKeySpecifier | (() => undefined | JobExecutionStateCountsKeySpecifier);
    fields?: JobExecutionStateCountsFieldPolicy;
  };
  LegacyDocuments?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | LegacyDocumentsKeySpecifier | (() => undefined | LegacyDocumentsKeySpecifier);
    fields?: LegacyDocumentsFieldPolicy;
  };
  LegacyFederalRdTaxCreditDocumentsRo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LegacyFederalRdTaxCreditDocumentsRoKeySpecifier
      | (() => undefined | LegacyFederalRdTaxCreditDocumentsRoKeySpecifier);
    fields?: LegacyFederalRdTaxCreditDocumentsRoFieldPolicy;
  };
  LegacyFederalRdTaxWriteUpDocumentsRo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LegacyFederalRdTaxWriteUpDocumentsRoKeySpecifier
      | (() => undefined | LegacyFederalRdTaxWriteUpDocumentsRoKeySpecifier);
    fields?: LegacyFederalRdTaxWriteUpDocumentsRoFieldPolicy;
  };
  LegacyStateRdTaxCreditDocumentsRo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LegacyStateRdTaxCreditDocumentsRoKeySpecifier
      | (() => undefined | LegacyStateRdTaxCreditDocumentsRoKeySpecifier);
    fields?: LegacyStateRdTaxCreditDocumentsRoFieldPolicy;
  };
  LoginAuditLog?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | LoginAuditLogKeySpecifier | (() => undefined | LoginAuditLogKeySpecifier);
    fields?: LoginAuditLogFieldPolicy;
  };
  MissingValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | MissingValueKeySpecifier | (() => undefined | MissingValueKeySpecifier);
    fields?: MissingValueFieldPolicy;
  };
  MonthYear?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | MonthYearKeySpecifier | (() => undefined | MonthYearKeySpecifier);
    fields?: MonthYearFieldPolicy;
  };
  MonthYearPeriod?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | MonthYearPeriodKeySpecifier | (() => undefined | MonthYearPeriodKeySpecifier);
    fields?: MonthYearPeriodFieldPolicy;
  };
  MoveTicketsToAscProjectOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MoveTicketsToAscProjectOutputKeySpecifier
      | (() => undefined | MoveTicketsToAscProjectOutputKeySpecifier);
    fields?: MoveTicketsToAscProjectOutputFieldPolicy;
  };
  MoveTicketsToRdProjectOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MoveTicketsToRdProjectOutputKeySpecifier
      | (() => undefined | MoveTicketsToRdProjectOutputKeySpecifier);
    fields?: MoveTicketsToRdProjectOutputFieldPolicy;
  };
  Mutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier);
    fields?: MutationFieldPolicy;
  };
  OnCallShift?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | OnCallShiftKeySpecifier | (() => undefined | OnCallShiftKeySpecifier);
    fields?: OnCallShiftFieldPolicy;
  };
  Organization?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | OrganizationKeySpecifier | (() => undefined | OrganizationKeySpecifier);
    fields?: OrganizationFieldPolicy;
  };
  OrganizationInvitation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | OrganizationInvitationKeySpecifier | (() => undefined | OrganizationInvitationKeySpecifier);
    fields?: OrganizationInvitationFieldPolicy;
  };
  PageInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier);
    fields?: PageInfoFieldPolicy;
  };
  ParentQuestionChoice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ParentQuestionChoiceKeySpecifier | (() => undefined | ParentQuestionChoiceKeySpecifier);
    fields?: ParentQuestionChoiceFieldPolicy;
  };
  PayrollExpense?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PayrollExpenseKeySpecifier | (() => undefined | PayrollExpenseKeySpecifier);
    fields?: PayrollExpenseFieldPolicy;
  };
  PayrollQre?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PayrollQreKeySpecifier | (() => undefined | PayrollQreKeySpecifier);
    fields?: PayrollQreFieldPolicy;
  };
  PayrollQreAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PayrollQreAggregateGroupByKeySpecifier
      | (() => undefined | PayrollQreAggregateGroupByKeySpecifier);
    fields?: PayrollQreAggregateGroupByFieldPolicy;
  };
  PayrollQreAvgAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PayrollQreAvgAggregateKeySpecifier | (() => undefined | PayrollQreAvgAggregateKeySpecifier);
    fields?: PayrollQreAvgAggregateFieldPolicy;
  };
  PayrollQreConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PayrollQreConnectionKeySpecifier | (() => undefined | PayrollQreConnectionKeySpecifier);
    fields?: PayrollQreConnectionFieldPolicy;
  };
  PayrollQreCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PayrollQreCountAggregateKeySpecifier | (() => undefined | PayrollQreCountAggregateKeySpecifier);
    fields?: PayrollQreCountAggregateFieldPolicy;
  };
  PayrollQreEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PayrollQreEdgeKeySpecifier | (() => undefined | PayrollQreEdgeKeySpecifier);
    fields?: PayrollQreEdgeFieldPolicy;
  };
  PayrollQreMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PayrollQreMaxAggregateKeySpecifier | (() => undefined | PayrollQreMaxAggregateKeySpecifier);
    fields?: PayrollQreMaxAggregateFieldPolicy;
  };
  PayrollQreMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PayrollQreMinAggregateKeySpecifier | (() => undefined | PayrollQreMinAggregateKeySpecifier);
    fields?: PayrollQreMinAggregateFieldPolicy;
  };
  PayrollQreSumAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PayrollQreSumAggregateKeySpecifier | (() => undefined | PayrollQreSumAggregateKeySpecifier);
    fields?: PayrollQreSumAggregateFieldPolicy;
  };
  PayrollQreSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PayrollQreSummaryKeySpecifier | (() => undefined | PayrollQreSummaryKeySpecifier);
    fields?: PayrollQreSummaryFieldPolicy;
  };
  PayrollQreUniqueCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PayrollQreUniqueCountAggregateKeySpecifier
      | (() => undefined | PayrollQreUniqueCountAggregateKeySpecifier);
    fields?: PayrollQreUniqueCountAggregateFieldPolicy;
  };
  PayrollToken?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PayrollTokenKeySpecifier | (() => undefined | PayrollTokenKeySpecifier);
    fields?: PayrollTokenFieldPolicy;
  };
  PreviewAllocationChangeResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PreviewAllocationChangeResultKeySpecifier
      | (() => undefined | PreviewAllocationChangeResultKeySpecifier);
    fields?: PreviewAllocationChangeResultFieldPolicy;
  };
  PreviewAllocationProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PreviewAllocationProjectKeySpecifier | (() => undefined | PreviewAllocationProjectKeySpecifier);
    fields?: PreviewAllocationProjectFieldPolicy;
  };
  PriorYearQRE?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PriorYearQREKeySpecifier | (() => undefined | PriorYearQREKeySpecifier);
    fields?: PriorYearQREFieldPolicy;
  };
  PriorYearRevenue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PriorYearRevenueKeySpecifier | (() => undefined | PriorYearRevenueKeySpecifier);
    fields?: PriorYearRevenueFieldPolicy;
  };
  Product?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ProductKeySpecifier | (() => undefined | ProductKeySpecifier);
    fields?: ProductFieldPolicy;
  };
  ProjectPerAccountingExpense?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectPerAccountingExpenseKeySpecifier
      | (() => undefined | ProjectPerAccountingExpenseKeySpecifier);
    fields?: ProjectPerAccountingExpenseFieldPolicy;
  };
  ProjectPerRdExpense?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ProjectPerRdExpenseKeySpecifier | (() => undefined | ProjectPerRdExpenseKeySpecifier);
    fields?: ProjectPerRdExpenseFieldPolicy;
  };
  ProjectRdDetermination?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ProjectRdDeterminationKeySpecifier | (() => undefined | ProjectRdDeterminationKeySpecifier);
    fields?: ProjectRdDeterminationFieldPolicy;
  };
  ProjectRdDeterminationUncertainty?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectRdDeterminationUncertaintyKeySpecifier
      | (() => undefined | ProjectRdDeterminationUncertaintyKeySpecifier);
    fields?: ProjectRdDeterminationUncertaintyFieldPolicy;
  };
  Query?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier);
    fields?: QueryFieldPolicy;
  };
  Question?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | QuestionKeySpecifier | (() => undefined | QuestionKeySpecifier);
    fields?: QuestionFieldPolicy;
  };
  QuestionChoice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | QuestionChoiceKeySpecifier | (() => undefined | QuestionChoiceKeySpecifier);
    fields?: QuestionChoiceFieldPolicy;
  };
  QuestionSection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | QuestionSectionKeySpecifier | (() => undefined | QuestionSectionKeySpecifier);
    fields?: QuestionSectionFieldPolicy;
  };
  RDTaxCredit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RDTaxCreditKeySpecifier | (() => undefined | RDTaxCreditKeySpecifier);
    fields?: RDTaxCreditFieldPolicy;
  };
  RDTaxQuestions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RDTaxQuestionsKeySpecifier | (() => undefined | RDTaxQuestionsKeySpecifier);
    fields?: RDTaxQuestionsFieldPolicy;
  };
  RdBusinessComponent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdBusinessComponentKeySpecifier | (() => undefined | RdBusinessComponentKeySpecifier);
    fields?: RdBusinessComponentFieldPolicy;
  };
  RdBusinessComponentSync?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdBusinessComponentSyncKeySpecifier | (() => undefined | RdBusinessComponentSyncKeySpecifier);
    fields?: RdBusinessComponentSyncFieldPolicy;
  };
  RdBusinessComponentTicketMatch?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdBusinessComponentTicketMatchKeySpecifier
      | (() => undefined | RdBusinessComponentTicketMatchKeySpecifier);
    fields?: RdBusinessComponentTicketMatchFieldPolicy;
  };
  RdBusinessComponentTicketMatches?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdBusinessComponentTicketMatchesKeySpecifier
      | (() => undefined | RdBusinessComponentTicketMatchesKeySpecifier);
    fields?: RdBusinessComponentTicketMatchesFieldPolicy;
  };
  RdCreditsReportRo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdCreditsReportRoKeySpecifier | (() => undefined | RdCreditsReportRoKeySpecifier);
    fields?: RdCreditsReportRoFieldPolicy;
  };
  RdExpense?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdExpenseKeySpecifier | (() => undefined | RdExpenseKeySpecifier);
    fields?: RdExpenseFieldPolicy;
  };
  RdExpenseProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdExpenseProjectKeySpecifier | (() => undefined | RdExpenseProjectKeySpecifier);
    fields?: RdExpenseProjectFieldPolicy;
  };
  RdExpenseProjectAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectAggregateGroupByKeySpecifier
      | (() => undefined | RdExpenseProjectAggregateGroupByKeySpecifier);
    fields?: RdExpenseProjectAggregateGroupByFieldPolicy;
  };
  RdExpenseProjectAllocation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectAllocationKeySpecifier
      | (() => undefined | RdExpenseProjectAllocationKeySpecifier);
    fields?: RdExpenseProjectAllocationFieldPolicy;
  };
  RdExpenseProjectAllocationAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectAllocationAggregateGroupByKeySpecifier
      | (() => undefined | RdExpenseProjectAllocationAggregateGroupByKeySpecifier);
    fields?: RdExpenseProjectAllocationAggregateGroupByFieldPolicy;
  };
  RdExpenseProjectAllocationConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectAllocationConnectionKeySpecifier
      | (() => undefined | RdExpenseProjectAllocationConnectionKeySpecifier);
    fields?: RdExpenseProjectAllocationConnectionFieldPolicy;
  };
  RdExpenseProjectAllocationCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectAllocationCountAggregateKeySpecifier
      | (() => undefined | RdExpenseProjectAllocationCountAggregateKeySpecifier);
    fields?: RdExpenseProjectAllocationCountAggregateFieldPolicy;
  };
  RdExpenseProjectAllocationEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectAllocationEdgeKeySpecifier
      | (() => undefined | RdExpenseProjectAllocationEdgeKeySpecifier);
    fields?: RdExpenseProjectAllocationEdgeFieldPolicy;
  };
  RdExpenseProjectAllocationMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectAllocationMaxAggregateKeySpecifier
      | (() => undefined | RdExpenseProjectAllocationMaxAggregateKeySpecifier);
    fields?: RdExpenseProjectAllocationMaxAggregateFieldPolicy;
  };
  RdExpenseProjectAllocationMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectAllocationMinAggregateKeySpecifier
      | (() => undefined | RdExpenseProjectAllocationMinAggregateKeySpecifier);
    fields?: RdExpenseProjectAllocationMinAggregateFieldPolicy;
  };
  RdExpenseProjectAllocationReportRo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectAllocationReportRoKeySpecifier
      | (() => undefined | RdExpenseProjectAllocationReportRoKeySpecifier);
    fields?: RdExpenseProjectAllocationReportRoFieldPolicy;
  };
  RdExpenseProjectConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectConnectionKeySpecifier
      | (() => undefined | RdExpenseProjectConnectionKeySpecifier);
    fields?: RdExpenseProjectConnectionFieldPolicy;
  };
  RdExpenseProjectCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectCountAggregateKeySpecifier
      | (() => undefined | RdExpenseProjectCountAggregateKeySpecifier);
    fields?: RdExpenseProjectCountAggregateFieldPolicy;
  };
  RdExpenseProjectEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdExpenseProjectEdgeKeySpecifier | (() => undefined | RdExpenseProjectEdgeKeySpecifier);
    fields?: RdExpenseProjectEdgeFieldPolicy;
  };
  RdExpenseProjectMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectMaxAggregateKeySpecifier
      | (() => undefined | RdExpenseProjectMaxAggregateKeySpecifier);
    fields?: RdExpenseProjectMaxAggregateFieldPolicy;
  };
  RdExpenseProjectMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdExpenseProjectMinAggregateKeySpecifier
      | (() => undefined | RdExpenseProjectMinAggregateKeySpecifier);
    fields?: RdExpenseProjectMinAggregateFieldPolicy;
  };
  RdGroupingTicketOrCollection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdGroupingTicketOrCollectionKeySpecifier
      | (() => undefined | RdGroupingTicketOrCollectionKeySpecifier);
    fields?: RdGroupingTicketOrCollectionFieldPolicy;
  };
  RdProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectKeySpecifier | (() => undefined | RdProjectKeySpecifier);
    fields?: RdProjectFieldPolicy;
  };
  RdProjectAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectAggregateGroupByKeySpecifier
      | (() => undefined | RdProjectAggregateGroupByKeySpecifier);
    fields?: RdProjectAggregateGroupByFieldPolicy;
  };
  RdProjectAvgAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectAvgAggregateKeySpecifier | (() => undefined | RdProjectAvgAggregateKeySpecifier);
    fields?: RdProjectAvgAggregateFieldPolicy;
  };
  RdProjectConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectConnectionKeySpecifier | (() => undefined | RdProjectConnectionKeySpecifier);
    fields?: RdProjectConnectionFieldPolicy;
  };
  RdProjectCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectCountAggregateKeySpecifier | (() => undefined | RdProjectCountAggregateKeySpecifier);
    fields?: RdProjectCountAggregateFieldPolicy;
  };
  RdProjectDeletionResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectDeletionResultKeySpecifier | (() => undefined | RdProjectDeletionResultKeySpecifier);
    fields?: RdProjectDeletionResultFieldPolicy;
  };
  RdProjectEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectEdgeKeySpecifier | (() => undefined | RdProjectEdgeKeySpecifier);
    fields?: RdProjectEdgeFieldPolicy;
  };
  RdProjectMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectMaxAggregateKeySpecifier | (() => undefined | RdProjectMaxAggregateKeySpecifier);
    fields?: RdProjectMaxAggregateFieldPolicy;
  };
  RdProjectMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectMinAggregateKeySpecifier | (() => undefined | RdProjectMinAggregateKeySpecifier);
    fields?: RdProjectMinAggregateFieldPolicy;
  };
  RdProjectNameAndDescription?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectNameAndDescriptionKeySpecifier
      | (() => undefined | RdProjectNameAndDescriptionKeySpecifier);
    fields?: RdProjectNameAndDescriptionFieldPolicy;
  };
  RdProjectOwner?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectOwnerKeySpecifier | (() => undefined | RdProjectOwnerKeySpecifier);
    fields?: RdProjectOwnerFieldPolicy;
  };
  RdProjectReport?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectReportKeySpecifier | (() => undefined | RdProjectReportKeySpecifier);
    fields?: RdProjectReportFieldPolicy;
  };
  RdProjectSumAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectSumAggregateKeySpecifier | (() => undefined | RdProjectSumAggregateKeySpecifier);
    fields?: RdProjectSumAggregateFieldPolicy;
  };
  RdProjectTeamMember?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectTeamMemberKeySpecifier | (() => undefined | RdProjectTeamMemberKeySpecifier);
    fields?: RdProjectTeamMemberFieldPolicy;
  };
  RdProjectTeamMemberAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTeamMemberAggregateGroupByKeySpecifier
      | (() => undefined | RdProjectTeamMemberAggregateGroupByKeySpecifier);
    fields?: RdProjectTeamMemberAggregateGroupByFieldPolicy;
  };
  RdProjectTeamMemberAvgAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTeamMemberAvgAggregateKeySpecifier
      | (() => undefined | RdProjectTeamMemberAvgAggregateKeySpecifier);
    fields?: RdProjectTeamMemberAvgAggregateFieldPolicy;
  };
  RdProjectTeamMemberConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTeamMemberConnectionKeySpecifier
      | (() => undefined | RdProjectTeamMemberConnectionKeySpecifier);
    fields?: RdProjectTeamMemberConnectionFieldPolicy;
  };
  RdProjectTeamMemberCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTeamMemberCountAggregateKeySpecifier
      | (() => undefined | RdProjectTeamMemberCountAggregateKeySpecifier);
    fields?: RdProjectTeamMemberCountAggregateFieldPolicy;
  };
  RdProjectTeamMemberEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectTeamMemberEdgeKeySpecifier | (() => undefined | RdProjectTeamMemberEdgeKeySpecifier);
    fields?: RdProjectTeamMemberEdgeFieldPolicy;
  };
  RdProjectTeamMemberMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTeamMemberMaxAggregateKeySpecifier
      | (() => undefined | RdProjectTeamMemberMaxAggregateKeySpecifier);
    fields?: RdProjectTeamMemberMaxAggregateFieldPolicy;
  };
  RdProjectTeamMemberMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTeamMemberMinAggregateKeySpecifier
      | (() => undefined | RdProjectTeamMemberMinAggregateKeySpecifier);
    fields?: RdProjectTeamMemberMinAggregateFieldPolicy;
  };
  RdProjectTeamMemberSumAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTeamMemberSumAggregateKeySpecifier
      | (() => undefined | RdProjectTeamMemberSumAggregateKeySpecifier);
    fields?: RdProjectTeamMemberSumAggregateFieldPolicy;
  };
  RdProjectTpTicketsView?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectTpTicketsViewKeySpecifier | (() => undefined | RdProjectTpTicketsViewKeySpecifier);
    fields?: RdProjectTpTicketsViewFieldPolicy;
  };
  RdProjectTpTicketsViewAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTpTicketsViewAggregateGroupByKeySpecifier
      | (() => undefined | RdProjectTpTicketsViewAggregateGroupByKeySpecifier);
    fields?: RdProjectTpTicketsViewAggregateGroupByFieldPolicy;
  };
  RdProjectTpTicketsViewAvgAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTpTicketsViewAvgAggregateKeySpecifier
      | (() => undefined | RdProjectTpTicketsViewAvgAggregateKeySpecifier);
    fields?: RdProjectTpTicketsViewAvgAggregateFieldPolicy;
  };
  RdProjectTpTicketsViewConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTpTicketsViewConnectionKeySpecifier
      | (() => undefined | RdProjectTpTicketsViewConnectionKeySpecifier);
    fields?: RdProjectTpTicketsViewConnectionFieldPolicy;
  };
  RdProjectTpTicketsViewCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTpTicketsViewCountAggregateKeySpecifier
      | (() => undefined | RdProjectTpTicketsViewCountAggregateKeySpecifier);
    fields?: RdProjectTpTicketsViewCountAggregateFieldPolicy;
  };
  RdProjectTpTicketsViewEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTpTicketsViewEdgeKeySpecifier
      | (() => undefined | RdProjectTpTicketsViewEdgeKeySpecifier);
    fields?: RdProjectTpTicketsViewEdgeFieldPolicy;
  };
  RdProjectTpTicketsViewMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTpTicketsViewMaxAggregateKeySpecifier
      | (() => undefined | RdProjectTpTicketsViewMaxAggregateKeySpecifier);
    fields?: RdProjectTpTicketsViewMaxAggregateFieldPolicy;
  };
  RdProjectTpTicketsViewMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTpTicketsViewMinAggregateKeySpecifier
      | (() => undefined | RdProjectTpTicketsViewMinAggregateKeySpecifier);
    fields?: RdProjectTpTicketsViewMinAggregateFieldPolicy;
  };
  RdProjectTpTicketsViewSumAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectTpTicketsViewSumAggregateKeySpecifier
      | (() => undefined | RdProjectTpTicketsViewSumAggregateKeySpecifier);
    fields?: RdProjectTpTicketsViewSumAggregateFieldPolicy;
  };
  RdProjectUniqueCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdProjectUniqueCountAggregateKeySpecifier
      | (() => undefined | RdProjectUniqueCountAggregateKeySpecifier);
    fields?: RdProjectUniqueCountAggregateFieldPolicy;
  };
  RdProjectsSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdProjectsSummaryKeySpecifier | (() => undefined | RdProjectsSummaryKeySpecifier);
    fields?: RdProjectsSummaryFieldPolicy;
  };
  RdTaxCreditContributor?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdTaxCreditContributorKeySpecifier | (() => undefined | RdTaxCreditContributorKeySpecifier);
    fields?: RdTaxCreditContributorFieldPolicy;
  };
  RdTaxCreditContributorWithAllocation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdTaxCreditContributorWithAllocationKeySpecifier
      | (() => undefined | RdTaxCreditContributorWithAllocationKeySpecifier);
    fields?: RdTaxCreditContributorWithAllocationFieldPolicy;
  };
  RdTaxCreditContributorsWithAllocationPaginated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RdTaxCreditContributorsWithAllocationPaginatedKeySpecifier
      | (() => undefined | RdTaxCreditContributorsWithAllocationPaginatedKeySpecifier);
    fields?: RdTaxCreditContributorsWithAllocationPaginatedFieldPolicy;
  };
  RdTicketMatchExport?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | RdTicketMatchExportKeySpecifier | (() => undefined | RdTicketMatchExportKeySpecifier);
    fields?: RdTicketMatchExportFieldPolicy;
  };
  Report?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ReportKeySpecifier | (() => undefined | ReportKeySpecifier);
    fields?: ReportFieldPolicy;
  };
  ScheduledBackgroundOperationModel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ScheduledBackgroundOperationModelKeySpecifier
      | (() => undefined | ScheduledBackgroundOperationModelKeySpecifier);
    fields?: ScheduledBackgroundOperationModelFieldPolicy;
  };
  SentinelEmail?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SentinelEmailKeySpecifier | (() => undefined | SentinelEmailKeySpecifier);
    fields?: SentinelEmailFieldPolicy;
  };
  SentinelEmailCompany?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SentinelEmailCompanyKeySpecifier | (() => undefined | SentinelEmailCompanyKeySpecifier);
    fields?: SentinelEmailCompanyFieldPolicy;
  };
  ServerInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ServerInfoKeySpecifier | (() => undefined | ServerInfoKeySpecifier);
    fields?: ServerInfoFieldPolicy;
  };
  SingleTenantDomainRedirect?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SingleTenantDomainRedirectKeySpecifier
      | (() => undefined | SingleTenantDomainRedirectKeySpecifier);
    fields?: SingleTenantDomainRedirectFieldPolicy;
  };
  SnowflakeDetail?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SnowflakeDetailKeySpecifier | (() => undefined | SnowflakeDetailKeySpecifier);
    fields?: SnowflakeDetailFieldPolicy;
  };
  SnowflakeTicketingToken?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SnowflakeTicketingTokenKeySpecifier | (() => undefined | SnowflakeTicketingTokenKeySpecifier);
    fields?: SnowflakeTicketingTokenFieldPolicy;
  };
  SredPayrollExpense?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SredPayrollExpenseKeySpecifier | (() => undefined | SredPayrollExpenseKeySpecifier);
    fields?: SredPayrollExpenseFieldPolicy;
  };
  SredPayrollExpenseAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SredPayrollExpenseAggregateGroupByKeySpecifier
      | (() => undefined | SredPayrollExpenseAggregateGroupByKeySpecifier);
    fields?: SredPayrollExpenseAggregateGroupByFieldPolicy;
  };
  SredPayrollExpenseAvgAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SredPayrollExpenseAvgAggregateKeySpecifier
      | (() => undefined | SredPayrollExpenseAvgAggregateKeySpecifier);
    fields?: SredPayrollExpenseAvgAggregateFieldPolicy;
  };
  SredPayrollExpenseConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SredPayrollExpenseConnectionKeySpecifier
      | (() => undefined | SredPayrollExpenseConnectionKeySpecifier);
    fields?: SredPayrollExpenseConnectionFieldPolicy;
  };
  SredPayrollExpenseCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SredPayrollExpenseCountAggregateKeySpecifier
      | (() => undefined | SredPayrollExpenseCountAggregateKeySpecifier);
    fields?: SredPayrollExpenseCountAggregateFieldPolicy;
  };
  SredPayrollExpenseEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SredPayrollExpenseEdgeKeySpecifier | (() => undefined | SredPayrollExpenseEdgeKeySpecifier);
    fields?: SredPayrollExpenseEdgeFieldPolicy;
  };
  SredPayrollExpenseMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SredPayrollExpenseMaxAggregateKeySpecifier
      | (() => undefined | SredPayrollExpenseMaxAggregateKeySpecifier);
    fields?: SredPayrollExpenseMaxAggregateFieldPolicy;
  };
  SredPayrollExpenseMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SredPayrollExpenseMinAggregateKeySpecifier
      | (() => undefined | SredPayrollExpenseMinAggregateKeySpecifier);
    fields?: SredPayrollExpenseMinAggregateFieldPolicy;
  };
  SredPayrollExpenseSumAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SredPayrollExpenseSumAggregateKeySpecifier
      | (() => undefined | SredPayrollExpenseSumAggregateKeySpecifier);
    fields?: SredPayrollExpenseSumAggregateFieldPolicy;
  };
  SredPayrollExpenseUniqueCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SredPayrollExpenseUniqueCountAggregateKeySpecifier
      | (() => undefined | SredPayrollExpenseUniqueCountAggregateKeySpecifier);
    fields?: SredPayrollExpenseUniqueCountAggregateFieldPolicy;
  };
  SredPayrollExpensesSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SredPayrollExpensesSummaryKeySpecifier
      | (() => undefined | SredPayrollExpensesSummaryKeySpecifier);
    fields?: SredPayrollExpensesSummaryFieldPolicy;
  };
  SredProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SredProjectKeySpecifier | (() => undefined | SredProjectKeySpecifier);
    fields?: SredProjectFieldPolicy;
  };
  SredProjectAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SredProjectAggregateGroupByKeySpecifier
      | (() => undefined | SredProjectAggregateGroupByKeySpecifier);
    fields?: SredProjectAggregateGroupByFieldPolicy;
  };
  SredProjectAvgAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SredProjectAvgAggregateKeySpecifier | (() => undefined | SredProjectAvgAggregateKeySpecifier);
    fields?: SredProjectAvgAggregateFieldPolicy;
  };
  SredProjectConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SredProjectConnectionKeySpecifier | (() => undefined | SredProjectConnectionKeySpecifier);
    fields?: SredProjectConnectionFieldPolicy;
  };
  SredProjectCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SredProjectCountAggregateKeySpecifier
      | (() => undefined | SredProjectCountAggregateKeySpecifier);
    fields?: SredProjectCountAggregateFieldPolicy;
  };
  SredProjectEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SredProjectEdgeKeySpecifier | (() => undefined | SredProjectEdgeKeySpecifier);
    fields?: SredProjectEdgeFieldPolicy;
  };
  SredProjectMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SredProjectMaxAggregateKeySpecifier | (() => undefined | SredProjectMaxAggregateKeySpecifier);
    fields?: SredProjectMaxAggregateFieldPolicy;
  };
  SredProjectMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SredProjectMinAggregateKeySpecifier | (() => undefined | SredProjectMinAggregateKeySpecifier);
    fields?: SredProjectMinAggregateFieldPolicy;
  };
  SredProjectOwner?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SredProjectOwnerKeySpecifier | (() => undefined | SredProjectOwnerKeySpecifier);
    fields?: SredProjectOwnerFieldPolicy;
  };
  SredProjectSumAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SredProjectSumAggregateKeySpecifier | (() => undefined | SredProjectSumAggregateKeySpecifier);
    fields?: SredProjectSumAggregateFieldPolicy;
  };
  SredTaxCredit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SredTaxCreditKeySpecifier | (() => undefined | SredTaxCreditKeySpecifier);
    fields?: SredTaxCreditFieldPolicy;
  };
  StateRdTaxCreditDocument?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | StateRdTaxCreditDocumentKeySpecifier | (() => undefined | StateRdTaxCreditDocumentKeySpecifier);
    fields?: StateRdTaxCreditDocumentFieldPolicy;
  };
  SupervisorIdentificationResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SupervisorIdentificationResultKeySpecifier
      | (() => undefined | SupervisorIdentificationResultKeySpecifier);
    fields?: SupervisorIdentificationResultFieldPolicy;
  };
  SyncAccountingProviderResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SyncAccountingProviderResultKeySpecifier
      | (() => undefined | SyncAccountingProviderResultKeySpecifier);
    fields?: SyncAccountingProviderResultFieldPolicy;
  };
  SyncConfigurationRd?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SyncConfigurationRdKeySpecifier | (() => undefined | SyncConfigurationRdKeySpecifier);
    fields?: SyncConfigurationRdFieldPolicy;
  };
  SyncConfigurationsAscExcludedWorkstreamRo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SyncConfigurationsAscExcludedWorkstreamRoKeySpecifier
      | (() => undefined | SyncConfigurationsAscExcludedWorkstreamRoKeySpecifier);
    fields?: SyncConfigurationsAscExcludedWorkstreamRoFieldPolicy;
  };
  SyncPayrollProviderResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SyncPayrollProviderResultKeySpecifier
      | (() => undefined | SyncPayrollProviderResultKeySpecifier);
    fields?: SyncPayrollProviderResultFieldPolicy;
  };
  SyncPeriodModel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SyncPeriodModelKeySpecifier | (() => undefined | SyncPeriodModelKeySpecifier);
    fields?: SyncPeriodModelFieldPolicy;
  };
  SyncTicketingDataScheduleModel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SyncTicketingDataScheduleModelKeySpecifier
      | (() => undefined | SyncTicketingDataScheduleModelKeySpecifier);
    fields?: SyncTicketingDataScheduleModelFieldPolicy;
  };
  SyncedAccountingProviders?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SyncedAccountingProvidersKeySpecifier
      | (() => undefined | SyncedAccountingProvidersKeySpecifier);
    fields?: SyncedAccountingProvidersFieldPolicy;
  };
  SyncedPayrollMonthExpense?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SyncedPayrollMonthExpenseKeySpecifier
      | (() => undefined | SyncedPayrollMonthExpenseKeySpecifier);
    fields?: SyncedPayrollMonthExpenseFieldPolicy;
  };
  SyncedPayrollProviders?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SyncedPayrollProvidersKeySpecifier | (() => undefined | SyncedPayrollProvidersKeySpecifier);
    fields?: SyncedPayrollProvidersFieldPolicy;
  };
  SyncedProviders?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SyncedProvidersKeySpecifier | (() => undefined | SyncedProvidersKeySpecifier);
    fields?: SyncedProvidersFieldPolicy;
  };
  SyncedRdPayrollCost?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SyncedRdPayrollCostKeySpecifier | (() => undefined | SyncedRdPayrollCostKeySpecifier);
    fields?: SyncedRdPayrollCostFieldPolicy;
  };
  SyncedTicketingProviders?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SyncedTicketingProvidersKeySpecifier | (() => undefined | SyncedTicketingProvidersKeySpecifier);
    fields?: SyncedTicketingProvidersFieldPolicy;
  };
  TabularDataParseError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TabularDataParseErrorKeySpecifier | (() => undefined | TabularDataParseErrorKeySpecifier);
    fields?: TabularDataParseErrorFieldPolicy;
  };
  TaskDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TaskDetailsKeySpecifier | (() => undefined | TaskDetailsKeySpecifier);
    fields?: TaskDetailsFieldPolicy;
  };
  TicketingProviderSyncEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TicketingProviderSyncEventKeySpecifier
      | (() => undefined | TicketingProviderSyncEventKeySpecifier);
    fields?: TicketingProviderSyncEventFieldPolicy;
  };
  TicketingProviderUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TicketingProviderUserKeySpecifier | (() => undefined | TicketingProviderUserKeySpecifier);
    fields?: TicketingProviderUserFieldPolicy;
  };
  TicketingProviderWorkstream?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TicketingProviderWorkstreamKeySpecifier
      | (() => undefined | TicketingProviderWorkstreamKeySpecifier);
    fields?: TicketingProviderWorkstreamFieldPolicy;
  };
  TicketingToken?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TicketingTokenKeySpecifier | (() => undefined | TicketingTokenKeySpecifier);
    fields?: TicketingTokenFieldPolicy;
  };
  TicketingTokenLastSuccessfulSync?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TicketingTokenLastSuccessfulSyncKeySpecifier
      | (() => undefined | TicketingTokenLastSuccessfulSyncKeySpecifier);
    fields?: TicketingTokenLastSuccessfulSyncFieldPolicy;
  };
  TicketingUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TicketingUserKeySpecifier | (() => undefined | TicketingUserKeySpecifier);
    fields?: TicketingUserFieldPolicy;
  };
  TicketingUserAggregateGroupBy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TicketingUserAggregateGroupByKeySpecifier
      | (() => undefined | TicketingUserAggregateGroupByKeySpecifier);
    fields?: TicketingUserAggregateGroupByFieldPolicy;
  };
  TicketingUserConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TicketingUserConnectionKeySpecifier | (() => undefined | TicketingUserConnectionKeySpecifier);
    fields?: TicketingUserConnectionFieldPolicy;
  };
  TicketingUserCountAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TicketingUserCountAggregateKeySpecifier
      | (() => undefined | TicketingUserCountAggregateKeySpecifier);
    fields?: TicketingUserCountAggregateFieldPolicy;
  };
  TicketingUserEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TicketingUserEdgeKeySpecifier | (() => undefined | TicketingUserEdgeKeySpecifier);
    fields?: TicketingUserEdgeFieldPolicy;
  };
  TicketingUserMaxAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TicketingUserMaxAggregateKeySpecifier
      | (() => undefined | TicketingUserMaxAggregateKeySpecifier);
    fields?: TicketingUserMaxAggregateFieldPolicy;
  };
  TicketingUserMinAggregate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TicketingUserMinAggregateKeySpecifier
      | (() => undefined | TicketingUserMinAggregateKeySpecifier);
    fields?: TicketingUserMinAggregateFieldPolicy;
  };
  TimesheetRdReport?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TimesheetRdReportKeySpecifier | (() => undefined | TimesheetRdReportKeySpecifier);
    fields?: TimesheetRdReportFieldPolicy;
  };
  TimesheetRdReportFlowStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TimesheetRdReportFlowStatusKeySpecifier
      | (() => undefined | TimesheetRdReportFlowStatusKeySpecifier);
    fields?: TimesheetRdReportFlowStatusFieldPolicy;
  };
  TimesheetRdReportMatchSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TimesheetRdReportMatchSummaryKeySpecifier
      | (() => undefined | TimesheetRdReportMatchSummaryKeySpecifier);
    fields?: TimesheetRdReportMatchSummaryFieldPolicy;
  };
  TimesheetRdReportProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TimesheetRdReportProjectKeySpecifier | (() => undefined | TimesheetRdReportProjectKeySpecifier);
    fields?: TimesheetRdReportProjectFieldPolicy;
  };
  TimesheetRdReportUserRow?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TimesheetRdReportUserRowKeySpecifier | (() => undefined | TimesheetRdReportUserRowKeySpecifier);
    fields?: TimesheetRdReportUserRowFieldPolicy;
  };
  TimesheetSyncEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TimesheetSyncEventKeySpecifier | (() => undefined | TimesheetSyncEventKeySpecifier);
    fields?: TimesheetSyncEventFieldPolicy;
  };
  TokenValidationIssue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | TokenValidationIssueKeySpecifier | (() => undefined | TokenValidationIssueKeySpecifier);
    fields?: TokenValidationIssueFieldPolicy;
  };
  UploadAccountingExpenseCsvResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UploadAccountingExpenseCsvResultKeySpecifier
      | (() => undefined | UploadAccountingExpenseCsvResultKeySpecifier);
    fields?: UploadAccountingExpenseCsvResultFieldPolicy;
  };
  UploadAscWageReportResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UploadAscWageReportResultKeySpecifier
      | (() => undefined | UploadAscWageReportResultKeySpecifier);
    fields?: UploadAscWageReportResultFieldPolicy;
  };
  UploadCsvToMoveTicketsToAscProjects?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UploadCsvToMoveTicketsToAscProjectsKeySpecifier
      | (() => undefined | UploadCsvToMoveTicketsToAscProjectsKeySpecifier);
    fields?: UploadCsvToMoveTicketsToAscProjectsFieldPolicy;
  };
  UploadCsvToMoveTicketsToRdProjects?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UploadCsvToMoveTicketsToRdProjectsKeySpecifier
      | (() => undefined | UploadCsvToMoveTicketsToRdProjectsKeySpecifier);
    fields?: UploadCsvToMoveTicketsToRdProjectsFieldPolicy;
  };
  UploadPayrollExpenseCsvResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UploadPayrollExpenseCsvResultKeySpecifier
      | (() => undefined | UploadPayrollExpenseCsvResultKeySpecifier);
    fields?: UploadPayrollExpenseCsvResultFieldPolicy;
  };
  UploadRdExpenseProjectAllocationReportResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UploadRdExpenseProjectAllocationReportResultKeySpecifier
      | (() => undefined | UploadRdExpenseProjectAllocationReportResultKeySpecifier);
    fields?: UploadRdExpenseProjectAllocationReportResultFieldPolicy;
  };
  UploadUrl?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | UploadUrlKeySpecifier | (() => undefined | UploadUrlKeySpecifier);
    fields?: UploadUrlFieldPolicy;
  };
  User?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier);
    fields?: UserFieldPolicy;
  };
  UserAttributes?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | UserAttributesKeySpecifier | (() => undefined | UserAttributesKeySpecifier);
    fields?: UserAttributesFieldPolicy;
  };
  UserIdWithRole?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | UserIdWithRoleKeySpecifier | (() => undefined | UserIdWithRoleKeySpecifier);
    fields?: UserIdWithRoleFieldPolicy;
  };
  ValidateTicketingTokenOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ValidateTicketingTokenOutputKeySpecifier
      | (() => undefined | ValidateTicketingTokenOutputKeySpecifier);
    fields?: ValidateTicketingTokenOutputFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
